webpackJsonp([1],{

/***/ "+94u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_row_vue__ = __webpack_require__("fVBG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_row_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_row_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_row_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_row_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aab532aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_row_vue__ = __webpack_require__("zIIn");
function injectStyle (ssrContext) {
  __webpack_require__("n3gS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_row_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aab532aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_row_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+MSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"smart-phone",attrs:{"data-type":"default"}},[_c('a',{attrs:{"href":_vm.linkHref}},[_vm._v(_vm._s(_vm.phoneNumber))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+QJm":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjAwcHgiIGhlaWdodD0iMjAwcHgiIHZpZXdCb3g9IjAgMCAyMDAgMjAwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OS4zICg1MTE2NykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+R3JvdXAgMTEgQ29weSA1PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9Ik1haW4iIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJBcnRib2FyZC0zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTU2MS4wMDAwMDAsIC0yODM5LjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMTEtQ29weS01IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjYxLjAwMDAwMCwgMjkzOS4wMDAwMDApIHNjYWxlKC0xLCAxKSByb3RhdGUoLTI3MC4wMDAwMDApIHRyYW5zbGF0ZSgtMTY2MS4wMDAwMDAsIC0yOTM5LjAwMDAwMCkgdHJhbnNsYXRlKDE1NjEuMDAwMDAwLCAyODM5LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkZpbGwtMTQ2NC1Db3B5LTIiIGZpbGw9IiNGRkZGRkYiIHBvaW50cz0iMCAyMDAgMjAwIDIwMCAyMDAgMCAwIDAiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJGaWxsLTE0NjQtQ29weSIgZmlsbD0iIzAwMDAwMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAwLjAwMDAwMCwgMTAwLjAwMDAwMCkgc2NhbGUoMSwgLTEpIHRyYW5zbGF0ZSgtMTAwLjAwMDAwMCwgLTEwMC4wMDAwMDApICIgcG9pbnRzPSIwIDIwMCAyMDAgMCAwIDAiPjwvcG9seWdvbj4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ "+R6s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+asZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'module_hcAbout',
  props: ['window', 'scrollState', 'scrollPosition'],
  data: function data() {
    return {
      container: null,
      sections: null,
      sectionScroll: {}
    };
  },
  computed: {
    percentScrolled: function percentScrolled() {
      if (!this.container) {
        return 0;
      }
      var vh = this.window.height;

      var containerOffset = this.container.offsetTop - this.window.height;
      var offset = Math.max(0, this.scrollPosition - containerOffset);

      var percent = offset / vh * 100;
      return percent;
    },
    graphicVisibility: function graphicVisibility() {
      // set the breakpoints for graphic display
      var w = this.window.width;
      var h = this.window.height;

      var ratio = w / h;
      var display = 'mobile';

      if (ratio > 0.9) {
        display = 'compact';
      }

      if (ratio > 1.45) {
        display = 'full';
      }

      if (h > 1024) {
        display = 'compact';

        if (ratio < 0.8) {
          display = 'mobile';
        }
      }

      if (h > 1700) {
        display = 'mobile';
      }

      if (w < 768) {
        display = 'mobile';
      }

      return display;
    },
    aboutNavClasses: function aboutNavClasses() {
      if (!this.sectionScroll.bottomOfAboutContent || !this.sectionScroll.topOfAboutContent) {
        return {};
      }
      return {
        following: this.sectionScroll.topOfAboutContent.isAboveViewport && this.sectionScroll.bottomOfAboutContent.isBelowViewport,
        'fixed--bottom': this.sectionScroll.bottomOfAboutContent.isInViewport
      };
    },
    aboutNavStyles: function aboutNavStyles() {
      // since we're using position fixed, right-side
      // we'll need to manually calculate what that right value is
      try {
        if (this.sectionScroll.topOfAboutContent.isAboveViewport && !this.sectionScroll.bottomOfAboutContent.isInViewport && this.window.width > 1024) {
          var contentWidth = document.querySelector('[data-module="about"]').clientWidth;

          return {
            transform: 'translateX(-100%)',
            left: 'calc(50% + ' + contentWidth / 2 + 'px)'
          };
        }
      } catch (e) {
        return {};
      }

      return {};
    },
    aboutNavPositionStyle: function aboutNavPositionStyle() {
      var position = this.percentScrolled;
      var track = 0;

      // irregular scrolling - manually scrub nav bar
      if (position < 100) {
        // percent of scroll (100) traveled to full opacity
        track = position / 100 * 100;
      } else if (position < 125) {
        // end of full opacity
        track = 100;
      } else if (position < 225) {
        // percent of scroll (100) traveled to full opacity
        var dist = 100;
        var travel = position - 125; // 125 = full opacity start point
        var ratio = travel / dist * 100;
        track = 100 + ratio;
      } else if (position < 250) {
        track = 200;
      } else if (position < 350) {
        // percent of scroll (100) traveled to full opacity
        var _dist = 100;
        var _travel = position - 250; // 250 = full opacity start point
        var _ratio = _travel / _dist * 100;
        track = 200 + _ratio;
      } else {
        track = 300;
      }

      // return converts to proper ratio
      return {
        transform: 'translateY( calc( ' + track / 3 + 'vh - 100% ) )'
      };
    }
  },
  mounted: function mounted() {
    this.container = document.querySelector('[data-module="about"]');
  },
  methods: {
    updateSectionScrollState: function updateSectionScrollState(state) {
      this.sectionScroll = state;
    }
  }
};

/***/ }),

/***/ "+nnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bus = __webpack_require__("EJZp");

exports.default = {
  name: 'component_blurb',
  props: ['data'],
  data: function data() {
    return {
      tapped: false
    };
  },
  computed: {
    blurb: function blurb() {
      return this.data.blurb;
    },
    styles: function styles() {
      var background = void 0;
      var window = this.data.window;

      if (this.data.blurb.backgroundSet) {
        background = this.data.blurb.backgroundSet.find(function (bg) {
          return window.width < bg.max;
        });
      }

      if (background) {
        background = background.src;
      } else {
        background = this.data.blurb.background;
      }

      return {
        'background-image': 'url(\'' + background + '\')'
      };
    }
  },
  methods: {
    touchHandler: function touchHandler(e) {
      if (this.tapped === false) {
        e.preventDefault();
        this.tapped = !this.tapped;

        _bus.Bus.$emit('tapped-blurb', this.data.slug);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    _bus.Bus.$on('tapped-blurb', function (slug) {
      if (_this.data.slug !== slug) {
        _this.tapped = false;
      }
    });
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "+u5O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"work-multi-image-text"}},[_c('div',{staticClass:"module-layout",class:_vm.layoutClasses},[_c('div',{ref:"imageContainer",staticClass:"image-container",class:_vm.containerClasses},[_c('div',{staticClass:"flex-wrapper-vert"},[_c('div',{staticClass:"image-col-1"},_vm._l((2),function(n,idx){return _c('div',{key:idx,staticClass:"image",class:("image-" + idx),style:(_vm.imageStyles(_vm.data.images[idx]))})}),0),_vm._v(" "),(_vm.data.images.length > 2)?[_c('div',{staticClass:"image-col-2"},[_c('div',{staticClass:"image",class:"image-2",style:(_vm.imageStyles(_vm.data.images[2]))})])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"content-container",class:_vm.containerClasses},[_c('markdown',{staticClass:"markdown"},[_vm._v(_vm._s(_vm.data.content))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+zjS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
  THIS FILE IS GENERATED !!

  #> npm run gen:people
*/
/* eslint-disable */

exports.default = {
  "Amber Ward": {
    "title": "Amber Ward",
    "position": "UX Researcher and Project Manager",
    "thumbSrc": "/static/content/uploads/amberward.jpg"
  },
  "Annika Hansteen-Izora": {
    "title": "Annika Hansteen-Izora",
    "position": "UX Researcher",
    "thumbSrc": "/static/content/uploads/annika-hansteen-izora.jpg"
  },
  "Ben Decherd": {
    "title": "Ben Decherd",
    "position": "UX Researcher",
    "thumbSrc": "/static/content/uploads/ben1.jpg"
  },
  "Crystal Rutland": {
    "title": "Crystal Rutland",
    "position": "Founder and CEO",
    "thumbSrc": "/static/content/uploads/people-crystal-rutland-1200.jpg"
  },
  "David McCuskey": {
    "title": "David McCuskey",
    "position": "Director of Technology",
    "thumbSrc": "/static/content/uploads/thumb-david-mccuskey.png"
  },
  "Emma Shepanek": {
    "title": "Emma Shepanek",
    "position": "UX Researcher ",
    "thumbSrc": "/static/content/uploads/people-emma-shepanek-240.png"
  },
  "Joe Smith ": {
    "title": "Joe Smith ",
    "position": "Best UX Researcher EVER ",
    "thumbSrc": "/static/content/uploads/thumb-person.png"
  },
  "Jon Salud": {
    "title": "Jon Salud",
    "position": "UX Researcher and Designer",
    "thumbSrc": "/static/content/uploads/jon2.jpg"
  },
  "Kat Sutton": {
    "title": "Kat Sutton",
    "position": "UX and Visual Designer",
    "thumbSrc": "/static/content/uploads/kat1.jpg"
  },
  "Matt Adamo": {
    "title": "Matt Adamo",
    "position": "Director of UX Strategy",
    "thumbSrc": "/static/content/uploads/matt.jpg"
  },
  "Stacey Rutland": {
    "title": "Stacey Rutland",
    "position": "Director of Client Services",
    "thumbSrc": "/static/content/uploads/stacey.jpg"
  },
  "Zak Edey": {
    "title": "Zak Edey",
    "position": "UX Designer",
    "thumbSrc": "/static/content/uploads/zak.jpg"
  }
};

/***/ }),

/***/ "/Jh2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tablet",style:(_vm.mainContainerStyles),attrs:{"data-module":"work-main-articles"}},[_c('div',{staticClass:"background",style:(_vm.bgStyles)}),_vm._v(" "),_c('div',{ref:"mainContainer",staticClass:"component-layout"},_vm._l((_vm.tileRecords),function(record,idx){return _c('div',{key:idx,staticClass:"article-tile-container",style:(record.style)},[(record.data.isCategory === true)?_c('category-page-tile',{ref:"tileRefs",refInFor:true,attrs:{"record":record.data,"height":record.height,"width":record.width,"colSpan":record.colSpan}}):(record.data.isMatterArticle === true && _vm.isDesktop)?_c('static-matter-tile',{ref:"tileRefs",refInFor:true,attrs:{"record":record.data,"height":record.height,"width":record.width,"colSpan":record.colSpan}}):(_vm.isTablet)?_c('reveal-work-tile',{ref:"tileRefs",refInFor:true,attrs:{"record":record.data}}):_c('static-work-tile',{ref:"tileRefs",refInFor:true,attrs:{"record":record.data,"height":record.height,"width":record.width,"colSpan":record.colSpan}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/es/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/frontback.45802ea.svg";

/***/ }),

/***/ "065w":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.ca7336f.jpg";

/***/ }),

/***/ "0FAZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0STu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'module_text_image_row',
  props: ['data'],
  computed: {
    imageCount: function imageCount() {
      return this.data.images.length;
    },
    imageRail: function imageRail() {
      var images = this.data.images;
      var rail = [];

      var primary = [];
      var secondary = [];

      images.forEach(function (image) {
        if (image.primary) {
          primary.push(image);
        } else {
          secondary.push(image);
        }
      });

      if (primary.length !== 0) {
        rail.push(primary);
      }

      rail.push(secondary);

      return rail;
    }
  }
};

/***/ }),

/***/ "0dFh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.ab23ae0.jpg";

/***/ }),

/***/ "0r2s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _imageUtils = __webpack_require__("Rn8A");

var _fourOhFour = __webpack_require__("4I25");

var _fourOhFour2 = _interopRequireDefault(_fourOhFour);

var _WorkMixin = __webpack_require__("OytB");

var _WorkMixin2 = _interopRequireDefault(_WorkMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  Work section ImageTextColumn module

  data record:
  {
    imageSrc: <url>,
    aspectRatio: <string> // '16:9', '4:3', '1:1'
    showTitle: <boolean> // true, false
  }
*/
// Libs
exports.default = {

  name: 'four-oh-four',

  mixins: [_WorkMixin2.default],

  props: ['data'],

  data: function data() {
    return {
      imageContentHeight: 0,
      imageContentWidth: 0
    };
  },


  computed: {
    contentBody: function contentBody() {
      return _fourOhFour2.default.body;
    },
    contentTitle: function contentTitle() {
      return _fourOhFour2.default.title;
    },
    containerClasses: function containerClasses() {
      // return class string, eg 'desktop', 'mobile'
      var deviceStr = '';
      if (this.isMobile) {
        deviceStr = 'mobile';
      } else if (this.isTablet) {
        deviceStr = 'tablet';
      } else {
        deviceStr = 'desktop';
      }
      return deviceStr;
    },
    imageStyles: function imageStyles() {
      var imageContentHeight = this.imageContentHeight,
          imageContentWidth = this.imageContentWidth,
          data = this.data;
      var imageSrc = data.imageSrc;


      var maxDim = Math.max(imageContentWidth, imageContentHeight);
      var rUrl = (0, _imageUtils.getResponsiveUrl)(imageSrc, maxDim);

      var styles = {
        backgroundImage: 'url(' + rUrl + ')',
        backgroundPosition: 'center center'
      };

      return styles;
    },
    imageContainerClasses: function imageContainerClasses() {
      var classStr = this.containerClasses;
      var aspectRatio = this.data.aspectRatio;


      var aspectStr = '';
      switch (aspectRatio) {
        case '16:9':
          aspectStr = 'aspect16-9';
          break;
        case '4:3':
          aspectStr = 'aspect4-3';
          break;
        case '1:1':
        default:
          aspectStr = 'aspect1-1';
          break;
      }

      return classStr + ' ' + aspectStr;
    },
    shouldShowTitle: function shouldShowTitle() {
      var showTitle = this.data.showTitle;

      return showTitle === true;
    }
  },

  methods: {
    measureLayout: function measureLayout() {
      this.imageContentHeight = this.getImageContentHeight();
      this.imageContentWidth = this.getImageContentWidth();
    },
    getImageContentHeight: function getImageContentHeight() {
      var el = this.$refs.imageContainer;
      return el ? el.clientHeight : 0;
    },
    getImageContentWidth: function getImageContentWidth() {
      var el = this.$refs.imageContainer;
      return el ? el.clientWidth : 0;
    }
  },

  watch: {
    currentWidth: function currentWidth() /* newVal, oldVal */{
      var _this = this;

      _vue2.default.nextTick(function () {
        _this.measureLayout();
      });
    }
  },

  mounted: function mounted() {
    this.measureLayout();
  }
};

// Utils

/***/ }),

/***/ "0z+k":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDAwcHgiIGhlaWdodD0iMjAwcHgiIHZpZXdCb3g9IjAgMCA0MDAgMjAwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OS4zICg1MTE2NykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+aGFsZiBjaXJjbGVzXzF4d2lkZSBjb3B5PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9Ik1haW4iIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJBcnRib2FyZC0zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTkxOC4wMDAwMDAsIC0yNTU5LjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iaGFsZi1jaXJjbGVzXzF4d2lkZS1jb3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMTE4LjAwMDAwMCwgMjY1OS4wMDAwMDApIHNjYWxlKC0xLCAxKSB0cmFuc2xhdGUoLTIxMTguMDAwMDAwLCAtMjY1OS4wMDAwMDApIHRyYW5zbGF0ZSgxOTE4LjAwMDAwMCwgMjU1OS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMjYiIGZpbGw9IiNGRkZGRkYiIHg9IjAiIHk9IjAiIHdpZHRoPSI0MDAiIGhlaWdodD0iMjAwIj48L3JlY3Q+CiAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjAwLjAwMDAwMCwgMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCwxMDAgQzAsNDQuNzcxODc1IDQ0Ljc3MDMxMjUsMCAxMDAsMCBDMTU1LjIyODEyNSwwIDIwMCw0NC43NzE4NzUgMjAwLDEwMCBMMCwxMDAgWiIgaWQ9IkZpbGwtMjk0IiBmaWxsPSIjRDRERDVEIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTAsMjAwIEMwLDE0NC43NzAzMTMgNDQuNzcwMzEyNSwxMDAgMTAwLDEwMCBDMTU1LjIyODEyNSwxMDAgMjAwLDE0NC43NzAzMTMgMjAwLDIwMCBMMCwyMDAgWiIgaWQ9IkZpbGwtMjk2IiBmaWxsPSIjMDAwMDAwIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ "0z0p":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.01b0f97.jpg";

/***/ }),

/***/ "12GE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hero.78f74bf.jpg";

/***/ }),

/***/ "15Jj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "18a0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _imageUtils = __webpack_require__("Rn8A");

var _WorkMixin = __webpack_require__("OytB");

var _WorkMixin2 = _interopRequireDefault(_WorkMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
exports.default = {

  name: 'work-image-text-row',

  props: ['data'],

  mixins: [_WorkMixin2.default],

  data: function data() {
    return {
      imageContentHeight: 0,
      imageContentWidth: 0
    };
  },


  computed: {
    contentText: function contentText() {
      var content = this.data.content;

      return content;
    },
    hasContent: function hasContent() {
      var content = this.data.content;

      return content !== undefined;
    },
    hasImage: function hasImage() {
      var image = this.data.image;

      return image !== undefined;
    },
    imageCaption: function imageCaption() {
      var image = this.data.image;

      return image.caption;
    },
    imageAspect: function imageAspect() {
      var image = this.data.image;

      var aspect = '';
      if (this.hasImage) {
        aspect = image.aspect || 'medium';
      }
      return aspect;
    },
    imageWidth: function imageWidth() {
      var image = this.data.image;

      var width = '';
      if (this.hasImage) {
        width = image.width || 'regular';
      }
      return width;
    },
    containerClasses: function containerClasses() {
      // return class string, eg 'desktop', 'mobile.reversed'
      var imageAspect = this.imageAspect,
          imageWidth = this.imageWidth,
          isReversed = this.isReversed,
          deviceType = this.deviceType;


      var classes = [deviceType, imageWidth, imageAspect];
      if (isReversed) {
        classes.push('reversed');
      }

      return classes.join(' ');
    },
    imageStyles: function imageStyles() {
      var imageContentHeight = this.imageContentHeight,
          imageContentWidth = this.imageContentWidth;
      var image = this.data.image;
      var hA = image.hAlign,
          vA = image.vAlign,
          sResImg = image.showResponsiveImage;

      // add defaults

      var hAlign = hA || 'center';
      var vAlign = vA || 'center';
      var sRI = sResImg === undefined ? true : sResImg;

      var maxDim = Math.max(imageContentWidth, imageContentHeight);
      var rUrl = image.src;
      if (sRI) {
        rUrl = (0, _imageUtils.getResponsiveUrl)(image.src, maxDim);
      }
      var styles = {
        backgroundImage: 'url(' + rUrl + ')',
        backgroundPosition: hAlign + ' ' + vAlign
      };

      return styles;
    }
  },

  methods: {
    measureLayout: function measureLayout() {
      this.imageContentHeight = this.getImageContentHeight();
      this.imageContentWidth = this.getImageContentWidth();
    },
    getImageContentHeight: function getImageContentHeight() {
      var el = this.$refs.imageContainer;
      return el ? el.clientHeight : 0;
    },
    getImageContentWidth: function getImageContentWidth() {
      var el = this.$refs.imageContainer;
      return el ? el.clientWidth : 0;
    }
  },

  watch: {
    currentWidth: function currentWidth() /* newVal, oldVal */{
      var _this = this;

      _vue2.default.nextTick(function () {
        _this.measureLayout();
      });
    }
  },

  mounted: function mounted() {
    this.measureLayout();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  Work section ImageTextRow module

  data record:
  {
    reversed: <boolean>
    image: {
      width: <string>, // 'narrow', 'regular', 'wide'
      aspect: <string>, // 'short', 'medium', 'tall'
      src: <url> //
      alt: <string>, // 'picture of a big mouse'
      caption: <string>, // 'a big mouse'
      hAlign: <string>, // 'left', 'center', 'right'
      vAlign: <string>, // 'top', 'center', 'bottom'
    },
    content: <markdown>
  }
*/
// Libs

/***/ }),

/***/ "1Ceh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageTextRow_vue__ = __webpack_require__("18a0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageTextRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageTextRow_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageTextRow_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageTextRow_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57574588_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageTextRow_vue__ = __webpack_require__("fdr1");
function injectStyle (ssrContext) {
  __webpack_require__("P62E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57574588"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageTextRow_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57574588_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageTextRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1E1Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'debug_windowDimensions',
  props: ['window'],
  computed: {
    ratioWH: function ratioWH() {
      return (this.window.width / this.window.height).toFixed(2);
    },
    ratioHW: function ratioHW() {
      return (this.window.height / this.window.width).toFixed(2);
    }
  }
};

/***/ }),

/***/ "1LY0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1VJu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/preview.0c95584.jpg";

/***/ }),

/***/ "1coi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1mau":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"data-module":"hcAbout1"}},[_c('div',{staticClass:"intro"},[_c('h1',{staticClass:"h1"},[_vm._v("\n      We are an interdisciplinary team of researchers, designers, builders and doers. \n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      We are powered by empathy, curiosity, and collaboration. Drawing on our vast global experience in sectors including technology, health, transportation, education, and much more, we make ideas relevant, memorable, and come to life. \n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "22kU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intro_vue__ = __webpack_require__("4Pz3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intro_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intro_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intro_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intro_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32933792_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_intro_vue__ = __webpack_require__("yYDX");
function injectStyle (ssrContext) {
  __webpack_require__("vMqN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intro_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32933792_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_intro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "244o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modules_vue__ = __webpack_require__("iu78");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modules_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modules_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modules_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modules_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16e35c1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modules_vue__ = __webpack_require__("HFee");
function injectStyle (ssrContext) {
  __webpack_require__("OmGg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modules_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16e35c1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modules_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "2Tf9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var companyName = exports.companyName = 'Particle Design';

var socialMedia = [{
  platform: 'LinkedIn',
  url: 'https://www.linkedin.com/company/18343156/'
}, {
  platform: 'Medium',
  url: 'https://medium.com/particle-matter'
}, {
  platform: 'Twitter',
  url: 'https://twitter.com/ParticleDesign_'
}, {
  platform: 'Instagram',
  url: 'https://www.instagram.com/particle.design/'
}];

var address = exports.address = {
  line1: '217 NE 8th Ave.',
  line2: '#201',
  city: 'Portland',
  state: 'OR',
  zip: 97232,
  address1: '217 NE 8th Ave. #201',
  address2: 'Portland, OR 97232',
  latitude: 45.5246273,
  longitude: -122.6600956
};

var phone = exports.phone = '+1.503.206.7760';

var email = exports.email = 'hello@particledesign.com';

exports.default = { socialMedia: socialMedia, address: address, email: email, phone: phone };

/***/ }),

/***/ "2Vqw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jaguar.2b6c804.svg";

/***/ }),

/***/ "2Wfb":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "30i/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bigHeading_vue__ = __webpack_require__("J8Lv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bigHeading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bigHeading_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bigHeading_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bigHeading_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f9d3f6f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bigHeading_vue__ = __webpack_require__("VwZG");
function injectStyle (ssrContext) {
  __webpack_require__("rWLT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bigHeading_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f9d3f6f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bigHeading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3Ill":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

// Module expects:
// - src
// - alt (description text)
exports.default = {
  name: 'component_image',
  props: ['data'],
  computed: {
    output: function output() {
      var output = void 0;
      var window = this.data.window;

      if (this.data.srcSet) {
        output = this.data.srcSet.find(function (img) {
          return window.width < img.max;
        });
      }

      if (output) {
        output = output.src;
      } else {
        output = this.data.src;
      }

      return output;
    }
  }
};

/***/ }),

/***/ "3JVN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _companyInfo = __webpack_require__("2Tf9");

exports.default = {

  name: 'SmartPhone',

  data: function data() {
    return {
      phoneNumber: _companyInfo.phone
    };
  },


  computed: {
    intlPhoneNumber: function intlPhoneNumber() {
      // transform to "international" format
      return _companyInfo.phone.replace(/\./gi, '-');
    },
    linkHref: function linkHref() {
      return 'tel:' + this.intlPhoneNumber;
    }
  }

}; //
//
//
//
//
//

/***/ }),

/***/ "3KYK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/camera.ca7336f.jpg";

/***/ }),

/***/ "3XUE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/preview.5f8d953.jpg";

/***/ }),

/***/ "3ZBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("F/v5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8860f72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("sZvB");
function injectStyle (ssrContext) {
  __webpack_require__("c8bw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8860f72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3ljX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/preview-mobile.0c95584.jpg";

/***/ }),

/***/ "3mXB":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "3uW7":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "49AP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clients = __webpack_require__("fL60");

var _clients2 = _interopRequireDefault(_clients);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

  slug: 'module-test-page',

  company: _clients2.default.dreamworks.name,
  logo: _clients2.default.dreamworks.logo,
  logoWhite: _clients2.default.dreamworks.logoWhite,

  blurb: {
    headline: "Designing a digital storytelling adventure.",
    tags: [],
    byline: 'Learn more about our work with Dreamworks',
    background: __webpack_require__("dOKh"),
    backgroundSet: [{
      max: 1024,
      src: __webpack_require__("MdCA")
    }]
  },

  modules: [{
    type: 'work-header',

    data: {
      background: __webpack_require__("gdJg"),
      title: 'Work Header – Where Kids Become the Directors of Their Own Movies.',
      content: 'DreamWorks has developed an entire website aimed at inspiring kids to express their creativity (http://create.dreamworks.com/). The site is filled with options for fashioning crafts and paper toys, bringing DreamWorks characters to life through augmented reality, making scrapbooks, learning art techniques, and more.\n\nWhen DreamWorks got in touch with Particle Design, they were looking to add a video and storytelling element to the site. They wanted an activity that would empower kids to feel like they were directing their own movies. They envisioned kids choosing characters, making storyline decisions, and writing the simple scripts that would drive the narrative. They also wanted the final video each child created to convert immediately into a black-and-white comic book that kids could print and color.',
      roles: ['UX Strategy', 'Interaction Design', 'Visual Design', 'Front-End Development', 'Back-End Development']
    }
  }, {
    type: 'work-image-text-column',

    data: {
      reversed: false,
      image: {
        src: __webpack_require__("L25W"),
        alt: 'Image of Toothless from Dreamworks\' "How to Train Your Dragon"',
        hAlign: 'left', // left, center, right
        vAlign: 'top' // top, center, bottom
      },
      content: {
        text: '## Image Text Column – not reversed.\n\nno caption on image. content aligned left. creativity (http://create.dreamworks.com/). The site is filled with options for fashioning crafts and paper toys, bringing DreamWorks characters to life through augmented reality, making scrapbooks, learning art techniques, and more.',
        hAlign: 'left' // left, right
      }
    }
  }, {
    type: 'work-image-text-column',

    data: {
      reversed: false,
      image: {
        src: __webpack_require__("L25W"),
        alt: 'Image of Toothless from Dreamworks\' "How to Train Your Dragon"',
        hAlign: 'left', // left, center, right
        vAlign: 'top' // top, center, bottom
      },
      content: {
        text: '## Image Text Column – not reversed.\n\nno caption on image. content aligned right. (http://create.dreamworks.com/). The site is filled with options for fashioning crafts and paper toys, bringing DreamWorks characters to life through augmented reality, making scrapbooks, learning art techniques, and more.',
        hAlign: 'right' // left, right
      }
    }
  }, {
    type: 'work-image-text-column',

    data: {
      reversed: true,
      image: {
        src: __webpack_require__("L25W"),
        alt: 'Image of Toothless from Dreamworks\' "How to Train Your Dragon"',
        hAlign: 'left', // left, center, right
        vAlign: 'top' // top, center, bottom
      },
      content: {
        text: '## Image Text Column – reversed.\n\ncontent aligned left. their creativity (http://create.dreamworks.com/). The site is filled with options for fashioning crafts and paper toys, bringing DreamWorks characters to life through augmented reality, making scrapbooks, learning art techniques, and more.',
        hAlign: 'left' // left, right
      }
    }
  }, {
    type: 'work-image-text-column',

    data: {
      reversed: true,
      image: {
        src: __webpack_require__("L25W"),
        alt: 'Image of Toothless from Dreamworks\' "How to Train Your Dragon"',
        hAlign: 'left', // left, center, right
        vAlign: 'top' // top, center, bottom
      },
      content: {
        text: '## Image Text Column – reversed.\n\ncontent aligned right (http://create.dreamworks.com/). The site is filled with options for fashioning crafts and paper toys, bringing DreamWorks characters to life through augmented reality, making scrapbooks, learning art techniques, and more.',
        hAlign: 'right' // left, right
      }
    }
  }, {
    type: 'work-image-text-row',

    data: {
      reversed: false,
      image: {
        src: __webpack_require__("L25W"),
        alt: 'Image of Toothless from Dreamworks\' "How to Train Your Dragon"',
        hAlign: 'left', // left, center, right
        vAlign: 'top' // top, center, bottom
      },
      content: '## Image Text Row – not reversed.\n\nno caption on image. aimed at inspiring kids to express their creativity (http://create.dreamworks.com/). The site is filled with options for fashioning crafts and paper toys, bringing DreamWorks characters to life through augmented reality, making scrapbooks, learning art techniques, and more.'
    }
  }, {
    type: 'work-image-text-row',

    data: {
      reversed: true,
      image: {
        src: __webpack_require__("L25W"),
        alt: 'Image of Toothless from Dreamworks\' "How to Train Your Dragon"',
        caption: 'Image of Toothless from Dreamworks\' "How to Train Your Dragon"'
      },
      content: '>Image Text Row – reversed. bad-ass caption included. on your face scratch the furniture damn that dog meow to be let in. Cat not kitten around. Cats are fats I like to pets them they like to meow back meow.\n\n>> Kat Sutton\nUX Lead, Particle'
    }
  }, {
    type: 'work-image-text-row',

    data: {
      reversed: false,
      image: {
        src: __webpack_require__("L25W"),
        alt: 'Image of Toothless from Dreamworks\' "How to Train Your Dragon"',
        caption: 'Image of Toothless from Dreamworks\' "How to Train Your Dragon"'
      },
      content: '## Hello there, it\'s me again\n\nImage Text Row – this time just a tiny bit of text we will want to center as well. We like balance.'
    }
  }, {
    type: 'work-two-column-text',

    data: {
      reversed: false,
      contentLeft: '## Two Col Text – not reversed, but gotta get this to two lines.\n\nFor this DreamWorks project, Particle had limited time—less than 60 days—and a tight budget. There were also complex restrictions and guidelines about how DreamWorks characters could be used in the experience in order to maintain brand authenticity.\n\nAnd most significantly, since the site was for young children, it was critical that the content maintained compliance with COPPA (Children’s Online Privacy Protection Act), under U.S. federal law. COPPA’s primary goal is to place parents in control of the information collected from their children online. As such, it imposes regulations on websites focused on children under 13. Its requirements are stringent, and Particle’s team had to ensure there was no deviation as design decisions were made throughout the project.',

      contentRight: '>Building an experience that allows kids to take an active role in creating the content they consume every day was an exciting opportunity.\n\n>> Stacey Rutland\nParticle, Project Lead'
    }
  }, {
    type: 'work-two-column-text',

    data: {
      reversed: true,
      contentLeft: '## Two Col Text – reversed, but gotta get this to two lines.\n\nFor this DreamWorks project, Particle had limited time—less than 60 days—and a tight budget. There were also complex restrictions and guidelines about how DreamWorks characters could be used in the experience in order to maintain brand authenticity.\n\nAnd most significantly, since the site was for young children, it was critical that the content maintained compliance with COPPA (Children’s Online Privacy Protection Act), under U.S. federal law. COPPA’s primary goal is to place parents in control of the information collected from their children online. As such, it imposes regulations on websites focused on children under 13. Its requirements are stringent, and Particle’s team had to ensure there was no deviation as design decisions were made throughout the project.',

      contentRight: '>Building an experience that allows kids to take an active role in creating the content they consume every day was an exciting opportunity.\n\n>> Stacey Rutland\nParticle, Project Lead'
    }
  }, {
    type: 'work-multi-image-text',

    data: {
      reversed: false,
      images: [{
        src: __webpack_require__("J3uG")
      }, {
        src: __webpack_require__("pqBA"),
        hAlign: 'center', // left, center, right
        vAlign: 'bottom' // top, center, bottom
      }],
      content: '## Multi Image Text – not reversed - two images.\n\nDreamWorks wanted to give kids a great storytelling experience as directors of their own movie scenes. Particle was keen to bring their idea to life but quickly identified the project’s central challenge. The objective was to give children the freedom to create their own stories and have an output when finished. But if there were too many options, the rendering process would take so long kids would give up before the final video could be created. On the other hand, if there weren’t enough options, the activity would be boring and fail to inspire.\n\nParticle’s developers knew the complexity that video brings to web apps and the requirements for success. We were able to help the whole project team understand what would and would not work and kept the project on track. In the end, the video activity we developed struck the perfect balance between creativity and functionality.'
    }
  }, {
    type: 'work-multi-image-text',

    data: {
      reversed: true,
      images: [{
        src: __webpack_require__("J3uG")
      }, {
        src: __webpack_require__("pqBA")
      }],
      content: '## Multi Image Text – reversed - two images.\n\nDreamWorks wanted to give kids a great storytelling experience as directors of their own movie scenes. Particle was keen to bring their idea to life but quickly identified the project’s central challenge. The objective was to give children the freedom to create their own stories and have an output when finished. But if there were too many options, the rendering process would take so long kids would give up before the final video could be created. On the other hand, if there weren’t enough options, the activity would be boring and fail to inspire.\n\nParticle’s developers knew the complexity that video brings to web apps and the requirements for success. We were able to help the whole project team understand what would and would not work and kept the project on track. In the end, the video activity we developed struck the perfect balance between creativity and functionality.'
    }
  }, {
    type: 'work-multi-image-text',

    data: {
      reversed: false,
      images: [{
        src: __webpack_require__("J3uG")
      }, {
        src: __webpack_require__("pqBA")
      }, {
        src: __webpack_require__("3KYK")
      }],
      content: '## Multi Image Text – not reversed - three images.\n\nDreamWorks wanted to give kids a great storytelling experience as directors of their own movie scenes. Particle was keen to bring their idea to life but quickly identified the project’s central challenge. The objective was to give children the freedom to create their own stories and have an output when finished. But if there were too many options, the rendering process would take so long kids would give up before the final video could be created. On the other hand, if there weren’t enough options, the activity would be boring and fail to inspire.\n\nParticle’s developers knew the complexity that video brings to web apps and the requirements for success. We were able to help the whole project team understand what would and would not work and kept the project on track. In the end, the video activity we developed struck the perfect balance between creativity and functionality.'
    }
  }, {
    type: 'work-multi-image-text',

    data: {
      reversed: true,
      images: [{
        src: __webpack_require__("J3uG")
      }, {
        src: __webpack_require__("pqBA")
      }, {
        src: __webpack_require__("3KYK")
      }],
      content: '## Multi Image Text – reversed - three images.\n\nDreamWorks wanted to give kids a great storytelling experience as directors of their own movie scenes. Particle was keen to bring their idea to life but quickly identified the project’s central challenge. The objective was to give children the freedom to create their own stories and have an output when finished. But if there were too many options, the rendering process would take so long kids would give up before the final video could be created. On the other hand, if there weren’t enough options, the activity would be boring and fail to inspire.\n\nParticle’s developers knew the complexity that video brings to web apps and the requirements for success. We were able to help the whole project team understand what would and would not work and kept the project on track. In the end, the video activity we developed struck the perfect balance between creativity and functionality.'
    }
  }]
};

/***/ }),

/***/ "4I25":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var title = 'It looks like this page doesn&rsquo;t exist.';

var body = 'But you can:\n\n* Learn more [about us](/about).\n* Read about how we helped [Land Rover Jaguar reduce range anxiety](/work/jlr-electric-vehicle).\n* Go ahead and [contact us](/contact#contact-us-form).';

exports.default = { body: body, title: title };

/***/ }),

/***/ "4IzA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4OCw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _imageUtils = __webpack_require__("Rn8A");

var _WorkMixin = __webpack_require__("OytB");

var _WorkMixin2 = _interopRequireDefault(_WorkMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
exports.default = {

  props: ['data'],

  mixins: [_WorkMixin2.default],

  data: function data() {
    return {
      thumbContentWidth: 0
    };
  },


  computed: {
    isMobile: function isMobile() {
      return this.$store.getters.isMobile;
    },
    person: function person() {
      var byline = this.data.byline;

      return this.$store.getters.getPersonInfo(byline);
    },
    thumbStyles: function thumbStyles() {
      var person = this.person,
          tWidth = this.thumbContentWidth;

      var thumbSrc = person ? person.thumbSrc : null;

      var rUrl = thumbSrc ? (0, _imageUtils.getResponsiveUrl)(thumbSrc, tWidth) : '/static/content/uploads/thumb-person.png';

      var styles = {
        backgroundImage: 'url(' + rUrl + ')'
      };

      return styles;
    },
    byline: function byline() {
      var person = this.person,
          isMobile = this.isMobile;

      var byline = '';
      if (person) {
        var parts = [person.title, person.position];
        byline = isMobile ? parts.join('<br />') : parts.join(', ');
      }
      return byline;
    }
  },

  methods: {
    measureLayout: function measureLayout() {
      this.thumbContentWidth = this.getThumbContentWidth();
    },
    getThumbContentWidth: function getThumbContentWidth() {
      var el = this.$refs.thumbnailImage;
      return el ? el.clientWidth : 0;
    }
  },

  watch: {
    currentWidth: function currentWidth() /* newVal, oldVal */{
      var _this = this;

      _vue2.default.nextTick(function () {
        _this.measureLayout();
      });
    }
  },

  mounted: function mounted() {
    this.measureLayout();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Libs

/***/ }),

/***/ "4Pz3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'module_intro',
  props: ['data']
};

/***/ }),

/***/ "4fNz":
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),

/***/ "4fQy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blockquote_vue__ = __webpack_require__("hzqc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blockquote_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blockquote_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blockquote_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blockquote_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c24cce72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blockquote_vue__ = __webpack_require__("C7nA");
function injectStyle (ssrContext) {
  __webpack_require__("wK4Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blockquote_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c24cce72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blockquote_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4mIv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkArticlesTablet_vue__ = __webpack_require__("BQpB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkArticlesTablet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkArticlesTablet_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkArticlesTablet_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkArticlesTablet_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61fc0124_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkArticlesTablet_vue__ = __webpack_require__("/Jh2");
function injectStyle (ssrContext) {
  __webpack_require__("nwZe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61fc0124"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkArticlesTablet_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61fc0124_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkArticlesTablet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4xQX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hero.411f1bd.jpg";

/***/ }),

/***/ "5/DG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/vh1_white.fc999e7.svg";

/***/ }),

/***/ "5/Qg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "515s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "55bw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatterMain_vue__ = __webpack_require__("AfxY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatterMain_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatterMain_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatterMain_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatterMain_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d5e7144_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MatterMain_vue__ = __webpack_require__("5Yqo");
function injectStyle (ssrContext) {
  __webpack_require__("WaSW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatterMain_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d5e7144_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MatterMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "57Yo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MouseEventContainer = __webpack_require__("eJwU");

var _MouseEventContainer2 = _interopRequireDefault(_MouseEventContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

  name: 'component_contentStack',

  components: { MouseEventContainer: _MouseEventContainer2.default },

  props: ['data']

}; //
//
//
//
//
//
//
//
//
//

// Components

/***/ }),

/***/ "57xY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactHeader_vue__ = __webpack_require__("YpG3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactHeader_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactHeader_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactHeader_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02430583_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactHeader_vue__ = __webpack_require__("Epfa");
function injectStyle (ssrContext) {
  __webpack_require__("R016")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02430583"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactHeader_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02430583_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "584i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Ttu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"work-two-column-text"}},[_c('div',{staticClass:"module-layout"},[(_vm.hasContentLeft)?_c('div',{staticClass:"content-left",class:_vm.contentContainerClasses},[_c('markdown',{staticClass:"markdown"},[_vm._v(_vm._s(_vm.data.contentLeft))])],1):_vm._e(),_vm._v(" "),(_vm.hasContentRight)?_c('div',{staticClass:"content-right",class:_vm.contentContainerClasses},[_c('markdown',{staticClass:"markdown"},[_vm._v(_vm._s(_vm.data.contentRight))])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5XeE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hero-video-poster.267760b.jpg";

/***/ }),

/***/ "5Yqo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('defaultLayout',{attrs:{"data":_vm.data,"page":_vm.page,"section":"matter"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('div',{staticClass:"matter-container"},[_c('matter-header'),_vm._v(" "),_c('featured-article',{attrs:{"article":_vm.featuredArticleData}}),_vm._v(" "),_c('matter-articles',{attrs:{"articles":_vm.articlesData}})],1)]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5Z09":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5qPY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5qSk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"no-hover",attrs:{"to":{ name: _vm.hrefInfo.name, params: _vm.hrefInfo.params }}},[_c('div',{staticClass:"featured-article"},[_c('div',{staticClass:"featured-article__image",style:(_vm.imageStyles)}),_vm._v(" "),_c('div',{ref:"articleHeader",staticClass:"featured-article__header"},[(_vm.article.category)?_c('span',{staticClass:"featured-article__category category"},[_vm._v("\n        "+_vm._s(_vm.article.category)+"\n      ")]):_vm._e(),_vm._v(" "),_c('h2',{staticClass:"featured-article__title title"},[_vm._v(_vm._s(_vm.article.title))])]),_vm._v(" "),_c('div',{ref:"articleInfo",staticClass:"featured-article__info"},[_c('p',{staticClass:"featured-article__standfirst standfirst"},[_vm._v(_vm._s(_vm.article.standfirst))]),_vm._v(" "),_c('link-with-button-below',{attrs:{"data":{
          text: 'Read More',
          href: _vm.hrefInfo
        }}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "67B1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6FWq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c83d5d0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/matter/MatterHeader.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"matter-header"},[_c('div',{staticClass:"hero-image"}),_vm._v(" "),_c('div',{staticClass:"content__heading"},[_c('div',{staticClass:"title"}),_vm._v(" "),_c('h2',{},[_vm._v("Thoughts & Things")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var MatterHeader = (esExports);
// CONCATENATED MODULE: ./src/components/matter/MatterHeader.vue
function injectStyle (ssrContext) {
  __webpack_require__("4IzA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  MatterHeader,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var matter_MatterHeader = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6XCz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6hQY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clients = __webpack_require__("fL60");

var _clients2 = _interopRequireDefault(_clients);

var _dreamworks = __webpack_require__("9/KV");

var _dreamworks2 = _interopRequireDefault(_dreamworks);

var _hpWearable = __webpack_require__("HrIc");

var _hpWearable2 = _interopRequireDefault(_hpWearable);

var _landRover = __webpack_require__("aPwj");

var _landRover2 = _interopRequireDefault(_landRover);

var _virtualLessonPlan = __webpack_require__("tTgq");

var _virtualLessonPlan2 = _interopRequireDefault(_virtualLessonPlan);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  layout: 'default',
  blocks: [{
    module: 'hero',
    stretch: true,
    ornament: true,
    overlay: true,
    headline: "We are a product design agency for global brands.",
    background: {
      type: 'video',
      src: __webpack_require__("Hn6a"),
      poster: __webpack_require__("5XeE")
    }
  }, {
    module: 'featuredItems',
    id: 'homepageFeaturedWork',
    title: 'Our Work.',
    byline: null,
    itemType: 'work',
    items: [_landRover2.default.slug, _dreamworks2.default.slug, _hpWearable2.default.slug, _virtualLessonPlan2.default.slug]
    // outlink: {
    //   copy: "View more work",
    //   href: "/work",
    // },
  }, {
    module: 'row',
    singleton: true,
    columns: [{
      grid: {
        start: 1,
        end: 5
      },
      component: 'bigHeading',
      heading: 'Our method is our difference.'
    }, {
      grid: {
        start: 7,
        end: 12
      },
      component: 'contentStack',
      stack: [{
        type: 'markdown',
        content: 'Particle Design is a user experience design agency for future-forward brands. We work with our clients to design experiences that solve complex problems.',
        href: {
          name: 'L2',
          params: {
            slug: 'about'
          }
        }
      }, {
        type: 'linkWithButtonBelow',
        text: 'Read more about Particle',
        href: {
          name: 'L2',
          params: {
            slug: 'about'
          }
        }
      }]
    }]
  }, {
    module: 'row',
    singleton: true,
    styles: {
      gridGap: 0
    },
    id: 'homepage__image-row',
    columns: [{
      grid: {
        start: 1,
        end: 3
      },
      component: 'image',
      src: __webpack_require__("LUn9"),
      alt: 'geometric representation of a polyhedron with triangle faces'
    }, {
      grid: {
        start: 4,
        end: 6
      },
      component: 'image',
      src: __webpack_require__("BW/C"),
      alt: 'geometric representation of a polyhedron with triangle faces'
    }, {
      grid: {
        start: 7,
        end: 9
      },
      component: 'image',
      src: __webpack_require__("zNrC"),
      alt: 'geometric representation of a polyhedron with triangle faces'
    }, {
      grid: {
        start: 10,
        end: 12
      },
      component: 'image',
      src: __webpack_require__("idZ9"),
      alt: 'geometric representation of a polyhedron with triangle faces'
    }]
  }, {
    module: 'partners',
    clients: [_clients2.default.dreamworks, _clients2.default.vh1, _clients2.default.hp, _clients2.default.moovel, _clients2.default.jaguar, _clients2.default.landrover, _clients2.default.samsung, _clients2.default.regence, _clients2.default.outcome, _clients2.default.skyryse, _clients2.default.gm, _clients2.default.mentorSiemens]
  }]
};

/***/ }),

/***/ "75l9":
/***/ (function(module, exports) {

module.exports = {"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}

/***/ }),

/***/ "7Xh6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tileContent",staticClass:"category-page-tile"},[_c('router-link',{directives:[{name:"touch",rawName:"v-touch",value:(_vm.touchHandler),expression:"touchHandler"}],attrs:{"to":_vm.routerLinkTo}},[_c('div',{staticClass:"info-container",class:_vm.containerClasses},[_c('div',{staticClass:"background"}),_vm._v(" "),_c('div',{staticClass:"info-content"},[_c('div',{staticClass:"subhead"},[_vm._v("\n          our work and thoughts on:\n        ")]),_vm._v(" "),_c('div',{ref:"headlineContent",staticClass:"headline"},[_vm._v("\n         "+_vm._s(_vm.record.headline)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"ornament"}),_vm._v(" "),_c('div',{staticClass:"arrow"}),_vm._v(" "),_c('div',{staticClass:"corner upper-left"}),_vm._v(" "),_c('div',{staticClass:"corner lower-right"})])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7YIY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7fyb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.componentClasses,on:{"mouseover":_vm.onMouseOver,"mouseout":_vm.onMouseOut}},[_vm._t("default",null,{"isMouseOver":_vm.isMouseOver})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7v22":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/eye2eye_tall.59d7c18.svg";

/***/ }),

/***/ "83VV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article-tile"},[_c('router-link',{directives:[{name:"touch",rawName:"v-touch",value:(_vm.touchHandler),expression:"touchHandler"}],attrs:{"to":_vm.routerLinkTo}},[_c('div',{ref:"tileBgImage",staticClass:"background-image",style:(_vm.bgImageStyles),attrs:{"data-orientation":_vm.imageAspect}}),_vm._v(" "),_c('div',{staticClass:"tile-info"},[_c('div',{staticClass:"info-logo"},[_c('img',{staticClass:"logo-img",attrs:{"src":_vm.clientLogoSrc}})]),_vm._v(" "),_c('div',{ref:"infoTitle",staticClass:"info-title",style:(_vm.infoTitleStyles)},[_vm._v("\n        "+_vm._s(_vm.record.headline)+"\n      ")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "84Sb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Axk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Module expects:
//  - `headline`: text string
//  - `background`: media element (acceptable formats: video, image, color)
exports.default = {
  name: 'module_hero',
  props: ['data', 'window'],
  computed: {
    style: function style() {
      if (this.data.background.type === 'image') {
        var background = void 0;
        var window = this.window;

        if (this.data.backgroundSet) {
          background = this.data.backgroundSet.find(function (bg) {
            return window.width < bg.max;
          });
        }
        if (background) {
          background = background.src;
        } else {
          background = this.data.background.image;
        }

        return {
          'background-image': 'url(\'' + background + '\')'
        };
        // const background = [];
        // if (this.data.overlay) {
        //   const overlay = this.data.overlay;
        //   // set a default overlay:
        //   if (typeof overlay === 'boolean') {
        //     background.push(`linear-gradient(to bottom, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.4) 100%)`);
        //   }

        //   // TODO: lol let user decide
        // }
        // background.push(`url('${this.data.background.image}')`);

        // return {
        //   'background-image': background.join(),
        // };
      }

      return false;
    }
  }
};

/***/ }),

/***/ "8Lcf":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "8Sbb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"category-page-header"}},[_c('div',{staticClass:"color-block",style:(_vm.colorBlockStyles)}),_vm._v(" "),_c('div',{staticClass:"component-layout"},[_c('h1',[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('p',{ref:"burnerText"},[_vm._v(_vm._s(_vm.data.burner))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8ioz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"relatedWorks"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._l((_vm.works),function(work){return [_c('div',{key:work.slug,staticClass:"related-work"},[_c('h3',{attrs:{"data-type":"article-heading"}},[_vm._v("\n          "+_vm._s(work.blurb.headline)+"\n        ")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'L3', params: { slug: work.slug, itemType: 'work' } }}},[_vm._v("\n          "+_vm._s(work.blurb.byline)+"\n        ")])],1)]})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading"},[_c('h2',{attrs:{"data-type":"default"}},[_vm._v("\n      More Work\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9/KV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clients = __webpack_require__("fL60");

var _clients2 = _interopRequireDefault(_clients);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  slug: 'dreamworks-kids-gaming',
  company: _clients2.default.dreamworks.name,
  logo: _clients2.default.dreamworks.logo,
  logoWhite: _clients2.default.dreamworks.logoWhite,
  blurb: {
    headline: "Designing a digital storytelling adventure.",
    tags: [],
    byline: 'Learn more about our work with Dreamworks',
    background: __webpack_require__("1VJu"),
    backgroundSet: [{
      max: 1024,
      src: __webpack_require__("3ljX")
    }]
  },
  blocks: [{
    module: 'hero',
    background: {
      image: __webpack_require__("T+rh"),
      type: 'image'
    },
    backgroundSet: [{
      max: 1024,
      src: __webpack_require__("pUUz")
    }],
    constrain: true
  }, {
    module: 'intro',
    title: 'Where kids become the directors of their own movies.',
    content: 'DreamWorks has developed an entire website aimed at inspiring kids to express their creativity (http://create.dreamworks.com/). The site is filled with options for fashioning crafts and paper toys, bringing DreamWorks characters to life through augmented reality, making scrapbooks, learning art techniques, and more.\n\nWhen DreamWorks got in touch with Particle Design, they were looking to add a video and storytelling element to the site. They wanted an activity that would empower kids to feel like they were directing their own movies. They envisioned kids choosing characters, making storyline decisions, and writing the simple scripts that would drive the narrative. They also wanted the final video each child created to convert immediately into a black-and-white comic book that kids could print and color.',
    roles: ['UX Strategy', 'Interaction Design', 'Visual Design', ' Front-End Development', 'Back-End Development']
  }, {
    module: 'text_image_row',
    images: [{
      src: __webpack_require__("913A"),
      height: '363px',
      gravity: 'center bottom',
      primary: true
    }, {
      src: __webpack_require__("HaPn"),
      height: '252px',
      gravity: 'center bottom'
    }, {
      src: __webpack_require__("065w"),
      height: '490px',
      gravity: 'center top'
    }],
    content: '## When a constraint inspires an engaging and functional platform.\n\nDreamWorks wanted to give kids a great storytelling experience as directors of their own movie scenes. Particle was keen to bring their idea to life but quickly identified the project’s central challenge. The objective was to give children the freedom to create their own stories and have an output when finished. But if there were too many options, the rendering process would take so long kids would give up before the final video could be created. On the other hand, if there weren’t enough options, the activity would be boring and fail to inspire.\n\nParticle’s developers knew the complexity that video brings to web apps and the requirements for success. We were able to help the whole project team understand what would and would not work and kept the project on track. In the end, the video activity we developed struck the perfect balance between creativity and functionality.'
  }, {
    module: 'row',
    styles: {
      alignItems: 'center'
    },
    columns: [{
      grid: {
        start: 2,
        end: 7
      },
      component: 'markdown',
      content: '## Designing a complex and interactive app that meets unique design restrictions.\n\nFor this DreamWorks project, Particle had limited time—less than 60 days—and a tight budget. There were also complex restrictions and guidelines about how DreamWorks characters could be used in the experience in order to maintain brand authenticity.\n\nAnd most significantly, since the site was for young children, it was critical that the content maintained compliance with COPPA (Children’s Online Privacy Protection Act), under U.S. federal law. COPPA’s primary goal is to place parents in control of the information collected from their children online. As such, it imposes regulations on websites focused on children under 13. Its requirements are stringent, and Particle’s team had to ensure there was no deviation as design decisions were made throughout the project.'
    }, {
      grid: {
        start: 9,
        end: 12
      },
      component: 'blockquote',
      quote: 'Building an experience that allows kids to take an active role in creating the content they consume every day was an exciting opportunity.',
      sourceName: 'Stacey Rutland',
      sourceInfo: 'Particle, Project Lead'
    }]
  }, {
    module: 'row',
    columns: [{
      grid: {
        start: 1,
        end: 12
      },
      component: 'image',
      src: __webpack_require__("ZeKW"),
      srcSet: [{
        max: 375,
        src: __webpack_require__("iaoP")
      }],
      alt: 'Image of Toothless from Dreamworks\' "How to Train Your Dragon"'
    }]
  }, {
    module: 'relatedWorks',
    works: ['land-rover', 'hp-wearable']
  }]
};

/***/ }),

/***/ "913A":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.1ae68d9.jpg";

/***/ }),

/***/ "9t57":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mouse-event-container',[_c('div',{attrs:{"data-component":"contentStack"}},_vm._l((_vm.data.stack),function(piece,i){return _c('div',{key:i,staticClass:"stack-item"},[_c(("component_" + (piece.type)),{key:piece.type,tag:"component",attrs:{"data":piece}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9usk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _work = __webpack_require__("s6ON");

var _work2 = _interopRequireDefault(_work);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'module_relatedWorks',
  props: ['data'],
  computed: {
    works: function works() {
      var works = [];
      this.data.works.forEach(function (work) {
        works.push(_work2.default[work]);
      });

      return works;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "9zH2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9zel":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleHeader_vue__ = __webpack_require__("GVZ3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleHeader_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleHeader_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleHeader_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f4e2c0d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticleHeader_vue__ = __webpack_require__("S+Y7");
function injectStyle (ssrContext) {
  __webpack_require__("0FAZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f4e2c0d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleHeader_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f4e2c0d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticleHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "A11U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Component data property:
{
  text: 'Read More',  // <string>
  href: {
    name: 'matter-article', // name of route <string>
    params: {
      slug: 'article-slug', // <string>
    }
  }
*/

exports.default = {

  props: ['data'],

  computed: {
    isDesktop: function isDesktop() {
      return this.$store.getters.isDesktop;
    },
    showOrnament: function showOrnament() {
      return this.isDesktop;
    }
  }

};

/***/ }),

/***/ "A3y+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AIFD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ALFy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentStaticTile_vue__ = __webpack_require__("Zc4S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentStaticTile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentStaticTile_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentStaticTile_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentStaticTile_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11cda19a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentStaticTile_vue__ = __webpack_require__("83VV");
function injectStyle (ssrContext) {
  __webpack_require__("kis0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11cda19a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentStaticTile_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11cda19a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentStaticTile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AWz0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AarE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _linkWithButtonBelow = __webpack_require__("SDfB");

var _linkWithButtonBelow2 = _interopRequireDefault(_linkWithButtonBelow);

var _bus = __webpack_require__("EJZp");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
exports.default = {

  components: {
    LinkWithButtonBelow: _linkWithButtonBelow2.default
  },

  props: ['article'],

  data: function data() {
    return {
      headerHeight: 0,
      infoHeight: 0
    };
  },


  computed: {
    hrefInfo: function hrefInfo() {
      return {
        name: 'matter-article',
        params: {
          slug: this.article.slug
        }
      };
    },
    isDesktop: function isDesktop() {
      return this.$store.getters.isDesktop;
    },
    currentWidth: function currentWidth() {
      return this.$store.state.width;
    },
    imageStyles: function imageStyles() {
      var styles = {
        backgroundImage: 'url(' + this.article.image.imageSrc + ')'
      };
      if (this.isDesktop) {
        styles.height = this.headerHeight + this.infoHeight + 37 + 'px';
      }
      return styles;
    }
  },

  methods: {
    updateHeaderClientHeight: function updateHeaderClientHeight() {
      var el = this.$refs.articleHeader;
      this.headerHeight = el ? el.clientHeight : 0;
    },
    updateInfoClientHeight: function updateInfoClientHeight() {
      var el = this.$refs.articleInfo;
      this.infoHeight = el ? el.clientHeight : 0;
    },
    measureLayout: function measureLayout() {
      this.updateHeaderClientHeight();
      this.updateInfoClientHeight();
    }
  },

  watch: {
    currentDevice: function currentDevice() /* newVal, oldVal */{
      var _this = this;

      _vue2.default.nextTick(function () {
        _this.measureLayout();
      });
    },
    currentWidth: function currentWidth() /* newVal, oldVal */{
      var _this2 = this;

      _vue2.default.nextTick(function () {
        _this2.measureLayout();
      });
    }
  },

  mounted: function mounted() {
    _bus.Bus.$emit('rendered-article');
    this.measureLayout();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Libs

/***/ }),

/***/ "Abrb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_image_row_vue__ = __webpack_require__("0STu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_image_row_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_image_row_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_image_row_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_image_row_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_128e8159_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_text_image_row_vue__ = __webpack_require__("Of3d");
function injectStyle (ssrContext) {
  __webpack_require__("krgZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_image_row_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_128e8159_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_text_image_row_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AfxY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _default = __webpack_require__("lfHO");

var _default2 = _interopRequireDefault(_default);

var _FeaturedArticle = __webpack_require__("rM9G");

var _FeaturedArticle2 = _interopRequireDefault(_FeaturedArticle);

var _MatterArticles = __webpack_require__("Jn7d");

var _MatterArticles2 = _interopRequireDefault(_MatterArticles);

var _MatterHeader = __webpack_require__("6FWq");

var _MatterHeader2 = _interopRequireDefault(_MatterHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {

  name: 'MatterMain',

  metaInfo: {
    title: 'Matter - Particle Design'
  },

  props: ['data', 'page'],

  components: { defaultLayout: _default2.default, FeaturedArticle: _FeaturedArticle2.default, MatterArticles: _MatterArticles2.default, MatterHeader: _MatterHeader2.default },

  computed: {
    featuredArticleData: function featuredArticleData() {
      return this.data.featured[0] || {};
    },
    articlesData: function articlesData() {
      return this.data.articles || [];
    }
  }
};

/***/ }),

/***/ "AqYs":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Az3z":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mentor-siemens.e147d6f.svg";

/***/ }),

/***/ "BErO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BQpB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _ContentRevealTile = __webpack_require__("GZoJ");

var _ContentRevealTile2 = _interopRequireDefault(_ContentRevealTile);

var _CategoryPageTile = __webpack_require__("XDdv");

var _CategoryPageTile2 = _interopRequireDefault(_CategoryPageTile);

var _ContentStaticMatterTile = __webpack_require__("PMnj");

var _ContentStaticMatterTile2 = _interopRequireDefault(_ContentStaticMatterTile);

var _ContentStaticTile = __webpack_require__("ALFy");

var _ContentStaticTile2 = _interopRequireDefault(_ContentStaticTile);

var _dataUtils = __webpack_require__("uhrr");

var _appConstants = __webpack_require__("y3R9");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants & Utils


// Components
exports.default = {

  props: {
    articles: Array
  },

  components: {
    CategoryPageTile: _CategoryPageTile2.default,
    RevealWorkTile: _ContentRevealTile2.default,
    StaticMatterTile: _ContentStaticMatterTile2.default,
    StaticWorkTile: _ContentStaticTile2.default
  },

  data: function data() {
    return {

      // constants for layout
      colCount: 12,
      gapWidth: 26,

      // track dimensions of main tile container
      mainWidth: 0,
      mainHeight: 0,

      // track occupied height of columns
      col1Height: 0,
      col2Height: 0,
      col3Height: 0,

      // offset for each tile, if it's needed
      yDimOffset: []

    };
  },


  computed: {
    currentBrowserWidth: function currentBrowserWidth() {
      return this.$store.state.width;
    },
    isDesktop: function isDesktop() {
      return this.$store.getters.isDesktop;
    },
    isTablet: function isTablet() {
      return this.$store.getters.isTablet;
    },
    singleColumnWidth: function singleColumnWidth() {
      var col1Start = this.col1Start,
          col4End = this.col4End;

      var value = col4End - col1Start;

      // initial values are < 0, so clean up
      return Math.max(0, value);
    },


    /*
      calculate grid column width
      using current browser width & gap
    */
    colWidth: function colWidth() {
      var colCount = this.colCount,
          gapWidth = this.gapWidth,
          mainWidth = this.mainWidth;

      var totalGap = gapWidth * (colCount - 1);
      var colWidth = (mainWidth - totalGap) / colCount;
      return colWidth;
    },


    /*
      helpers for column starts & ends
    */
    col1Start: function col1Start() {
      return 0;
    },
    col4End: function col4End() {
      var col = 4;
      var colWidth = this.colWidth,
          gapWidth = this.gapWidth;

      return col * colWidth + (col - 1) * gapWidth;
    },
    col5Start: function col5Start() {
      var col = 5;
      var colWidth = this.colWidth,
          gapWidth = this.gapWidth;

      return (col - 1) * (colWidth + gapWidth);
    },
    col8End: function col8End() {
      var col = 8;
      var colWidth = this.colWidth,
          gapWidth = this.gapWidth;

      return col * colWidth + (col - 1) * gapWidth;
    },
    col9Start: function col9Start() {
      var col = 9;
      var colWidth = this.colWidth,
          gapWidth = this.gapWidth;

      return (col - 1) * (colWidth + gapWidth);
    },
    col12End: function col12End() {
      var col = 12;
      var colWidth = this.colWidth,
          gapWidth = this.gapWidth;

      return col * colWidth + (col - 1) * gapWidth;
    },


    /*
      processing incoming work records
      {
        style: {
          top
          left
          width
          height
        }
        data: <tile data>
        height: <number>
        width: <number>
      }
    */
    tileRecords: function tileRecords() {
      var _this = this;

      var articles = this.articles,
          isDesktop = this.isDesktop;

      this.resetTileLayoutVars();

      var recs = articles.map(function (record, idx) {
        var colSpan = record.colSpan;

        var tileAdjust = _this.getTileHeightAdjustment(idx);
        var style = _this.calcTileContainerStyles({ record: record, tileAdjust: tileAdjust });
        var height = style.height - tileAdjust;
        var width = style.width;

        // Tile Record

        return {
          data: record,
          style: (0, _dataUtils.objPropsToPixels)(style),

          // sent to tile
          height: height,
          width: width,
          colSpan: colSpan
        };
      });

      // after layout calcs, find bounding container height
      this.mainHeight = this.calcMainContainerHeight();

      if (isDesktop) {
        // see if children need some more room
        this.requestChildUpdate();
      }

      return recs;
    },
    mainContainerStyles: function mainContainerStyles() {
      var mainHeight = this.mainHeight;

      return {
        height: mainHeight + 'px'
      };
    },
    bgStyles: function bgStyles() {
      var currentBrowserWidth = this.currentBrowserWidth;

      // calculate width

      var offset = 0;
      if (currentBrowserWidth > _appConstants.MaxBrowserWidth) {
        offset = (currentBrowserWidth - _appConstants.MaxBrowserWidth) * 0.5;
      }
      var style = {
        marginLeft: '-' + offset + 'px'
      };
      return style;
    }
  },

  methods: {

    /*
      lookup child's required height adjustment
    */
    getTileHeightAdjustment: function getTileHeightAdjustment(idx) {
      var isDesktop = this.isDesktop,
          yDimOffset = this.yDimOffset;

      if (isDesktop) {
        return yDimOffset[idx] || 0;
      }
      return 0;
    },


    /*
      calculate the height of a tile
      based on responsive value & aspect ratio
    */
    calcSingleTileHeight: function calcSingleTileHeight(props) {
      var aspect = props.aspect,
          colSpan = props.colSpan;
      var desktop = _appConstants.CategoryTileDims.desktop;

      var sCW = this.singleColumnWidth;
      var ar169 = _appConstants.AspectRatios['16:9'];
      var ar43 = _appConstants.AspectRatios['4:3'];
      var ar34 = _appConstants.AspectRatios['3:4'];
      var ar916 = _appConstants.AspectRatios['9:16'];
      var ar72 = _appConstants.AspectRatios['7:2'];

      // tablet or desktop 2-col
      if (this.isTablet) {
        return sCW; // square
      } else if (colSpan === 2 && aspect === 'category-tile') {
        return (2 * sCW + desktop.gridGap) / ar72; // two-col item
      } else if (colSpan === 2) {
        return 2 * sCW / ar169; // two-col item, 16:9
      }

      // desktop other aspects
      switch (aspect) {
        case 'landscape':
          return sCW / ar169;
        case 'small':
          return sCW / ar43;
        case 'medium':
          return sCW / ar34;
        case 'portrait':
        case 'tall':
          return sCW / ar916;
        case 'square':
        default:
          return sCW; // square
      }
    },
    resetTileLayoutVars: function resetTileLayoutVars() {
      this.col1Height = 0;
      this.col2Height = 0;
      this.col3Height = 0;
    },
    calcMainContainerHeight: function calcMainContainerHeight() {
      var col1Height = this.col1Height,
          col2Height = this.col2Height,
          col3Height = this.col3Height;
      // padding matches CSS declaration

      var padding = 20;
      return Math.max(col1Height, col2Height, col3Height) + padding * 2;
    },


    /*
      lookup a tile's artistic margin
    */
    getTileTopMargin: function getTileTopMargin(record) {
      var tileOffset = record.tileOffset;
      var isTablet = this.isTablet;


      if (isTablet) {
        return 0;
      }
      return _appConstants.WorkImageOffsets[tileOffset] || 0;
    },


    /*
      return container styles
    */
    calcTileContainerStyles: function calcTileContainerStyles(props) {
      var record = props.record,
          tileAdjust = props.tileAdjust;
      var colSpan = record.colSpan,
          image = record.image;

      var aspect = image.aspect || _appConstants.DefaultAspectRatio;

      var _calcTileBasicDimensi = this.calcTileBasicDimensions({ colSpan: colSpan, aspect: aspect }),
          width = _calcTileBasicDimensi.width,
          height = _calcTileBasicDimensi.height;

      var tileHeight = height + tileAdjust;
      var tileMargin = this.getTileTopMargin(record);

      var config = {
        colSpan: colSpan,
        tileMargin: tileMargin,
        tileHeight: tileHeight
      };

      var _calcTileContainerPla = this.calcTileContainerPlacement(config),
          top = _calcTileContainerPla.top,
          left = _calcTileContainerPla.left;

      return {
        top: top,
        left: left,
        height: tileHeight,
        width: width
      };
    },
    calcTileBasicDimensions: function calcTileBasicDimensions(props) {
      var colSpan = props.colSpan,
          aspect = props.aspect;
      var col1Start = this.col1Start,
          col4End = this.col4End,
          col8End = this.col8End;

      var width = void 0;
      var height = void 0;

      var config = {
        aspect: aspect,
        colSpan: colSpan
      };
      switch (colSpan) {
        case 2:
          width = col8End - col1Start;
          height = this.calcSingleTileHeight(config);
          break;
        case 1:
        default:
          width = col4End - col1Start;
          height = this.calcSingleTileHeight(config);
      }
      return { width: width, height: height };
    },
    calcTileContainerPlacement: function calcTileContainerPlacement(config) {
      var colSpan = config.colSpan;

      if (colSpan === 1) {
        return this.calc1ColTilePlacement(config);
      }
      return this.calc2ColTilePlacement(config);
    },
    calc1ColTilePlacement: function calc1ColTilePlacement(config) {
      var col1Start = this.col1Start,
          col5Start = this.col5Start,
          col9Start = this.col9Start,
          gapWidth = this.gapWidth;
      var col1Height = this.col1Height,
          col2Height = this.col2Height,
          col3Height = this.col3Height;

      var top = void 0;
      var left = void 0;

      var tileMargin = config.tileMargin,
          tileHeight = config.tileHeight;

      // figure out column with best-fit

      var arr = [{ key: 'col-1', val: col1Height }, { key: 'col-2', val: col2Height }, { key: 'col-3', val: col3Height }];
      arr.sort(function (a, b) {
        return a.val - b.val;
      });
      var bestColKey = arr[0].key;


      switch (bestColKey) {
        case 'col-1':
          if (col1Height !== 0) {
            col1Height += gapWidth;
          }
          col1Height += tileMargin;

          top = col1Height;
          left = col1Start;
          col1Height += tileHeight;
          this.col1Height = col1Height;
          break;
        case 'col-2':
          if (col2Height !== 0) {
            col2Height += gapWidth;
          }
          col2Height += tileMargin;

          top = col2Height;
          left = col5Start;
          col2Height += tileHeight;
          this.col2Height = col2Height;
          break;
        case 'col-3':
          if (col3Height !== 0) {
            col3Height += gapWidth;
          }
          col3Height += tileMargin;

          top = col3Height;
          left = col9Start;
          col3Height += tileHeight;
          this.col3Height = col3Height;
          break;
        default:
          console.warn('calc1ColTilePlacement: Default Case');
          break;
      }

      return { top: top, left: left };
    },


    /*
      2-column tile can only be placed in Col 1 or Col 2
    */
    calc2ColTilePlacement: function calc2ColTilePlacement(config) {
      var col1Start = this.col1Start,
          col5Start = this.col5Start,
          gapWidth = this.gapWidth;
      var col1Height = this.col1Height,
          col2Height = this.col2Height,
          col3Height = this.col3Height;

      var top = void 0;
      var left = void 0;

      var tileMargin = config.tileMargin,
          tileHeight = config.tileHeight;

      // figure out column with best-fit

      var Col12Max = Math.max(col1Height, col2Height);
      var Col23Max = Math.max(col2Height, col3Height);
      // calculate trapped whitespace
      var trap12 = Math.max(Col12Max - col1Height, Col12Max - col2Height);
      var trap23 = Math.max(Col23Max - col2Height, Col23Max - col3Height);
      var bestColKey = trap12 <= trap23 ? 'col-12' : 'col-23';

      var tmp = void 0;
      switch (bestColKey) {
        case 'col-12':
          tmp = Col12Max;
          if (Col12Max !== 0) {
            tmp += gapWidth;
          }
          tmp += tileMargin;

          top = tmp;
          left = col1Start;
          tmp += tileHeight;
          this.col1Height = tmp;
          this.col2Height = tmp;
          break;
        case 'col-23':
          tmp = Col23Max;

          if (Col23Max !== 0) {
            tmp += gapWidth;
          }
          tmp += tileMargin;

          top = tmp;
          left = col5Start;
          tmp += tileHeight;
          this.col2Height = tmp;
          this.col3Height = tmp;
          break;
        default:
          console.warn('calc2ColTilePlacement: Default Case');
          break;
      }

      return { top: top, left: left };
    },
    calcMainContainerWidth: function calcMainContainerWidth() {
      var el = this.$refs.mainContainer;
      return el ? el.clientWidth : 0;
    },
    childUpdate: function childUpdate() {
      var isDesktop = this.isDesktop,
          yDimOffset = this.yDimOffset;

      if (!isDesktop) {
        // another safety, not on tablet/mobile tiles
        return;
      }
      var children = this.$refs.tileRefs;
      var arr = [];
      var needsReset = false;
      children.forEach(function (child, idx) {
        var value = child.calculateTileAdjustment();
        if (yDimOffset[idx] !== value) {
          needsReset = true;
        }
        arr.push(value);
      });
      if (needsReset) {
        this.yDimOffset = arr;
      }
    },
    measureLayout: function measureLayout() {
      this.mainWidth = this.calcMainContainerWidth();
    },
    requestChildUpdate: function requestChildUpdate() {
      var _this2 = this;

      _vue2.default.nextTick().then(function () {
        return _this2.childUpdate();
      });
    },
    requestMeasureLayout: function requestMeasureLayout() {
      var _this3 = this;

      _vue2.default.nextTick().then(function () {
        return _this3.measureLayout();
      });
    }
  },

  mounted: function mounted() {
    this.requestMeasureLayout();
  },


  watch: {
    mainWidth: function mainWidth() /* newVal, oldVal */{
      // handle browser resize
      this.requestMeasureLayout();
    },
    currentBrowserWidth: function currentBrowserWidth() /* newVal, oldVal */{
      this.requestMeasureLayout();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  supported aspect ratios:
  (colSpan=1)
    landscape: 16:9
    small: 4:3
    square: 1:1
    medium: 3:4
    portrait / tall: 9:16
  (colSpan=2)
    <any>: 16:9
*/
// Libs

/***/ }),

/***/ "BW/C":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lightbulb.d6e1865.png";

/***/ }),

/***/ "Bfm5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_int_hcAboutAlive_vue__ = __webpack_require__("Zw1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_int_hcAboutAlive_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_int_hcAboutAlive_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_int_hcAboutAlive_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_int_hcAboutAlive_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_573cc2bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_int_hcAboutAlive_vue__ = __webpack_require__("xOg+");
function injectStyle (ssrContext) {
  __webpack_require__("1coi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_int_hcAboutAlive_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_573cc2bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_int_hcAboutAlive_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BiQ1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _default = __webpack_require__("lfHO");

var _default2 = _interopRequireDefault(_default);

var _ArticleHeader = __webpack_require__("9zel");

var _ArticleHeader2 = _interopRequireDefault(_ArticleHeader);

var _ArticleBody = __webpack_require__("jW0R");

var _ArticleBody2 = _interopRequireDefault(_ArticleBody);

var _SocialMediaSharing = __webpack_require__("ilJb");

var _SocialMediaSharing2 = _interopRequireDefault(_SocialMediaSharing);

var _companyInfo = __webpack_require__("2Tf9");

var _imageUtils = __webpack_require__("Rn8A");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants


// Components
exports.default = {

  name: 'MatterArticle',

  metaInfo: function metaInfo() {
    return {
      title: this.articleTitle || 'Particle Design',
      meta: [{
        property: 'og:type',
        content: 'article'
      }, {
        name: 'description',
        property: 'og:description',
        content: this.articleDescription
      }, {
        name: 'image',
        property: 'og:image',
        content: this.imageUrl
      }, {
        property: 'og:site_name',
        content: this.companyName
      }, {
        name: 'title',
        property: 'og:title',
        content: this.articleTitle
      }, {
        property: 'og:url',
        content: this.href
      },

      // Twitter Specific
      {
        name: 'twitter:card',
        content: 'summary_large_image'
      }, {
        name: 'twitter:description',
        content: this.articleTitle
      }, {
        name: 'twitter:image',
        content: this.imageUrl
      }, {
        name: 'twitter:title',
        content: this.articleTitle
      }, {
        name: 'twitter:url',
        content: this.href
      }]
    };
  },


  components: {
    defaultLayout: _default2.default,
    ArticleBody: _ArticleBody2.default,
    ArticleHeader: _ArticleHeader2.default,
    SocialMediaSharing: _SocialMediaSharing2.default
  },

  props: ['href', 'origin', 'path', 'slug'],

  data: function data() {
    return {
      // this will be the json structure of the article
      data: {},
      companyName: _companyInfo.companyName
    };
  },


  computed: {
    articleTitle: function articleTitle() {
      var data = this.data;

      return data.title || 'Particle Design';
    },
    articleDescription: function articleDescription() {
      var data = this.data;

      return data.standfirst || '';
    },
    featuredImage: function featuredImage() {
      var data = this.data;

      return data.featuredImage;
    },
    hasFeaturedImage: function hasFeaturedImage() {
      var featuredImage = this.featuredImage;

      return featuredImage !== undefined;
    },
    imageUrl: function imageUrl() {
      var hasFeaturedImage = this.hasFeaturedImage,
          featuredImage = this.featuredImage,
          origin = this.origin;


      var result = '';
      if (hasFeaturedImage) {
        var src = featuredImage.imageSrc;

        var rUrl = (0, _imageUtils.getResponsiveUrl)(src, 1200);
        result = [origin, rUrl].join('');
      }
      return result;
    }
  },

  created: function created() {
    var _this = this;

    var url = '/static/content/matter/' + this.slug + '.json';
    (0, _axios2.default)({ method: 'get', url: url }).then(function (response) {
      var status = response.status,
          data = response.data;

      if (status === 200) {
        _this.data = data;
      } else {
        // do something
      }
    }).catch(function (e) {
      // TODO: send out error somewhere
      // until then...
      /* eslint-disable no-console */
      console.error('ERROR retrieving \'' + url + '\'');
      console.error(e);
    });
  }
};

// Utils
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Libs

/***/ }),

/***/ "Brp9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BsxF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _companyInfo = __webpack_require__("2Tf9");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Libs
function encode(data) {
  return (0, _keys2.default)(data).map(function (key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
  }).join('&');
}

// Module expects:


// Constants / Data
exports.default = {

  name: 'contact-form',

  props: ['data'],

  data: function data() {
    return {
      name: null,
      company: null,
      email: null,
      message: null,
      submitting: false,
      formStatus: 'default',
      contactEmail: _companyInfo.email
    };
  },


  methods: {
    hasInput: function hasInput(el) {
      if (el && el.trim().length > 0) {
        return true;
      }
      return false;
    },
    packageFormData: function packageFormData() {
      return {
        name: this.name,
        company: this.company,
        email: this.email,
        message: this.message
      };
    },
    handleOkResponse: function handleOkResponse(response) {
      switch (response.status) {
        case 200:
          // show a way cool notification
          this.formStatus = 'success';
          break;
        default:
          // show a cool, but not as cool notification here
          // console.log('shrug emoticon');
          this.formStatus = 'error';
          this.submitting = false;
          break;
      }
    },
    handleErrorResponse: function handleErrorResponse(err) {
      // handle some errors here
      switch (err) {
        default:
          this.formStatus = 'error';
          break;
      }
    },
    submitForm: function submitForm() {
      var _this = this;

      // stop double submit
      this.submitting = true;

      var url = '' + window.location.origin;
      var formData = this.packageFormData();
      var data = encode((0, _extends3.default)({
        'form-name': 'contact' }, formData));
      (0, _axios2.default)({
        url: url,
        method: 'post',
        data: data,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        return _this.handleOkResponse(response);
      }).catch(function (err) {
        return _this.handleErrorResponse(err);
      });
    }
  }
};

/***/ }),

/***/ "BzuX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactUsForm_vue__ = __webpack_require__("BsxF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactUsForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactUsForm_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactUsForm_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactUsForm_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1497218f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactUsForm_vue__ = __webpack_require__("h40S");
function injectStyle (ssrContext) {
  __webpack_require__("+R6s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1497218f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactUsForm_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1497218f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactUsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "C27M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"matter-article-body"}},[_c('div',{staticClass:"module-layout"},[_c('div',{staticClass:"article__body"},[_c('h1',{staticClass:"article__title"},[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('div',{staticClass:"article__meta"},[_c('div',{ref:"thumbnailImage",staticClass:"thumbnail",style:(_vm.thumbStyles)}),_vm._v(" "),_c('div',[(_vm.isMobile)?[_c('div',{staticClass:"byline",domProps:{"innerHTML":_vm._s(_vm.byline)}}),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.data.date)))])]:[_c('div',{staticClass:"byline",domProps:{"innerHTML":_vm._s(_vm.byline)}}),_vm._v(" "),_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.data.date)))])]],2)]),_vm._v(" "),_c('markdown',{staticClass:"markdown",attrs:{"source":_vm.data.body}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C65D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"particle-hiring"}},[_c('div',{staticClass:"module-layout"},[_c('div',{staticClass:"headline"},[_c('div',{attrs:{"data-ornament":"rectangle"}}),_vm._v(" "),_c('h2',{domProps:{"innerHTML":_vm._s(_vm.heading)}})]),_vm._v(" "),_c('div',{staticClass:"intro"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.teaser)}})]),_vm._v(" "),(_vm.haveJobs)?[_c('div',{staticClass:"listings"},[_c('ul',_vm._l((_vm.data.listings),function(listing){return _c('li',{key:listing.jobTitle},[_c('a',{attrs:{"href":listing.listingURL,"rel":"external","target":"_blank"}},[_vm._v("\n            "+_vm._s(listing.jobTitle)+"\n          ")]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v(_vm._s(listing.description))])])}),0)])]:[_c('div',{staticClass:"no-listings"},[_c('router-link',{staticClass:"no-hover",attrs:{"to":_vm.contactLinkInfo}},[_c('mouse-event-container',[_c('router-link',{staticClass:"link--underline",attrs:{"to":_vm.contactLinkInfo}},[_vm._v("\n            Drop us a line\n          ")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.noJobsContent)}})],1)],1)],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C7nA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"blockquote","data-modifier":_vm.data.modifier}},[_c('blockquote',[_c('div',{staticClass:"quote"},[_vm._v("\n      “"+_vm._s(_vm.data.quote)+"”\n    ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"source"},[_c('div',{staticClass:"source__name"},[_vm._v("\n        "+_vm._s(_vm.data.sourceName)+"\n      ")]),_vm._v(" "),(_vm.data.sourceInfo)?_c('div',{staticClass:"source__info"},[_vm._v("\n        "+_vm._s(_vm.data.sourceInfo)+"\n      ")]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spacers"},[_c('span',{staticClass:"spacer"}),_vm._v(" "),_c('span',{staticClass:"spacer"}),_vm._v(" "),_c('span',{staticClass:"spacer"}),_vm._v(" "),_c('span',{staticClass:"spacer"}),_vm._v(" "),_c('span',{staticClass:"spacer"}),_vm._v(" "),_c('span',{staticClass:"spacer"}),_vm._v(" "),_c('span',{staticClass:"spacer"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CEP7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _imageUtils = __webpack_require__("Rn8A");

var _responsiveMixin = __webpack_require__("Zlvm");

var _responsiveMixin2 = _interopRequireDefault(_responsiveMixin);

var _SmartAddress = __webpack_require__("i5mi");

var _SmartAddress2 = _interopRequireDefault(_SmartAddress);

var _SmartPhone = __webpack_require__("IA45");

var _SmartPhone2 = _interopRequireDefault(_SmartPhone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components


// Utils
exports.default = {

  name: 'contact-map',

  mixins: [_responsiveMixin2.default],

  components: { SmartAddress: _SmartAddress2.default, SmartPhone: _SmartPhone2.default },

  props: ['data'],

  data: function data() {
    return {
      imageContentHeight: 0,
      imageContentWidth: 0
    };
  },


  computed: {
    contentText: function contentText() {
      var content = this.data.content;

      return content;
    },
    containerClasses: function containerClasses() {
      // return class string, eg 'desktop', 'mobile.reversed'
      var deviceType = this.deviceType;

      var classes = [deviceType];
      return classes.join(' ');
    },
    imageStyles: function imageStyles() {
      var imageContentHeight = this.imageContentHeight,
          imageContentWidth = this.imageContentWidth;
      var image = this.data.image;
      var hA = image.hAlign,
          vA = image.vAlign;

      // add defaults

      var hAlign = hA || 'center';
      var vAlign = vA || 'center';

      var maxDim = Math.max(imageContentWidth, imageContentHeight);
      var rUrl = (0, _imageUtils.getResponsiveUrl)(image.src, maxDim);
      var styles = {
        backgroundImage: 'url(' + rUrl + ')',
        backgroundPosition: hAlign + ' ' + vAlign
      };

      return styles;
    }
  },

  methods: {
    measureLayout: function measureLayout() {
      this.imageContentHeight = this.getImageContentHeight();
      this.imageContentWidth = this.getImageContentWidth();
    },
    getImageContentHeight: function getImageContentHeight() {
      var el = this.$refs.imageContainer;
      return el ? el.clientHeight : 0;
    },
    getImageContentWidth: function getImageContentWidth() {
      var el = this.$refs.imageContainer;
      return el ? el.clientWidth : 0;
    }
  },

  watch: {
    currentWidth: function currentWidth() /* newVal, oldVal */{
      var _this = this;

      _vue2.default.nextTick(function () {
        _this.measureLayout();
      });
    }
  },

  mounted: function mounted() {
    this.measureLayout();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Libs

/***/ }),

/***/ "CJVr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/preview.c9f0b51.jpg";

/***/ }),

/***/ "CRnV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _default = __webpack_require__("lfHO");

var _default2 = _interopRequireDefault(_default);

var _ContactUsForm = __webpack_require__("BzuX");

var _ContactUsForm2 = _interopRequireDefault(_ContactUsForm);

var _WorkArticlesMobile = __webpack_require__("t6J1");

var _WorkArticlesMobile2 = _interopRequireDefault(_WorkArticlesMobile);

var _WorkArticlesTablet = __webpack_require__("4mIv");

var _WorkArticlesTablet2 = _interopRequireDefault(_WorkArticlesTablet);

var _WorkHeader = __webpack_require__("uPNK");

var _WorkHeader2 = _interopRequireDefault(_WorkHeader);

var _dataUtils = __webpack_require__("uhrr");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
exports.default = {

  name: 'WorkMain',

  metaInfo: {
    title: ' Work - Particle Design'
  },

  props: ['data'],

  components: {
    DefaultLayout: _default2.default,
    WorkArticlesMobile: _WorkArticlesMobile2.default,
    ContactForm: _ContactUsForm2.default,
    WorkArticlesTablet: _WorkArticlesTablet2.default,
    WorkHeader: _WorkHeader2.default
  },

  computed: {
    articlesData: function articlesData() {
      var data = this.data;

      return (0, _dataUtils.groupAndShuffleArticleRecords)(data);
    },
    isDesktop: function isDesktop() {
      return this.$store.getters.isDesktop;
    },
    isMobile: function isMobile() {
      return this.$store.getters.isMobile;
    },
    isTablet: function isTablet() {
      return this.$store.getters.isTablet;
    }
  }
};

// Utils

/***/ }),

/***/ "D/vw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D5ie":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D6iG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D6lx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('defaultLayout',{attrs:{"section":"work-article"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [(!_vm.post)?[_c('div',{staticStyle:{"width":"100vw","height":"600px","background-color":"white"}})]:_vm._e(),_vm._v(" "),(_vm.post)?[_c('div',{staticClass:"work-article-container"},_vm._l((_vm.post.modules),function(module,idx){return _c(("module_" + (module.type)),{key:(_vm.slug + "-" + idx),tag:"component",attrs:{"data":module.data}})}),1)]:_vm._e()]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DD6R":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "DXIW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_image_stack_vue__ = __webpack_require__("EwPD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_image_stack_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_image_stack_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_image_stack_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_image_stack_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2eda6cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_text_image_stack_vue__ = __webpack_require__("n/d4");
function injectStyle (ssrContext) {
  __webpack_require__("D6iG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_image_stack_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2eda6cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_text_image_stack_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DZVs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _featuredItems = __webpack_require__("RslD");

var _featuredItems2 = _interopRequireDefault(_featuredItems);

var _announcement = __webpack_require__("bCBs");

var _announcement2 = _interopRequireDefault(_announcement);

var _hero = __webpack_require__("agTS");

var _hero2 = _interopRequireDefault(_hero);

var _hiring = __webpack_require__("roTQ");

var _hiring2 = _interopRequireDefault(_hiring);

var _image = __webpack_require__("iRj3");

var _image2 = _interopRequireDefault(_image);

var _intro = __webpack_require__("22kU");

var _intro2 = _interopRequireDefault(_intro);

var _partners = __webpack_require__("M/uQ");

var _partners2 = _interopRequireDefault(_partners);

var _relatedWorks = __webpack_require__("spc+");

var _relatedWorks2 = _interopRequireDefault(_relatedWorks);

var _row = __webpack_require__("+94u");

var _row2 = _interopRequireDefault(_row);

var _text_image_row = __webpack_require__("Abrb");

var _text_image_row2 = _interopRequireDefault(_text_image_row);

var _text_image_stack = __webpack_require__("DXIW");

var _text_image_stack2 = _interopRequireDefault(_text_image_stack);

var _ContactUsForm = __webpack_require__("BzuX");

var _ContactUsForm2 = _interopRequireDefault(_ContactUsForm);

var _CategoryContent = __webpack_require__("GJ8p");

var _CategoryContent2 = _interopRequireDefault(_CategoryContent);

var _CategoryHeader = __webpack_require__("pmfv");

var _CategoryHeader2 = _interopRequireDefault(_CategoryHeader);

var _Header = __webpack_require__("3ZBE");

var _Header2 = _interopRequireDefault(_Header);

var _ImageTextColumn = __webpack_require__("g4Nl");

var _ImageTextColumn2 = _interopRequireDefault(_ImageTextColumn);

var _ImageTextRow = __webpack_require__("1Ceh");

var _ImageTextRow2 = _interopRequireDefault(_ImageTextRow);

var _MultiImageText = __webpack_require__("OsZp");

var _MultiImageText2 = _interopRequireDefault(_MultiImageText);

var _TwoColumnText = __webpack_require__("hfhv");

var _TwoColumnText2 = _interopRequireDefault(_TwoColumnText);

var _OneColumnText = __webpack_require__("uhiZ");

var _OneColumnText2 = _interopRequireDefault(_OneColumnText);

var _RelatedArticles = __webpack_require__("INOn");

var _RelatedArticles2 = _interopRequireDefault(_RelatedArticles);

var _FourOhFour = __webpack_require__("L/Q9");

var _FourOhFour2 = _interopRequireDefault(_FourOhFour);

var _hcAbout = __webpack_require__("jb4Y");

var _hcAbout2 = _interopRequireDefault(_hcAbout);

var _hcAboutIntro = __webpack_require__("dJf4");

var _hcAboutIntro2 = _interopRequireDefault(_hcAboutIntro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// hardcoded modules


// Work Modules

var modules = { featuredItems: _featuredItems2.default, announcement: _announcement2.default, hero: _hero2.default, hiring: _hiring2.default, image: _image2.default, intro: _intro2.default, partners: _partners2.default, text_image_row: _text_image_row2.default, text_image_stack: _text_image_stack2.default, relatedWorks: _relatedWorks2.default, row: _row2.default, hcAbout: _hcAbout2.default, hcAboutIntro: _hcAboutIntro2.default };

// Misc

// Contact Modules

var addModule = function (struct) {
  return function (modz) {
    var name = modz.name;
    // eslint-disable-next-line no-param-reassign
    struct[name] = modz;
  };
}(modules);

addModule(_ContactUsForm2.default);

addModule(_FourOhFour2.default);

addModule(_CategoryContent2.default);
addModule(_CategoryHeader2.default);
addModule(_Header2.default);
addModule(_ImageTextColumn2.default);
addModule(_ImageTextRow2.default);
addModule(_MultiImageText2.default);
addModule(_TwoColumnText2.default);
addModule(_OneColumnText2.default);
addModule(_RelatedArticles2.default);

exports.default = modules;

/***/ }),

/***/ "Dqik":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E5JD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hero.657b898.jpg";

/***/ }),

/***/ "EJZp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bus = undefined;

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Bus = exports.Bus = new _vue2.default();

exports.default = {};

/***/ }),

/***/ "EMmj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkArticle_vue__ = __webpack_require__("MhNn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkArticle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkArticle_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkArticle_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkArticle_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c9cefd1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkArticle_vue__ = __webpack_require__("D6lx");
function injectStyle (ssrContext) {
  __webpack_require__("BErO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkArticle_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c9cefd1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkArticle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "EUtp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _default = __webpack_require__("lfHO");

var _default2 = _interopRequireDefault(_default);

var _FourOhFour = __webpack_require__("L/Q9");

var _FourOhFour2 = _interopRequireDefault(_FourOhFour);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//

// Components
exports.default = {

  name: 'PageNotFound',

  props: ['data'],

  components: {
    DefaultLayout: _default2.default,
    FourOhFour: _FourOhFour2.default
  }

};

/***/ }),

/***/ "EYO/":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "EZhh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ecuq":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Epfa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"contact-header"}},[_c('div',{staticClass:"component-layout"},[(_vm.type === 'video')?_c('div',{staticClass:"background",attrs:{"id":"video"}},[_c('video',{attrs:{"autoplay":"","muted":"","loop":"","playsinline":"","poster":_vm.bgData.poster},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.bgData.src}}),_vm._v(" "),_c('img',{attrs:{"alt":_vm.bgData.alt,"src":_vm.bgData.poster}})])]):_vm._e(),_vm._v(" "),_c('h1',{domProps:{"innerHTML":_vm._s(_vm.headline)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EwPD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'module_text_image_stack',
  props: ['data']
};

/***/ }),

/***/ "EzTz":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Ezi0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_int_hcAboutMemorable_vue__ = __webpack_require__("b5za");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_int_hcAboutMemorable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_int_hcAboutMemorable_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_int_hcAboutMemorable_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_int_hcAboutMemorable_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8099768_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_int_hcAboutMemorable_vue__ = __webpack_require__("h6CU");
function injectStyle (ssrContext) {
  __webpack_require__("pZpt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_int_hcAboutMemorable_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8099768_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_int_hcAboutMemorable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "F/v5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _imageUtils = __webpack_require__("Rn8A");

var _WorkMixin = __webpack_require__("OytB");

var _WorkMixin2 = _interopRequireDefault(_WorkMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
exports.default = {

  name: 'work-header',

  props: ['data'],

  mixins: [_WorkMixin2.default],

  data: function data() {
    return {
      imageContentWidth: 0
    };
  },


  computed: {
    bgImageStyles: function bgImageStyles() {
      var imageContentWidth = this.imageContentWidth;
      var image = this.data.image;
      var hA = image.hAlign,
          vA = image.vAlign,
          src = image.src;

      // add defaults

      var hAlign = hA || 'center';
      var vAlign = vA || 'center';

      var rUrl = (0, _imageUtils.getResponsiveUrl)(src, imageContentWidth);
      return {
        backgroundImage: 'url(' + rUrl + ')',
        backgroundPosition: hAlign + ' ' + vAlign
      };
    }
  },

  methods: {
    measureLayout: function measureLayout() {
      this.imageContentWidth = this.getImageContentWidth();
    },
    getImageContentWidth: function getImageContentWidth() {
      var el = this.$refs.headerHeroImage;
      return el ? el.clientWidth : 0;
    }
  },

  watch: {
    currentWidth: function currentWidth() /* newVal, oldVal */{
      var _this = this;

      _vue2.default.nextTick(function () {
        _this.measureLayout();
      });
    }
  },

  mounted: function mounted() {
    this.measureLayout();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  Work section Header module

  data record:
  {
    image: <string> // url
    title: <string>
    content: <markdown>
    roles: Array<string> //
  }
*/
// Lib

/***/ }),

/***/ "FGQ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contentStack_vue__ = __webpack_require__("57Yo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contentStack_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contentStack_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contentStack_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contentStack_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f617d698_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contentStack_vue__ = __webpack_require__("9t57");
function injectStyle (ssrContext) {
  __webpack_require__("515s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contentStack_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f617d698_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contentStack_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FOuc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.6b42137.jpg";

/***/ }),

/***/ "FVsJ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTQycHgiIGhlaWdodD0iMTAwcHgiIHZpZXdCb3g9IjAgMCAxNDIgMTAwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OS4zICg1MTE2NykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+UERjbGllbnRsb2dvXzEwMHhWYXJpYWJsZS9zYW1zdW5nPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBEY2xpZW50bG9nb18xMDB4VmFyaWFibGUvc2Ftc3VuZyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlBEX2NsaWVudGxvZ29fc2Ftc3VuZyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDI2LjAwMDAwMCkiIGZpbGw9IiM0OTQ4NDciIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNDEuNTgxMzc3LDExLjE5NzU5MzcgQzEzOS42NTM1OTksMC4xMzY0ODI1NTEgMTA2LjQyMDI2NiwtMy4zMTM1MTc0NSA2Ny4zNDgwNDM3LDMuNDg2NDgyNTUgQzUwLjkzNjkzMjYsNi4zNDIwMzgxMSAzNi4xMjAyNjYsMTAuNTU4NzA0OCAyNC41NzAyNjYsMTUuMzAzMTQ5MiBDMjYuMzQyNDg4MiwxNS4zNDIwMzgxIDI3LjY1OTE1NDksMTUuNzQ3NTkzNyAyOC40NTkxNTQ5LDE2LjU0NzU5MzcgQzI5LjEwMzA1OSwxNy4yMjU3ODI1IDI5LjQ0NTY1MDYsMTguMTM1MzUzIDI5LjQwOTE1NDksMTkuMDY5ODE1OSBMMjkuNDA5MTU0OSwyMC4xODA5MjcgTDI1LjU3NTgyMTUsMjAuMTgwOTI3IEwyNS41NzU4MjE1LDE5LjIyNTM3MTQgQzI1LjYwNDQyMSwxOC44NjQxMzM5IDI1LjQ3MDUxMiwxOC41MDg5NDgzIDI1LjIxMDU0NjksMTguMjU2NTAyOSBDMjQuOTUwNTgxOSwxOC4wMDQwNTc1IDI0LjU5MTYxOTgsMTcuODgwNjI4NiAyNC4yMzEzNzcxLDE3LjkxOTgxNTkgQzIzLjYwODgxNzMsMTcuODQ1MjY2NSAyMy4wMzYxNzgxLDE4LjI2OTI2MzMgMjIuOTI1ODIxNSwxOC44ODY0ODI2IEMyMi44NzIyODc2LDE5LjEzOTIzNDUgMjIuODcyMjg3NiwxOS40MDAzOTcyIDIyLjkyNTgyMTUsMTkuNjUzMTQ5MiBDMjMuMzM2OTMyNiwyMS4zMTk4MTU5IDI5LjAzNjkzMjYsMjIuMzY5ODE1OSAyOS42NDI0ODgyLDI1LjQ2NDI2MDMgQzI5Ljc4MDkxMTksMjYuMjgwNjU2NSAyOS43ODA5MTE5LDI3LjExNDUzMDggMjkuNjQyNDg4MiwyNy45MzA5MjcgQzI5LjI4NjkzMjYsMzAuNDI1MzcxNCAyNy4wOTgwNDM3LDMxLjM4NjQ4MjYgMjQuMzAzNTk5MywzMS4zODY0ODI2IEMyMC40MTQ3MTA0LDMxLjM4NjQ4MjYgMTguODI1ODIxNSwyOS41NDIwMzgxIDE4LjgyNTgyMTUsMjYuOTk3NTkzNyBMMTguODI1ODIxNSwyNS43OTIwMzgxIEwyMi45MzEzNzcxLDI1Ljc5MjAzODEgTDIyLjkzMTM3NzEsMjcuMjkyMDM4MSBDMjIuOTI1NjU4NiwyNy42NjQ5MTUzIDIzLjA4MTAzMjcsMjguMDIyMTQzMyAyMy4zNTc2OTMsMjguMjcyMjAxNiBDMjMuNjM0MzUzMywyOC41MjIyNTk5IDI0LjAwNTQxNzksMjguNjQwODUxNSAyNC4zNzU4MjE1LDI4LjU5NzU5MzcgQzI1LjA0NDMzOTIsMjguNzI0NTQyOSAyNS42OTIzMTI0LDI4LjI5NTg0NTggMjUuODM2OTMyNiwyNy42MzA5MjcgQzI1Ljk0MDk2MzgsMjcuMjc5MTk4OCAyNS45NDA5NjM4LDI2LjkwNDg3NzQgMjUuODM2OTMyNiwyNi41NTMxNDkyIEMyNS4wNTM1OTkzLDI0LjYyNTM3MTQgMTkuNzI1ODIxNSwyMy43NTMxNDkyIDE5LjA4NjkzMjYsMjAuNjY5ODE1OSBDMTguOTM5OTgxNSwyMC4wMDMxMTQ4IDE4LjkyNjc2MzQsMTkuMzEzODgzNCAxOS4wNDgwNDM3LDE4LjY0MjAzODEgQzE5LjEwOTM2MTQsMTguMjcyMDkyOCAxOS4yMjM0ODkzLDE3LjkxMjg3MDYgMTkuMzg2OTMyNiwxNy41NzUzNzE0IEM2LjYwOTE1NDg1LDIzLjU1ODcwNDggLTAuOTAxOTU2MjYxLDMwLjE0NzU5MzcgMC4wODY5MzI2MjgzLDM1LjgzMDkyNyBDMi4wMTQ3MTA0MSw0Ni44OTIwMzgxIDM1LjI0ODA0MzcsNTAuMzQyMDM4MSA3NC4zMjAyNjYsNDMuNTM2NDgyNiBDOTEuNDk4MDQzNyw0MC41NDc1OTM3IDEwNi45MzY5MzMsMzYuMDY5ODE1OSAxMTguNjg2OTMzLDMxLjA1ODcwNDggQzExOC41MTQ3MSwzMS4wNTg3MDQ4IDExOC4zNTM1OTksMzEuMDU4NzA0OCAxMTguMTc1ODIyLDMxLjA1ODcwNDggQzExNS41MDM1OTksMzEuMDU4NzA0OCAxMTMuMTE0NzEsMzAuMDU4NzA0OCAxMTIuODY0NzEsMjcuMzI1MzcxNCBDMTEyLjgyMDI2NiwyNi44MjUzNzE0IDExMi44MTQ3MSwyNi42MTk4MTU5IDExMi44MDkxNTUsMjYuMzM2NDgyNiBMMTEyLjgwOTE1NSwyMC4wODA5MjcgQzExMi44MDkxNTUsMTkuODA4NzA0OCAxMTIuODQyNDg4LDE5LjMzNjQ4MjYgMTEyLjg3MDI2NiwxOS4wODY0ODI2IEMxMTMuMTg2OTMzLDE2LjQ0NzU5MzcgMTE1LjI3NTgyMiwxNS4zNTMxNDkyIDExOC4xNzAyNjYsMTUuMzUzMTQ5MiBDMTIwLjM5MjQ4OCwxNS4zNTMxNDkyIDEyMy4xNzAyNjYsMTUuOTk3NTkzNyAxMjMuNDU5MTU1LDE5LjA4NjQ4MjYgQzEyMy40ODY1MjQsMTkuMzk4NjU2NyAxMjMuNDk3NjUsMTkuNzEyMDQyMyAxMjMuNDkyNDg4LDIwLjAyNTM3MTQgTDEyMy40OTI0ODgsMjAuNjE0MjYwMyBMMTE5LjYwMzU5OSwyMC42MTQyNjAzIEwxMTkuNjAzNTk5LDE5Ljc0MjAzODEgQzExOS42MDEzMjYsMTkuNTU1ODM4NSAxMTkuNTg0NjA5LDE5LjM3MDA5NTkgMTE5LjU1MzU5OSwxOS4xODY0ODI2IEMxMTkuNDIxODg0LDE4LjUxNzQ0NzkgMTE4Ljc5NzQ4MywxOC4wNjI0NTg3IDExOC4xMjAyNjYsMTguMTQyMDM4MSBDMTE3LjQ0MjkwMiwxOC4wNzMzMzUgMTE2LjgyMjU4LDE4LjUyNjAwMjMgMTE2LjY4MTM3NywxOS4xOTIwMzgxIEMxMTYuNjM2NzksMTkuNDIwNzQ3MyAxMTYuNjE2MzA4LDE5LjY1MzUwMTQgMTE2LjYyMDI2NiwxOS44ODY0ODI2IEwxMTYuNjIwMjY2LDI2LjcwODcwNDggQzExNi42MTQ2OTcsMjYuODk0NTE0OCAxMTYuNjI1ODU0LDI3LjA4MDQ0OTEgMTE2LjY1MzU5OSwyNy4yNjQyNjAzIEMxMTYuODcxNDQsMjcuODkyNjY4OSAxMTcuNDYzNTA0LDI4LjMxNDA1NjYgMTE4LjEyODU5OSwyOC4zMTQwNTY2IEMxMTguNzkzNjk1LDI4LjMxNDA1NjYgMTE5LjM4NTc1OSwyNy44OTI2Njg5IDExOS42MDM1OTksMjcuMjY0MjYwMyBDMTE5LjYzMDcxMiwyNy4wODAzODMxIDExOS42NDE4NjUsMjYuODk0NTA0NyAxMTkuNjM2OTMzLDI2LjcwODcwNDggTDExOS42MzY5MzMsMjQuNTkyMDM4MSBMMTE4LjExNDcxLDI0LjU5MjAzODEgTDExOC4xMTQ3MSwyMi4zMTQyNjAzIEwxMjMuNDk4MDQ0LDIyLjMxNDI2MDMgTDEyMy40OTgwNDQsMjYuMzY5ODE1OSBDMTIzLjQ5ODQ0OCwyNi43MDAwODc0IDEyMy40ODE3NTksMjcuMDMwMTU4NSAxMjMuNDQ4MDQ0LDI3LjM1ODcwNDggQzEyMy4zOTcxNSwyOC4wMTkwNzMxIDEyMy4xNzUwMzYsMjguNjU0Nzc3OCAxMjIuODAzNTk5LDI5LjIwMzE0OTIgQzEzNS4yODEzNzcsMjMuMjgwOTI3IDE0Mi41NTkxNTUsMTYuNzk3NTkzNyAxNDEuNTgxMzc3LDExLjE5NzU5MzcgWiBNNDAuMjgxMzc3MSwzMC43OTc1OTM3IEwzOC4zMjAyNjYsMTcuNDY0MjYwMyBMMzguMjQ4MDQzNywxNy40NjQyNjAzIEwzNi4yMzY5MzI2LDMwLjc5NzU5MzcgTDMyLjEwMzU5OTMsMzAuNzk3NTkzNyBMMzQuODgxMzc3MSwxNS43NTg3MDQ4IEw0MS42MTQ3MTA0LDE1Ljc1ODcwNDggTDQ0LjM5MjQ4ODIsMzAuNzk3NTkzNyBMNDAuMjgxMzc3MSwzMC43OTc1OTM3IFogTTYwLjE1MzU5OTMsMzAuNzk3NTkzNyBMNjAuMDY0NzEwNCwxNy43MzY0ODI2IEw1OS45OTgwNDM3LDE3LjczNjQ4MjYgTDU3LjU2NDcxMDQsMzAuNzk3NTkzNyBMNTMuNjc1ODIxNSwzMC43OTc1OTM3IEw1MS4yNTM1OTkzLDE3LjczNjQ4MjYgTDUxLjE4NjkzMjYsMTcuNzM2NDgyNiBMNTEuMDk4MDQzNywzMC43OTc1OTM3IEw0Ny4yNTM1OTkzLDMwLjc5NzU5MzcgTDQ3LjU4NjkzMjYsMTUuNzU4NzA0OCBMNTMuNzY0NzEwNCwxNS43NTg3MDQ4IEw1NS41NjQ3MTA0LDI2LjkzMDkyNyBMNTUuNjUzNTk5MywyNi45MzA5MjcgTDU3LjQ1OTE1NDksMTUuNzM2NDgyNiBMNjMuNjE0NzEwNCwxNS43MzY0ODI2IEw2My45NDgwNDM3LDMwLjc3NTM3MTQgTDYwLjE1MzU5OTMsMzAuNzk3NTkzNyBaIE03OC4yNDgwNDM3LDI3Ljg4MDkyNyBDNzcuODM2OTMyNiwzMC43OTIwMzgxIDc0Ljk4MTM3NzEsMzEuMzAzMTQ5MiA3Mi45NjQ3MTA0LDMxLjMwMzE0OTIgQzY5LjYzMTM3NzEsMzEuMzAzMTQ5MiA2Ny41NDI0ODgyLDI5Ljg2OTgxNTkgNjcuNTQyNDg4MiwyNi45NTg3MDQ4IEw2Ny41NDI0ODgyLDI1Ljc2OTgxNTkgTDcxLjU5ODA0MzcsMjUuNzY5ODE1OSBMNzEuNTk4MDQzNywyNy4yNDc1OTM3IEM3MS41OTAyMTgzLDI3LjYxOTIyMjcgNzEuNzQ0NjA4OCwyNy45NzU4MzgzIDcyLjAyMDk1MjcsMjguMjI0NDQxMSBDNzIuMjk3Mjk2NywyOC40NzMwNDQgNzIuNjY4MTk4MywyOC41ODg5ODg0IDczLjAzNjkzMjYsMjguNTQyMDM4MSBDNzMuNjc5OTU4NywyOC42MzY1MjQ4IDc0LjI4NzQwNTEsMjguMjIwMjY2NyA3NC40MzEzNzcxLDI3LjU4NjQ4MjYgQzc0LjUzMjkyMDMsMjcuMjM4MTc2OSA3NC41MzI5MjAzLDI2Ljg2ODEyMTUgNzQuNDMxMzc3MSwyNi41MTk4MTU5IEM3My42ODY5MzI2LDI0LjY0NzU5MzcgNjguNDE0NzEwNCwyMy43NDIwMzgxIDY3Ljc2NDcxMDQsMjAuNjk3NTkzNyBDNjcuNjE3NDcwNSwyMC4wMzY1NTk0IDY3LjYwNDI0NywxOS4zNTI3MTQ5IDY3LjcyNTgyMTUsMTguNjg2NDgyNiBDNjguMTcwMjY2LDE1LjkwODcwNDggNzAuODE0NzEwNCwxNS4zNTMxNDkyIDcyLjkzNjkzMjYsMTUuMzUzMTQ5MiBDNzQuODM2OTMyNiwxNS4zNTMxNDkyIDc2LjIyMDI2NiwxNS43Njk4MTU5IDc3LjA1MzU5OTMsMTYuNTk3NTkzNyBDNzcuNjk2MTcyNCwxNy4yNzc3OTYgNzguMDMzMjgwOSwxOC4xOTA3OTgxIDc3Ljk4NjkzMjYsMTkuMTI1MzcxNCBMNzcuOTg2OTMyNiwyMC4yMzY0ODI2IEw3NC4xNzAyNjYsMjAuMjM2NDgyNiBMNzQuMTcwMjY2LDE5LjI2OTgxNTkgQzc0LjIwMzk1MDIsMTguOTA5ODI1NCA3NC4wNzQyODI0LDE4LjU1MzcyMzMgNzMuODE3MDA5MiwxOC4yOTk2Nzk1IEM3My41NTk3MzYsMTguMDQ1NjM1NyA3My4yMDIwMjQ0LDE3LjkyMDQ3NjEgNzIuODQyNDg4MiwxNy45NTg3MDQ4IEM3Mi4yMjM1MTc4LDE3Ljg4MzUxODMgNzEuNjUyNDAzMiwxOC4zMDE1MjU1IDcxLjUzNjkzMjYsMTguOTE0MjYwMyBDNzEuNDg0NDczLDE5LjE2MzM4MDQgNzEuNDg0NDczLDE5LjQyMDY5NTggNzEuNTM2OTMyNiwxOS42Njk4MTU5IEM3MS45NDI0ODgyLDIxLjMzNjQ4MjYgNzcuNTgxMzc3MSwyMi4zNTg3MDQ4IDc4LjIwMzU5OTMsMjUuNDE5ODE1OSBDNzguMzUxMTI2NCwyNi4yMzI3OTM0IDc4LjM2MDUxNzMsMjcuMDY0ODI2OSA3OC4yMzEzNzcxLDI3Ljg4MDkyNyBMNzguMjQ4MDQzNywyNy44ODA5MjcgWiBNOTIuMzAzNTk5MywyNi41MTQyNjAzIEM5Mi4zMDM1OTkzLDI2Ljc5NzU5MzcgOTIuMzAzNTk5MywyNy4zNTg3MDQ4IDkyLjI2NDcxMDQsMjcuNTAzMTQ5MiBDOTIuMDMxMzc3MSwyOS45ODA5MjcgOTAuMjU5MTU0OSwzMS4yNDIwMzgxIDg3LjAwOTE1NDksMzEuMjQyMDM4MSBDODMuNzU5MTU0OSwzMS4yNDIwMzgxIDgxLjk3MDI2NiwyOS45ODA5MjcgODEuNzQyNDg4MiwyNy41MDMxNDkyIEM4MS43NDI0ODgyLDI3LjM1ODcwNDggODEuNjk4MDQzNywyNi43OTc1OTM3IDgxLjcwMzU5OTMsMjYuNTE0MjYwMyBMODEuNzAzNTk5MywxNS43MzY0ODI2IEw4NS41OTI0ODgyLDE1LjczNjQ4MjYgTDg1LjU5MjQ4ODIsMjYuODQ3NTkzNyBDODUuNTg1NDEyLDI3LjAzMzQyMzIgODUuNTk2NTc2NSwyNy4yMTk0OTg5IDg1LjYyNTgyMTUsMjcuNDAzMTQ5MiBDODUuODAyOTY4NiwyOC4wMjMyODggODYuMzY5NzY2LDI4LjQ1MDg0NzYgODcuMDE0NzEwNCwyOC40NTA4NDc2IEM4Ny42NTk2NTQ4LDI4LjQ1MDg0NzYgODguMjI2NDUyMiwyOC4wMjMyODggODguNDAzNTk5MywyNy40MDMxNDkyIEM4OC40Mjg4OTgzLDI3LjIxOTA4ODcgODguNDQwMDQyMSwyNy4wMzMzNTg3IDg4LjQzNjkzMjYsMjYuODQ3NTkzNyBMODguNDM2OTMyNiwxNS43MzY0ODI2IEw5Mi4zMjU4MjE1LDE1LjczNjQ4MjYgTDkyLjMwMzU5OTMsMjYuNTE0MjYwMyBaIE0xMDkuMDMxMzc3LDMwLjY0MjAzODEgTDEwMy42MTQ3MSwzMC42NDIwMzgxIEw5OS45ODY5MzI2LDE4LjcyNTM3MTQgTDk5LjkyNTgyMTUsMTguNzI1MzcxNCBMMTAwLjEyNTgyMiwzMC42NDIwMzgxIEw5Ni4zNTkxNTQ5LDMwLjY0MjAzODEgTDk2LjM1OTE1NDksMTUuNzM2NDgyNiBMMTAxLjk4NjkzMywxNS43MzY0ODI2IEwxMDUuMzIwMjY2LDI3LjE4MDkyNyBMMTA1LjM5ODA0NCwyNy4xODA5MjcgTDEwNS4yMjAyNjYsMTUuNzM2NDgyNiBMMTA5LjAxNDcxLDE1LjczNjQ4MjYgTDEwOS4wMzEzNzcsMzAuNjQyMDM4MSBaIiBpZD0iU2hhcGUiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ "Fdbr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _WorkMixin = __webpack_require__("OytB");

var _WorkMixin2 = _interopRequireDefault(_WorkMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

  name: 'work-one-column-text',

  props: ['data'],

  mixins: [_WorkMixin2.default],

  computed: {
    containerClasses: function containerClasses() {
      // return class string, eg 'desktop', 'mobile.reversed'
      var isReversed = this.isReversed;

      var deviceStr = '';
      if (this.isMobile) {
        deviceStr = 'mobile';
      } else if (this.isTablet) {
        deviceStr = 'tablet';
      } else {
        deviceStr = 'desktop';
      }
      return isReversed ? deviceStr + ' reversed' : deviceStr;
    },
    contentContainerClasses: function contentContainerClasses() {
      var s = this.data.size;

      var classStr = this.containerClasses;

      // add defaults
      var size = s || 'large';

      return classStr + ' ' + size;
    }
  }
}; //
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "FoPb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G9fO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleTile_vue__ = __webpack_require__("JYzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleTile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleTile_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleTile_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleTile_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f6a8f3d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticleTile_vue__ = __webpack_require__("MbGc");
function injectStyle (ssrContext) {
  __webpack_require__("HwIs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleTile_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f6a8f3d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticleTile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "GHPs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GJ8p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryContent_vue__ = __webpack_require__("nwra");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryContent_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryContent_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryContent_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4db82094_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryContent_vue__ = __webpack_require__("vax0");
function injectStyle (ssrContext) {
  __webpack_require__("zKSb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4db82094"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryContent_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4db82094_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "GQOj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/eyeball.01a9c64.svg";

/***/ }),

/***/ "GVZ3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _imageUtils = __webpack_require__("Rn8A");

var _WorkMixin = __webpack_require__("OytB");

var _WorkMixin2 = _interopRequireDefault(_WorkMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
exports.default = {

  name: 'article-header',

  props: ['data'],

  mixins: [_WorkMixin2.default],

  data: function data() {
    return {
      imageContentWidth: 0
    };
  },


  computed: {
    bgImageStyles: function bgImageStyles() {
      var imageContentWidth = this.imageContentWidth;
      var _data = this.data,
          src = _data.imageSrc,
          hA = _data.hAlign,
          vA = _data.vAlign;

      // add defaults

      var hAlign = hA || 'center';
      var vAlign = vA || 'center';

      var rUrl = (0, _imageUtils.getResponsiveUrl)(src, imageContentWidth);
      return {
        backgroundImage: 'url(' + rUrl + ')',
        backgroundPosition: hAlign + ' ' + vAlign
      };
    }
  },

  methods: {
    measureLayout: function measureLayout() {
      this.imageContentWidth = this.getImageContentWidth();
    },
    getImageContentWidth: function getImageContentWidth() {
      var el = this.$refs.headerHeroImage;
      return el ? el.clientWidth : 0;
    }
  },

  watch: {
    currentWidth: function currentWidth() /* newVal, oldVal */{
      var _this = this;

      _vue2.default.nextTick(function () {
        _this.measureLayout();
      });
    }
  },

  mounted: function mounted() {
    this.measureLayout();
  }
}; //
//
//
//
//
//
//
//
//
//
//

// Lib

/***/ }),

/***/ "GXFC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GZoJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentRevealTile_vue__ = __webpack_require__("Q8be");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentRevealTile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentRevealTile_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentRevealTile_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentRevealTile_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba84094a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentRevealTile_vue__ = __webpack_require__("bx/H");
function injectStyle (ssrContext) {
  __webpack_require__("hp1n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ba84094a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentRevealTile_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba84094a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentRevealTile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "H9yH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HFee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('defaultLayout',{attrs:{"data":_vm.data,"page":_vm.page,"section":_vm.section},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return _vm._l((_vm.data.blocks),function(block){return _c(("module_" + (block.module)),{key:block.title,tag:"component",attrs:{"data":block,"window":slotProps.window,"scrollState":slotProps.monitorState,"scrollPosition":slotProps.scrollPosition}})})}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HQIC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HV/o":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "HaPn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.5a9b2e3.jpg";

/***/ }),

/***/ "HbWz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"about-subsection",attrs:{"data-component":"hcAboutRelevant","data-visibility":_vm.visibility}},[(_vm.visibility === 'mobile')?[_vm._m(0),_vm._v(" "),_vm._m(1)]:[_c('div',{staticClass:"content__anchor",attrs:{"id":"hcAboutRelevant"}}),_vm._v(" "),_c('ScrollItem',{attrs:{"id":"aboutRelevant_component_top"}},[_c('div',{attrs:{"data-anchor":"aboutRelevant_component_top"}})]),_vm._v(" "),_c('div',{staticClass:"content",class:_vm.contentFixed},[_c('div',{staticClass:"content__container",style:(_vm.contentOpacity)},[_c('span',{staticClass:"tab-number"},[_vm._v("01")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',[_vm._v("\n          Empathy is a powerful motivational force that turns good ideas into exceptional experiences.  We root our design process in compelling research to solve for the right problems, and turn big-picture ideas into unforgettable products. It’s our human-first approach that inspires us to deliver work that’s unexpected, complex, and deeply thoughtful.\n        ")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),(_vm.visibility==='compact')?_c('div',{staticClass:"graphic",class:_vm.graphicFixed},[_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7)]):_vm._e(),_vm._v(" "),(_vm.visibility === 'full')?_c('div',{staticClass:"graphic",class:_vm.graphicFixed},[_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)]):_vm._e()]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"graphic"},[_c('div',{staticClass:"quadrant-l"},[_c('div',{staticClass:"subquadrant-tl"},[_c('div',{staticClass:"placeholder black"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("HltI"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"subquadrant-tr"},[_c('div',{staticClass:"placeholder blue"})]),_vm._v(" "),_c('div',{staticClass:"subquadrant-bl"},[_c('div',{staticClass:"placeholder yellow"})]),_vm._v(" "),_c('div',{staticClass:"subquadrant-br"},[_c('div',{staticClass:"placeholder white"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("Q/rj"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"quadrant-r"},[_c('div',{staticClass:"placeholder black"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("OqtW"),"alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"content__container"},[_c('span',[_vm._v("01")]),_vm._v(" "),_c('h1',{staticClass:"h1"},[_vm._v("\n          Make it\n          "),_c('br'),_vm._v("\n          Relevant\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Empathy is a powerful motivational force that turns good ideas into exceptional experiences.  We root our design process in compelling research to solve for the right problems, and turn big-picture ideas into unforgettable products. It’s our human-first approach that inspires us to deliver work that’s unexpected, complex, and deeply thoughtful.\n        ")]),_vm._v(" "),_c('div',{staticClass:"headline"},[_c('span',{attrs:{"data-ornament":"rectangle"}}),_vm._v(" "),_c('h2',{staticClass:"h2"},[_vm._v("\n            Services\n          ")])]),_vm._v(" "),_c('ul',{staticClass:"services"},[_c('li',{staticClass:"service"},[_vm._v("Ideation Workshops")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Ethnographic Research")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Market Strategy")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Customer Journey Maps")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Competitive Analysis")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Scenarios & Storyboards")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"h1"},[_vm._v("\n          Make it\n          "),_c('br'),_vm._v("\n          Relevant\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headline"},[_c('span',{attrs:{"data-ornament":"rectangle"}}),_vm._v(" "),_c('h2',{staticClass:"h2"},[_vm._v("\n            Services\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"services"},[_c('li',{staticClass:"service"},[_vm._v("Ideation Workshops")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Ethnographic Research")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Market Strategy")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Customer Journey Maps")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Competitive Analysis")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Scenarios & Storyboards")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-t"},[_c('div',{staticClass:"subquadrant-l"},[_c('div',{staticClass:"placeholder blue"})]),_vm._v(" "),_c('div',{staticClass:"subquadrant-r"},[_c('div',{staticClass:"placeholder black"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("HltI"),"alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-m"},[_c('div',{staticClass:"subquadrant-l"},[_c('div',{staticClass:"placeholder white"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("Q/rj"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"subquadrant-r"},[_c('div',{staticClass:"placeholder yellow"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-b"},[_c('div',{staticClass:"placeholder black"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("KPtl"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-tl"},[_c('div',{staticClass:"placeholder black"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("OqtW"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-tr"},[_c('div',{staticClass:"subquadrant-tl"},[_c('div',{staticClass:"placeholder blue"})]),_vm._v(" "),_c('div',{staticClass:"subquadrant-tr"},[_c('div',{staticClass:"placeholder black"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("HltI"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"subquadrant-bl"},[_c('div',{staticClass:"placeholder yellow"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("Q/rj"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"subquadrant-br"},[_c('div',{staticClass:"placeholder yellow"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-bl"},[_c('div',{staticClass:"placeholder blue"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("7v22"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-br"},[_c('div',{staticClass:"placeholder black"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("KPtl"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HdBo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scroll-container',{attrs:{"data-module":"about"},on:{"change":_vm.updateSectionScrollState}},[_c('ScrollItem',{attrs:{"id":"topOfAboutContent"}},[_c('div',{attrs:{"data-anchor":"topOfAboutContent"}})]),_vm._v(" "),_c('ScrollItem',{attrs:{"id":"bottomOfAboutContent"}},[_c('div',{attrs:{"data-anchor":"bottomOfAboutContent"}})]),_vm._v(" "),_c('div',{staticClass:"about__content",attrs:{"data-visibility":_vm.graphicVisibility}},[_c('component_hcAboutRelevant',{attrs:{"scrollState":_vm.sectionScroll,"visibility":_vm.graphicVisibility,"percentScrolled":_vm.percentScrolled}}),_vm._v(" "),_c('component_hcAboutMemorable',{attrs:{"scrollState":_vm.sectionScroll,"visibility":_vm.graphicVisibility,"percentScrolled":_vm.percentScrolled}}),_vm._v(" "),_c('component_hcAboutAlive',{attrs:{"scrollState":_vm.sectionScroll,"visibility":_vm.graphicVisibility,"percentScrolled":_vm.percentScrolled}})],1),_vm._v(" "),(_vm.graphicVisibility !== 'mobile')?_c('div',{staticClass:"about__nav",class:_vm.aboutNavClasses,style:(_vm.aboutNavStyles)},[_c('div',{staticClass:"nav__indicator",style:(_vm.aboutNavPositionStyle)}),_vm._v(" "),_c('div',{staticClass:"nav__section-link"},[_c('a',{staticClass:"section-link__copy",attrs:{"href":"#hcAboutRelevant"}},[_vm._v("\n        01 Relevant\n      ")])]),_vm._v(" "),_c('div',{staticClass:"nav__section-link"},[_c('a',{staticClass:"section-link__copy",attrs:{"href":"#hcAboutMemorable"}},[_vm._v("\n        02 Memorable\n      ")])]),_vm._v(" "),_c('div',{staticClass:"nav__section-link"},[_c('a',{staticClass:"section-link__copy",attrs:{"href":"#hcAboutAlive"}},[_vm._v("\n        03 Alive\n      ")])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HdTL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkMain_vue__ = __webpack_require__("CRnV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkMain_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkMain_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkMain_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkMain_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b02dcad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkMain_vue__ = __webpack_require__("kOWT");
function injectStyle (ssrContext) {
  __webpack_require__("cmVA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkMain_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b02dcad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "HltI":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Hn6a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hero-video-720p.dca5ec6.mp4";

/***/ }),

/***/ "HrIc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clients = __webpack_require__("fL60");

var _clients2 = _interopRequireDefault(_clients);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var client = _clients2.default.hp;

exports.default = {
  slug: 'hp-wearable-smartwatch',
  company: client.name,
  logo: client.logo,
  logoWhite: client.logoWhite,
  blurb: {
    headline: "Launching a new class of smart watch.",
    tags: [],
    byline: 'Learn more about our work with HP',
    background: __webpack_require__("k8rL"),
    backgroundSet: [{
      max: 1024,
      src: __webpack_require__("qnuT")
    }]
  },
  blocks: [{
    module: 'hero',
    background: {
      image: __webpack_require__("E5JD"),
      type: 'image'
    },
    constrain: true
  }, {
    module: 'intro',
    title: 'A new class of smart watch.',
    content: 'Several years ago, HP Inc. decided to enter the wearables market. Their approach was unique: HP would provide the engineering and technology; designers and watchmakers would create the watches. Each watch would look and feel like a classic analog timepiece but would have built-in intelligence and connectivity to a smartphone app.\n\nHP brought in Particle Design for help with several projects all tied to their smartwatches’ UX design.',
    roles: ["Roundtable Discussions", "1:1 Usability Testing", "Longitudinal Diary Study", "Participatory Design", "User Highlights Video"]
  }, {
    module: 'text_image_stack',
    image: {
      src: __webpack_require__("0dFh"),
      alt: 'image of watch designs'
    }
  }, {
    module: 'text_image_row',
    images: [
    // {
    //   src: require('./article/2.jpg'),
    //   height: '540px',
    //   gravity: 'left bottom',
    // },
    {
      src: __webpack_require__("Y2Ti"),
      height: '325px',
      gravity: 'left top',
      primary: true
    }, {
      src: __webpack_require__("0z0p"),
      height: '225px',
      gravity: 'center center'
    }],
    content: '## Capturing insight through real-world testing.\n\nHP also asked Particle Design to wear test two versions of a newly developed men’s smartwatch. They had the prototypes but wanted to understand the out-of-box and set-up experience. They also wanted to know which features users found helpful.\n\nParticle asked a group of potential users to wear the prototypes for ten days and maintain a diary. We helped HP streamline the information provided and steps involved with set-up. We also helped pinpoint what features were most useful and where others fell short.\n\nTo date, HP has partnered with several designers and watchmakers to create and bring to market stunning timepieces with digital capabilities, all of which incorporate insights brought to light by the Particle team.'
  }, {
    module: 'row',
    columns: [{
      grid: {
        start: 2,
        end: 11
      },
      component: 'blockquote',
      modifier: 'big',
      quote: 'About 6 months after I purchased an Apple Watch, I stopped wearing it...the beauty of the Coach Bleecker Smart Watch is that when you are wearing it, it simply looks like a nice watch with a regular analog face.',
      sourceName: 'Gear Diary, November 2016'
    }]
  }, {
    module: 'relatedWorks',
    works: ['dreamworks', 'vr-science-education']
  }]
};

/***/ }),

/***/ "HwIs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I+yb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _appConstants = __webpack_require__("y3R9");

var _WorkMixin = __webpack_require__("OytB");

var _WorkMixin2 = _interopRequireDefault(_WorkMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants
exports.default = {

  name: 'category-page-header',

  props: ['data'],

  mixins: [_WorkMixin2.default],

  data: function data() {
    return {
      burnerHeight: 0
    };
  },


  computed: {
    colorBlockStyles: function colorBlockStyles() {
      var burnerHeight = this.burnerHeight,
          currentBrowserWidth = this.currentWidth,
          deviceType = this.deviceType;

      // calculate width

      var offset = 0;
      if (currentBrowserWidth > _appConstants.MaxBrowserWidth) {
        offset = (currentBrowserWidth - _appConstants.MaxBrowserWidth) * 0.5;
      }

      // calculate height
      // this is height of burner text plus some value to cover title
      var height = 0;
      switch (deviceType) {
        case 'desktop':
          height = burnerHeight + 128;
          break;
        case 'tablet':
          height = burnerHeight + 134;
          break;
        case 'mobile':
        default:
          height = 0;
          break;
      }

      var style = {
        height: height + 'px',
        marginLeft: '-' + offset + 'px'
      };
      return style;
    }
  },

  methods: {
    measureLayout: function measureLayout() {
      this.burnerHeight = this.getBurnerHeight();
    },
    getBurnerHeight: function getBurnerHeight() {
      var el = this.$refs.burnerText;
      return el ? el.clientHeight : 0;
    }
  },

  watch: {
    currentWidth: function currentWidth() /* newVal, oldVal */{
      var _this = this;

      _vue2.default.nextTick(function () {
        _this.measureLayout();
      });
    }
  },

  mounted: function mounted() {
    this.measureLayout();
  }
};

// Mixins
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  Category Page Header module

  data record:
  {
    title: <string>
    content: <string>
  }
*/
// Lib

/***/ }),

/***/ "IA45":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SmartPhone_vue__ = __webpack_require__("3JVN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SmartPhone_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SmartPhone_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SmartPhone_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SmartPhone_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28c0cdb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SmartPhone_vue__ = __webpack_require__("+MSI");
function injectStyle (ssrContext) {
  __webpack_require__("9zH2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28c0cdb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SmartPhone_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28c0cdb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SmartPhone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "INOn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatedArticles_vue__ = __webpack_require__("ShOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatedArticles_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatedArticles_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatedArticles_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatedArticles_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01cc3584_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatedArticles_vue__ = __webpack_require__("KeDd");
function injectStyle (ssrContext) {
  __webpack_require__("AIFD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01cc3584"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatedArticles_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01cc3584_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatedArticles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IcsF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("JtxL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40c003ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("o0Es");
function injectStyle (ssrContext) {
  __webpack_require__("zyDQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40c003ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IdUJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'module_partners',
  props: ['data']
};

/***/ }),

/***/ "Ij5r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J3uG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/office-discussion.1ae68d9.jpg";

/***/ }),

/***/ "J8Lv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//

// Module expects:
// - heading
// - byline (optional)
exports.default = {
  name: 'component_bigHeading',
  props: ['data']
};

/***/ }),

/***/ "JYzC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _bus = __webpack_require__("EJZp");

var _appConstants = __webpack_require__("y3R9");

var _imageUtils = __webpack_require__("Rn8A");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Libs
exports.default = {

  props: ['item'],

  data: function data() {
    return {
      tapped: false,
      contentHeight: 0,
      imageContentHeight: 0,
      imageContentWidth: 0,
      handleTapFunc: null
    };
  },


  computed: {
    backgroundImageStyles: function backgroundImageStyles() {
      var imageContentHeight = this.imageContentHeight,
          imageContentWidth = this.imageContentWidth;

      var src = this.item.featuredImage.imageSrc;

      var maxDim = Math.max(imageContentWidth, imageContentHeight);
      var rUrl = (0, _imageUtils.getResponsiveUrl)(src, maxDim);
      var styles = {
        backgroundImage: 'url(' + rUrl + ')'
      };
      return styles;
    },
    isDesktop: function isDesktop() {
      return this.$store.getters.isDesktop;
    },
    currentWidth: function currentWidth() {
      return this.$store.state.width;
    },
    infoStyles: function infoStyles() {
      var bottom = Math.abs(this.contentBottom);
      var margin = _appConstants.ArticleTile.articleMargin;
      var styles = {};
      if (this.isDesktop) {
        styles.marginBottom = bottom + margin + 'px';
      }
      return styles;
    },
    infoContentStyles: function infoContentStyles() {
      var styles = {};
      if (this.isDesktop) {
        styles.bottom = this.contentBottom + 'px';
      }
      return styles;
    },
    contentBottom: function contentBottom() {
      var overlap = _appConstants.ArticleTile.articleInfoOverlap;
      return overlap - this.contentHeight;
    }
  },

  methods: {
    touchHandler: function touchHandler(e) {
      if (this.tapped === false) {
        e.preventDefault();
        this.tapped = !this.tapped;
        _bus.Bus.$emit(_appConstants.Events.TappedArticle, this.item.slug);
      }
    },
    measureLayout: function measureLayout() {
      this.contentHeight = this.getInfoContentHeight();
      this.imageContentHeight = this.getImageContentHeight();
      this.imageContentWidth = this.getImageContentWidth();
    },
    getInfoContentHeight: function getInfoContentHeight() {
      var el = this.$refs.infoContent;
      return el ? el.clientHeight : 0;
    },
    getImageContentHeight: function getImageContentHeight() {
      var el = this.$refs.articleImage;
      return el ? el.clientHeight : 0;
    },
    getImageContentWidth: function getImageContentWidth() {
      var el = this.$refs.articleImage;
      return el ? el.clientWidth : 0;
    }
  },

  watch: {
    currentWidth: function currentWidth() /* newVal, oldVal */{
      var _this = this;

      _vue2.default.nextTick(function () {
        _this.measureLayout();
      });
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.measureLayout();
    this.handleBusTapEventFunc = function (slug) {
      // console.log(slug, this.item.slug);
      if (_this2.item.slug !== slug) {
        _this2.tapped = false;
      }
    };
    _bus.Bus.$on(_appConstants.Events.TappedArticle, this.handleBusTapEventFunc);
  },
  beforeDestroy: function beforeDestroy() {
    _bus.Bus.$off(_appConstants.Events.TappedArticle, this.handleBusTapEventFunc);
  }
};

// Utils


// Components

/***/ }),

/***/ "Jn7d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatterArticles_vue__ = __webpack_require__("sWJL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatterArticles_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatterArticles_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatterArticles_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatterArticles_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dbecc5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MatterArticles_vue__ = __webpack_require__("S8ZO");
function injectStyle (ssrContext) {
  __webpack_require__("ljI3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7dbecc5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatterArticles_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dbecc5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MatterArticles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JtxL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _companyInfo = __webpack_require__("2Tf9");

var _companyInfo2 = _interopRequireDefault(_companyInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

  name: 'layoutFooter',

  data: function data() {
    return {
      companyInfo: _companyInfo2.default
    };
  },

  methods: {

    scrollTo: function scrollTo(hash) {
      // vue-router won't scroll to anchors if you already browsed to it
      // because the url is identical and it boots out
      // use native click as a fallback
      location.href = hash;
    }

  }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "KPtl":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "KeDd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"work-related-articles"}},[_c('div',{staticClass:"module-layout"},[_c('div',{staticClass:"section-title"},[_vm._v("Related Work")]),_vm._v(" "),(_vm.haveArticleLeft)?_c('div',{staticClass:"content-container left",class:_vm.containerClasses},[_c('mouse-event-container',[_c('router-link',{staticClass:"no-hover",attrs:{"to":_vm.getRouterLink(_vm.articleContentLeft)}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.articleContentLeft.headline))])]),_vm._v(" "),_c('router-link',{attrs:{"to":_vm.getRouterLink(_vm.articleContentLeft)}},[_vm._v("\n          "+_vm._s(_vm.articleContentLeft.linkText)+"\n        ")])],1)],1):_vm._e(),_vm._v(" "),(_vm.haveArticleRight)?_c('div',{staticClass:"content-container right",class:_vm.containerClasses},[_c('mouse-event-container',[_c('router-link',{staticClass:"no-hover",attrs:{"to":_vm.getRouterLink(_vm.articleContentRight)}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.articleContentRight.headline))])]),_vm._v(" "),_c('router-link',{attrs:{"to":_vm.getRouterLink(_vm.articleContentRight)}},[_vm._v("\n          "+_vm._s(_vm.articleContentRight.linkText)+"\n        ")])],1)],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kl68":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sunburst.cefe549.svg";

/***/ }),

/***/ "L/Q9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FourOhFour_vue__ = __webpack_require__("0r2s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FourOhFour_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FourOhFour_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FourOhFour_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FourOhFour_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04832df1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FourOhFour_vue__ = __webpack_require__("Mma6");
function injectStyle (ssrContext) {
  __webpack_require__("MwAT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04832df1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FourOhFour_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04832df1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FourOhFour_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "L25W":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dragon-racers.93e5dcb.jpg";

/***/ }),

/***/ "L6Nz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"image"}},[_c('img',{attrs:{"src":_vm.output,"alt":_vm.data.alt}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LFK+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  slug: 'taco-recombinator',
  company: "Particle Design",
  logo: null,
  blurb: {
    headline: "Sometimes you just want tacos.",
    tags: [],
    background: __webpack_require__("nFlW")
  },
  content: ["# title\ncase study here - ideally would be able to write a super long module-esque nesting thing"]
};

/***/ }),

/***/ "LM1A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_map_vue__ = __webpack_require__("fo8f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_map_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_map_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_map_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_351a5560_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("MSGa");
function injectStyle (ssrContext) {
  __webpack_require__("O9k8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_map_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_351a5560_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LUn9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/crystal.2c57533.png";

/***/ }),

/***/ "Lj5t":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/eureka_tall.1b6c56d.svg";

/***/ }),

/***/ "M/uQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partners_vue__ = __webpack_require__("IdUJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partners_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partners_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partners_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partners_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_039c20fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partners_vue__ = __webpack_require__("pKud");
function injectStyle (ssrContext) {
  __webpack_require__("5Z09")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partners_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_039c20fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partners_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "M0MU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{attrs:{"data-module":"image"}},[_c('img',{attrs:{"src":_vm.output}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74f09ff3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Ij5r");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74f09ff3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MFCq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MHjq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
  THIS FILE IS GENERATED !!

  #> npm run gen:work-category-index
  #> NETLIFY_ENV=development npm run gen:work-category-index
*/
/* eslint-disable */

exports.default = { "undefined": [{ "category": "strategy", "colSpan": 1, "client": "particleDesign", "date": "2018-10-11", "headline": "3 Ways Rapid Prototyping Inspires Meaningful Experiences ", "image": { "aspect": "landscape", "imageSrc": "/static/content/uploads/pdsite_matter_rapidprototyping_header.jpg", "src": "/static/content/uploads/pdsite_matter_rapidprototyping_header.jpg" }, "isMatterArticle": true, "isShown": true, "linkText": "3 Ways Rapid Prototyping Inspires Meaningful Experiences ", "slug": "3-ways-rapid-prototyping-inspires-meaningful-experiences", "tileOffset": "none", "url": "/matter/3-ways-rapid-prototyping-inspires-meaningful-experiences" }], "artificial-intelligence": [{ "category": "technology", "colSpan": 1, "client": "particleDesign", "date": "2018-10-04", "group": "2", "headline": "5 Principles for Designing Artificial Intelligence ", "image": { "aspect": "square", "imageSrc": "/static/content/uploads/randall-bruder-136626-unsplash.jpg", "src": "/static/content/uploads/randall-bruder-136626-unsplash.jpg" }, "isMatterArticle": true, "isShown": true, "linkText": "5 Principles for Designing Artificial Intelligence ", "slug": "5-principles-for-designing-artificial-intelligence", "tileOffset": "none", "url": "/matter/5-principles-for-designing-artificial-intelligence" }, { "category": "technology", "colSpan": 1, "client": "particleDesign", "date": "2018-12-20", "group": "2", "headline": "Artificial Intelligence Needs a Design Makeover", "image": { "aspect": "portrait", "imageSrc": "/static/content/uploads/jj-ying-787486-unsplash.jpg", "src": "/static/content/uploads/jj-ying-787486-unsplash.jpg" }, "isMatterArticle": true, "isShown": true, "linkText": "Artificial Intelligence Needs a Design Makeover", "slug": "artificial-intelligence-needs-a-design-makeover", "tileOffset": "none", "url": "/matter/artificial-intelligence-needs-a-design-makeover" }, { "category": "technology", "colSpan": 1, "client": "particleDesign", "date": "2018-06-15", "group": "3", "headline": "Video Talk: Crystal Rutland and the Future of UX in the AI Revolution ", "image": { "aspect": "landscape", "imageSrc": "/static/content/uploads/dw2018_particledesign_speakers_crystalrutland.jpg", "src": "/static/content/uploads/dw2018_particledesign_speakers_crystalrutland.jpg" }, "isMatterArticle": true, "isShown": true, "linkText": "Video Talk: Crystal Rutland and the Future of UX in the AI Revolution ", "slug": "crystal-rutland-founder-of-particle-design", "tileOffset": "none", "url": "/matter/crystal-rutland-founder-of-particle-design" }, { "category": "technology", "colSpan": 1, "client": "particleDesign", "date": "2018-06-21", "group": "3", "headline": "Video Talk: Josh Lovejoy's Human-Centered Approach to AI ", "image": { "imageSrc": "/static/content/uploads/dw2018_particledesign_speakers_joshlovejoy.jpg", "src": "/static/content/uploads/dw2018_particledesign_speakers_joshlovejoy.jpg" }, "isMatterArticle": true, "isShown": true, "linkText": "Video Talk: Josh Lovejoy's Human-Centered Approach to AI ", "slug": "josh-lovejoy-and-human-centered-ai", "tileOffset": "none", "url": "/matter/josh-lovejoy-and-human-centered-ai" }, { "category": "technology", "colSpan": 1, "client": "particleDesign", "date": "2018-09-19", "group": "2", "headline": "Let’s Not Repeat UX History", "image": { "aspect": "portrait", "imageSrc": "/static/content/uploads/markus-spiske-482453-unsplash.jpg", "src": "/static/content/uploads/markus-spiske-482453-unsplash.jpg" }, "isMatterArticle": true, "isShown": true, "linkText": "Let’s Not Repeat UX History", "slug": "let’s-not-repeat-ux-history", "tileOffset": "none", "url": "/matter/let’s-not-repeat-ux-history" }, { "category": "technology", "colSpan": 1, "client": "particleDesign", "date": "2018-08-22", "group": "2", "headline": "AI Must Be Designed for Transparency ", "image": { "aspect": "square", "imageSrc": "/static/content/uploads/phrenology-art-1-.png", "src": "/static/content/uploads/phrenology-art-1-.png" }, "isMatterArticle": true, "isShown": true, "linkText": "AI Must Be Designed for Transparency ", "slug": "surprise-ai-is-already-here-now-what", "tileOffset": "none", "url": "/matter/surprise-ai-is-already-here-now-what" }, { "category": "technology", "colSpan": 1, "client": "particleDesign", "date": "2018-04-24", "group": "4", "headline": "Video Talk: Anima Anandkumar and the Meaning of Data in the Age of AI", "image": { "imageSrc": "/static/content/uploads/dw2018_particledesign_speakers_animaanandkumar.jpg", "src": "/static/content/uploads/dw2018_particledesign_speakers_animaanandkumar.jpg" }, "isMatterArticle": true, "isShown": true, "linkText": "Video Talk: Anima Anandkumar and the Meaning of Data in the Age of AI", "slug": "video-talk-anima-anandkumar-and-the-question-of-data-in-the-age-of-ai", "tileOffset": "none", "url": "/matter/video-talk-anima-anandkumar-and-the-question-of-data-in-the-age-of-ai" }, { "category": "technology", "colSpan": 1, "client": "particleDesign", "date": "2018-05-31", "group": "3", "headline": "Video Talk: Brian David Johnson and the Future of AI ", "image": { "imageSrc": "/static/content/uploads/dw2018_particledesign_speakers_briandavidjohnson.jpg", "src": "/static/content/uploads/dw2018_particledesign_speakers_briandavidjohnson.jpg" }, "isMatterArticle": true, "isShown": true, "linkText": "Video Talk: Brian David Johnson and the Future of AI ", "slug": "video-talk-brian-david-johnson-and-the-future-of-ai", "tileOffset": "none", "url": "/matter/video-talk-brian-david-johnson-and-the-future-of-ai" }, { "client": "particleDesign", "colSpan": 1, "date": "2018-12-18", "group": "1", "headline": "Ushering in The Future Smart Car.", "image": { "src": "/static/content/uploads/work-ai-car.jpg", "aspect": "landscape", "hAlign": "center", "vAlign": "center" }, "isShown": true, "isWorkArticle": true, "linkText": "Learn more about our work in Transportation.", "slug": "ai-future-smart-car", "tileOffset": "small", "url": "/work/ai-future-smart-car" }, { "client": "particleDesign", "colSpan": 1, "date": "2018-12-20", "group": "1", "headline": "When AI and Wearables Meet.", "image": { "src": "/static/content/uploads/work-machine-learning-wearable.jpg", "aspect": "square", "hAlign": "center", "vAlign": "center" }, "isShown": true, "isWorkArticle": true, "linkText": "Learn more about our work in Artificial Intelligence.", "slug": "machine-learning-wearable-development", "tileOffset": "small", "url": "/work/machine-learning-wearable-development" }, { "client": "vh1", "colSpan": 2, "date": "2018-12-20", "group": "1", "headline": "Designing AI for Virgin Hyperloop One.", "image": { "src": "/static/content/uploads/work-vho-tube-outside.jpg", "aspect": "landscape", "hAlign": "center", "vAlign": "center" }, "isShown": true, "isWorkArticle": true, "linkText": "Learn more about our work with Virgin Hyperloop One", "slug": "vho-incorporating-ux-ai-software", "tileOffset": "small", "url": "/work/vho-incorporating-ux-ai-software" }], "transportation": [{ "category": "technology", "colSpan": 1, "client": "particleDesign", "date": "2018-11-19", "group": "1", "headline": "We Need to Design Autonomous Vehicles for Trust. Here's How. ", "image": { "imageSrc": "/static/content/uploads/pdsite_matter_avtrust_graphic3_headerratio.jpg", "src": "/static/content/uploads/pdsite_matter_avtrust_graphic3_headerratio.jpg" }, "isMatterArticle": true, "isShown": true, "linkText": "We Need to Design Autonomous Vehicles for Trust. Here's How. ", "slug": "what-does-designing-for-trust-mean-the-case-of-the-smart-car", "tileOffset": "none", "url": "/matter/what-does-designing-for-trust-mean-the-case-of-the-smart-car" }, { "client": "honeywell", "colSpan": 1, "date": "2018-06-08", "group": "1", "headline": "A New Future of Global Shipping.", "image": { "src": "/static/content/uploads/work-honeywell-tile.jpg", "aspect": "square", "hAlign": "center", "vAlign": "center" }, "isShown": true, "isWorkArticle": true, "linkText": "Learn more about our work with Honeywell", "slug": "dhl-honeywell-iot-shipping", "tileOffset": "small", "url": "/work/dhl-honeywell-iot-shipping" }, { "client": "jaguar", "colSpan": 2, "date": "2018-06-07", "group": "1", "headline": "Reimagining IVI Design for a New Electric Vehicle.", "image": { "src": "/static/content/uploads/work-lr-ev-hero.jpg", "aspect": "landscape", "hAlign": "center", "vAlign": "center" }, "isShown": true, "isWorkArticle": true, "linkText": "Learn more about our work with Jaguar Land Rover", "slug": "jlr-electric-vehicle", "tileOffset": "medium", "url": "/work/jlr-electric-vehicle" }, { "client": "landrover", "colSpan": 1, "date": "2018-06-07", "group": "1", "headline": "The Luxury Vehicle of Tomorrow.", "image": { "src": "/static/content/uploads/work-jlr-2020-tile.jpg", "aspect": "landscape", "hAlign": "center", "vAlign": "center" }, "isShown": true, "isWorkArticle": true, "linkText": "Learn more about our work with Jaguar Land Rover", "slug": "jlr-future-car", "tileOffset": "medium", "url": "/work/jlr-future-car" }, { "client": "vh1", "colSpan": 1, "date": "2018-1-4", "group": "1", "headline": "How we designed a new way to think about travel.", "image": { "src": "/static/content/uploads/work-vho-pod-city.jpg", "aspect": "landscape", "hAlign": "center", "vAlign": "center" }, "isShown": true, "isWorkArticle": true, "linkText": "Learn more about our work with Virgin Hyperloop One.", "slug": "vho-ai-transportation-rider-app", "tileOffset": "small", "url": "/work/vho-ai-transportation-rider-app" }] };

/***/ }),

/***/ "MIUD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'module_hcAboutIntro'
};

/***/ }),

/***/ "MSGa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"map"}},[_c('div',{staticClass:"map__container"},[_c('img',{attrs:{"src":_vm.data.src,"alt":_vm.data.alt}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MbGc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"matter-article",class:{'tapped': _vm.tapped},attrs:{"data-orientation":_vm.item.featuredImage.aspect}},[_c('router-link',{directives:[{name:"touch",rawName:"v-touch",value:(_vm.touchHandler),expression:"touchHandler"}],attrs:{"to":{ path: _vm.item.url, params: { url: _vm.item.url, data: _vm.item.data } }}},[_c('div',{ref:"articleImage",staticClass:"matter-article__image",style:(_vm.backgroundImageStyles),attrs:{"data-orientation":_vm.item.featuredImage.aspect}}),_vm._v(" "),_c('div',{staticClass:"matter-article__info",style:(_vm.infoStyles),attrs:{"data-orientation":_vm.item.featuredImage.aspect}},[_c('div',{ref:"infoContent",staticClass:"matter-article__info-content",style:(_vm.infoContentStyles)},[_c('span',{staticClass:"matter-article__category"},[_vm._v("\n          "+_vm._s(_vm.item.category)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"matter-article__title"},[_vm._v("\n          "+_vm._s(_vm.item.title)+"\n        ")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MdCA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/preview-mobile.c4efb9e.jpg";

/***/ }),

/***/ "MhMP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MhNn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _default = __webpack_require__("lfHO");

var _default2 = _interopRequireDefault(_default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

  name: 'WorkArticle',

  metaInfo: function metaInfo() {
    return {
      title: this.articleTitle
    };
  },


  props: ['url', 'slug', 'workArticles'],

  components: { defaultLayout: _default2.default },

  data: function data() {
    return {

      // json structure of the article
      post: null,

      isLoading: false,
      error: null
    };
  },


  computed: {
    articleData: function articleData() {
      var slug = this.slug,
          workArticles = this.workArticles;

      return workArticles[slug] || null;
    },
    articleTitle: function articleTitle() {
      var articleTileHeadline = this.articleTileHeadline,
          articleModuleTitle = this.articleModuleTitle;

      return articleModuleTitle || articleTileHeadline || 'Particle Design';
    },
    articleModuleTitle: function articleModuleTitle() {
      var articleData = this.articleData;

      var modules = articleData.modules || [];
      var first = modules[0] || {};
      var data = first.data || {};
      return data.title || null;
    },
    articleTileHeadline: function articleTileHeadline() {
      var articleData = this.articleData;

      var tile = articleData ? articleData.tile : {};
      return tile.headline || null;
    }
  },

  methods: {
    retrieveArticleData: function retrieveArticleData() {
      var _this = this;

      var articleData = this.articleData,
          slug = this.slug;

      if (articleData !== null) {
        this.isLoading = false;
        this.post = articleData;
      } else {
        var url = '/static/content/work/' + slug + '.json';
        this.isLoading = true;
        this.post = null;
        this.$store.dispatch('loadWorkArticleData', { url: url }).then(function () {
          _this.isLoading = false;
          _this.error = false;
        }).catch(function (err) {
          console.warn('ERROR loading article data', err);
          _this.isLoading = false;
          _this.error = true;
          _this.requestRetrieveArticleData();
        });
      }
    },
    requestRetrieveArticleData: function requestRetrieveArticleData() {
      var _this2 = this;

      var delay = 500;
      console.warn('Will load data in ' + delay + ' ms');
      setTimeout(function () {
        console.warn('Attempting to load article data');
        _this2.retrieveArticleData();
      }, delay);
    }
  },

  watch: {

    $route: 'retrieveArticleData'

  },

  created: function created() {
    this.retrieveArticleData();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "MkAP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nav = __webpack_require__("eops");

var _nav2 = _interopRequireDefault(_nav);

var _companyInfo = __webpack_require__("2Tf9");

var _companyInfo2 = _interopRequireDefault(_companyInfo);

var _throttle = __webpack_require__("+X65");

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'layoutNavigation',
  props: ['scrollPosition'],
  data: function data() {
    return {
      nav: _nav2.default,
      companyInfo: _companyInfo2.default,
      hamburgerVisible: false,
      breakpoints: {
        hamburger: {
          size: [0, 1024],
          isBreakpoint: false
        },
        desktop: {
          size: [1024, 10000],
          isBreakpoint: false
        }
      }
    };
  },

  computed: {
    navClasses: function navClasses() {
      var classes = {};

      for (var key in this.breakpoints) {
        var breakpoint = this.breakpoints[key];
        if (breakpoint.isBreakpoint) {
          classes['bp--' + key] = true;
        }
      }

      classes['has-overlay'] = this.$store.state.scrollDirection === 'up' || this.scrollPosition <= 0;

      return classes;
    }
  },
  methods: {
    shouldNavHaveOverlay: function shouldNavHaveOverlay() {
      var scrollState = this.$store.state.scrollState;

      // if no nav scroll anchor, assume we should always show the bar
      if (!scrollState.beginNavOverlay) {
        return true;
      }

      if (scrollState.beginNavOverlay && scrollState.beginNavOverlay.isAboveViewport) {
        return true;
      }

      return false;
    },
    checkBreakpoints: function checkBreakpoints() {
      var width = window.innerWidth;
      var breakpoints = this.breakpoints;
      for (var key in breakpoints) {
        var breakpoint = breakpoints[key];

        if (width > breakpoint.size[0] && width <= breakpoint.size[1]) {
          breakpoints[key].isBreakpoint = true;
        } else {
          breakpoints[key].isBreakpoint = false;
        }
      }
      this.breakpoints = breakpoints;
    },

    toggleHamburgerVisibility: function toggleHamburgerVisibility() {
      this.hamburgerVisible = !this.hamburgerVisible;
    },
    handleMenuClick: function handleMenuClick() /* event */{
      this.closeNavMenu();
    },
    closeNavMenu: function closeNavMenu() {
      this.hamburgerVisible = false;
    }
  },

  mounted: function mounted() {
    this.checkBreakpoints();

    this.handleResize = (0, _throttle2.default)(this.checkBreakpoints, 50);
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "Mma6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"four-oh-four"}},[_c('div',{staticClass:"module-layout"},[_c('div',{ref:"imageContainer",staticClass:"image-container",class:_vm.imageContainerClasses},[_c('div',{staticClass:"image",style:(_vm.imageStyles)})]),_vm._v(" "),_c('div',{staticClass:"content-container",class:_vm.containerClasses},[(_vm.shouldShowTitle)?_c('h1',{domProps:{"innerHTML":_vm._s(_vm.contentTitle)}}):_vm._e(),_vm._v(" "),_c('markdown',{staticClass:"markdown"},[_vm._v(_vm._s(_vm.contentBody))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MwAT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N8oW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scroll-container',{staticClass:"site section",class:_vm.scrollClasses,attrs:{"data-page":_vm.page},on:{"change":_vm.updateMonitorState}},[_c('Navigation',{attrs:{"scrollPosition":_vm.scrollPosition}}),_vm._v(" "),_c('main',[_vm._t("default",null,{"scrollPosition":_vm.scrollPosition,"window":_vm.window,"monitorState":_vm.monitorState})],2),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NFb/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:_vm.navClasses},[(this.breakpoints.hamburger.isBreakpoint)?[_c('div',{staticClass:"nav--hamburger",class:{'expanded': this.hamburgerVisible}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"nav__bar"},[_c('router-link',{staticClass:"logo",attrs:{"to":{ name: 'homepage' }},nativeOn:{"click":function($event){return _vm.handleMenuClick.apply(null, arguments)}}},[_c('img',{attrs:{"src":__webpack_require__("AqYs"),"alt":""}})]),_vm._v(" "),_c('button',{staticClass:"nav__toggle",on:{"click":_vm.toggleHamburgerVisibility}},[_c('span',{staticClass:"copy"},[_vm._v("Toggle Nav")])])],1),_vm._v(" "),_c('div',{staticClass:"nav__content"},[_c('ul',{staticClass:"nav-links"},_vm._l((_vm.nav),function(link){return _c('li',{key:link.text,staticClass:"nav-link"},[_c('router-link',{attrs:{"to":{ name: link.name, params: link.params }},nativeOn:{"click":function($event){return _vm.handleMenuClick.apply(null, arguments)}}},[_vm._v("\n              "+_vm._s(link.text)+"\n            ")])],1)}),0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('ul',{staticClass:"footer-links"},_vm._l((_vm.companyInfo.socialMedia),function(link){return _c('li',{key:link.platform,staticClass:"footer-link"},[_c('a',{attrs:{"href":link.url}},[_vm._v(_vm._s(link.platform))])])}),0)])])]:[_c('router-link',{staticClass:"logo",attrs:{"to":{ name: 'homepage' }}},[_c('img',{attrs:{"src":__webpack_require__("AqYs"),"alt":""}})]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"nav__content"},[_c('ul',{staticClass:"nav-links"},_vm._l((_vm.nav),function(link){return _c('li',{key:link.text},[_c('router-link',{attrs:{"to":{ name: link.name, params: link.params }}},[_vm._v("\n              "+_vm._s(link.text)+"\n              "),_c('div',{staticClass:"spacer"})])],1)}),0)])]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"announcement"}},[_c('div',{staticClass:"announcement__content"},[_c('p',{staticClass:"lead"},[_vm._v("In the machine economy of 2030, UX will be key for success.")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("Wind River acquires Particle Design.")]),_vm._v(" "),_c('button',[_c('a',{attrs:{"href":"https://www.windriver.com/news/press/news-20210920"}},[_vm._v("Read the press release")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spacers"},[_c('span',{staticClass:"spacer"}),_vm._v(" "),_c('span',{staticClass:"spacer"}),_vm._v(" "),_c('span',{staticClass:"spacer"}),_vm._v(" "),_c('span',{staticClass:"spacer"}),_vm._v(" "),_c('span',{staticClass:"spacer"}),_vm._v(" "),_c('span',{staticClass:"spacer"}),_vm._v(" "),_c('span',{staticClass:"spacer"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"hire-us"},[_vm._v("\n          Plan a project\n          "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"/contact"}},[_vm._v("Hire Us")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"announcement"}},[_c('div',{staticClass:"announcement__content"},[_c('p',{staticClass:"lead"},[_vm._v("In the machine economy of 2030, UX will be key for success.")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("Wind River acquires Particle Design.")]),_vm._v(" "),_c('button',[_c('a',{attrs:{"href":"https://www.windriver.com/news/press/news-20210920"}},[_vm._v("Read the press release")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vueScrollmonitor = __webpack_require__("Wk7A");

var _vueScrollmonitor2 = _interopRequireDefault(_vueScrollmonitor);

var _vue2TouchEvents = __webpack_require__("ufW0");

var _vue2TouchEvents2 = _interopRequireDefault(_vue2TouchEvents);

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__("j1ja");

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

var _googleAnalytics = __webpack_require__("iZuN");

var _googleAnalytics2 = _interopRequireDefault(_googleAnalytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
_vue2.default.filter('formatDate', function (value) {
  return value ? (0, _moment2.default)(String(value)).format('MMMM Do, YYYY') : '';
});

_vue2.default.use(_vueScrollmonitor2.default);
_vue2.default.use(_vue2TouchEvents2.default);

_vue2.default.config.productionTip = false;

/* eslint-disable no-new */
new _vue2.default({
  el: '#app',
  router: _router2.default,
  template: '<App/>',
  components: { App: _App2.default }
});

_googleAnalytics2.default.use(_router2.default);

/***/ }),

/***/ "Np4h":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "NtwM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__("ZRZ2");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'module_featuredItems',
  props: ['data', 'window'],
  data: function data() {
    return {
      masonry: {
        breakpoint: [1024, 10000],
        container: '[id="homepageFeaturedWork"]',
        columns: 2,
        set: false
      },
      preTapCheck: 0
    };
  },

  computed: {
    items: function items() {
      var refs = this.data.items;
      var itemType = this.data.itemType;
      var window = this.window;

      var items = refs.reduce(function (a, b) {
        if (_index2.default[b]) {
          _index2.default[b].itemType = itemType;
          a.push(_index2.default[b]);
        }

        return a;
      }, []);

      // add window data for use in blurb
      items.forEach(function (item) {
        item.window = window; // eslint-disable-line
      });

      return items;
    }
  },
  methods: {
    setMasonry: function setMasonry() {
      // HACK DIY masonry
      var cells = document.querySelectorAll(this.masonry.container + ' > *');
      if (!cells) {
        return;
      }

      var currentCol = 0;
      var cols = [];

      if (this.window.width <= this.masonry.breakpoint[0] || this.window.width > this.masonry.breakpoint[1]) {
        if (!this.masonry.set) {
          return;
        }
        for (var i = 0; i < cells.length; i += 1) {
          // reset margins while we're here
          cells[i].style.marginTop = 0;
        }

        return;
      }

      for (var _i = 0; _i < cells.length; _i += 1) {
        // set up the container if it doesn't exist
        if (!cols[currentCol]) {
          cols[currentCol] = [];
        }

        cols[currentCol].push(cells[_i]);

        if (currentCol < this.masonry.columns - 1) {
          currentCol += 1;
        } else {
          currentCol = 0;
        }

        // reset margins while we're here
        cells[_i].style.marginTop = 0;
      }

      // Loop through each column, looking back to determine how to space the items
      cols.forEach(function (col) {
        var colHeight = 0;
        for (var _i2 = 0; _i2 < col.length; _i2 += 1) {
          var item = col[_i2];
          var itemHeight = item.offsetHeight;

          // find out how offset the item is
          var itemOffset = item.offsetTop;

          // masonry effect:
          var diff = colHeight - itemOffset;
          item.style.marginTop = diff + 'px';

          // add item height to the column
          colHeight += itemHeight;
        }
      });

      this.masonry.set = true;
    }
  },
  mounted: function mounted() {
    setTimeout(this.setMasonry(), 5);
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "NvDy":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "O9k8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OYJs":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjAwcHgiIGhlaWdodD0iMjAwcHgiIHZpZXdCb3g9IjAgMCAyMDAgMjAwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OS4zICg1MTE2NykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+R3JvdXAgMTEgQ29weSA0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9Ik1haW4iIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJBcnRib2FyZC0zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjE3Ny4wMDAwMDAsIC0yMjI5LjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMTEtQ29weS00IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMTc3LjAwMDAwMCwgMjIyOS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJGaWxsLTE0NjQtQ29weS0yIiBmaWxsPSIjMTBCMUM5IiBwb2ludHM9IjAgMjAwIDIwMCAyMDAgMjAwIDAgMCAwIj48L3BvbHlnb24+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iRmlsbC0xNDY0LUNvcHkiIGZpbGw9IiMwMDAwMDAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwMC4wMDAwMDAsIDEwMC4wMDAwMDApIHNjYWxlKDEsIC0xKSB0cmFuc2xhdGUoLTEwMC4wMDAwMDAsIC0xMDAuMDAwMDAwKSAiIHBvaW50cz0iMCAyMDAgMjAwIDAgMCAwIj48L3BvbHlnb24+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ "Oezs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HolidayLanding2008_vue__ = __webpack_require__("o0pg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HolidayLanding2008_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HolidayLanding2008_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HolidayLanding2008_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HolidayLanding2008_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d1f2898_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HolidayLanding2008_vue__ = __webpack_require__("lJjj");
function injectStyle (ssrContext) {
  __webpack_require__("HQIC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HolidayLanding2008_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d1f2898_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HolidayLanding2008_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Of3d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"text_image_row","data-imagecount":_vm.imageCount}},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"main__content"},[_c('markdown',{staticClass:"markdown"},[_vm._v(_vm._s(_vm.data.content))])],1)]),_vm._v(" "),_c('div',{staticClass:"aside"},[_c('div',{staticClass:"aside__content"},_vm._l((_vm.imageRail),function(rail,i){return _c('div',{key:i,staticClass:"aside__image-rail"},_vm._l((rail),function(image){return _c('div',{key:image.src,staticClass:"aside__image",style:({ 'height': image.height, 'background-image': ("url(" + (image.src) + ")"), 'background-position': image.gravity }),attrs:{"data-primary":image.primary}},[_c('img',{attrs:{"src":image.src,"alt":""}})])}),0)}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OmGg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OqtW":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "OsZp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiImageText_vue__ = __webpack_require__("cNRn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiImageText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiImageText_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiImageText_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiImageText_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37e1c566_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiImageText_vue__ = __webpack_require__("+u5O");
function injectStyle (ssrContext) {
  __webpack_require__("naH/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37e1c566"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiImageText_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37e1c566_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiImageText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Otlw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('defaultLayout',{attrs:{"section":"matter-article"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('div',{staticClass:"matter-article-container"},[(_vm.hasFeaturedImage)?_c('article-header',{attrs:{"data":_vm.featuredImage}}):_vm._e(),_vm._v(" "),_c('article-body',{attrs:{"data":_vm.data}}),_vm._v(" "),_c('social-media-sharing',{attrs:{"data":_vm.data,"href":_vm.href}})],1)]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OytB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
*/

exports.default = {

  computed: {
    isDesktop: function isDesktop() {
      return this.$store.getters.isDesktop;
    },
    isMobile: function isMobile() {
      return this.$store.getters.isMobile;
    },
    isTablet: function isTablet() {
      return this.$store.getters.isTablet;
    },
    isReversed: function isReversed() {
      var reversed = this.data.reversed;

      return reversed === true ? reversed : false;
    },
    currentWidth: function currentWidth() {
      return this.$store.state.width;
    },
    deviceType: function deviceType() {
      var deviceStr = '';
      if (this.isMobile) {
        deviceStr = 'mobile';
      } else if (this.isTablet) {
        deviceStr = 'tablet';
      } else {
        deviceStr = 'desktop';
      }
      return deviceStr;
    }
  }

};

/***/ }),

/***/ "P3PI":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "P62E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PHN8":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "PMnj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentStaticMatterTile_vue__ = __webpack_require__("VZd/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentStaticMatterTile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentStaticMatterTile_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentStaticMatterTile_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentStaticMatterTile_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d061cf70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentStaticMatterTile_vue__ = __webpack_require__("eve6");
function injectStyle (ssrContext) {
  __webpack_require__("84Sb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d061cf70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentStaticMatterTile_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d061cf70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentStaticMatterTile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "PSBx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasHyperlink)?[_c('router-link',{staticClass:"no-hover",attrs:{"to":{ name: _vm.data.href.name, params: _vm.data.href.params }}},[_c('markdown',{staticClass:"markdown"},[_vm._v(_vm._s(_vm.data.content))])],1)]:[_c('markdown',{staticClass:"markdown"},[_vm._v(_vm._s(_vm.data.content))])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PewQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/vh1.aaa991f.svg";

/***/ }),

/***/ "Q/rj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjAwcHgiIGhlaWdodD0iMjAwcHgiIHZpZXdCb3g9IjAgMCAyMDAgMjAwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OS4zICg1MTE2NykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+cGllXzF4PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9Ik1haW4iIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJBcnRib2FyZC0zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTE1LjAwMDAwMCwgLTQxMy4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9InBpZV8xeCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTE1LjAwMDAwMCwgNDEzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkZpbGwtMi1Db3B5IiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjAgMjAwIDIwMCAyMDAgMjAwIDAgMCAwIj48L3BvbHlnb24+CiAgICAgICAgICAgICAgICA8ZyBpZD0icGllLWdyYXBoIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0Mi4wMDAwMDAsIDQyLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik01Ny42OTc2NDk1LDU4LjM5OTcwMDYgTDk4LjM0ODA2MzEsOTkuMDQ0MzQ3NSBDODcuOTQ0ODAyOSwxMDkuNDQ2MTMyIDczLjU3Mjc2NDEsMTE1Ljg3OTcwMSA1Ny42OTc2NDk1LDExNS44Nzk3MDEgQzI1Ljk0NzQyMDQsMTE1Ljg3OTg1IDAuMjA5NDk0MTc1LDkwLjE0NTU3NTMgMC4yMDk0OTQxNzUsNTguMzk5ODUwMyBDMC4yMDk0OTQxNzUsMjYuNjU0MTI1MyAyNS45NDc0MjA0LDAuOTE5ODUwMzEyIDU3LjY5NzY0OTUsMC45MTk4NTAzMTIgTDU3LjY5NzY0OTUsNTguMzk5NzAwNiBaIiBpZD0iQ29tYmluZWQtU2hhcGUiIGZpbGw9IiMwMDAwMDAiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNOTguMzQ3OTEzNCw5OS4wNDQ3OTY2IEMxMDguNzUxMTc0LDg4LjY0MzAxMjIgMTE1LjE4NTY1NSw3NC4yNzMwMTIyIDExNS4xODU2NTUsNTguNDAwMTQ5NyBDMTE1LjE4NTY1NSwyNi42NTQ0MjQ3IDg5LjQ0NzcyODksMC45MjAxNDk2ODggNTcuNjk3NDk5OCwwLjkyMDE0OTY4OCBMNTcuNjk3NDk5OCw1OC40MDAxNDk3IEw5OC4zNDc5MTM0LDk5LjA0NDc5NjYgWiIgaWQ9IkZpbGwtODAwIiBmaWxsPSIjRDRERDVEIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ "Q4na":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"contact-map"}},[_c('div',{staticClass:"module-layout"},[_c('div',{staticClass:"decoration-container",class:_vm.containerClasses},[_c('div',{attrs:{"data-ornament":"circle"}})]),_vm._v(" "),_c('div',{staticClass:"map-container",class:_vm.containerClasses},[_c('div',{staticClass:"image",style:(_vm.imageStyles)})]),_vm._v(" "),_c('div',{staticClass:"content-container",class:_vm.containerClasses},[_c('markdown',{staticClass:"markdown"},[_vm._v(_vm._s(_vm.contentText))]),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"contact-container",class:_vm.containerClasses},[_c('smart-address'),_vm._v(" "),_c('smart-phone')],1):_vm._e()],1),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"contact-container",class:_vm.containerClasses},[_c('smart-address'),_vm._v(" "),_c('smart-phone')],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q8be":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _bus = __webpack_require__("EJZp");

var _appConstants = __webpack_require__("y3R9");

var _imageUtils = __webpack_require__("Rn8A");

var _clients = __webpack_require__("fL60");

var _clients2 = _interopRequireDefault(_clients);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

  props: ['record'],

  data: function data() {
    return {
      isTapped: false,
      imageContentHeight: 0,
      imageContentWidth: 0,
      handleBusTapEventFunc: null
    };
  },


  computed: {
    clientInfo: function clientInfo() {
      var client = this.record.client;

      return _clients2.default[client] || {};
    },
    logoSrc: function logoSrc() {
      var logo = this.clientInfo.logo;

      return logo;
    },
    tileClasses: function tileClasses() {
      var isTapped = this.isTapped;

      return {
        tapped: isTapped
      };
    },
    bgImageStyles: function bgImageStyles() {
      var imageContentHeight = this.imageContentHeight,
          imageContentWidth = this.imageContentWidth,
          record = this.record;
      var image = record.image;
      var src = image.src,
          hA = image.hAlign,
          vA = image.vAlign;

      // add defaults

      var hAlign = hA || 'center';
      var vAlign = vA || 'center';

      var maxDim = Math.max(imageContentWidth, imageContentHeight);
      var rUrl = (0, _imageUtils.getResponsiveUrl)(src, maxDim);

      var styles = {
        backgroundImage: 'url(' + rUrl + ')',
        backgroundPosition: hAlign + ' ' + vAlign
      };
      return styles;
    },
    routerLinkTo: function routerLinkTo() {
      var _record = this.record,
          url = _record.url,
          data = _record.data;

      return {
        path: url,
        params: {
          url: url,
          data: data
        }
      };
    },
    currentBrowserWidth: function currentBrowserWidth() {
      return this.$store.state.width;
    }
  },

  methods: {
    touchHandler: function touchHandler(e) {
      var slug = this.record.slug;

      if (this.isTapped === true) {
        // double-tap: do default handling
        // console.warn(`double tap on ${slug}`);
      } else {
        // single-tap: show article content
        // console.warn(`single tap on ${slug}`);
        e.preventDefault();
        this.isTapped = true;
        _bus.Bus.$emit(_appConstants.Events.TappedArticle, slug);
      }
    },
    measureLayout: function measureLayout() {
      this.imageContentHeight = this.getImageContentHeight();
      this.imageContentWidth = this.getImageContentWidth();
    },
    getImageContentHeight: function getImageContentHeight() {
      var el = this.$refs.imageContainer;
      return el ? el.clientHeight : 0;
    },
    getImageContentWidth: function getImageContentWidth() {
      var el = this.$refs.articleImage;
      return el ? el.clientWidth : 0;
    }
  },

  watch: {
    currentBrowserWidth: function currentBrowserWidth() /* newVal, oldVal */{
      var _this = this;

      _vue2.default.nextTick(function () {
        _this.measureLayout();
      });
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.measureLayout();
    this.handleBusTapEventFunc = function (slug) {
      var tapIsMe = _this2.record.slug === slug;
      // console.log('tap event', tapIsMe, this.record.slug);
      if (!tapIsMe) {
        // reset any previous tapped state
        _this2.isTapped = false;
      }
    };
    _bus.Bus.$on(_appConstants.Events.TappedArticle, this.handleBusTapEventFunc);
  },
  beforeDestroy: function beforeDestroy() {
    _bus.Bus.$off(_appConstants.Events.TappedArticle, this.handleBusTapEventFunc);
    this.handleBusTapEventFunc = null;
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  this component fits to the size of its container
  width: 100%; height: 100%;
  so container must define size and location
*/
// Libs

/***/ }),

/***/ "QHDi":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "QbIR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/preview-mobile.54f3761.jpg";

/***/ }),

/***/ "QdRU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavSpacer_vue__ = __webpack_require__("Wv9z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavSpacer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavSpacer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavSpacer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavSpacer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15dfee1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavSpacer_vue__ = __webpack_require__("XQf3");
function injectStyle (ssrContext) {
  __webpack_require__("huw7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavSpacer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15dfee1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavSpacer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "R+WO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R016":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RLYt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _bus = __webpack_require__("EJZp");

var _appConstants = __webpack_require__("y3R9");

var _WorkMixin = __webpack_require__("OytB");

var _WorkMixin2 = _interopRequireDefault(_WorkMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  this component fits to the size of its container
  width: 100%; height: 100%;
  so container must define size and location
*/
// Libs
exports.default = {

  name: 'category-page-tile',

  mixins: [_WorkMixin2.default],

  props: ['record'],

  data: function data() {
    return {
      isTapped: false,
      handleBusTapEventFunc: null,
      headlineContentHeight: 0,
      tileContentHeight: 0
    };
  },


  computed: {
    containerClasses: function containerClasses() {
      var isMobile = this.isMobile,
          isTablet = this.isTablet;
      // return class string, eg 'desktop', 'mobile'

      var deviceStr = '';
      if (isMobile) {
        deviceStr = 'mobile';
      } else if (isTablet) {
        deviceStr = 'tablet';
      } else {
        deviceStr = 'desktop';
      }
      return deviceStr;
    },
    routerLinkTo: function routerLinkTo() {
      var _record = this.record,
          url = _record.url,
          data = _record.data;

      return {
        path: url,
        params: {
          url: url,
          data: data
        }
      };
    },
    currentBrowserWidth: function currentBrowserWidth() {
      return this.$store.state.width;
    }
  },

  methods: {

    // called from parent
    calculateTileAdjustment: function calculateTileAdjustment() {
      this.measureLayout();
      var isDesktop = this.isDesktop,
          isTablet = this.isTablet,
          headlineContentHeight = this.headlineContentHeight;

      var lineHeight = 60; // account for 1 line

      var realHeight = headlineContentHeight;
      // adjust with margin from below
      if (isDesktop) {
        realHeight -= 22;
      } else if (isTablet) {
        realHeight -= 12;
      } else {
        realHeight -= 24;
      }

      var diff = realHeight - lineHeight;
      var ff = 5; // 5 used as fudge factor
      return diff > -ff && diff < ff ? 0 : 40;
    },
    getHeadlineContentHeight: function getHeadlineContentHeight() {
      var el = this.$refs.headlineContent;
      return el ? el.clientHeight : 0;
    },
    getTileContentHeight: function getTileContentHeight() {
      var el = this.$refs.tileContent;
      return el ? el.clientHeight : 0;
    },
    measureLayout: function measureLayout() {
      this.headlineContentHeight = this.getHeadlineContentHeight();
      this.tileContentHeight = this.getTileContentHeight();
    },
    touchHandler: function touchHandler() {
      var slug = this.record.slug;

      _bus.Bus.$emit(_appConstants.Events.TappedArticle, slug);
    }
  },

  watch: {
    currentBrowserWidth: function currentBrowserWidth() /* newVal, oldVal */{
      var _this = this;

      _vue2.default.nextTick(function () {
        _this.measureLayout();
      });
    }
  },

  mounted: function mounted() {
    this.measureLayout();
  }
};

/***/ }),

/***/ "RWjT":
/***/ (function(module, exports) {

module.exports = {"100":"💯","1234":"🔢","grinning":"😀","smiley":"😃","smile":"😄","grin":"😁","laughing":"😆","satisfied":"😆","sweat_smile":"😅","joy":"😂","rofl":"🤣","relaxed":"☺️","blush":"😊","innocent":"😇","slightly_smiling_face":"🙂","upside_down_face":"🙃","wink":"😉","relieved":"😌","heart_eyes":"😍","kissing_heart":"😘","kissing":"😗","kissing_smiling_eyes":"😙","kissing_closed_eyes":"😚","yum":"😋","stuck_out_tongue_winking_eye":"😜","stuck_out_tongue_closed_eyes":"😝","stuck_out_tongue":"😛","money_mouth_face":"🤑","hugs":"🤗","nerd_face":"🤓","sunglasses":"😎","clown_face":"🤡","cowboy_hat_face":"🤠","smirk":"😏","unamused":"😒","disappointed":"😞","pensive":"😔","worried":"😟","confused":"😕","slightly_frowning_face":"🙁","frowning_face":"☹️","persevere":"😣","confounded":"😖","tired_face":"😫","weary":"😩","triumph":"😤","angry":"😠","rage":"😡","pout":"😡","no_mouth":"😶","neutral_face":"😐","expressionless":"😑","hushed":"😯","frowning":"😦","anguished":"😧","open_mouth":"😮","astonished":"😲","dizzy_face":"😵","flushed":"😳","scream":"😱","fearful":"😨","cold_sweat":"😰","cry":"😢","disappointed_relieved":"😥","drooling_face":"🤤","sob":"😭","sweat":"😓","sleepy":"😪","sleeping":"😴","roll_eyes":"🙄","thinking":"🤔","lying_face":"🤥","grimacing":"😬","zipper_mouth_face":"🤐","nauseated_face":"🤢","sneezing_face":"🤧","mask":"😷","face_with_thermometer":"🤒","face_with_head_bandage":"🤕","smiling_imp":"😈","imp":"👿","japanese_ogre":"👹","japanese_goblin":"👺","hankey":"💩","poop":"💩","shit":"💩","ghost":"👻","skull":"💀","skull_and_crossbones":"☠️","alien":"👽","space_invader":"👾","robot":"🤖","jack_o_lantern":"🎃","smiley_cat":"😺","smile_cat":"😸","joy_cat":"😹","heart_eyes_cat":"😻","smirk_cat":"😼","kissing_cat":"😽","scream_cat":"🙀","crying_cat_face":"😿","pouting_cat":"😾","open_hands":"👐","raised_hands":"🙌","clap":"👏","pray":"🙏","handshake":"🤝","+1":"👍","thumbsup":"👍","-1":"👎","thumbsdown":"👎","fist_oncoming":"👊","facepunch":"👊","punch":"👊","fist_raised":"✊","fist":"✊","fist_left":"🤛","fist_right":"🤜","crossed_fingers":"🤞","v":"✌️","metal":"🤘","ok_hand":"👌","point_left":"👈","point_right":"👉","point_up_2":"👆","point_down":"👇","point_up":"☝️","hand":"✋","raised_hand":"✋","raised_back_of_hand":"🤚","raised_hand_with_fingers_splayed":"🖐","vulcan_salute":"🖖","wave":"👋","call_me_hand":"🤙","muscle":"💪","middle_finger":"🖕","fu":"🖕","writing_hand":"✍️","selfie":"🤳","nail_care":"💅","ring":"💍","lipstick":"💄","kiss":"💋","lips":"👄","tongue":"👅","ear":"👂","nose":"👃","footprints":"👣","eye":"👁","eyes":"👀","speaking_head":"🗣","bust_in_silhouette":"👤","busts_in_silhouette":"👥","baby":"👶","boy":"👦","girl":"👧","man":"👨","woman":"👩","blonde_woman":"👱‍♀","blonde_man":"👱","person_with_blond_hair":"👱","older_man":"👴","older_woman":"👵","man_with_gua_pi_mao":"👲","woman_with_turban":"👳‍♀","man_with_turban":"👳","policewoman":"👮‍♀","policeman":"👮","cop":"👮","construction_worker_woman":"👷‍♀","construction_worker_man":"👷","construction_worker":"👷","guardswoman":"💂‍♀","guardsman":"💂","female_detective":"🕵️‍♀️","male_detective":"🕵","detective":"🕵","woman_health_worker":"👩‍⚕","man_health_worker":"👨‍⚕","woman_farmer":"👩‍🌾","man_farmer":"👨‍🌾","woman_cook":"👩‍🍳","man_cook":"👨‍🍳","woman_student":"👩‍🎓","man_student":"👨‍🎓","woman_singer":"👩‍🎤","man_singer":"👨‍🎤","woman_teacher":"👩‍🏫","man_teacher":"👨‍🏫","woman_factory_worker":"👩‍🏭","man_factory_worker":"👨‍🏭","woman_technologist":"👩‍💻","man_technologist":"👨‍💻","woman_office_worker":"👩‍💼","man_office_worker":"👨‍💼","woman_mechanic":"👩‍🔧","man_mechanic":"👨‍🔧","woman_scientist":"👩‍🔬","man_scientist":"👨‍🔬","woman_artist":"👩‍🎨","man_artist":"👨‍🎨","woman_firefighter":"👩‍🚒","man_firefighter":"👨‍🚒","woman_pilot":"👩‍✈","man_pilot":"👨‍✈","woman_astronaut":"👩‍🚀","man_astronaut":"👨‍🚀","woman_judge":"👩‍⚖","man_judge":"👨‍⚖","mrs_claus":"🤶","santa":"🎅","princess":"👸","prince":"🤴","bride_with_veil":"👰","man_in_tuxedo":"🤵","angel":"👼","pregnant_woman":"🤰","bowing_woman":"🙇‍♀","bowing_man":"🙇","bow":"🙇","tipping_hand_woman":"💁","information_desk_person":"💁","sassy_woman":"💁","tipping_hand_man":"💁‍♂","sassy_man":"💁‍♂","no_good_woman":"🙅","no_good":"🙅","ng_woman":"🙅","no_good_man":"🙅‍♂","ng_man":"🙅‍♂","ok_woman":"🙆","ok_man":"🙆‍♂","raising_hand_woman":"🙋","raising_hand":"🙋","raising_hand_man":"🙋‍♂","woman_facepalming":"🤦‍♀","man_facepalming":"🤦‍♂","woman_shrugging":"🤷‍♀","man_shrugging":"🤷‍♂","pouting_woman":"🙎","person_with_pouting_face":"🙎","pouting_man":"🙎‍♂","frowning_woman":"🙍","person_frowning":"🙍","frowning_man":"🙍‍♂","haircut_woman":"💇","haircut":"💇","haircut_man":"💇‍♂","massage_woman":"💆","massage":"💆","massage_man":"💆‍♂","business_suit_levitating":"🕴","dancer":"💃","man_dancing":"🕺","dancing_women":"👯","dancers":"👯","dancing_men":"👯‍♂","walking_woman":"🚶‍♀","walking_man":"🚶","walking":"🚶","running_woman":"🏃‍♀","running_man":"🏃","runner":"🏃","running":"🏃","couple":"👫","two_women_holding_hands":"👭","two_men_holding_hands":"👬","couple_with_heart_woman_man":"💑","couple_with_heart":"💑","couple_with_heart_woman_woman":"👩‍❤️‍👩","couple_with_heart_man_man":"👨‍❤️‍👨","couplekiss_man_woman":"💏","couplekiss_woman_woman":"👩‍❤️‍💋‍👩","couplekiss_man_man":"👨‍❤️‍💋‍👨","family_man_woman_boy":"👪","family":"👪","family_man_woman_girl":"👨‍👩‍👧","family_man_woman_girl_boy":"👨‍👩‍👧‍👦","family_man_woman_boy_boy":"👨‍👩‍👦‍👦","family_man_woman_girl_girl":"👨‍👩‍👧‍👧","family_woman_woman_boy":"👩‍👩‍👦","family_woman_woman_girl":"👩‍👩‍👧","family_woman_woman_girl_boy":"👩‍👩‍👧‍👦","family_woman_woman_boy_boy":"👩‍👩‍👦‍👦","family_woman_woman_girl_girl":"👩‍👩‍👧‍👧","family_man_man_boy":"👨‍👨‍👦","family_man_man_girl":"👨‍👨‍👧","family_man_man_girl_boy":"👨‍👨‍👧‍👦","family_man_man_boy_boy":"👨‍👨‍👦‍👦","family_man_man_girl_girl":"👨‍👨‍👧‍👧","family_woman_boy":"👩‍👦","family_woman_girl":"👩‍👧","family_woman_girl_boy":"👩‍👧‍👦","family_woman_boy_boy":"👩‍👦‍👦","family_woman_girl_girl":"👩‍👧‍👧","family_man_boy":"👨‍👦","family_man_girl":"👨‍👧","family_man_girl_boy":"👨‍👧‍👦","family_man_boy_boy":"👨‍👦‍👦","family_man_girl_girl":"👨‍👧‍👧","womans_clothes":"👚","shirt":"👕","tshirt":"👕","jeans":"👖","necktie":"👔","dress":"👗","bikini":"👙","kimono":"👘","high_heel":"👠","sandal":"👡","boot":"👢","mans_shoe":"👞","shoe":"👞","athletic_shoe":"👟","womans_hat":"👒","tophat":"🎩","mortar_board":"🎓","crown":"👑","rescue_worker_helmet":"⛑","school_satchel":"🎒","pouch":"👝","purse":"👛","handbag":"👜","briefcase":"💼","eyeglasses":"👓","dark_sunglasses":"🕶","closed_umbrella":"🌂","open_umbrella":"☂️","dog":"🐶","cat":"🐱","mouse":"🐭","hamster":"🐹","rabbit":"🐰","fox_face":"🦊","bear":"🐻","panda_face":"🐼","koala":"🐨","tiger":"🐯","lion":"🦁","cow":"🐮","pig":"🐷","pig_nose":"🐽","frog":"🐸","monkey_face":"🐵","see_no_evil":"🙈","hear_no_evil":"🙉","speak_no_evil":"🙊","monkey":"🐒","chicken":"🐔","penguin":"🐧","bird":"🐦","baby_chick":"🐤","hatching_chick":"🐣","hatched_chick":"🐥","duck":"🦆","eagle":"🦅","owl":"🦉","bat":"🦇","wolf":"🐺","boar":"🐗","horse":"🐴","unicorn":"🦄","bee":"🐝","honeybee":"🐝","bug":"🐛","butterfly":"🦋","snail":"🐌","shell":"🐚","beetle":"🐞","ant":"🐜","spider":"🕷","spider_web":"🕸","turtle":"🐢","snake":"🐍","lizard":"🦎","scorpion":"🦂","crab":"🦀","squid":"🦑","octopus":"🐙","shrimp":"🦐","tropical_fish":"🐠","fish":"🐟","blowfish":"🐡","dolphin":"🐬","flipper":"🐬","shark":"🦈","whale":"🐳","whale2":"🐋","crocodile":"🐊","leopard":"🐆","tiger2":"🐅","water_buffalo":"🐃","ox":"🐂","cow2":"🐄","deer":"🦌","dromedary_camel":"🐪","camel":"🐫","elephant":"🐘","rhinoceros":"🦏","gorilla":"🦍","racehorse":"🐎","pig2":"🐖","goat":"🐐","ram":"🐏","sheep":"🐑","dog2":"🐕","poodle":"🐩","cat2":"🐈","rooster":"🐓","turkey":"🦃","dove":"🕊","rabbit2":"🐇","mouse2":"🐁","rat":"🐀","chipmunk":"🐿","feet":"🐾","paw_prints":"🐾","dragon":"🐉","dragon_face":"🐲","cactus":"🌵","christmas_tree":"🎄","evergreen_tree":"🌲","deciduous_tree":"🌳","palm_tree":"🌴","seedling":"🌱","herb":"🌿","shamrock":"☘️","four_leaf_clover":"🍀","bamboo":"🎍","tanabata_tree":"🎋","leaves":"🍃","fallen_leaf":"🍂","maple_leaf":"🍁","mushroom":"🍄","ear_of_rice":"🌾","bouquet":"💐","tulip":"🌷","rose":"🌹","wilted_flower":"🥀","sunflower":"🌻","blossom":"🌼","cherry_blossom":"🌸","hibiscus":"🌺","earth_americas":"🌎","earth_africa":"🌍","earth_asia":"🌏","full_moon":"🌕","waning_gibbous_moon":"🌖","last_quarter_moon":"🌗","waning_crescent_moon":"🌘","new_moon":"🌑","waxing_crescent_moon":"🌒","first_quarter_moon":"🌓","moon":"🌔","waxing_gibbous_moon":"🌔","new_moon_with_face":"🌚","full_moon_with_face":"🌝","sun_with_face":"🌞","first_quarter_moon_with_face":"🌛","last_quarter_moon_with_face":"🌜","crescent_moon":"🌙","dizzy":"💫","star":"⭐️","star2":"🌟","sparkles":"✨","zap":"⚡️","fire":"🔥","boom":"💥","collision":"💥","comet":"☄","sunny":"☀️","sun_behind_small_cloud":"🌤","partly_sunny":"⛅️","sun_behind_large_cloud":"🌥","sun_behind_rain_cloud":"🌦","rainbow":"🌈","cloud":"☁️","cloud_with_rain":"🌧","cloud_with_lightning_and_rain":"⛈","cloud_with_lightning":"🌩","cloud_with_snow":"🌨","snowman_with_snow":"☃️","snowman":"⛄️","snowflake":"❄️","wind_face":"🌬","dash":"💨","tornado":"🌪","fog":"🌫","ocean":"🌊","droplet":"💧","sweat_drops":"💦","umbrella":"☔️","green_apple":"🍏","apple":"🍎","pear":"🍐","tangerine":"🍊","orange":"🍊","mandarin":"🍊","lemon":"🍋","banana":"🍌","watermelon":"🍉","grapes":"🍇","strawberry":"🍓","melon":"🍈","cherries":"🍒","peach":"🍑","pineapple":"🍍","kiwi_fruit":"🥝","avocado":"🥑","tomato":"🍅","eggplant":"🍆","cucumber":"🥒","carrot":"🥕","corn":"🌽","hot_pepper":"🌶","potato":"🥔","sweet_potato":"🍠","chestnut":"🌰","peanuts":"🥜","honey_pot":"🍯","croissant":"🥐","bread":"🍞","baguette_bread":"🥖","cheese":"🧀","egg":"🥚","fried_egg":"🍳","bacon":"🥓","pancakes":"🥞","fried_shrimp":"🍤","poultry_leg":"🍗","meat_on_bone":"🍖","pizza":"🍕","hotdog":"🌭","hamburger":"🍔","fries":"🍟","stuffed_flatbread":"🥙","taco":"🌮","burrito":"🌯","green_salad":"🥗","shallow_pan_of_food":"🥘","spaghetti":"🍝","ramen":"🍜","stew":"🍲","fish_cake":"🍥","sushi":"🍣","bento":"🍱","curry":"🍛","rice":"🍚","rice_ball":"🍙","rice_cracker":"🍘","oden":"🍢","dango":"🍡","shaved_ice":"🍧","ice_cream":"🍨","icecream":"🍦","cake":"🍰","birthday":"🎂","custard":"🍮","lollipop":"🍭","candy":"🍬","chocolate_bar":"🍫","popcorn":"🍿","doughnut":"🍩","cookie":"🍪","milk_glass":"🥛","baby_bottle":"🍼","coffee":"☕️","tea":"🍵","sake":"🍶","beer":"🍺","beers":"🍻","clinking_glasses":"🥂","wine_glass":"🍷","tumbler_glass":"🥃","cocktail":"🍸","tropical_drink":"🍹","champagne":"🍾","spoon":"🥄","fork_and_knife":"🍴","plate_with_cutlery":"🍽","soccer":"⚽️","basketball":"🏀","football":"🏈","baseball":"⚾️","tennis":"🎾","volleyball":"🏐","rugby_football":"🏉","8ball":"🎱","ping_pong":"🏓","badminton":"🏸","goal_net":"🥅","ice_hockey":"🏒","field_hockey":"🏑","cricket":"🏏","golf":"⛳️","bow_and_arrow":"🏹","fishing_pole_and_fish":"🎣","boxing_glove":"🥊","martial_arts_uniform":"🥋","ice_skate":"⛸","ski":"🎿","skier":"⛷","snowboarder":"🏂","weight_lifting_woman":"🏋️‍♀️","weight_lifting_man":"🏋","person_fencing":"🤺","women_wrestling":"🤼‍♀","men_wrestling":"🤼‍♂","woman_cartwheeling":"🤸‍♀","man_cartwheeling":"🤸‍♂","basketball_woman":"⛹️‍♀️","basketball_man":"⛹","woman_playing_handball":"🤾‍♀","man_playing_handball":"🤾‍♂","golfing_woman":"🏌️‍♀️","golfing_man":"🏌","surfing_woman":"🏄‍♀","surfing_man":"🏄","surfer":"🏄","swimming_woman":"🏊‍♀","swimming_man":"🏊","swimmer":"🏊","woman_playing_water_polo":"🤽‍♀","man_playing_water_polo":"🤽‍♂","rowing_woman":"🚣‍♀","rowing_man":"🚣","rowboat":"🚣","horse_racing":"🏇","biking_woman":"🚴‍♀","biking_man":"🚴","bicyclist":"🚴","mountain_biking_woman":"🚵‍♀","mountain_biking_man":"🚵","mountain_bicyclist":"🚵","running_shirt_with_sash":"🎽","medal_sports":"🏅","medal_military":"🎖","1st_place_medal":"🥇","2nd_place_medal":"🥈","3rd_place_medal":"🥉","trophy":"🏆","rosette":"🏵","reminder_ribbon":"🎗","ticket":"🎫","tickets":"🎟","circus_tent":"🎪","woman_juggling":"🤹‍♀","man_juggling":"🤹‍♂","performing_arts":"🎭","art":"🎨","clapper":"🎬","microphone":"🎤","headphones":"🎧","musical_score":"🎼","musical_keyboard":"🎹","drum":"🥁","saxophone":"🎷","trumpet":"🎺","guitar":"🎸","violin":"🎻","game_die":"🎲","dart":"🎯","bowling":"🎳","video_game":"🎮","slot_machine":"🎰","car":"🚗","red_car":"🚗","taxi":"🚕","blue_car":"🚙","bus":"🚌","trolleybus":"🚎","racing_car":"🏎","police_car":"🚓","ambulance":"🚑","fire_engine":"🚒","minibus":"🚐","truck":"🚚","articulated_lorry":"🚛","tractor":"🚜","kick_scooter":"🛴","bike":"🚲","motor_scooter":"🛵","motorcycle":"🏍","rotating_light":"🚨","oncoming_police_car":"🚔","oncoming_bus":"🚍","oncoming_automobile":"🚘","oncoming_taxi":"🚖","aerial_tramway":"🚡","mountain_cableway":"🚠","suspension_railway":"🚟","railway_car":"🚃","train":"🚋","mountain_railway":"🚞","monorail":"🚝","bullettrain_side":"🚄","bullettrain_front":"🚅","light_rail":"🚈","steam_locomotive":"🚂","train2":"🚆","metro":"🚇","tram":"🚊","station":"🚉","helicopter":"🚁","small_airplane":"🛩","airplane":"✈️","flight_departure":"🛫","flight_arrival":"🛬","rocket":"🚀","artificial_satellite":"🛰","seat":"💺","canoe":"🛶","boat":"⛵️","sailboat":"⛵️","motor_boat":"🛥","speedboat":"🚤","passenger_ship":"🛳","ferry":"⛴","ship":"🚢","anchor":"⚓️","construction":"🚧","fuelpump":"⛽️","busstop":"🚏","vertical_traffic_light":"🚦","traffic_light":"🚥","world_map":"🗺","moyai":"🗿","statue_of_liberty":"🗽","fountain":"⛲️","tokyo_tower":"🗼","european_castle":"🏰","japanese_castle":"🏯","stadium":"🏟","ferris_wheel":"🎡","roller_coaster":"🎢","carousel_horse":"🎠","parasol_on_ground":"⛱","beach_umbrella":"🏖","desert_island":"🏝","mountain":"⛰","mountain_snow":"🏔","mount_fuji":"🗻","volcano":"🌋","desert":"🏜","camping":"🏕","tent":"⛺️","railway_track":"🛤","motorway":"🛣","building_construction":"🏗","factory":"🏭","house":"🏠","house_with_garden":"🏡","houses":"🏘","derelict_house":"🏚","office":"🏢","department_store":"🏬","post_office":"🏣","european_post_office":"🏤","hospital":"🏥","bank":"🏦","hotel":"🏨","convenience_store":"🏪","school":"🏫","love_hotel":"🏩","wedding":"💒","classical_building":"🏛","church":"⛪️","mosque":"🕌","synagogue":"🕍","kaaba":"🕋","shinto_shrine":"⛩","japan":"🗾","rice_scene":"🎑","national_park":"🏞","sunrise":"🌅","sunrise_over_mountains":"🌄","stars":"🌠","sparkler":"🎇","fireworks":"🎆","city_sunrise":"🌇","city_sunset":"🌆","cityscape":"🏙","night_with_stars":"🌃","milky_way":"🌌","bridge_at_night":"🌉","foggy":"🌁","watch":"⌚️","iphone":"📱","calling":"📲","computer":"💻","keyboard":"⌨️","desktop_computer":"🖥","printer":"🖨","computer_mouse":"🖱","trackball":"🖲","joystick":"🕹","clamp":"🗜","minidisc":"💽","floppy_disk":"💾","cd":"💿","dvd":"📀","vhs":"📼","camera":"📷","camera_flash":"📸","video_camera":"📹","movie_camera":"🎥","film_projector":"📽","film_strip":"🎞","telephone_receiver":"📞","phone":"☎️","telephone":"☎️","pager":"📟","fax":"📠","tv":"📺","radio":"📻","studio_microphone":"🎙","level_slider":"🎚","control_knobs":"🎛","stopwatch":"⏱","timer_clock":"⏲","alarm_clock":"⏰","mantelpiece_clock":"🕰","hourglass":"⌛️","hourglass_flowing_sand":"⏳","satellite":"📡","battery":"🔋","electric_plug":"🔌","bulb":"💡","flashlight":"🔦","candle":"🕯","wastebasket":"🗑","oil_drum":"🛢","money_with_wings":"💸","dollar":"💵","yen":"💴","euro":"💶","pound":"💷","moneybag":"💰","credit_card":"💳","gem":"💎","balance_scale":"⚖️","wrench":"🔧","hammer":"🔨","hammer_and_pick":"⚒","hammer_and_wrench":"🛠","pick":"⛏","nut_and_bolt":"🔩","gear":"⚙️","chains":"⛓","gun":"🔫","bomb":"💣","hocho":"🔪","knife":"🔪","dagger":"🗡","crossed_swords":"⚔️","shield":"🛡","smoking":"🚬","coffin":"⚰️","funeral_urn":"⚱️","amphora":"🏺","crystal_ball":"🔮","prayer_beads":"📿","barber":"💈","alembic":"⚗️","telescope":"🔭","microscope":"🔬","hole":"🕳","pill":"💊","syringe":"💉","thermometer":"🌡","toilet":"🚽","potable_water":"🚰","shower":"🚿","bathtub":"🛁","bath":"🛀","bellhop_bell":"🛎","key":"🔑","old_key":"🗝","door":"🚪","couch_and_lamp":"🛋","bed":"🛏","sleeping_bed":"🛌","framed_picture":"🖼","shopping":"🛍","shopping_cart":"🛒","gift":"🎁","balloon":"🎈","flags":"🎏","ribbon":"🎀","confetti_ball":"🎊","tada":"🎉","dolls":"🎎","izakaya_lantern":"🏮","lantern":"🏮","wind_chime":"🎐","email":"✉️","envelope":"✉️","envelope_with_arrow":"📩","incoming_envelope":"📨","e-mail":"📧","love_letter":"💌","inbox_tray":"📥","outbox_tray":"📤","package":"📦","label":"🏷","mailbox_closed":"📪","mailbox":"📫","mailbox_with_mail":"📬","mailbox_with_no_mail":"📭","postbox":"📮","postal_horn":"📯","scroll":"📜","page_with_curl":"📃","page_facing_up":"📄","bookmark_tabs":"📑","bar_chart":"📊","chart_with_upwards_trend":"📈","chart_with_downwards_trend":"📉","spiral_notepad":"🗒","spiral_calendar":"🗓","calendar":"📆","date":"📅","card_index":"📇","card_file_box":"🗃","ballot_box":"🗳","file_cabinet":"🗄","clipboard":"📋","file_folder":"📁","open_file_folder":"📂","card_index_dividers":"🗂","newspaper_roll":"🗞","newspaper":"📰","notebook":"📓","notebook_with_decorative_cover":"📔","ledger":"📒","closed_book":"📕","green_book":"📗","blue_book":"📘","orange_book":"📙","books":"📚","book":"📖","open_book":"📖","bookmark":"🔖","link":"🔗","paperclip":"📎","paperclips":"🖇","triangular_ruler":"📐","straight_ruler":"📏","pushpin":"📌","round_pushpin":"📍","scissors":"✂️","pen":"🖊","fountain_pen":"🖋","black_nib":"✒️","paintbrush":"🖌","crayon":"🖍","memo":"📝","pencil":"📝","pencil2":"✏️","mag":"🔍","mag_right":"🔎","lock_with_ink_pen":"🔏","closed_lock_with_key":"🔐","lock":"🔒","unlock":"🔓","heart":"❤️","yellow_heart":"💛","green_heart":"💚","blue_heart":"💙","purple_heart":"💜","black_heart":"🖤","broken_heart":"💔","heavy_heart_exclamation":"❣️","two_hearts":"💕","revolving_hearts":"💞","heartbeat":"💓","heartpulse":"💗","sparkling_heart":"💖","cupid":"💘","gift_heart":"💝","heart_decoration":"💟","peace_symbol":"☮️","latin_cross":"✝️","star_and_crescent":"☪️","om":"🕉","wheel_of_dharma":"☸️","star_of_david":"✡️","six_pointed_star":"🔯","menorah":"🕎","yin_yang":"☯️","orthodox_cross":"☦️","place_of_worship":"🛐","ophiuchus":"⛎","aries":"♈️","taurus":"♉️","gemini":"♊️","cancer":"♋️","leo":"♌️","virgo":"♍️","libra":"♎️","scorpius":"♏️","sagittarius":"♐️","capricorn":"♑️","aquarius":"♒️","pisces":"♓️","id":"🆔","atom_symbol":"⚛️","accept":"🉑","radioactive":"☢️","biohazard":"☣️","mobile_phone_off":"📴","vibration_mode":"📳","eight_pointed_black_star":"✴️","vs":"🆚","white_flower":"💮","ideograph_advantage":"🉐","secret":"㊙️","congratulations":"㊗️","u6e80":"🈵","a":"🅰️","b":"🅱️","ab":"🆎","cl":"🆑","o2":"🅾️","sos":"🆘","x":"❌","o":"⭕️","stop_sign":"🛑","no_entry":"⛔️","name_badge":"📛","no_entry_sign":"🚫","anger":"💢","hotsprings":"♨️","no_pedestrians":"🚷","do_not_litter":"🚯","no_bicycles":"🚳","non-potable_water":"🚱","underage":"🔞","no_mobile_phones":"📵","no_smoking":"🚭","exclamation":"❗️","heavy_exclamation_mark":"❗️","grey_exclamation":"❕","question":"❓","grey_question":"❔","bangbang":"‼️","interrobang":"⁉️","low_brightness":"🔅","high_brightness":"🔆","part_alternation_mark":"〽️","warning":"⚠️","children_crossing":"🚸","trident":"🔱","fleur_de_lis":"⚜️","beginner":"🔰","recycle":"♻️","white_check_mark":"✅","chart":"💹","sparkle":"❇️","eight_spoked_asterisk":"✳️","negative_squared_cross_mark":"❎","globe_with_meridians":"🌐","diamond_shape_with_a_dot_inside":"💠","m":"Ⓜ️","cyclone":"🌀","zzz":"💤","atm":"🏧","wc":"🚾","wheelchair":"♿️","parking":"🅿️","sa":"🈂️","passport_control":"🛂","customs":"🛃","baggage_claim":"🛄","left_luggage":"🛅","mens":"🚹","womens":"🚺","baby_symbol":"🚼","restroom":"🚻","put_litter_in_its_place":"🚮","cinema":"🎦","signal_strength":"📶","koko":"🈁","symbols":"🔣","information_source":"ℹ️","abc":"🔤","abcd":"🔡","capital_abcd":"🔠","ng":"🆖","ok":"🆗","up":"🆙","cool":"🆒","new":"🆕","free":"🆓","zero":"0️⃣","one":"1️⃣","two":"2️⃣","three":"3️⃣","four":"4️⃣","five":"5️⃣","six":"6️⃣","seven":"7️⃣","eight":"8️⃣","nine":"9️⃣","keycap_ten":"🔟","hash":"#️⃣","asterisk":"*️⃣","arrow_forward":"▶️","pause_button":"⏸","play_or_pause_button":"⏯","stop_button":"⏹","record_button":"⏺","next_track_button":"⏭","previous_track_button":"⏮","fast_forward":"⏩","rewind":"⏪","arrow_double_up":"⏫","arrow_double_down":"⏬","arrow_backward":"◀️","arrow_up_small":"🔼","arrow_down_small":"🔽","arrow_right":"➡️","arrow_left":"⬅️","arrow_up":"⬆️","arrow_down":"⬇️","arrow_upper_right":"↗️","arrow_lower_right":"↘️","arrow_lower_left":"↙️","arrow_upper_left":"↖️","arrow_up_down":"↕️","left_right_arrow":"↔️","arrow_right_hook":"↪️","leftwards_arrow_with_hook":"↩️","arrow_heading_up":"⤴️","arrow_heading_down":"⤵️","twisted_rightwards_arrows":"🔀","repeat":"🔁","repeat_one":"🔂","arrows_counterclockwise":"🔄","arrows_clockwise":"🔃","musical_note":"🎵","notes":"🎶","heavy_plus_sign":"➕","heavy_minus_sign":"➖","heavy_division_sign":"➗","heavy_multiplication_x":"✖️","heavy_dollar_sign":"💲","currency_exchange":"💱","tm":"™️","copyright":"©️","registered":"®️","wavy_dash":"〰️","curly_loop":"➰","loop":"➿","end":"🔚","back":"🔙","on":"🔛","top":"🔝","soon":"🔜","heavy_check_mark":"✔️","ballot_box_with_check":"☑️","radio_button":"🔘","white_circle":"⚪️","black_circle":"⚫️","red_circle":"🔴","large_blue_circle":"🔵","small_red_triangle":"🔺","small_red_triangle_down":"🔻","small_orange_diamond":"🔸","small_blue_diamond":"🔹","large_orange_diamond":"🔶","large_blue_diamond":"🔷","white_square_button":"🔳","black_square_button":"🔲","black_small_square":"▪️","white_small_square":"▫️","black_medium_small_square":"◾️","white_medium_small_square":"◽️","black_medium_square":"◼️","white_medium_square":"◻️","black_large_square":"⬛️","white_large_square":"⬜️","speaker":"🔈","mute":"🔇","sound":"🔉","loud_sound":"🔊","bell":"🔔","no_bell":"🔕","mega":"📣","loudspeaker":"📢","eye_speech_bubble":"👁‍🗨","speech_balloon":"💬","thought_balloon":"💭","right_anger_bubble":"🗯","spades":"♠️","clubs":"♣️","hearts":"♥️","diamonds":"♦️","black_joker":"🃏","flower_playing_cards":"🎴","mahjong":"🀄️","clock1":"🕐","clock2":"🕑","clock3":"🕒","clock4":"🕓","clock5":"🕔","clock6":"🕕","clock7":"🕖","clock8":"🕗","clock9":"🕘","clock10":"🕙","clock11":"🕚","clock12":"🕛","clock130":"🕜","clock230":"🕝","clock330":"🕞","clock430":"🕟","clock530":"🕠","clock630":"🕡","clock730":"🕢","clock830":"🕣","clock930":"🕤","clock1030":"🕥","clock1130":"🕦","clock1230":"🕧","white_flag":"🏳️","black_flag":"🏴","checkered_flag":"🏁","triangular_flag_on_post":"🚩","rainbow_flag":"🏳️‍🌈","afghanistan":"🇦🇫","aland_islands":"🇦🇽","albania":"🇦🇱","algeria":"🇩🇿","american_samoa":"🇦🇸","andorra":"🇦🇩","angola":"🇦🇴","anguilla":"🇦🇮","antarctica":"🇦🇶","antigua_barbuda":"🇦🇬","argentina":"🇦🇷","armenia":"🇦🇲","aruba":"🇦🇼","australia":"🇦🇺","austria":"🇦🇹","azerbaijan":"🇦🇿","bahamas":"🇧🇸","bahrain":"🇧🇭","bangladesh":"🇧🇩","barbados":"🇧🇧","belarus":"🇧🇾","belgium":"🇧🇪","belize":"🇧🇿","benin":"🇧🇯","bermuda":"🇧🇲","bhutan":"🇧🇹","bolivia":"🇧🇴","caribbean_netherlands":"🇧🇶","bosnia_herzegovina":"🇧🇦","botswana":"🇧🇼","brazil":"🇧🇷","british_indian_ocean_territory":"🇮🇴","british_virgin_islands":"🇻🇬","brunei":"🇧🇳","bulgaria":"🇧🇬","burkina_faso":"🇧🇫","burundi":"🇧🇮","cape_verde":"🇨🇻","cambodia":"🇰🇭","cameroon":"🇨🇲","canada":"🇨🇦","canary_islands":"🇮🇨","cayman_islands":"🇰🇾","central_african_republic":"🇨🇫","chad":"🇹🇩","chile":"🇨🇱","cn":"🇨🇳","christmas_island":"🇨🇽","cocos_islands":"🇨🇨","colombia":"🇨🇴","comoros":"🇰🇲","congo_brazzaville":"🇨🇬","congo_kinshasa":"🇨🇩","cook_islands":"🇨🇰","costa_rica":"🇨🇷","cote_divoire":"🇨🇮","croatia":"🇭🇷","cuba":"🇨🇺","curacao":"🇨🇼","cyprus":"🇨🇾","czech_republic":"🇨🇿","denmark":"🇩🇰","djibouti":"🇩🇯","dominica":"🇩🇲","dominican_republic":"🇩🇴","ecuador":"🇪🇨","egypt":"🇪🇬","el_salvador":"🇸🇻","equatorial_guinea":"🇬🇶","eritrea":"🇪🇷","estonia":"🇪🇪","ethiopia":"🇪🇹","eu":"🇪🇺","european_union":"🇪🇺","falkland_islands":"🇫🇰","faroe_islands":"🇫🇴","fiji":"🇫🇯","finland":"🇫🇮","fr":"🇫🇷","french_guiana":"🇬🇫","french_polynesia":"🇵🇫","french_southern_territories":"🇹🇫","gabon":"🇬🇦","gambia":"🇬🇲","georgia":"🇬🇪","de":"🇩🇪","ghana":"🇬🇭","gibraltar":"🇬🇮","greece":"🇬🇷","greenland":"🇬🇱","grenada":"🇬🇩","guadeloupe":"🇬🇵","guam":"🇬🇺","guatemala":"🇬🇹","guernsey":"🇬🇬","guinea":"🇬🇳","guinea_bissau":"🇬🇼","guyana":"🇬🇾","haiti":"🇭🇹","honduras":"🇭🇳","hong_kong":"🇭🇰","hungary":"🇭🇺","iceland":"🇮🇸","india":"🇮🇳","indonesia":"🇮🇩","iran":"🇮🇷","iraq":"🇮🇶","ireland":"🇮🇪","isle_of_man":"🇮🇲","israel":"🇮🇱","it":"🇮🇹","jamaica":"🇯🇲","jp":"🇯🇵","crossed_flags":"🎌","jersey":"🇯🇪","jordan":"🇯🇴","kazakhstan":"🇰🇿","kenya":"🇰🇪","kiribati":"🇰🇮","kosovo":"🇽🇰","kuwait":"🇰🇼","kyrgyzstan":"🇰🇬","laos":"🇱🇦","latvia":"🇱🇻","lebanon":"🇱🇧","lesotho":"🇱🇸","liberia":"🇱🇷","libya":"🇱🇾","liechtenstein":"🇱🇮","lithuania":"🇱🇹","luxembourg":"🇱🇺","macau":"🇲🇴","macedonia":"🇲🇰","madagascar":"🇲🇬","malawi":"🇲🇼","malaysia":"🇲🇾","maldives":"🇲🇻","mali":"🇲🇱","malta":"🇲🇹","marshall_islands":"🇲🇭","martinique":"🇲🇶","mauritania":"🇲🇷","mauritius":"🇲🇺","mayotte":"🇾🇹","mexico":"🇲🇽","micronesia":"🇫🇲","moldova":"🇲🇩","monaco":"🇲🇨","mongolia":"🇲🇳","montenegro":"🇲🇪","montserrat":"🇲🇸","morocco":"🇲🇦","mozambique":"🇲🇿","myanmar":"🇲🇲","namibia":"🇳🇦","nauru":"🇳🇷","nepal":"🇳🇵","netherlands":"🇳🇱","new_caledonia":"🇳🇨","new_zealand":"🇳🇿","nicaragua":"🇳🇮","niger":"🇳🇪","nigeria":"🇳🇬","niue":"🇳🇺","norfolk_island":"🇳🇫","northern_mariana_islands":"🇲🇵","north_korea":"🇰🇵","norway":"🇳🇴","oman":"🇴🇲","pakistan":"🇵🇰","palau":"🇵🇼","palestinian_territories":"🇵🇸","panama":"🇵🇦","papua_new_guinea":"🇵🇬","paraguay":"🇵🇾","peru":"🇵🇪","philippines":"🇵🇭","pitcairn_islands":"🇵🇳","poland":"🇵🇱","portugal":"🇵🇹","puerto_rico":"🇵🇷","qatar":"🇶🇦","reunion":"🇷🇪","romania":"🇷🇴","ru":"🇷🇺","rwanda":"🇷🇼","st_barthelemy":"🇧🇱","st_helena":"🇸🇭","st_kitts_nevis":"🇰🇳","st_lucia":"🇱🇨","st_pierre_miquelon":"🇵🇲","st_vincent_grenadines":"🇻🇨","samoa":"🇼🇸","san_marino":"🇸🇲","sao_tome_principe":"🇸🇹","saudi_arabia":"🇸🇦","senegal":"🇸🇳","serbia":"🇷🇸","seychelles":"🇸🇨","sierra_leone":"🇸🇱","singapore":"🇸🇬","sint_maarten":"🇸🇽","slovakia":"🇸🇰","slovenia":"🇸🇮","solomon_islands":"🇸🇧","somalia":"🇸🇴","south_africa":"🇿🇦","south_georgia_south_sandwich_islands":"🇬🇸","kr":"🇰🇷","south_sudan":"🇸🇸","es":"🇪🇸","sri_lanka":"🇱🇰","sudan":"🇸🇩","suriname":"🇸🇷","swaziland":"🇸🇿","sweden":"🇸🇪","switzerland":"🇨🇭","syria":"🇸🇾","taiwan":"🇹🇼","tajikistan":"🇹🇯","tanzania":"🇹🇿","thailand":"🇹🇭","timor_leste":"🇹🇱","togo":"🇹🇬","tokelau":"🇹🇰","tonga":"🇹🇴","trinidad_tobago":"🇹🇹","tunisia":"🇹🇳","tr":"🇹🇷","turkmenistan":"🇹🇲","turks_caicos_islands":"🇹🇨","tuvalu":"🇹🇻","uganda":"🇺🇬","ukraine":"🇺🇦","united_arab_emirates":"🇦🇪","gb":"🇬🇧","uk":"🇬🇧","us":"🇺🇸","us_virgin_islands":"🇻🇮","uruguay":"🇺🇾","uzbekistan":"🇺🇿","vanuatu":"🇻🇺","vatican_city":"🇻🇦","venezuela":"🇻🇪","vietnam":"🇻🇳","wallis_futuna":"🇼🇫","western_sahara":"🇪🇭","yemen":"🇾🇪","zambia":"🇿🇲","zimbabwe":"🇿🇼"}

/***/ }),

/***/ "RdN2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile",attrs:{"data-module":"work-main-articles"}},[_c('div',{staticClass:"component-layout"},_vm._l((_vm.articles),function(record,idx){return _c('div',{key:idx,staticClass:"article-tile-container"},[(record.isCategory === true)?_c('category-page-tile',{attrs:{"record":record}}):_c('ArticleTile',{attrs:{"record":record}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RhFO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_windowDimensions_vue__ = __webpack_require__("1E1Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_windowDimensions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_windowDimensions_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_windowDimensions_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_windowDimensions_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a6c832_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_windowDimensions_vue__ = __webpack_require__("nXDj");
function injectStyle (ssrContext) {
  __webpack_require__("V3/P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_windowDimensions_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a6c832_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_windowDimensions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Rn8A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResponsiveUrl = undefined;

var _appConstants = __webpack_require__("y3R9");

/* eslint no-useless-escape: off */
var imgRegex = new RegExp('^(.*?).([^.]*)$');

/* eslint import/prefer-default-export: off */
/*
  url: url of image to display
  width: width of page it will take up, in pixels
*/
var getResponsiveUrl = exports.getResponsiveUrl = function getResponsiveUrl(url, width) {
  var match = url.match(imgRegex);
  var path = match[1];
  var ext = match[2];

  var size = _appConstants.ResponsiveMax;
  for (var idx = 0; idx < _appConstants.ResponsiveSizes.length; idx += 1) {
    var rSize = _appConstants.ResponsiveSizes[idx];
    if (width <= rSize) {
      size = rSize;
      break;
    }
  }

  var split = path.split('/');
  split.splice(split.length - 1, 0, _appConstants.ResponsivePathName);
  var newPath = split.join('/');
  return [newPath, '-' + size, '.', ext].join('');
};

/***/ }),

/***/ "RslD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_featuredItems_vue__ = __webpack_require__("NtwM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_featuredItems_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_featuredItems_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_featuredItems_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_featuredItems_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67c410ab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_featuredItems_vue__ = __webpack_require__("ZJ/5");
function injectStyle (ssrContext) {
  __webpack_require__("7YIY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_featuredItems_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67c410ab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_featuredItems_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "S+Y7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"matter-article-header"}},[_c('div',{staticClass:"module-layout"},[_c('div',{ref:"headerHeroImage",staticClass:"image-background",style:(_vm.bgImageStyles)})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S8ZO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"matter-articles"},_vm._l((_vm.columns),function(col,idx){return _c('div',{key:idx,staticClass:"matter-articles__column"},[_vm._l((col),function(item,j){return [_c('ArticleTile',{key:j,attrs:{"item":item}})]})],2)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SDfB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linkWithButtonBelow_vue__ = __webpack_require__("A11U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linkWithButtonBelow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linkWithButtonBelow_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linkWithButtonBelow_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linkWithButtonBelow_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6372ded2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_linkWithButtonBelow_vue__ = __webpack_require__("qLtD");
function injectStyle (ssrContext) {
  __webpack_require__("A3y+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linkWithButtonBelow_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6372ded2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_linkWithButtonBelow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "SEzC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/map.c333325.jpg";

/***/ }),

/***/ "SHp6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_markdown_vue__ = __webpack_require__("Yymm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_markdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_markdown_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_markdown_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_markdown_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58159b90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_markdown_vue__ = __webpack_require__("PSBx");
function injectStyle (ssrContext) {
  __webpack_require__("6XCz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58159b90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_markdown_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58159b90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_markdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "SaSh":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "SfIE":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "ShOl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MouseEventContainer = __webpack_require__("eJwU");

var _MouseEventContainer2 = _interopRequireDefault(_MouseEventContainer);

var _workArticleIndex = __webpack_require__("m7L3");

var _workArticleIndex2 = _interopRequireDefault(_workArticleIndex);

var _WorkMixin = __webpack_require__("OytB");

var _WorkMixin2 = _interopRequireDefault(_WorkMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

  name: 'work-related-articles',

  components: { MouseEventContainer: _MouseEventContainer2.default },

  props: ['data'],

  mixins: [_WorkMixin2.default],

  computed: {
    articleSlugLeft: function articleSlugLeft() {
      var articles = this.data.articles;

      return articles[0];
    },
    articleSlugRight: function articleSlugRight() {
      var articles = this.data.articles;

      return articles[1];
    },
    articleContentLeft: function articleContentLeft() {
      var slug = this.articleSlugLeft;

      return this.getArticleData(slug);
    },
    articleContentRight: function articleContentRight() {
      var slug = this.articleSlugRight;

      return this.getArticleData(slug);
    },
    haveArticleLeft: function haveArticleLeft() {
      var slug = this.articleSlugLeft,
          content = this.articleContentLeft;

      return slug !== undefined && content !== undefined;
    },
    haveArticleRight: function haveArticleRight() {
      var slug = this.articleSlugRight,
          content = this.articleContentRight;

      return slug !== undefined && content !== undefined;
    },
    deviceType: function deviceType() {
      var deviceStr = '';
      if (this.isMobile) {
        deviceStr = 'mobile';
      } else if (this.isTablet) {
        deviceStr = 'tablet';
      } else {
        deviceStr = 'desktop';
      }
      return deviceStr;
    },
    containerClasses: function containerClasses() {
      // return class string, eg 'desktop', 'mobile.reversed'
      var deviceType = this.deviceType;


      var classes = [deviceType];
      return classes.join(' ');
    }
  },

  methods: {
    getArticleData: function getArticleData(slug) {
      var result = _workArticleIndex2.default.filter(function (item) {
        return item.slug === slug;
      });
      return result[0];
    },
    getRouterLink: function getRouterLink(data) {
      return {
        name: 'work-article',
        path: data.url,
        params: {
          slug: data.slug
        }
      };
    }
  }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  Work section RelatedArticles module

  data record:
  {
    articles: [
      <work-article-slug>,
      <work-article-slug>,
    ]
  }
*/
// Components

/***/ }),

/***/ "SlJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',{attrs:{"data":_vm.data,"section":"contact"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('div',{staticClass:"contact-container"},[_c('contact-header',{attrs:{"data":_vm.headerData}}),_vm._v(" "),_c('contact-map',{attrs:{"data":_vm.mapData}}),_vm._v(" "),_c('contact-form'),_vm._v(" "),_c('particle-hiring',{attrs:{"data":_vm.hiringData}})],1)]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T+rh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hero.689e704.jpg";

/***/ }),

/***/ "T2+B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigation_vue__ = __webpack_require__("MkAP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigation_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigation_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigation_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a5fe978_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navigation_vue__ = __webpack_require__("NFb/");
function injectStyle (ssrContext) {
  __webpack_require__("eW4l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigation_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a5fe978_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "THYn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TIbz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _WorkMixin = __webpack_require__("OytB");

var _WorkMixin2 = _interopRequireDefault(_WorkMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

  name: 'work-two-column-text',

  props: ['data'],

  mixins: [_WorkMixin2.default],

  computed: {
    hasContentLeft: function hasContentLeft() {
      var contentLeft = this.data.contentLeft;

      return contentLeft !== undefined;
    },
    hasContentRight: function hasContentRight() {
      var contentRight = this.data.contentRight;

      return contentRight !== undefined;
    },
    containerClasses: function containerClasses() {
      // return class string, eg 'desktop', 'mobile.reversed'
      var isReversed = this.isReversed;


      var deviceStr = '';
      if (this.isMobile) {
        deviceStr = 'mobile';
      } else if (this.isTablet) {
        deviceStr = 'tablet';
      } else {
        deviceStr = 'desktop';
      }
      return isReversed ? deviceStr + ' reversed' : deviceStr;
    },
    contentContainerClasses: function contentContainerClasses() {
      // return class string, eg 'desktop', 'mobile.reversed'
      var classStr = this.containerClasses;
      var data = this.data;
      var isOffset = data.isOffset;

      // add defaults

      var offset = isOffset ? 'offset' : 'equal';

      return classStr + ' ' + offset;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "UpFw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'module_image',
  props: ['data', 'window'],
  computed: {
    visible: function visible() {
      var visibility = this.data.visibility;
      if (!visibility) {
        return true;
      }

      var visible = true;
      if (this.window.width <= visibility.min) {
        visible = false;
      }

      if (this.window.width > visibility.max) {
        visible = false;
      }

      return visible;
    },
    output: function output() {
      var output = void 0;
      var window = this.window;

      if (this.data.srcSet) {
        output = this.data.srcSet.find(function (img) {
          return window.width < img.max;
        });
      }

      if (output) {
        output = output.src;
      } else {
        output = this.data.src;
      }

      return output;
    }
  }
};

/***/ }),

/***/ "Uy9U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _content = __webpack_require__("i2aE");

var _content2 = _interopRequireDefault(_content);

var _content3 = __webpack_require__("6hQY");

var _content4 = _interopRequireDefault(_content3);

var _index = __webpack_require__("ZRZ2");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { about: _content2.default, homepage: _content4.default, work: _index2.default };

/***/ }),

/***/ "V0ux":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDAwcHgiIGhlaWdodD0iMjAwcHgiIHZpZXdCb3g9IjAgMCA0MDAgMjAwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OS4zICg1MTE2NykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+aGFsZiBjaXJjbGVzXzF4d2lkZTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJNYWluIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iQXJ0Ym9hcmQtMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUxNS4wMDAwMDAsIC0xNjEzLjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iaGFsZi1jaXJjbGVzXzF4d2lkZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTE1LjAwMDAwMCwgMTYxMy4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMjYiIGZpbGw9IiNGRkZGRkYiIHg9IjAiIHk9IjAiIHdpZHRoPSI0MDAiIGhlaWdodD0iMjAwIj48L3JlY3Q+CiAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjAwLjAwMDAwMCwgMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCwxMDAgQzAsNDQuNzcxODc1IDQ0Ljc3MDMxMjUsMCAxMDAsMCBDMTU1LjIyODEyNSwwIDIwMCw0NC43NzE4NzUgMjAwLDEwMCBMMCwxMDAgWiIgaWQ9IkZpbGwtMjk0IiBmaWxsPSIjRDRERDVEIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTAsMjAwIEMwLDE0NC43NzAzMTMgNDQuNzcwMzEyNSwxMDAgMTAwLDEwMCBDMTU1LjIyODEyNSwxMDAgMjAwLDE0NC43NzAzMTMgMjAwLDIwMCBMMCwyMDAgWiIgaWQ9IkZpbGwtMjk2IiBmaWxsPSIjMDAwMDAwIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ "V3/P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V4vZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VZc3":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "VZd/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bus = __webpack_require__("EJZp");

var _appConstants = __webpack_require__("y3R9");

var _imageUtils = __webpack_require__("Rn8A");

exports.default = {

  name: 'content-static-matter-tile',

  props: ['record', 'colSpan', 'height', 'width'],

  data: function data() {
    return {
      isTapped: false,
      handleBusTapEventFunc: null,
      tileInfoHeight: 0
    };
  },


  computed: {
    tileInfoStyles: function tileInfoStyles() {
      var colSpan = this.colSpan;

      var styles = {};
      if (colSpan === 2) {
        styles.paddingRight = '130px';
        styles.marginRight = '226px';
      } else {
        styles.paddingRight = '26px';
        styles.marginRight = '0';
      }
      return styles;
    },
    imageData: function imageData() {
      return this.record.image;
    },
    imageAspect: function imageAspect() {
      var _record = this.record,
          image = _record.image,
          colSpan = _record.colSpan;

      return colSpan === 2 ? 'landscape' : image.aspect;
    },
    bgImageStyles: function bgImageStyles() {
      var height = this.height,
          width = this.width,
          record = this.record;
      var image = record.image;
      var src = image.src,
          hA = image.hAlign,
          vA = image.vAlign;

      // add defaults

      var hAlign = hA || 'center';
      var vAlign = vA || 'center';

      var maxDim = Math.max(width, height);
      var rUrl = (0, _imageUtils.getResponsiveUrl)(src, maxDim);

      var styles = {
        backgroundImage: 'url(' + rUrl + ')',
        backgroundPosition: hAlign + ' ' + vAlign,
        height: this.height + 'px'
      };
      return styles;
    },
    routerLinkTo: function routerLinkTo() {
      var _record2 = this.record,
          url = _record2.url,
          data = _record2.data;

      return {
        path: url,
        params: {
          url: url,
          data: data
        }
      };
    }
  },

  methods: {
    measureLayout: function measureLayout() {
      this.tileInfoHeight = this.getInfoContentHeight();
    },
    getInfoContentHeight: function getInfoContentHeight() {
      var el = this.$refs.tileInfo;
      return el ? el.clientHeight : 0;
    },


    // called from parent
    calculateTileAdjustment: function calculateTileAdjustment() {
      this.measureLayout();
      var tileInfoHeight = this.tileInfoHeight;

      /*
      // calculate the better offset
      // const offsets = [48, 34, 0];
      // const minHeight = 16; // picked by hand
       let height;
      let idx = 0;
      do {
        const offset = offsets[idx];
        height = tileInfoHeight - offset;
        idx += 1;
      } while (height < minHeight);
      */

      var height = tileInfoHeight - 28;
      return height;
    },
    touchHandler: function touchHandler(e) {
      var slug = this.record.slug;

      if (this.isTapped === true) {
        // double-tap: do default handling
        // console.warn(`double tap on ${slug}`);
      } else {
        // single-tap: show article content
        // console.warn(`single tap on ${slug}`);
        e.preventDefault();
        this.isTapped = true;
        _bus.Bus.$emit(_appConstants.Events.TappedArticle, slug);
      }
    }
  }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  this component fits to the size of its container
  width: 100%; height: 100%;
  so container must define size and location

  see Work Article Tiles for supported aspect ratios
*/

/***/ }),

/***/ "VrjG":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "VwZG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"bigHeading"}},[_c('div',{staticClass:"heading"},[_c('span',{attrs:{"data-ornament":"rectangle"}}),_vm._v(" "),_c('markdown',{staticClass:"markdown"},[_vm._v("## "+_vm._s(_vm.data.heading))]),_vm._v(" "),(_vm.data.byline)?_c('span',{staticClass:"byline"},[_vm._v(_vm._s(_vm.data.byline))]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WH49":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"matter-social-media-sharing"}},[_c('div',{staticClass:"module-layout"},[_c('div',{staticClass:"content-container",class:_vm.containerClasses},[_c('h2',[_vm._v("Share")]),_vm._v(" "),_c('social-sharing',{attrs:{"url":_vm.href,"title":_vm.shareTitle,"description":_vm.shareDescription,"twitter-user":"ParticleDesign_"},inlineTemplate:{render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"network-shares"},[_c('network',{attrs:{"network":"facebook","data":""}},[_c('img',{staticClass:"icon",style:(_vm.iconStyles),attrs:{"src":"/static/assets/facebook.svg","alt":"facebook icon"}})]),_vm._v(" "),_c('network',{attrs:{"network":"twitter"}},[_c('img',{staticClass:"icon",style:(_vm.iconStyles),attrs:{"src":"/static/assets/twitter.svg","alt":"twitter icon"}})]),_vm._v(" "),_c('network',{attrs:{"network":"linkedin"}},[_c('img',{staticClass:"icon",style:(_vm.iconStyles),attrs:{"src":"/static/assets/linkedin.svg","alt":"linkedin icon"}})])],1)},staticRenderFns:[]}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WOFi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('defaultLayout',{attrs:{"section":"page-no-found"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('four-oh-four',{attrs:{"data":_vm.data}})]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WaSW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wemu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MouseEventContainer = __webpack_require__("eJwU");

var _MouseEventContainer2 = _interopRequireDefault(_MouseEventContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

  name: 'particle-hiring',

  components: { MouseEventContainer: _MouseEventContainer2.default },

  props: ['data'],

  computed: {
    contactLinkInfo: function contactLinkInfo() {
      return {
        name: 'contact-main',
        hash: '#contact-us-form'
      };
    },
    haveJobs: function haveJobs() {
      var listings = this.data.listings;

      return listings.length > 0;
    },
    heading: function heading() {
      var _data = this.data,
          haveJobs = _data.haveJobs,
          heading = _data.heading;

      if (haveJobs) {
        return heading.jobs;
      }
      return heading.noJobs;
    },
    noJobsContent: function noJobsContent() {
      var noJobsContent = this.data.noJobsContent;

      return noJobsContent;
    },
    teaser: function teaser() {
      var _data2 = this.data,
          haveJobs = _data2.haveJobs,
          teaser = _data2.teaser;

      if (haveJobs) {
        return teaser.jobs;
      }
      return teaser.noJobs;
    }
  }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components

/***/ }),

/***/ "Wv9z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//

/*
  Nav Spacer Header module
*/
exports.default = {

  name: 'nav-spacer-header',

  props: ['data']

};

/***/ }),

/***/ "WvvH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Wzfu":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "XDdv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryPageTile_vue__ = __webpack_require__("RLYt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryPageTile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryPageTile_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryPageTile_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryPageTile_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40a38146_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryPageTile_vue__ = __webpack_require__("7Xh6");
function injectStyle (ssrContext) {
  __webpack_require__("v+1E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40a38146"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryPageTile_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40a38146_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryPageTile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "XQf3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"nav-spacer-header"}},[_c('div',{staticClass:"spacer-layout"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xwvo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'component_hcAboutRelevant',
  props: ['scrollState', 'visibility', 'percentScrolled'],
  computed: {
    contentOpacity: function contentOpacity() {
      var opacity = 0;
      var pointerEvents = 'none';

      var percentScrolled = this.percentScrolled;

      if (percentScrolled < 75) {
        opacity = 0;
      } else if (percentScrolled < 100) {
        opacity = (percentScrolled - 75) / 25;
        pointerEvents = 'auto';
      } else if (percentScrolled < 125) {
        opacity = 1;
        pointerEvents = 'auto';
      } else if (percentScrolled < 187.5) {
        opacity = 1 - (percentScrolled - 125) / 62.5;
      }

      return {
        opacity: opacity,
        pointerEvents: pointerEvents
      };
    },
    graphicFixed: function graphicFixed() {
      var classes = {
        following: false,
        'fixed--bottom': false
      };

      var top = this.scrollState.aboutRelevant_component_top;
      var bot = this.scrollState.bottomOfAboutContent;

      if (!top || !bot) {
        return classes;
      }

      if (top.isAboveViewport && bot.isBelowViewport) {
        classes.following = true;
      } else if (top.isAboveViewport && !bot.isBelowViewport) {
        classes['fixed--bottom'] = true;
      }

      return classes;
    },
    contentFixed: function contentFixed() {
      var classes = {
        fixed: false,
        'fixed--bottom': false
      };

      var top = this.scrollState.aboutRelevant_component_top;
      var bot = this.scrollState.bottomOfAboutContent;

      if (!top || !bot) {
        return classes;
      }

      if (top.isAboveViewport && bot.isBelowViewport) {
        classes.fixed = true;
      } else if (top.isAboveViewport && !bot.isBelowViewport) {
        classes['fixed--bottom'] = true;
      }

      return classes;
    }
  }
};

/***/ }),

/***/ "Y1Ju":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_int_hcAboutRelevant_vue__ = __webpack_require__("Xwvo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_int_hcAboutRelevant_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_int_hcAboutRelevant_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_int_hcAboutRelevant_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_int_hcAboutRelevant_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24fd561f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_int_hcAboutRelevant_vue__ = __webpack_require__("HbWz");
function injectStyle (ssrContext) {
  __webpack_require__("cBty")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_int_hcAboutRelevant_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24fd561f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_int_hcAboutRelevant_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Y2Ti":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.66eb361.jpg";

/***/ }),

/***/ "Y3tK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mentor-siemens_white.046491f.svg";

/***/ }),

/***/ "YC9H":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/eb.8444d3f.svg";

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vueMarkdown = __webpack_require__("Xoog");

var _vueMarkdown2 = _interopRequireDefault(_vueMarkdown);

var _vueMeta = __webpack_require__("p3jY");

var _vueMeta2 = _interopRequireDefault(_vueMeta);

var _ContactMain = __webpack_require__("efQ2");

var _ContactMain2 = _interopRequireDefault(_ContactMain);

var _MatterArticle = __webpack_require__("hVWo");

var _MatterArticle2 = _interopRequireDefault(_MatterArticle);

var _MatterMain = __webpack_require__("55bw");

var _MatterMain2 = _interopRequireDefault(_MatterMain);

var _modules = __webpack_require__("244o");

var _modules2 = _interopRequireDefault(_modules);

var _WorkArticle = __webpack_require__("EMmj");

var _WorkArticle2 = _interopRequireDefault(_WorkArticle);

var _WorkMain = __webpack_require__("HdTL");

var _WorkMain2 = _interopRequireDefault(_WorkMain);

var _HolidayLanding = __webpack_require__("Oezs");

var _HolidayLanding2 = _interopRequireDefault(_HolidayLanding);

var _PageNotFound = __webpack_require__("lM8h");

var _PageNotFound2 = _interopRequireDefault(_PageNotFound);

var _index = __webpack_require__("DZVs");

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__("bGai");

var _index4 = _interopRequireDefault(_index3);

var _content = __webpack_require__("Uy9U");

var _content2 = _interopRequireDefault(_content);

var _debug = __webpack_require__("bHIN");

var _debug2 = _interopRequireDefault(_debug);

var _contactIndex = __webpack_require__("fCdG");

var _contactIndex2 = _interopRequireDefault(_contactIndex);

var _matterArticleIndex = __webpack_require__("u07h");

var _matterArticleIndex2 = _interopRequireDefault(_matterArticleIndex);

var _memeBundle = __webpack_require__("ekfp");

var _memeBundle2 = _interopRequireDefault(_memeBundle);

var _workArticleIndex = __webpack_require__("m7L3");

var _workArticleIndex2 = _interopRequireDefault(_workArticleIndex);

var _workArticleBundle = __webpack_require__("zW8K");

var _workArticleBundle2 = _interopRequireDefault(_workArticleBundle);

var _dataUtils = __webpack_require__("uhrr");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// register all modules & components


// import work from '@/content/work/index';

// Core Pages
for (var _module in _index2.default) {
  _vue2.default.component('module_' + _module, _index2.default[_module]);
}

// Utils


// Components


for (var component in _index4.default) {
  _vue2.default.component('component_' + component, _index4.default[component]);
}

for (var debug in _debug2.default) {
  _vue2.default.component('debug_' + debug, _debug2.default[debug]);
}

_vue2.default.component('markdown', _vueMarkdown2.default);

_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vueMeta2.default);

exports.default = new _vueRouter2.default({
  mode: 'history',
  routes: [
  // Misc Routes
  {
    path: '/2018-holiday-thank-you',
    name: 'holiday-landing-2008',
    component: _HolidayLanding2.default
  },
  // Core website routes
  {
    path: '/',
    name: 'homepage',
    component: _modules2.default,
    props: {
      page: 'homepage',
      data: _content2.default.homepage
    }
  }, {
    path: '/contact',
    name: 'contact-main',
    component: _ContactMain2.default,
    props: {
      page: 'contact',
      data: _contactIndex2.default
    }
  }, {
    path: '/matter',
    name: 'matter-main',
    component: _MatterMain2.default,
    props: {
      page: 'matter',
      data: _matterArticleIndex2.default
    }
  }, {
    path: '/matter/:slug',
    name: 'matter-article',
    component: _MatterArticle2.default,
    beforeEnter: function beforeEnter(to, from, next) {
      var slug = to.params.slug;
      var articles = _matterArticleIndex2.default.articles;


      var found = articles.filter(function (article) {
        return article.slug === slug;
      });
      var haveArticle = found.length !== 0;
      if (haveArticle) {
        next();
      } else {
        next({ name: 'page-not-found', params: [to.path], replace: true });
      }
    },

    props: function props(route) {
      var _location = location,
          origin = _location.origin,
          href = _location.href;
      var path = route.path,
          params = route.params;
      var slug = params.slug;

      return { slug: slug, path: path, origin: origin, href: href };
    }
  }, {
    path: '/work',
    name: 'work-main',
    component: _WorkMain2.default,
    props: {
      data: _workArticleIndex2.default
    }
  }, {
    path: '/work/:slug',
    name: 'work-article',
    component: _WorkArticle2.default,
    beforeEnter: function beforeEnter(to, from, next) {
      var slug = to.params.slug;


      var haveArticle = _workArticleBundle2.default[slug] !== undefined;
      if (haveArticle) {
        next();
      } else {
        next({ name: 'page-not-found', params: [to.path], replace: true });
      }
    },

    props: function props(route) {
      var url = route.path,
          params = route.params;
      var slug = params.slug;

      return { slug: slug, url: url, workArticles: _workArticleBundle2.default };
    }
  }, {
    // TODO: remove this once '/about' has own route
    path: '/:slug',
    name: 'L2',
    component: _modules2.default,
    beforeEnter: function beforeEnter(to, from, next) {
      var slug = to.params.slug;

      var validPageSlugs = ['about'];

      var havePage = validPageSlugs.includes(slug);
      if (havePage) {
        next();
      } else {
        next({ name: 'page-not-found', params: [to.path], replace: true });
      }
    },

    props: function props(route) {
      var slug = route.params.slug;

      return {
        page: slug,
        data: _content2.default[slug]
      };
    }
  }, {
    path: '*',
    name: 'page-not-found',
    component: _PageNotFound2.default,
    props: function props() {
      var list = (0, _dataUtils.shuffleArray)(_memeBundle2.default);
      var idx = Math.floor(Math.random() * list.length);
      return {
        data: list[idx]
      };
    }
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    }

    if (savedPosition) {
      return savedPosition;
    }

    return { x: 0, y: 0 };
  }
});

/***/ }),

/***/ "YpG3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  currently only coded to show a video
  original code was able to display more more

  current data structure:

    {
    headline: string // 'Welcome<br />to Particle.',
    background: {
      type: string // 'video'
      data: {
        src: string
        poster: string
        alt: string
      }
    },
  },

*/
exports.default = {
  name: 'contact-header',

  props: ['data'],

  computed: {
    headline: function headline() {
      var headline = this.data.headline;

      return headline;
    },
    background: function background() {
      var background = this.data.background;

      return background;
    },
    type: function type() {
      var background = this.background;
      var type = background.type;

      return type;
    },
    bgData: function bgData() {
      var background = this.background;
      var data = background.data;

      return data;
    }
  }
};

/***/ }),

/***/ "Yymm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//

// Component expects:
// - content
exports.default = {

  name: 'component_markdown',

  props: ['data'],

  computed: {
    hasHyperlink: function hasHyperlink() {
      return this.data.href !== undefined;
    }
  }

};

/***/ }),

/***/ "ZJ/5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"data-module":"featuredItems","id":_vm.data.id}},[_c('component_bigHeading',{attrs:{"data":{heading: _vm.data.title, byline: _vm.data.byline}}}),_vm._v(" "),_vm._l((_vm.items),function(item,i){return [_c('div',{key:item.headline,staticClass:"featured-item",attrs:{"data-index":i + 1}},[_c('component_blurb',{attrs:{"data":item}})],1)]}),_vm._v(" "),(_vm.data.outlink)?_c('div',{staticClass:"outlink-wrapper"},[_c('div',{staticClass:"outlink"},[_c('a',{attrs:{"href":_vm.data.outlink.href}},[_c('div',{staticClass:"copy"},[_vm._v("\n          "+_vm._s(_vm.data.outlink.copy)+"\n          "),_c('span',{attrs:{"data-ornament":"arrow--right"}})])])])]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.setMasonry())+"\n")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZRZ2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dreamworks = __webpack_require__("9/KV");

var _dreamworks2 = _interopRequireDefault(_dreamworks);

var _hpWearable = __webpack_require__("HrIc");

var _hpWearable2 = _interopRequireDefault(_hpWearable);

var _landRover = __webpack_require__("aPwj");

var _landRover2 = _interopRequireDefault(_landRover);

var _tacoRecombinator = __webpack_require__("LFK+");

var _tacoRecombinator2 = _interopRequireDefault(_tacoRecombinator);

var _virtualLessonPlan = __webpack_require__("tTgq");

var _virtualLessonPlan2 = _interopRequireDefault(_virtualLessonPlan);

var _moduleTestPage = __webpack_require__("49AP");

var _moduleTestPage2 = _interopRequireDefault(_moduleTestPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  add new Work data files here
  1. add new import line
  2. add new line with addContent()
*/

var workContent = {};

var addContent = function (struct) {
  return function (content) {
    var slug = content.slug;
    // eslint-disable-next-line no-param-reassign
    struct[slug] = content;
  };
}(workContent);

addContent(_dreamworks2.default);
addContent(_hpWearable2.default);
addContent(_landRover2.default);
addContent(_tacoRecombinator2.default);
addContent(_virtualLessonPlan2.default);

addContent(_moduleTestPage2.default);

exports.default = workContent;

/***/ }),

/***/ "Zc4S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bus = __webpack_require__("EJZp");

var _appConstants = __webpack_require__("y3R9");

var _imageUtils = __webpack_require__("Rn8A");

var _clients = __webpack_require__("fL60");

var _clients2 = _interopRequireDefault(_clients);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  this component fits to the size of its container
  width: 100%; height: 100%;
  so container must define size and location

  see Work Article Tiles for supported aspect ratios
*/
exports.default = {

  props: ['record', 'colSpan', 'height', 'width'],

  data: function data() {
    return {
      isTapped: false,
      handleBusTapEventFunc: null,
      titleHeight: 0
    };
  },


  computed: {
    infoTitleStyles: function infoTitleStyles() {
      var colSpan = this.colSpan;

      var styles = {};
      if (colSpan === 2) {
        styles.paddingRight = '130px';
        styles.marginRight = '226px';
      } else {
        styles.paddingRight = '26px';
        styles.marginRight = '0';
      }
      return styles;
    },
    imageData: function imageData() {
      return this.record.image;
    },
    imageAspect: function imageAspect() {
      var _record = this.record,
          image = _record.image,
          colSpan = _record.colSpan;

      return colSpan === 2 ? 'landscape' : image.aspect;
    },
    logoStyles: function logoStyles() {
      var logoSrc = this.clientLogoSrc;
      var styles = {
        src: 'url(' + logoSrc + ')'
      };
      return styles;
    },
    clientLogoSrc: function clientLogoSrc() {
      var clientKey = this.record.client;

      var clientRec = _clients2.default[clientKey];
      var logo = clientRec.logo;

      return logo;
    },
    bgImageStyles: function bgImageStyles() {
      var height = this.height,
          width = this.width,
          record = this.record;
      var image = record.image;
      var src = image.src,
          hA = image.hAlign,
          vA = image.vAlign;

      // add defaults

      var hAlign = hA || 'center';
      var vAlign = vA || 'center';

      var maxDim = Math.max(width, height);
      var rUrl = (0, _imageUtils.getResponsiveUrl)(src, maxDim);

      var styles = {
        backgroundImage: 'url(' + rUrl + ')',
        backgroundPosition: hAlign + ' ' + vAlign,
        height: this.height + 'px'
      };
      return styles;
    },
    routerLinkTo: function routerLinkTo() {
      var _record2 = this.record,
          url = _record2.url,
          data = _record2.data;

      return {
        path: url,
        params: {
          url: url,
          data: data
        }
      };
    }
  },

  methods: {
    measureLayout: function measureLayout() {
      this.titleHeight = this.getTitleContentHeight();
    },
    getTitleContentHeight: function getTitleContentHeight() {
      var el = this.$refs.infoTitle;
      return el ? el.clientHeight : 0;
    },


    // called from parent
    calculateTileAdjustment: function calculateTileAdjustment() {
      this.measureLayout();
      var titleHeight = this.titleHeight;

      /*
      // calculate the better offset
      // const offsets = [48, 34, 0];
      // const minHeight = 16; // picked by hand
       let height;
      let idx = 0;
      do {
        const offset = offsets[idx];
        height = titleHeight - offset;
        idx += 1;
      } while (height < minHeight);
      */

      var height = titleHeight - 28;
      return height;
    },
    touchHandler: function touchHandler(e) {
      var slug = this.record.slug;

      if (this.isTapped === true) {
        // double-tap: do default handling
        // console.warn(`double tap on ${slug}`);
      } else {
        // single-tap: show article content
        // console.warn(`single tap on ${slug}`);
        e.preventDefault();
        this.isTapped = true;
        _bus.Bus.$emit(_appConstants.Events.TappedArticle, slug);
      }
    }
  }

};

/***/ }),

/***/ "ZeKW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.93e5dcb.jpg";

/***/ }),

/***/ "ZfXl":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Zlvm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
*/

exports.default = {

  computed: {
    isDesktop: function isDesktop() {
      return this.$store.getters.isDesktop;
    },
    isMobile: function isMobile() {
      return this.$store.getters.isMobile;
    },
    isTablet: function isTablet() {
      return this.$store.getters.isTablet;
    },
    isReversed: function isReversed() {
      var reversed = this.data.reversed;

      return reversed === true ? reversed : false;
    },
    currentWidth: function currentWidth() {
      return this.$store.state.width;
    },
    deviceType: function deviceType() {
      var deviceStr = '';
      if (this.isMobile) {
        deviceStr = 'mobile';
      } else if (this.isTablet) {
        deviceStr = 'tablet';
      } else {
        deviceStr = 'desktop';
      }
      return deviceStr;
    }
  }

};

/***/ }),

/***/ "Zw1H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'component_hcAboutAlive',
  props: ['scrollState', 'visibility', 'percentScrolled'],
  computed: {
    contentOpacity: function contentOpacity() {
      var opacity = 0;
      var pointerEvents = 'none';

      var percentScrolled = this.percentScrolled;

      if (percentScrolled < 325) {
        opacity = 0;
        pointerEvents = 'none';
      } else if (percentScrolled < 350) {
        opacity = (percentScrolled - 325) / 25;
        pointerEvents = 'auto';
      } else if (percentScrolled < 375) {
        opacity = 1;
        pointerEvents = 'auto';
      } else {
        opacity = 1 - (percentScrolled - 375) / 25;
        opacity = Math.max(0, opacity);
        pointerEvents = 'none';
      }

      return {
        opacity: opacity,
        pointerEvents: pointerEvents
      };
    },
    graphicFixed: function graphicFixed() {
      var classes = {
        following: false,
        'fixed--bottom': false
      };

      var top = this.scrollState.aboutAlive_component_top;
      var bot = this.scrollState.bottomOfAboutContent;

      if (!top || !bot) {
        return classes;
      }

      if (top.isAboveViewport && bot.isBelowViewport) {
        classes.following = true;
      } else if (top.isAboveViewport && !bot.isBelowViewport) {
        classes['fixed--bottom'] = true;
      }

      return classes;
    },
    contentFixed: function contentFixed() {
      var classes = {
        fixed: false,
        'fixed--bottom': false
      };

      var top = this.scrollState.topOfAboutContent;
      var bot = this.scrollState.bottomOfAboutContent;

      if (!top || !bot) {
        return classes;
      }

      if (top.isAboveViewport && bot.isBelowViewport) {
        classes.fixed = true;
      } else if (top.isAboveViewport && !bot.isBelowViewport) {
        classes['fixed--bottom'] = true;
      }

      return classes;
    }
  }
};

/***/ }),

/***/ "aG0W":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNjguNSAxMDAiPjxkZWZzPjxzdHlsZT4uY2xzLTEsLmNscy0ye2ZpbGw6I2ZmZjt9LmNscy0ye3N0cm9rZTojZmZmO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmRyZWFtd29ya3Nfd2hpdGU8L3RpdGxlPjxnIGlkPSJMYXllcl8xIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwb2x5bGluZSBpZD0icG9seWxpbmUzIiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iODEuNSA0MC4wNiA4Ni4xNiA0MC4wNiA5MC4yNiA1My40NyA5NC42OSA0MCA5OC40MiA0MCAxMDIuODYgNTMuNDcgMTA2Ljk1IDQwLjA2IDExMS41IDQwLjA2IDEwNC43NSA2MCAxMDAuOTcgNjAgOTYuNSA0Ny4wNCA5Mi4wNCA2MCA4OC4yNSA2MCIvPjxwYXRoIGlkPSJwYXRoNSIgY2xhc3M9ImNscy0xIiBkPSJNMTA4LjUsNTEuNTV2MGMwLTQuNjcsMy44LTguNSw5LTguNXM5LDMuNzgsOSw4LjQ1djBjMCw0LjY3LTMuOCw4LjUtOSw4LjVzLTktMy43OC05LTguNDVtMTQuMTEsMHYwYTUuMDcsNS4wNywwLDAsMC01LjEzLTUuMTcsNSw1LDAsMCwwLTUuMDgsNS4xMnYwYTUuMDYsNS4wNiwwLDAsMCw1LjEyLDUuMTcsNSw1LDAsMCwwLDUuMDktNS4xMiIvPjxwYXRoIGlkPSJwYXRoNyIgY2xhc3M9ImNscy0xIiBkPSJNMTI3LjUsNDNoNy45NGE3LDcsMCwwLDEsNS4wNSwxLjcyQTUuMjgsNS4yOCwwLDAsMSwxNDIsNDguNjF2MGE1LjI5LDUuMjksMCwwLDEtMy43Miw1LjI3TDE0Mi41LDYwSDEzOGwtMy43Mi01LjQ0aC0zVjYwSDEyNy41Wm03LjY5LDguMjZjMS44NiwwLDIuOTItMSwyLjkyLTIuNDFWNDguOGMwLTEuNi0xLjE0LTIuNDItMy0yLjQyaC0zLjc5djQuODhaIi8+PHBvbHlsaW5lIGlkPSJwb2x5bGluZTkiIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIxNDIuNSA0MyAxNDYuMTMgNDMgMTQ2LjEzIDUwLjQzIDE1Mi44MiA0MyAxNTcuMTkgNDMgMTUwLjQ5IDUwLjIxIDE1Ny41IDYwIDE1My4xNSA2MCAxNDguMDMgNTIuNzYgMTQ2LjEzIDU0LjggMTQ2LjEzIDYwIDE0Mi41IDYwIi8+PHBhdGggaWQ9InBhdGgxMSIgY2xhc3M9ImNscy0xIiBkPSJNMTU1LjUsNTcuMzZsMi4xNC0yLjU4YTcuNDksNy40OSwwLDAsMCw0LjksMmMxLjQ4LDAsMi4zNy0uNTksMi4zNy0xLjU2djBjMC0uOTItLjU2LTEuMzktMy4zMS0yLjEtMy4zMS0uODUtNS40NC0xLjc3LTUuNDQtNVY0OGMwLTMsMi4zOS01LDUuNzUtNWE5LjQ5LDkuNDksMCwwLDEsNi4xLDIuMWwtMS44OCwyLjc0YTcuNjksNy42OSwwLDAsMC00LjI3LTEuNjNjLTEuMzgsMC0yLjExLjY0LTIuMTEsMS40NHYuMDVjMCwxLjA5LjcxLDEuNDQsMy41NCwyLjE3LDMuMzQuODcsNS4yMSwyLjA4LDUuMjEsNXYuMDVjMCwzLjI4LTIuNDgsNS4xMi02LDUuMTJhMTAuNDEsMTAuNDEsMCwwLDEtNy0yLjY0Ii8+PHBhdGggaWQ9InBhdGgxNSIgY2xhc3M9ImNscy0xIiBkPSJNMTkuNSw0M2g3Ljk0YTcsNywwLDAsMSw1LjA1LDEuNzJBNS4yOCw1LjI4LDAsMCwxLDM0LDQ4LjYxdjBhNS4yOSw1LjI5LDAsMCwxLTMuNzIsNS4yN0wzNC41LDYwSDMwbC0zLjcyLTUuNDRoLTNWNjBIMTkuNVptNy42OSw4LjI2YzEuODYsMCwyLjkyLTEsMi45Mi0yLjQxVjQ4LjhjMC0xLjYtMS4xNC0yLjQyLTMtMi40MkgyMy4zMnY0Ljg4WiIvPjxwb2x5bGluZSBpZD0icG9seWxpbmUxNyIgY2xhc3M9ImNscy0xIiBwb2ludHM9IjM1LjUgNDMgNDcuMzkgNDMgNDcuMzkgNDYuMzMgMzguOTUgNDYuMzMgMzguOTUgNDkuNzggNDYuMzggNDkuNzggNDYuMzggNTMuMSAzOC45NSA1My4xIDM4Ljk1IDU2LjY3IDQ3LjUgNTYuNjcgNDcuNSA2MCAzNS41IDYwIi8+PHBhdGggaWQ9InBhdGgxOSIgY2xhc3M9ImNscy0xIiBkPSJNNTQuNzgsNDNoMy40NEw2NS41LDYwSDYxLjZMNjAsNTYuMjFINTIuODZMNTEuMzEsNjBINDcuNVptMy45Myw5LjkzLTIuMjYtNS40N0w1NC4yLDUyLjkzWiIvPjxwb2x5bGluZSBpZD0icG9seWxpbmUyMSIgY2xhc3M9ImNscy0xIiBwb2ludHM9IjY0LjUgNDMgNjguNTMgNDMgNzMgNTAuMTkgNzcuNDcgNDMgODEuNSA0MyA4MS41IDYwIDc3Ljc4IDYwIDc3Ljc4IDQ4LjkgNzMgNTYuMTYgNzIuOSA1Ni4xNiA2OC4xNyA0OC45NyA2OC4xNyA2MCA2NC41IDYwIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNLS4wOCw0Ni43N2ExLjA5LDEuMDksMCwwLDEsLjI4LjA2Ii8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNNi41NSw1MS42NmEyLjYsMi42LDAsMCwxLC4yMS40aDBjLjEtLjEuMTcsMCwuMi4wOGEuNzYuNzYsMCwwLDAsLjExLjE2cy4xNiwwLC4yNCwwTDcuMzksNTJhMS45MiwxLjkyLDAsMCwxLS40OC0uMTZaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNNy42NCw1NC40MmMuMTMsMCwuMjItLjE0LjMyLS4xN3MuMzYtLjExLjUzLS4xOWEuMzQuMzQsMCwwLDAtLjA2LS4xNCw0LjYxLDQuNjEsMCwwLDEtLjI1LS43OXMwLS4yNi0uMDgtLjI1YTIuMjYsMi4yNiwwLDAsMCwwLC40Ni44Ny44NywwLDAsMCwwLC4xMXMuMDksMCwuMDguMDdTOCw1NCw4LDU0LjA1czAsMC0uMTIsMEw3LjY0LDU0QTEuMDUsMS4wNSwwLDAsMCw3LjY0LDU0LjQyWiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTksNTIuMzhhNC41Niw0LjU2LDAsMCwwLC4zOC41OWMuMDUtLjA4LDAtLjExLjA2LS4yOGExLjA4LDEuMDgsMCwwLDAtLjA3LS40MloiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik05LjI2LDQwSC4wNVY0Ni42YzEuNzMuNDIsNC41OCwyLjY4LDYsNC4zNGwuMSwwYzAtLjE0LDAtLjIyLjE0LS4yMXMuMS4yOC4yNC4zMy4yMS4yOS4yMS4zNC43Ny4xMy45MS4xMy4xLS4xNC4zNi0uMTRhLjUzLjUzLDAsMCwxLC40NC4xOWMuMTIsMCwwLS4wNy4yMi0uMDlBMS41OCwxLjU4LDAsMCwwLDksNTEuMzFjLjA5LDAsLjA5LS4wOC4xNS0uMTRzLjA3LS4xLjEyLS4xMywwLS4xOS4wNy0uMjN2MGMwLS4wOC0uMTksMC0uMjIsMHMtLjIxLDAtLjE5LS4xLDAtLjExLDAtLjExLDAsMCwwLS4wOGEuMDguMDgsMCwwLDEtLjA3LS4wNmMuMDYsMCwwLS4wOCwwLS4wOXMtLjA3LDAtLjA4LS4wNiwwLS4xLjA5LS4xMy4wNi0uMDksMC0uMTgtLjA3LS4yMSwwLS4yNmEuMTguMTgsMCwwLDAtLjEzLjExLjMyLjMyLDAsMCwxLDAtLjI3LjguOCwwLDAsMC0uMDguMTJjLjA3LS41OC43My0uODEuOS0uODUuMzItLjA4LjgzLS4wOS43NS4xNywwLDAsLjExLS4yMi0uMDgtLjI2YS4xNC4xNCwwLDAsMSwuMTUuMTljLjA2LDAsLjE2LS4wNi4xOSwwcy0uMTYuMDYtLjE3LjExLjIsMCwuMjcuMzdjMCwuMTUuMS42NS0uMTIuODFhLjI0LjI0LDAsMCwwLDAtLjA3LjE4LjE4LDAsMCwxLS4xOS4xMi4yLjIsMCwwLDAsMCwuMDhzLjE5LS4wOC4yNywwLS4xLjE4LS4xMy4yNWEuODIuODIsMCwwLDEsLjUzLjgzLDIuMDksMi4wOSwwLDAsMSwuMDcuODgsNS42MSw1LjYxLDAsMCwwLDEtMi40MSw2LjE1LDYuMTUsMCwwLDAtLjQyLTMuNzUsNiw2LDAsMCwwLTQuNjktMy4yOUE2LjMzLDYuMzMsMCwwLDEsMTQsNDYuNDFhNi42LDYuNiwwLDAsMS0uNjcsN0E3LDcsMCwwLDEsNy42OCw1NmwtLjA3LjA5czAsMCwwLC4xLDAsLjItLjE1LjMzLS4xNi4yNy0uMjUuMi0uMTcsMC0uMTcsMGExLjg0LDEuODQsMCwwLDAtLjMzLjQ1Yy0uMDguMjMtLjE0LjM1LS4wNy41NHMwLC4zNy0uMS4zOWExLjEsMS4xLDAsMCwwLS40OC4wOGMtLjE1LjA4LS4zNS4yMS0uNDQuMjVhLjQ4LjQ4LDAsMCwxLS4zNywwYy0uMTEsMC0uMTUtLjEtLjIxLS4xMVM0Ljg2LDU4LjEyLDUsNThzLjA3LjA4LjIyLjA2YTEsMSwwLDAsMCwuMzYtLjIzTDYsNTcuNDJBMi4xLDIuMSwwLDAsMCw2LjIzLDU3YTMuMzEsMy4zMSwwLDAsMCwuMjUtLjY2bC0uMjItLjE1czAtLjA4LDAtLjE2bC4xNi0uMjJoMGwtLjY1LS4yN2E4LjEyLDguMTIsMCwwLDEtMS44MS0xLjE2QTUuMzEsNS4zMSwwLDAsMCw2LDU1bC4yLDBhMS4zNiwxLjM2LDAsMCwxLS4zOCwwcy0uMTktLjE1LDAtLjI0LDAsMCwuMTMsMGEuMjcuMjcsMCwwLDAsLjIyLDAsNC41Myw0LjUzLDAsMCwwLC40NS0uMjIuODcuODcsMCwwLDAsLjQtLjQxLjUzLjUzLDAsMCwwLC4wNi0uMjRzMCwwLS4xNC0uMDYtLjE1LDAtLjE1LS4xNGEyLjU1LDIuNTUsMCwwLDEsLjA3LS40M2MwLS4wNi4wNy0uMDYuMjEtLjA2YTIuOTEsMi45MSwwLDAsMCwuMTYtLjVINy4xMUEuMzkuMzksMCwwLDAsNyw1Mi43YS44NS44NSwwLDAsMSwuMDYuMTdjMCwuMTMtLjE2LjEtLjE3LjA3bC0uMDctLjE2Yy0uMTEsMC0uMTgsMC0uMi0uMDdhMi41NSwyLjU1LDAsMCwwLS4wOC0uMjhjMC0uMDYtLjEyLS4wNi0uMS0uMTNhLjEzLjEzLDAsMCwxLC4wOS0uMTFzMCwwLC4wNywwYTMuNDMsMy40MywwLDAsMC0uMjgtLjUzYy0uMTQsMC0uMTItLjA3LS4yNC0uMjZzLS4wNy0uMTUtLjE4LS4yYS4xLjEsMCwwLDEsMC0uMTZBMTYuNzksMTYuNzksMCwwLDAsLjIsNDYuODNWNjBIOS4yNmM1LjA5LDAsOS4yMS00LjQ3LDkuMjEtMTBTMTQuMzUsNDAsOS4yNiw0MFoiLz48L2c+PC9zdmc+"

/***/ }),

/***/ "aPwj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clients = __webpack_require__("fL60");

var _clients2 = _interopRequireDefault(_clients);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  slug: 'jlr-electric-vehicle',
  company: _clients2.default.jaguar.name,
  logo: _clients2.default.jaguar.logo,
  logoWhite: _clients2.default.jaguar.logoWhite,
  blurb: {
    headline: "The new electric luxury vehicle.",
    tags: [],
    byline: 'Learn more about our work with Jaguar',
    background: __webpack_require__("3XUE"),
    backgroundSet: [{
      max: 1024,
      src: __webpack_require__("QbIR")
    }]
  },
  blocks: [{
    module: 'hero',
    background: {
      image: __webpack_require__("4xQX"),
      type: 'image'
    },
    constrain: true
  }, {
    module: 'intro',
    title: 'A luxury all-electric vehicle.',
    content: 'When Jaguar Land Rover (JLR) decided to make a move into the electric vehicle market with their first all-electric car, they asked the team at Particle Design to help them create an IVI (in-vehicle infotainment) system for their EV that was as exciting, technologically innovative, and future-facing as the car itself promised to be.\n\nJaguar Land Rover knew they were facing a critical challenge. Electric vehicles need to not only solve many of the same problems as regular cars, they also need to design around key infrastructure challenges that early adopters of electric vehicles face.',
    roles: ['Future Forecasting Workshop', 'Ethnographic Interviews', 'Competitive Landscape', 'Concept Design', 'Interaction Design', 'Visual Design', 'Prototyping', 'Front-End Development']
  }, {
    module: 'text_image_stack',
    image: {
      src: __webpack_require__("xJGN"),
      alt: 'image of a steering wheel with the digital interface on the dashboard'
    },
    content: '## How do you transform the electric vehicle experience? Reduce range anxiety. \n\n Known as “range anxiety,” electric vehicle (EV) drivers worry that they may not have enough charge to reach their destination or the next charging station. Some electric car makers have sought to ease the problem of range anxiety by building an infrastructure of charging stations to support drivers. But Jaguar Land Rover is a car company with a global reach , and creating a unique infrastructure to support its worldwide presence was untenable. They knew EVs were the transportation of the future, but until the real world caught up with this burgeoning industry, they’d need to design a vehicle that integrated with existing infrastructures and systems.'
  }, {
    module: 'text_image_row',
    images: [{
      src: __webpack_require__("SEzC"),
      height: '380px',
      gravity: 'center center',
      primary: true
    }],
    content: "## Pairing existing infrastructure with sharper design. \n\n Particle Design helped Jaguar Land Rover design an IVI system that can intelligently plan and route people to charging stations, not only when en route but also as they plan their trips. The design we created allows for smart, automated, contextual updates to the navigation system. It also includes a mobile app that can deliver alerts and communications about car and battery status when drivers are away from their vehicle."
  }, {
    module: 'row',
    columns: [{
      grid: {
        start: 3,
        end: 8
      },
      component: 'markdown',
      content: '## When a concept car is more than a concept. \n\n From idea to marketplace, Particle helped JLR bridge the gap between high concept and on-the-road usability by keeping future forecasting and design grounded in solving problems instead of just catching the eye.'
    }]
  }, {
    module: 'row',
    columns: [{
      grid: {
        start: 2,
        end: 11
      },
      component: 'blockquote',
      modifier: 'big',
      quote: 'The new Jaguar I-Pace concept has the potential of becoming a breakthrough vehicle, a luxury electric SUV that could cause quite a headache for Tesla Motors.',
      sourceName: 'USA Today, Feb 2016'
    }]
  }, {
    module: 'row',
    columns: [{
      grid: {
        start: 1,
        end: 12
      },
      component: 'image',
      src: __webpack_require__("va3D"),
      alt: 'Image of a taillight'
    }]
  }, {
    module: 'relatedWorks',
    works: ['vr-science-education', 'dreamworks']
  }]
};

/***/ }),

/***/ "agTS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hero_vue__ = __webpack_require__("8Axk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hero_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hero_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hero_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hero_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd08caec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_vue__ = __webpack_require__("y70L");
function injectStyle (ssrContext) {
  __webpack_require__("R+WO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hero_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd08caec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hero_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ausK":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "b5za":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'component_hcAboutMemorable',
  props: ['scrollState', 'visibility', 'percentScrolled'],
  computed: {
    contentOpacity: function contentOpacity() {
      var opacity = 0;
      var pointerEvents = 'none';

      var percentScrolled = this.percentScrolled;

      if (percentScrolled < 200) {
        opacity = 0;
        pointerEvents = 'none';
      } else if (percentScrolled < 225) {
        opacity = (percentScrolled - 200) / 25;
        pointerEvents = 'auto';
      } else if (percentScrolled < 250) {
        opacity = 1;
        pointerEvents = 'auto';
      } else if (percentScrolled < 312.5) {
        opacity = 1 - (percentScrolled - 250) / 62.5;
        pointerEvents = 'none';
      }

      return {
        opacity: opacity,
        pointerEvents: pointerEvents
      };
    },
    graphicFixed: function graphicFixed() {
      var classes = {
        following: false,
        'fixed--bottom': false
      };

      var top = this.scrollState.aboutMemorable_component_top;
      var bot = this.scrollState.bottomOfAboutContent;

      if (!top || !bot) {
        return classes;
      }

      if (top.isAboveViewport && bot.isBelowViewport) {
        classes.following = true;
      } else if (top.isAboveViewport && !bot.isBelowViewport) {
        classes['fixed--bottom'] = true;
      }

      return classes;
    },
    contentFixed: function contentFixed() {
      var classes = {
        fixed: false,
        'fixed--bottom': false
      };

      var top = this.scrollState.topOfAboutContent;
      var bot = this.scrollState.bottomOfAboutContent;

      if (!top || !bot) {
        return classes;
      }

      if (top.isAboveViewport && bot.isBelowViewport) {
        classes.fixed = true;
      } else if (top.isAboveViewport && !bot.isBelowViewport) {
        classes['fixed--bottom'] = true;
      }

      return classes;
    }
  }
};

/***/ }),

/***/ "bCBs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_announcement_vue__ = __webpack_require__("x5uD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_announcement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_announcement_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_announcement_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_announcement_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92797046_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_announcement_vue__ = __webpack_require__("knbV");
function injectStyle (ssrContext) {
  __webpack_require__("zWeP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_announcement_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92797046_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_announcement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "bGai":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _blockquote = __webpack_require__("4fQy");

var _blockquote2 = _interopRequireDefault(_blockquote);

var _bigHeading = __webpack_require__("30i/");

var _bigHeading2 = _interopRequireDefault(_bigHeading);

var _blurb = __webpack_require__("q2/K");

var _blurb2 = _interopRequireDefault(_blurb);

var _contentStack = __webpack_require__("FGQ4");

var _contentStack2 = _interopRequireDefault(_contentStack);

var _image = __webpack_require__("kRr6");

var _image2 = _interopRequireDefault(_image);

var _linkWithButtonBelow = __webpack_require__("SDfB");

var _linkWithButtonBelow2 = _interopRequireDefault(_linkWithButtonBelow);

var _map = __webpack_require__("LM1A");

var _map2 = _interopRequireDefault(_map);

var _markdown = __webpack_require__("SHp6");

var _markdown2 = _interopRequireDefault(_markdown);

var _int_hcAboutRelevant = __webpack_require__("Y1Ju");

var _int_hcAboutRelevant2 = _interopRequireDefault(_int_hcAboutRelevant);

var _int_hcAboutMemorable = __webpack_require__("Ezi0");

var _int_hcAboutMemorable2 = _interopRequireDefault(_int_hcAboutMemorable);

var _int_hcAboutAlive = __webpack_require__("Bfm5");

var _int_hcAboutAlive2 = _interopRequireDefault(_int_hcAboutAlive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { blockquote: _blockquote2.default, bigHeading: _bigHeading2.default, blurb: _blurb2.default, contentStack: _contentStack2.default, image: _image2.default, map: _map2.default, markdown: _markdown2.default, linkWithButtonBelow: _linkWithButtonBelow2.default, hcAboutRelevant: _int_hcAboutRelevant2.default, hcAboutMemorable: _int_hcAboutMemorable2.default, hcAboutAlive: _int_hcAboutAlive2.default };

// internal components - not for user resuse

/***/ }),

/***/ "bHIN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _windowDimensions = __webpack_require__("RhFO");

var _windowDimensions2 = _interopRequireDefault(_windowDimensions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { windowDimensions: _windowDimensions2.default };

/***/ }),

/***/ "bx/H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article-tile",class:_vm.tileClasses},[_c('router-link',{directives:[{name:"touch",rawName:"v-touch",value:(_vm.touchHandler),expression:"touchHandler"}],attrs:{"to":_vm.routerLinkTo}},[_c('div',{ref:"articleImage",staticClass:"background-image",style:(_vm.bgImageStyles)}),_vm._v(" "),_c('div',{staticClass:"info-container"},[_c('div',{ref:"infoContent",staticClass:"info-content"},[(_vm.logoSrc)?_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.logoSrc}})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"headline"},[_vm._v("\n          "+_vm._s(_vm.record.headline)+"\n        ")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c1Pa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{directives:[{name:"touch",rawName:"v-touch",value:(_vm.touchHandler),expression:"touchHandler"}],attrs:{"to":{ name: 'work-article', params: { slug: _vm.data.slug, itemType: _vm.data.itemType } },"data-component":"blurb"}},[_c('div',{staticClass:"blurb",class:{'tapped': _vm.tapped}},[_c('div',{staticClass:"blurb__background",style:(_vm.styles)}),_vm._v(" "),_c('div',{staticClass:"blurb__content"},[(_vm.data.logo)?_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.data.logoWhite,"alt":_vm.blurb.headline}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"description"},[(_vm.data.logo)?_c('div',{staticClass:"blurb__logo"},[_c('img',{attrs:{"src":_vm.data.logo,"alt":_vm.blurb.headline}})]):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"headline",attrs:{"data-type":"blurb-heading"}},[_vm._v("\n          "+_vm._s(_vm.blurb.headline)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"read-more"},[_vm._v("\n          Read More\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c8bw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cBty":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cHHQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _footer = __webpack_require__("IcsF");

var _footer2 = _interopRequireDefault(_footer);

var _navigation = __webpack_require__("T2+B");

var _navigation2 = _interopRequireDefault(_navigation);

var _throttle = __webpack_require__("+X65");

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { Footer: _footer2.default, Navigation: _navigation2.default },

  props: ['data', 'page', 'section'],

  data: function data() {
    return {
      scrollPosition: 0,
      window: {
        width: 0,
        height: 0
      },
      monitorState: {}
    };
  },


  computed: {
    scrollClasses: function scrollClasses() {
      var classes = {};
      var key = this.section || 'default';
      var keyName = 'section-' + key;
      classes[keyName] = true;
      return classes;
    }
  },

  methods: {
    updateMonitorState: function updateMonitorState(state) {
      this.monitorState = state;
    },
    updateScrollState: function updateScrollState(scrollState) {
      this.$store.commit('updateScrollState', scrollState);
    },
    onScroll: function onScroll() {
      var prev = this.scrollPosition;
      var current = this.getScrollPosition();

      var direction = current > prev ? 'down' : 'up';

      this.scrollPosition = current;
      if (direction !== this.$store.state.scrollDirection) {
        this.$store.commit('updateScrollDirection', direction);
      }
    },
    getScrollPosition: function getScrollPosition() {
      return window.pageYOffset || document.documentElement.scrollTop;
    },
    onResize: function onResize() {
      this.updateWindowDimensions();
    },
    updateWindowDimensions: function updateWindowDimensions() {
      var width = window.innerWidth;
      var height = window.innerHeight;
      this.$set(this.window, 'width', width);
      this.$set(this.window, 'height', height);
      var windowDimensions = {
        width: width, height: height
      };
      this.$store.commit('updateWindowDimensions', windowDimensions);
      // DEBUG
      // console.log('resize', width, height);
    }
  },

  mounted: function mounted() {
    this.onScroll();
    this.updateWindowDimensions();

    this.handleOnScroll = (0, _throttle2.default)(this.onScroll, 10);
    this.handleonResize = (0, _throttle2.default)(this.onResize, 50);
    window.addEventListener('scroll', this.handleOnScroll);
    window.addEventListener('resize', this.handleonResize);
    // DEBUG
    // console.log(`showing page: ${this.page}`);
    /*
    window.addEventListener('orientationchange', function() {
      const angle = screen.orientation.angle;
      // DEBUG
      // console.log(`the orientation of the device is now: ${angle}`);
    });
    */
  },


  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.handleOnScroll);
    window.removeEventListener('resize', this.handleonResize);
  }

}; //
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "cNRn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _imageUtils = __webpack_require__("Rn8A");

var _WorkMixin = __webpack_require__("OytB");

var _WorkMixin2 = _interopRequireDefault(_WorkMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
exports.default = {

  name: 'work-multi-image-text',

  props: ['data'],

  mixins: [_WorkMixin2.default],

  data: function data() {
    return {
      imageContentWidth: 0
    };
  },


  computed: {
    layoutClasses: function layoutClasses() {
      return {
        reversed: this.isReversed
      };
    },


    // return class string, eg 'desktop two', 'mobile one'
    containerClasses: function containerClasses() {
      var images = this.data.images;

      var isReversed = this.isReversed;

      var classArr = [];
      if (this.isMobile) {
        classArr = classArr.concat(['mobile', 'one']);
      } else if (this.isTablet) {
        classArr = classArr.concat(['tablet', 'two']);
      } else {
        classArr = classArr.concat(['desktop']);
        if (images.length === 2) {
          classArr = classArr.concat(['two']);
        } else {
          classArr = classArr.concat(['three']);
        }
      }

      if (isReversed) {
        classArr = classArr.concat(['reversed']);
      }

      return classArr.join(' ');
    }
  },

  methods: {
    imageStyles: function imageStyles(image) {
      var imageContentWidth = this.imageContentWidth;
      var hAlign = image.hAlign,
          vAlign = image.vAlign,
          src = image.src;

      // add defaults

      var hA = hAlign || 'center';
      var vA = vAlign || 'center';

      var rUrl = (0, _imageUtils.getResponsiveUrl)(src, imageContentWidth);
      return {
        backgroundImage: 'url(' + rUrl + ')',
        backgroundPosition: hA + ' ' + vA
      };
    },
    measureLayout: function measureLayout() {
      this.imageContentWidth = this.getImageContentWidth();
    },
    getImageContentWidth: function getImageContentWidth() {
      var el = this.$refs.imageContainer;
      return el ? el.clientWidth : 0;
    }
  },

  watch: {
    currentWidth: function currentWidth() /* newVal, oldVal */{
      var _this = this;

      _vue2.default.nextTick(function () {
        _this.measureLayout();
      });
    }
  },

  mounted: function mounted() {
    this.measureLayout();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  Work section MultiImageText module

  can have 2 or 3 images (only!)

  data record:
  {
    reversed: <boolean>
    images: [
      {
        src: <url> // url
        hAlign: <string>, // 'left', 'center', 'right'
        vAlign: <string>, // 'top', 'center', 'bottom'
      },
      {},
      {}
    ],
    content: <markdown>
  }
*/
// Lib

/***/ }),

/***/ "cmVA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dJf4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcAboutIntro_vue__ = __webpack_require__("MIUD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcAboutIntro_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcAboutIntro_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcAboutIntro_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcAboutIntro_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc944306_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcAboutIntro_vue__ = __webpack_require__("1mau");
function injectStyle (ssrContext) {
  __webpack_require__("gARq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcAboutIntro_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc944306_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcAboutIntro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dOKh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/preview.761d225.jpg";

/***/ }),

/***/ "dP5Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticleHiring_vue__ = __webpack_require__("Wemu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticleHiring_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticleHiring_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticleHiring_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticleHiring_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41764b74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticleHiring_vue__ = __webpack_require__("C65D");
function injectStyle (ssrContext) {
  __webpack_require__("THYn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticleHiring_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41764b74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticleHiring_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "diZL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.eb6dbfe.jpg";

/***/ }),

/***/ "eJwU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MouseEventContainer_vue__ = __webpack_require__("gA/E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MouseEventContainer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MouseEventContainer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MouseEventContainer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MouseEventContainer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59fd5492_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MouseEventContainer_vue__ = __webpack_require__("7fyb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MouseEventContainer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59fd5492_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MouseEventContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "eW4l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eXtR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/About-Us-Studio-Photo.a692c8e.jpg";

/***/ }),

/***/ "efQ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactMain_vue__ = __webpack_require__("f0at");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactMain_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactMain_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactMain_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactMain_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2efcdc29_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactMain_vue__ = __webpack_require__("SlJc");
function injectStyle (ssrContext) {
  __webpack_require__("584i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactMain_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2efcdc29_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ekfp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
  THIS FILE IS GENERATED !!

  #> npm run gen:meme-bundle
  #> NETLIFY_ENV=development npm run gen:meme-bundle
*/
/* eslint-disable */

exports.default = [{ "isShown": true, "imageSrc": "/static/content/uploads/arthur-fist.png", "title": "Arthur Fist ", "aspectRatio": "4:3", "showTitle": true }, { "isShown": true, "imageSrc": "/static/content/uploads/meme-test-lebron-4-3.png", "title": "LeBron James WTF", "aspectRatio": "4:3", "showTitle": true }, { "isShown": true, "imageSrc": "/static/content/uploads/meme-test-nick-young-1-1.jpg", "title": "Nick Young Huh", "aspectRatio": "1:1", "showTitle": true }, { "isShown": true, "imageSrc": "/static/content/uploads/meme-office-space-this-is-awkward.png", "title": "Office Space Well...This is Awkward", "aspectRatio": "4:3", "showTitle": true }, { "isShown": true, "imageSrc": "/static/content/uploads/meme-test-steve-urkel-16-9.png", "title": "Steve Urkel Did I Do That", "aspectRatio": "16:9", "showTitle": true }];

/***/ }),

/***/ "eops":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  text: 'Work',
  name: 'work-main'
}, {
  text: 'Matter',
  name: 'matter-main'
}, {
  text: "About",
  name: 'L2',
  params: {
    slug: 'about'
  }
}, {
  text: 'Contact',
  name: 'contact-main'
}];

/***/ }),

/***/ "etFc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _imageUtils = __webpack_require__("Rn8A");

var _WorkMixin = __webpack_require__("OytB");

var _WorkMixin2 = _interopRequireDefault(_WorkMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
exports.default = {

  name: 'work-image-text-column',

  props: ['data'],

  mixins: [_WorkMixin2.default],

  data: function data() {
    return {
      imageContentHeight: 0,
      imageContentWidth: 0
    };
  },


  computed: {
    hasContent: function hasContent() {
      var content = this.data.content;

      return content !== undefined;
    },
    hasImage: function hasImage() {
      var image = this.data.image;

      return image !== undefined;
    },
    imageCaption: function imageCaption() {
      var image = this.data.image;

      return image.caption;
    },
    contentText: function contentText() {
      var content = this.data.content;

      return content.text;
    },
    containerClasses: function containerClasses() {
      // return class string, eg 'desktop', 'mobile.reversed'
      var isReversed = this.isReversed;

      var deviceStr = '';
      if (this.isMobile) {
        deviceStr = 'mobile';
      } else if (this.isTablet) {
        deviceStr = 'tablet';
      } else {
        deviceStr = 'desktop';
      }
      return isReversed ? deviceStr + ' reversed' : deviceStr;
    },
    contentContainerClasses: function contentContainerClasses() {
      // return class string, eg 'desktop', 'mobile.reversed'
      var data = this.data;

      var classStr = this.containerClasses;
      var content = data.content;
      var hA = content.hAlign;

      // add defaults

      var hAlign = hA || 'left';

      return classStr + ' ' + hAlign;
    },
    imageStyles: function imageStyles() {
      var imageContentHeight = this.imageContentHeight,
          imageContentWidth = this.imageContentWidth,
          data = this.data;
      var image = data.image;
      var hA = image.hAlign,
          vA = image.vAlign;

      // add defaults

      var hAlign = hA || 'center';
      var vAlign = vA || 'center';

      var maxDim = Math.max(imageContentWidth, imageContentHeight);
      var rUrl = (0, _imageUtils.getResponsiveUrl)(image.src, maxDim);

      var styles = {
        backgroundImage: 'url(' + rUrl + ')',
        backgroundPosition: hAlign + ' ' + vAlign
      };

      return styles;
    },
    imageContainerClasses: function imageContainerClasses() {
      var classStr = this.containerClasses;
      var image = this.data.image;
      var size = image.height;


      var imgSize = size || 'tall';

      return classStr + ' ' + imgSize;
    }
  },

  methods: {
    measureLayout: function measureLayout() {
      this.imageContentHeight = this.getImageContentHeight();
      this.imageContentWidth = this.getImageContentWidth();
    },
    getImageContentHeight: function getImageContentHeight() {
      var el = this.$refs.imageContainer;
      return el ? el.clientHeight : 0;
    },
    getImageContentWidth: function getImageContentWidth() {
      var el = this.$refs.imageContainer;
      return el ? el.clientWidth : 0;
    }
  },

  watch: {
    currentWidth: function currentWidth() /* newVal, oldVal */{
      var _this = this;

      _vue2.default.nextTick(function () {
        _this.measureLayout();
      });
    }
  },

  mounted: function mounted() {
    this.measureLayout();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  Work section ImageTextColumn module

  data record:
  {
    reversed: <boolean>
    image: {
      height: <string>, // 'short', 'medium', 'tall'
      src: <url> //
      alt: <string>, // 'picture of a big mouse'
      caption: <string>, // 'a big mouse'
      hAlign: <string>, // 'left', 'center', 'right'
      vAlign: <string>, // 'top', 'center', 'bottom'
    },
    content: {
      text: <markdown>,
      hAlign: <string> // 'left' (default), 'right'
    }
  }
*/

/***/ }),

/***/ "eve6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-static-matter-tile"},[_c('router-link',{directives:[{name:"touch",rawName:"v-touch",value:(_vm.touchHandler),expression:"touchHandler"}],attrs:{"to":_vm.routerLinkTo}},[_c('div',{ref:"tileBgImage",staticClass:"background-image",style:(_vm.bgImageStyles),attrs:{"data-orientation":_vm.imageAspect}}),_vm._v(" "),_c('div',{ref:"tileInfo",staticClass:"tile-info",style:(_vm.tileInfoStyles)},[_c('div',{staticClass:"tile-info__category"},[_vm._v("\n        "+_vm._s(_vm.record.category)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"tile-info__title"},[_vm._v("\n        "+_vm._s(_vm.record.headline)+"\n      ")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f0at":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _default = __webpack_require__("lfHO");

var _default2 = _interopRequireDefault(_default);

var _ContactUsForm = __webpack_require__("BzuX");

var _ContactUsForm2 = _interopRequireDefault(_ContactUsForm);

var _ContactHeader = __webpack_require__("57xY");

var _ContactHeader2 = _interopRequireDefault(_ContactHeader);

var _ContactMap = __webpack_require__("joyZ");

var _ContactMap2 = _interopRequireDefault(_ContactMap);

var _ImageTextColumn = __webpack_require__("g4Nl");

var _ImageTextColumn2 = _interopRequireDefault(_ImageTextColumn);

var _ParticleHiring = __webpack_require__("dP5Q");

var _ParticleHiring2 = _interopRequireDefault(_ParticleHiring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
exports.default = {

  name: 'ContactMain',

  metaInfo: {
    title: 'Contact - Particle Design'
  },

  components: {
    DefaultLayout: _default2.default,
    ContactForm: _ContactUsForm2.default,
    ContactHeader: _ContactHeader2.default,
    ContactMap: _ContactMap2.default,
    ImageTextColumn: _ImageTextColumn2.default,
    ParticleHiring: _ParticleHiring2.default
  },

  props: ['data'],

  computed: {
    headerData: function headerData() {
      var data = this.data;

      return data.headerData;
    },
    hiringData: function hiringData() {
      var data = this.data;

      return data.hiringData;
    },
    imageData: function imageData() {
      var data = this.data;

      return data.imageData;
    },
    mapData: function mapData() {
      var data = this.data;

      return data.mapData;
    }
  }
};

/***/ }),

/***/ "fC9T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _appConstants = __webpack_require__("y3R9");

exports.default = {

  name: 'work-main-header',

  computed: {
    currentBrowserWidth: function currentBrowserWidth() {
      return this.$store.state.width;
    },
    colorBlockStyles: function colorBlockStyles() {
      var currentBrowserWidth = this.currentBrowserWidth;

      var offset = 0;
      if (currentBrowserWidth > _appConstants.MaxBrowserWidth) {
        offset = (currentBrowserWidth - _appConstants.MaxBrowserWidth) * 0.5;
      }
      var style = {
        marginLeft: '-' + offset + 'px'
      };
      return style;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//

/*
  Work section Header module

  data record:
  {
    background: <string> // url
    title: <string>
    content: <markdown>
    roles: Array<string> //
  }
*/
// Constants

/***/ }),

/***/ "fCdG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  headerData: {
    headline: 'Welcome<br />to Particle.',
    background: {
      type: 'video',
      data: {
        src: '/static/content/uploads/contact-pdx-time-lapse.mp4',
        poster: '/static/content/uploads/contact-pdx-time-lapse.jpg',
        alt: 'picture of Particle\'s logo on the wall'
      }
    }
  },

  hiringData: {
    heading: {
      jobs: 'We&rsquo;re hiring.',
      noJobs: 'We&rsquo;re usually hiring.'
    },
    teaser: {
      jobs: 'Want to help us create meaningful design in the everyday world? Join our growing team.',
      noJobs: 'Want to help us create meaningful design in the everyday world? Join our growing team.'
    },
    listings: [
      // {
      //   jobTitle: 'Interaction Designer',
      //   listingURL: 'https://www.linkedin.com/jobs/view/622160016/',
      //   description: 'Make usuable, useful things',
      // },
      // {
      //   jobTitle: 'Sr. Front-End Developer',
      //   listingURL: 'https://www.linkedin.com/jobs/view/622112067/',
      //   description: 'Come play with us. Build prototypes for clients like Virgin Hyperloop One and Samsung and have a great time doing it.',
      // },
    ],
    noJobsContent: 'We don&rsquo;t have any specific needs, but we&rsquo;re always open to meeting new people. Feel free to introduce yourself.'
  },

  imageData: {
    reversed: false,
    image: {
      src: '/static/content/uploads/contact-collage.jpg',
      alt: 'office peep hard at work',
      height: 'medium',
      hAlign: 'left'
    }
  },

  mapData: {
    content: '## Hello.\n\nCome on down to our place. We have a keggerator, views of downtown Portland, and lots of whiteboard space for capturing your ideas.',
    image: {
      src: '/static/content/uploads/contact-office-location-light.png'
    }
  }
};

/***/ }),

/***/ "fKIp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"work-main-header"}},[_c('div',{staticClass:"color-block",style:(_vm.colorBlockStyles)}),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-layout"},[_c('h1',[_vm._v("Our"),_c('br'),_vm._v("Work.")]),_vm._v(" "),_c('p',[_vm._v("We work at the intersection of technology, design, and culture. We create to be exceptional and unforgettable.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fL60":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dataUtils = __webpack_require__("uhrr");

var clients = {};

var addClient = (0, _dataUtils.createAddObjectKey)(clients, 'key');

var dreamworks = {
  key: 'dreamworks',
  name: 'Dreamworks',
  logo: __webpack_require__("WvvH"),
  logoWhite: __webpack_require__("aG0W"),
  href: null
};

addClient(dreamworks);

var eb = {
  // key: 'evelyn-bobbie',
  key: 'eb',
  name: 'Evelyn & Bobbie',
  logo: __webpack_require__("YC9H"),
  logoWhite: __webpack_require__("5/Qg"),
  href: null
};

addClient(eb);

var hp = {
  // key: 'hewlett-packard',
  key: 'hp',
  name: 'HP',
  logo: __webpack_require__("SfIE"),
  logoWhite: __webpack_require__("kE4L"),
  href: null
};

addClient(hp);

var jaguar = {
  key: 'jaguar',
  name: 'Jaguar',
  logo: __webpack_require__("2Vqw"),
  logoWhite: __webpack_require__("uy0X"),
  href: null
};

addClient(jaguar);

var landrover = {
  // key: 'land-rover',
  key: 'landrover',
  name: 'Landrover',
  logo: __webpack_require__("3uW7"),
  logoWhite: __webpack_require__("QHDi"),
  href: null
};

addClient(landrover);

var moovel = {
  key: 'moovel',
  name: 'Moovel',
  logo: __webpack_require__("Wzfu"),
  logoWhite: __webpack_require__("ausK"),
  href: null
};

addClient(moovel);

var outcome = {
  // key: 'outcome-md',
  key: 'outcome',
  name: 'Outcome',
  logo: __webpack_require__("rAq1"),
  logoWhite: __webpack_require__("P3PI"),
  href: null
};

addClient(outcome);

var particleDesign = {
  // key: 'particle-design',
  key: 'particleDesign',
  name: 'Particle Design',
  logo: __webpack_require__("Ecuq"),
  logoWhite: __webpack_require__("DD6R"),
  href: null
};

addClient(particleDesign);

var regence = {
  key: 'regence',
  name: 'Regence',
  logo: __webpack_require__("sFEi"),
  logoWhite: __webpack_require__("PHN8"),
  href: null
};

addClient(regence);

var samsung = {
  key: 'samsung',
  name: 'Samsung',
  logo: __webpack_require__("FVsJ"),
  logoWhite: __webpack_require__("tk+V"),
  href: null
};

addClient(samsung);

var vh1 = {
  key: 'vh1',
  // key: 'virgin-hyperloop-one',
  name: 'Virgin Hyperloop One',
  logo: __webpack_require__("PewQ"),
  logoWhite: __webpack_require__("5/DG"),
  href: null
};

addClient(vh1);

var vrMotion = {
  key: 'vrMotion',
  name: 'VR Motion',
  logo: __webpack_require__("HV/o"),
  logoWhite: __webpack_require__("8Lcf"),
  href: null
};

addClient(vrMotion);

var honeywell = {
  key: 'honeywell',
  name: 'Honeywell',
  logo: __webpack_require__("Np4h"),
  logoWhite: __webpack_require__("nHy4"),
  href: null
};

addClient(honeywell);

var skyryse = {
  key: 'skyryse',
  name: 'Skyryse',
  logo: __webpack_require__("EYO/"),
  logoWhite: __webpack_require__("EzTz"),
  href: null
};

addClient(skyryse);

var mentorSiemens = {
  key: 'mentorSiemens',
  name: 'Mentor Siemens',
  logo: __webpack_require__("Az3z"),
  logoWhite: __webpack_require__("Y3tK"),
  href: null
};

addClient(mentorSiemens);

var gm = {
  key: 'gm',
  name: 'GM',
  logo: __webpack_require__("oHJ4"),
  logoWhite: __webpack_require__("2Wfb"),
  href: null
};

addClient(gm);

exports.default = clients;

/***/ }),

/***/ "fVBG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {

  name: 'module_row',

  props: ['data', 'window'],

  computed: {
    columns: function columns() {
      var window = this.window;
      var cols = this.data.columns;

      // add window data for use in blurb
      cols.forEach(function (col) {
        col.window = window; // eslint-disable-line
      });

      return cols;
    }
  }

};

/***/ }),

/***/ "fdr1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"work-image-text-row"}},[_c('div',{staticClass:"module-layout"},[(_vm.hasImage)?_c('div',{ref:"imageContainer",staticClass:"image-container",class:_vm.containerClasses},[_c('div',{staticClass:"image",style:(_vm.imageStyles)}),_vm._v(" "),(_vm.imageCaption)?_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.imageCaption))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.hasContent)?_c('div',{staticClass:"content-container",class:_vm.containerClasses},[_c('markdown',{staticClass:"markdown"},[_vm._v(_vm._s(_vm.contentText))])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fo8f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//

exports.default = {
  name: 'component_map',
  props: ['data']
};

/***/ }),

/***/ "g4Nl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageTextColumn_vue__ = __webpack_require__("etFc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageTextColumn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageTextColumn_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageTextColumn_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageTextColumn_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_372658d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageTextColumn_vue__ = __webpack_require__("kGP1");
function injectStyle (ssrContext) {
  __webpack_require__("D5ie")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-372658d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageTextColumn_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_372658d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageTextColumn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gA/E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

/*
  MouseEventContainer

  this component was created to coordinate mouse-over events for a number of children components
*/
exports.default = {
  data: function data() {
    return {
      isMouseOver: false
    };
  },


  computed: {
    componentClasses: function componentClasses() {
      // console.warn(`mouseOver status: ${this.isMouseOver}`);
      var classes = {
        'hover--active': this.isMouseOver
      };
      return classes;
    }
  },

  methods: {
    onMouseOver: function onMouseOver() {
      this.isMouseOver = true;
    },
    onMouseOut: function onMouseOut() {
      this.isMouseOver = false;
    }
  }

};

/***/ }),

/***/ "gARq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gdJg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hero.0335098.jpg";

/***/ }),

/***/ "gmyM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MouseEventContainer = __webpack_require__("eJwU");

var _MouseEventContainer2 = _interopRequireDefault(_MouseEventContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

  name: 'HiringComponent',

  components: { MouseEventContainer: _MouseEventContainer2.default },

  props: ['data'],

  computed: {
    heading: function heading() {
      var heading = this.data.heading;
      if (this.haveJobs) {
        return heading.jobs;
      }
      return heading.noJobs;
    },
    teaser: function teaser() {
      var teaser = this.data.teaser;
      if (this.haveJobs) {
        return teaser.jobs;
      }
      return teaser.noJobs;
    },
    noJobsContent: function noJobsContent() {
      return this.data.noJobsContent;
    },
    haveJobs: function haveJobs() {
      return this.data.listings.length > 0;
    }
  }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components

/***/ }),

/***/ "h40S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"contact-form","data-status":_vm.formStatus}},[_c('div',{staticClass:"module-layout"},[_c('span',{staticClass:"contact-form__anchor",attrs:{"id":"contact-us-form"}}),_vm._v(" "),_c('component_bigHeading',{attrs:{"data":{heading: 'Drop us a line.'}}}),_vm._v(" "),_c('div',{staticClass:"form-container"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.formStatus=='default'),expression:"formStatus=='default'"}],on:{"submit":function($event){$event.preventDefault();return _vm.submitForm.apply(null, arguments)}}},[_c('div',{staticClass:"contact-form__input",class:{ 'has-input': _vm.hasInput(_vm.name) },attrs:{"data-field":"contact__name"}},[_c('label',{attrs:{"for":"contact__name"}},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],attrs:{"name":"contact__name","id":"contact__name","required":"","type":"text"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"contact-form__input",class:{ 'has-input': _vm.hasInput(_vm.company) },attrs:{"data-field":"contact__company"}},[_c('label',{attrs:{"for":"contact__company"}},[_vm._v("Company")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company),expression:"company"}],attrs:{"name":"contact__company","id":"contact__company","type":"text"},domProps:{"value":(_vm.company)},on:{"input":function($event){if($event.target.composing){ return; }_vm.company=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"contact-form__input",class:{ 'has-input': _vm.hasInput(_vm.email) },attrs:{"data-field":"contact__email"}},[_c('label',{attrs:{"for":"contact__email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"name":"contact__email","id":"contact__email","required":"","type":"email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"contact-form__textarea",class:{ 'has-input': _vm.hasInput(_vm.message) },attrs:{"data-field":"contact__message"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],attrs:{"name":"contact__message","id":"contact__message","placeholder":"The message"},domProps:{"value":(_vm.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"contact-form__submit"},[_c('button',{attrs:{"disabled":_vm.submitting}},[_c('span',{attrs:{"data-ornament":"arrow--right"}})])])]),_vm._v(" "),_c('div',{staticClass:"form-post-response form-post--success"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formStatus=='success'),expression:"formStatus=='success'"}],staticClass:"form-post__success-indicator"},[_c('p',[_vm._v("Thank you for contacting Particle! We’ll do our best to get back to you in a timely manner, but please understand if we may not be able to respond to all inquiries. We look forward to learning more about you!")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formStatus=='error'),expression:"formStatus=='error'"}],staticClass:"form-post-response form-post--error"},[_c('p',[_vm._v("There was an error! Please email us at "),_c('a',{attrs:{"href":("mailto:" + _vm.contactEmail)}},[_vm._v(_vm._s(_vm.contactEmail))])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h6CU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"about-subsection",attrs:{"data-component":"hcAboutMemorable","data-visibility":_vm.visibility}},[(_vm.visibility === 'mobile')?[_vm._m(0),_vm._v(" "),_vm._m(1)]:[_c('div',{staticClass:"content__anchor",attrs:{"id":"hcAboutMemorable"}}),_vm._v(" "),_c('ScrollItem',{attrs:{"id":"aboutMemorable_component_top"}},[_c('div',{attrs:{"data-anchor":"aboutMemorable_component_top"}})]),_vm._v(" "),_c('div',{staticClass:"content",class:_vm.contentFixed},[_c('div',{staticClass:"content__container",style:(_vm.contentOpacity)},[_c('span',{staticClass:"tab-number"},[_vm._v("02")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',[_vm._v("\n          We change how brands think of their users and how users think of brands. Through a design process developed over years of experience across industries, we define, design, and develop moments that make a difference in brand experiences. We create with heart and hustle to think big, take risks, and design game-changing products that drive innovation forward. \n        ")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),(_vm.visibility === 'compact')?_c('div',{staticClass:"graphic",class:_vm.graphicFixed},[_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8)]):_vm._e(),_vm._v(" "),(_vm.visibility === 'full')?_c('div',{staticClass:"graphic",class:_vm.graphicFixed},[_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12)]):_vm._e()]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"graphic"},[_c('div',{staticClass:"quadrant-l"},[_c('div',{staticClass:"subquadrant-t"},[_c('div',{staticClass:"placeholder"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("GQOj"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"subquadrant-bl"},[_c('div',{staticClass:"placeholder"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("ZfXl"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"subquadrant-br"},[_c('div',{staticClass:"placeholder"})])]),_vm._v(" "),_c('div',{staticClass:"quadrant-r"},[_c('div',{staticClass:"subquadrant-t"},[_c('div',{staticClass:"placeholder"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("0z+k"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"subquadrant-bl"},[_c('div',{staticClass:"placeholder"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("jpl5"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"subquadrant-br"},[_c('div',{staticClass:"placeholder"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("ybtO"),"alt":""}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"content__container"},[_c('span',[_vm._v("02")]),_vm._v(" "),_c('h1',{staticClass:"h1"},[_vm._v("\n          Make it\n          "),_c('br'),_vm._v("\n          Memorable\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          We change how brands think of their users and how users think of brands. Through a design process developed over years of experience across industries, we define, design, and develop moments that make a difference in brand experiences. We create with heart and hustle to think big, take risks, and design game-changing products that drive innovation forward. \n        ")]),_vm._v(" "),_c('div',{staticClass:"headline"},[_c('span',{attrs:{"data-ornament":"rectangle"}}),_vm._v(" "),_c('h2',{staticClass:"h2"},[_vm._v("\n            Services\n          ")])]),_vm._v(" "),_c('ul',{staticClass:"services"},[_c('li',{staticClass:"service"},[_vm._v("Visual Design")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Roles & Task Flows")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Interaction Design")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Usability Testing")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("UX Strategy")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Data Visualization")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"h1"},[_vm._v("\n          Make it\n          "),_c('br'),_vm._v("\n          Memorable\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headline"},[_c('span',{attrs:{"data-ornament":"rectangle"}}),_vm._v(" "),_c('h2',{staticClass:"h2"},[_vm._v("\n            Services\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"services"},[_c('li',{staticClass:"service"},[_vm._v("Visual Design")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Roles & Task Flows")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Interaction Design")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Usability Testing")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("UX Strategy")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Data Visualization")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-1"},[_c('div',{staticClass:"placeholder blue"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("GQOj"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-2"},[_c('div',{staticClass:"subquadrant-l"},[_c('div',{staticClass:"placeholder yellow"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("ybtO"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"subquadrant-r"},[_c('div',{staticClass:"placeholder black"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-3"},[_c('div',{staticClass:"placeholder white"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("V0ux"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-4"},[_c('div',{staticClass:"placeholder blue"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("ZfXl"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-tl"},[_c('div',{staticClass:"placeholder black"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("Kl68"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-tr"},[_c('div',{staticClass:"subquadrant-t"},[_c('div',{staticClass:"placeholder blue"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("GQOj"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"subquadrant-ml"},[_c('div',{staticClass:"placeholder yellow"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("ybtO"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"subquadrant-mr"},[_c('div',{staticClass:"placeholder black"})]),_vm._v(" "),_c('div',{staticClass:"subquadrant-b"},[_c('div',{staticClass:"placeholder white"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("V0ux"),"alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-bl"},[_c('div',{staticClass:"placeholder yellow"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("ZfXl"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-br"},[_c('div',{staticClass:"placeholder blue"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("jpl5"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hVWo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatterArticle_vue__ = __webpack_require__("BiQ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatterArticle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatterArticle_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatterArticle_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatterArticle_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20a44e2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MatterArticle_vue__ = __webpack_require__("Otlw");
function injectStyle (ssrContext) {
  __webpack_require__("Brp9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatterArticle_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20a44e2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MatterArticle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "hfhv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TwoColumnText_vue__ = __webpack_require__("TIbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TwoColumnText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TwoColumnText_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TwoColumnText_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TwoColumnText_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6486c491_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TwoColumnText_vue__ = __webpack_require__("5Ttu");
function injectStyle (ssrContext) {
  __webpack_require__("AWz0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6486c491"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TwoColumnText_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6486c491_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TwoColumnText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "hp1n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "huw7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hzqc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Module expects:
exports.default = {
  name: 'component_blockquote',
  props: ['data']
};

/***/ }),

/***/ "i2aE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  layout: 'default',
  blocks: [{
    module: 'hcAboutIntro'
  }, {
    module: 'hcAbout'
  }, {
    module: 'image',
    src: __webpack_require__("eXtR"),
    alt: 'Image of some people working at Particle'
  }, {
    module: 'hiring',
    heading: {
      jobs: 'We&rsquo;re hiring.',
      noJobs: 'We&rsquo;re usually hiring.'
    },
    teaser: {
      jobs: 'Want to help us create meaningful design in the everyday world? Join our growing team.',
      noJobs: 'Want to help us create meaningful design in the everyday world? Join our growing team.'
    },
    listings: [
      // {
      //   jobTitle: 'Interaction Designer',
      //   listingURL: 'https://www.linkedin.com/jobs/view/622160016/',
      //   description: 'Make usuable, useful things',
      // },
      // {
      //   jobTitle: 'Sr. Front-End Developer',
      //   listingURL: 'https://www.linkedin.com/jobs/view/622112067/',
      //   description: 'Come play with us. Build prototypes for clients like Virgin Hyperloop One and Samsung and have a great time doing it.',
      // },
    ],
    noJobsContent: 'We don&rsquo;t have any specific needs, but we&rsquo;re always open to meeting new people. Feel free to introduce yourself.'
  }]
};

/***/ }),

/***/ "i5mi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SmartAddress_vue__ = __webpack_require__("t1Ph");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SmartAddress_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SmartAddress_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SmartAddress_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SmartAddress_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2525a87c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SmartAddress_vue__ = __webpack_require__("mZo6");
function injectStyle (ssrContext) {
  __webpack_require__("H9yH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2525a87c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SmartAddress_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2525a87c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SmartAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "iRj3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_vue__ = __webpack_require__("UpFw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc02983_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_image_vue__ = __webpack_require__("M0MU");
function injectStyle (ssrContext) {
  __webpack_require__("5qPY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc02983_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_image_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "iZuN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
  Interface to Google Analytics tracking

  usage:

  ```
    import ga from './google-analytics'
    import router from './router'

    ga.use(router)
  ```

  help from following resources:
  * https://serversideup.net/google-analytics-vue-router-single-page-application/
  * https://gist.github.com/daliborgogic/91a01ff39ec2a30258b2a2fbe5555485
  * https://github.com/egoist/vue-ga
  * https://developers.google.com/analytics/devguides/collection/gtagjs/single-page-applications
*/

// custom Google Analytics tracking event
var gaNotLoaded = function gaNotLoaded() {
  return window.gaTrackPageview === undefined;
};

var gaSetPageview = function gaSetPageview(url) {
  window.gaTrackPageview(url);
};

var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
// [::1] is the IPv6 localhost address.
window.location.hostname === '[::1]' ||
// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));

var trackNewPage = function trackNewPage(url) {
  if (isLocalhost || gaNotLoaded()) return;
  gaSetPageview(url);
};

var initialize = function initialize(router) {
  // track a page after each route change
  router.afterEach(function (to) {
    trackNewPage(to.path);
  });
};

exports.default = {
  use: initialize
};

/***/ }),

/***/ "iaoP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-mobile.a4971a1.jpg";

/***/ }),

/***/ "idZ9":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVAAAAFSCAYAAACkIIfSAAAAAXNSR0IArs4c6QAAIrtJREFUeAHtnXmMZEd9x6vva3pm9pq113sYYwdyQLANDojIYGODTSSQkXH4AwsICkKQBBGDY0GQUCQgIYgQYwiQCCmJcRwgNuaQjDkcwA5XsHEC8rk+dtZ7eXZ37p6evlK/3l2YnUx3v1fvrvcpaXZm+9Xx6vP7vW/XqzPzi73X9hQBAhCAAARcE8i6TkECCEAAAhDoE0BAcQQIQAAChgQQUENwJIMABCCAgOIDEIAABAwJIKCG4EgGAQhAAAHFByAAAQgYEkBADcGRDAIQgAACig9AAAIQMCSAgBqCIxkEIAABBBQfgAAEIGBIAAE1BEcyCEAAAggoPgABCEDAkAACagiOZBCAAAQQUHwAAhCAgCEBBNQQHMkgAAEIIKD4AAQgAAFDAgioITiSQQACEEBA8QEIQAAChgQQUENwJIMABCCAgOIDEIAABAwJIKCG4EgGAQhAAAHFByAAAQgYEkBADcGRDAIQgAACig9AAAIQMCSAgBqCIxkEIAABBBQfgAAEIGBIAAE1BEcyCEAAAggoPgABCEDAkAACagiOZBCAAAQQUHwAAhCAgCEBBNQQHMkgAAEIIKD4AAQgAAFDAgioITiSQQACEEBA8QEIQAAChgQQUENwJIMABCCAgOIDEIAABAwJIKCG4EgGAQhAAAHFByAAAQgYEkBADcGRDAIQgAACig9AAAIQMCSAgBqCIxkEIAABBBQfgAAEIGBIAAE1BEcyCEAAAggoPgABCEDAkAACagiOZBCAAAQQUHwAAhCAgCEBBNQQHMkgAAEIIKD4AAQgAAFDAgioITiSQQACEEBA8QEIQAAChgQQUENwJIMABCCAgOIDEIAABAwJIKCG4EgGAQhAAAHFByAAAQgYEkBADcGRDAIQgAACig9AAAIQMCSAgBqCIxkEIAABBBQfgAAEIGBIAAE1BEcyCEAAAggoPgABCEDAkAACagiOZBCAAAQQUHwAAhCAgCEBBNQQHMkgAAEIIKD4AAQgAAFDAgioITiSQQACEEBA8QEIQAAChgQQUENwJIMABCCAgOIDEIAABAwJIKCG4EgGAQhAAAHFByAAAQgYEkBADcGRDAIQgAACig9AAAIQMCSAgBqCIxkEIAABBBQfgAAEIGBIAAE1BEcyCEAAAnkQQCBIAp1OS3U7q6rX7ejfbdXttZX+Q3X1T6/X1UX39LXeid89+a1UJpORf1Ume/J3Jquy2Zz+f15fy6lsLn/i/7miyuUK/TT8A4EoCCCgUVC3rMxer6M6rRXVbjf7vzv6d7crwtnSInlCFIOqsohtRoRUi2uuUFK5fFnlC2X9u9QX26DKJV8ICAEEFD9wR0ALYrvVUK3VZf17Sf+s9IXSXSb+xRaB7olgq6a+p6XTMs5qYRUxLRRrKl+sqHy+Is3b0+LwHwh4IYCAeqGXirRaMFcbarW5cEI0tXDKa3cSgnQdrMrPyvzJ281oMa2qfKmqiqW6FtdqEqrBPcaYAAIaY+NEdWtd/UreWtGC2VzsC6f0X9oRev1WqrRUGwvP6D7VnCqUxvpiWiyP68YpY6p22Dm8WiCg4bGOeUm9vlg2l2f7v3XnZczv1/vtyRfDamOu/yODViKipeqkFtQxnTmv+t4J258DAmq/jYfWUPozmw0tmvpHRsbTG/QXyIoWU/2T1QNSxcqkKuufnO5DJUBgEAEEdBAZiz+X0XERTfmREXPC6QS63bZaWZrp/4iAlrSQlioTWliZMnU6Kf6HgKbIB6S12Vg8oltZCymqtbeqyvSs5dYhtTx/WL/i11VlbJsefNKj+QQIaAIIaArcoN1a1oMmWjj1oBDBlIC84s/3f2TgqTI21R/RN82NdHYQQEDtsOOGtTgx2ny4P/1owwh8aERAZifIT6FUU5Xatv5IvlFGJEo8AQQ08Sb8/xWQOZsyTUdanoTgCLSaS1pIl/Qk/aqq1nSLtCyj94Q0EUBALbJ2a3VRLc0f6i+ntKhasa9KWy8umF99st83Wq1vp0Uae4v5d4MIqH8sI8tJ1p0va+Fs6jmNhOgIyCDd/LEn9RSoCTU2fmZ/85Po7oaSwyCAgIZBObAyenqqzTG1rEfW7VktFBis0DKWyfnHdR9ptT6lytUtoZVLQeETQEDDZ+5LidK/uTh3gNd1X2j6n4l8oS3NHVSysqs2sYOpT/4jjkWOCGgszOD8JvoP5oJ+XV8+7jwRMSMjIK/1czN7Vbm2WbdIz2C9fWSWCKZgBDQYroHkKq+Gi/MH9eu63pSYkCgC0tUi80hr4zv6a+4TdfPc7EACbD8zEE2cLvT06/rTamF2GvGMk1lc3ovsyL9wfJ+eKXFA7who/2YtLvEkMjot0JibraP3s1w8tk/v9r4S8zvl9pwSkNaobEhdn9ytd84vOk1GvBgSoAUaQ6OcuiXZ7GNu5jHE8xQQi37LGvu5o3v7r/UWVSt1VUFAY2nyXv81b3F2v35ll4PXCDYSkAHB/iu9Hq3nlT6ZFuYVPmZ26+rt5eZ1X6e0UAjpILCyfLS/7HZs0y59yiiv9EmyOi3QGFlLNqiYPfo44hkjm4R1K6emO8lyXEJyCCCgMbGV9HcuHH+KFUUxsUcUtyGv9PPHnmJJbhTwDcvkFd4QnJ/JGktH9Vp23Q9GgICe3rQo09V6bZaBJsAbaIFGbCTZ6RzxjNgIMSxeloEuLx6O4Z1xS2sJ0AJdSyPUv/VIu17LvsKSzFCpJ6kw2dNVXutl9RIhngQQ0Cjsol/TZFWRLO0jQGAYAZl03+109KT7nfqkZY5aHsYqimu8wodM/cRAwROIZ8jck1ycHLU8rwcYdXM0ydWw8t4R0DDNKi1P/SDIMj4CBNwQkClu83odPRPu3VALPi4CGjzjX5Ugr+2I569w8IdLAiKii3P7XaYiepAEENAg6a7JW3bgoc9zDRD+NCIgx7YsMeXNiF0QiRDQIKiuy1NGU2UwgAABPwis6HnDjaVn/MiKPDwSQEA9AhyVvLksZxYxn28UJ667IyDzhzmVwB2zIGIjoEFQPZmnvLIvyk47BAgEQEDOxFptLgSQM1k6JYCAOiXlMl57dUmPuE/rVOw87hId0R0T0Ms+tY/JufSEaAggoAFw73RaJ6acIJ4B0CXLtQR6em6oTI3rap8jhE8AAfWduV6iKZtB6CV4BAiEQaCrfU02IOFtJwzap5eBgJ7Ow/P/lhcOM9fTM0UycEtA5hcvLx5xm4z4HgkgoB4Brk2+qic6NxZn1n7E3xAIjYBMl5PJ9oTwCCCgPrHudlt6dyVWifiEk2wMCSzoc7Tk+GRCOATYjcknznIAHI47GubMTEvt27eiDjzdVIuLHdVY7qrl5Y7+6aqVla4qlbKqWpWfXP93bSynzjyzqHbvLqttUwW9IRE7Eg2j3Ou2dX/ofjW+5exh0bjmEwEE1AeQ0vfUai75kJNdWYhI3nffgnrg54vqqSdXtHA2VaNhvqNQqZRRu3aV1Z6zy+p5z6+pCy6sqz17ynZB86E2cq5SY/EZVRnb5kNuZDGMQOYXe69louIwQiOutfR8z/mjT4yIlY7LzWZX3XvPnPrJj+fVfT9bUIcPBz+1ZsuWvDr/grp60UV1dfHLJvst13TQHlXLjJrY+iyVL1RHReS6BwIIqAd4Mm1k9sijqtNZ9ZRLkhP39BZ90sL85p3H1N3fnfXUwvTKoVjM9EX0VVdsVhe+sK6PCE736342X1Sbtp7HRsxeHWtIegR0CJxRl2SNu4x8pjFIv+UdX5lRX7ltRh06FL8vkM26Zfqa12xVV79+m6qPp7enqlrfzqt8gA8oAmoIt9NeVbMzj6Zug9uFhba67cvPqC998Rm1sBD/xQKVSlZd9bqt6po3TKlNmwqG1k5uskwmqya3naeyufTVPQyrIaCGlOePPZmqOXfSv3nLzYfVF//9SH/E3BBbZMnk9f6q121Tb3rLGapWy0V2H1EUXCzXVX3TniiKtr5MBNTAxLLL0oIcr5CS8MP/mlOf+Lv96tDB+L2quzWBvNr/yZ/uVK+4bJPbpImOX9+8RxVL9UTXIY43j4C6tIps3jD7zGN6zmfyxWRU1Y8cXlU3/v1+9YPvz42KmrjrF1w4pv78ul1ql55fmoaQyxXV5JQeUFLpHljz29asRHJJVAaN0iCe3/3OcfWmax+0UjzF5Pf9bFH90ZsfUl+9Ix1Lb2WmyLKeG0rwlwAtUBc8O+2mHjh6zOqBo9XVrvrUJ59WX7k9HcIi5r/s8k3quvfuSsEc0kx/QCmnpzcR/CFAC9QFxyW905LNx8rKyqF3vP2RVImnmP/b3zqu3vbWh9XevQ0X3pDEqD097Y7jZfy0HALqkGa7vaJaevDI1vDgg0vq7W97WD36iO0isrEFp6eb6p36y+O/f2qvjaXmzZU5JW9SBH8IIKAOOa5YvE3dT38yr979Z4+pubn4z+t0aC6jaLJO/y/e+7iS/l+bg6yTJ/hDAAF1wLGrJ803G7MOYiYviojFDdc/HukSzDhRa7d76q8++KS6/TZ7RUbOlk/z8mM//Q0BdUDT1m/sb911rC8WIhqEXxPQy/vVJz6+X6+2snWH955aWUrPIOGvLev/XwjoCKZyQFxzxb7Wp7y2f+RDT9k8JjbCsqMv33Tj03qA6djoiAmMsbJ8XMkm4ARvBBDQEfzkm1p2HLIpPPTQsvrA+5/Qr3E21SqYunzkQ/vsHFjSPs3xM959BgEdwlB2mG/qb2qbwv79TXX9e/bS5+nQqNK98Zfve0I98rB9Z6+Lb3N6rENHGBANAR0ARj5eWZbWp/kO6kOyjuSSbAjygfc/ruZmOTPHjQFkdF5a7LITlU1BfLuhfZxgTgABHcROv+I0l+xqfd504371+N6VQTXm8yEEZM/Tj/71viExknmpuXTMui6qMC2BgA6gvdpcUN2ePZ2EMl3pq3ccHVBbPnZC4Pvfm+vvheokblLidLsd1VpdSMrtxu4+EdABJrFp3ufBA031t39jX+tpgOkC/fjTn3paPfqoXf2hzWX7dtsK1AnWZI6AroFx6k/pWJcWqC1B5jTKscEE7wRarZ762Een9RQge2ZmyP62PYvetrxb2XkOCOgGrGS9sPaoDa4k76N7fjCrfvQju9d3h22Vhx5cVl//mk3dIbq/v4GPmPhRek/bGkKruWzHxPmVla668RP7h9Q0ukvbz6iqs8+Z0Ge819X4eFHVxgoqm8nolnJLj3a31P7pBfXk4/P692IsW3uf+8wB9bKXT6qJCTseoVW9VLlcTdcu/X54vx3W94PEyTy6eqeadsuOPq6b/+VQKGezO8GfzWbU+RdOqVe8cpe65DLZCX7MSTJ1/FhT3f2dafXdu6bVD+89qJrNeAzsyYF6n/2HA+r6G3Y7qkfcI7VWl/RG4S0On3NpKDZUXgfMlqOKZ4+31DVX/1ILTrRdETvOGlNve8fvaOHcrTZtLq2j7e6/jUZb3fP9A+rzn/ml+t//iX7+YlZ3gP3rLb+ldu70Vi93FIKLXalPqerYVHAFWJgzfaDrjLpqyYikHDscpXhOTJTUe9/3QvWNb79WXf2G8zyLp5ipUsmry1+1W/3b7Veqj914sW7FRntIWlePy31Bn1RqS1jVuzQR3BFAQNfwkld3G7b5WlzsRLYdWy6XVW/5499Wd37vKvWmt/6mKhSDcbEr/mCP+tpdr1E3fOBFaqwe3REVd915TB05YscBg7LRcqfFQos1kjDyz2C8e2Sx8YzQai7F88Zc3pXsZbm0FP60pboWsk//0yXquhsuUPV6weVdu4+eL2TVG9/8XHXLl6+IrDUqa+VvvcWebe9Wm4vuDZHiFAjoGuNLR3rSgzzQX9av72GH3WePqy/8x5XqpRfvCLtodc65E+rW21+tLnrxGaGXLQV+/Wsz+gsrHoNbXgG0VhFQNwwR0FO09LzP9mryR99/8uN5NRvyZiEiXLfedqU659njp2iG/ntisqg+98+Xqav/UM4+DzdIX/N/3m3H1LdW/xmIduAxXOt5Kw0BPcmvpfs/bdh56a5vhrsB8HnP2aRu+twlanwiun7IU49APp9RH/zwi9XlV4Q/tShs7qfq7PtvvUNTezWdBwuasERAT1Kz4fVdBo/uvSe8kdTJTSX1yc++XFVr8ZpO/OGPvVQ957nhTgr/+f2L6rDescmGYMOzEJYdENCTpNsWDCB97+7janU1nNevfD6rPn7Ty9TOXc4mxIfl0FKOTHe66R8vUZu3lMMsVskZUzYEBNS5FRFQzUpe3eUVPukhzNbnu6+/QA/abI8tsjN31PpzRcO8wXvvDa/1H2S9+mMBluwFESQnyRsB1RDaLd3nk3CHkd2BHnggnFkEe5413p8+FLRzes1fBD7M/tCH9VlTy8vJH423pUHh1X+cpEdANaWWBXPfHnmkoaQPNIzwruteoHK5TBhFeS7jXe85X0l3QxhBDul74AE7pgHxGu/MY8LxLGf3ElksG6Yv3X9fOPuXPu/5W9Urr9wTma3cFny2bi1f9fpz3SYzjn//fXYIaMeCKX3GRnSREAHVsNrt5C9fC+vBfff157twr3hEfee7nq/K5XBmCoT1RRY02RZLOh0hTr2AyhZeNhzt+tijwQ+CycDMRS+JZrWPI28eEGnrtkpoK6SeeHwllvuXDkAz8ONet62fC7tOIR1YWQ8XUi+gbb2BQtKDDFwcPRq8s196+a7Eorr0sp2h3Lsc+XHooB3zQdu0Qkf6TOoFtGPB6/v0vnC+BC7VGyEnNbzs0p164Cscd9+3L/ldQmJn2Z2JMJxAOB41/B4ivdppJd9JpqeDf2Dl2I0LL4rvvM9RTiSrpl5wwbZR0Xy5HtYXmi83OySTTif5z8aQ6vlyKfUC2u22fAEZZSZhPLAv+f0z9XSgZExdGmSLi19+1qBLvn4+PW2H8HTayX82fDXsBpkhoO3k91cdPx58/+e5501u4D7J+ujZvzERyg0f18ep2BC6neQ/G0HbIeUC2tMjpsl39kYj+An0Z58T3VZ1fj0Ez9KngIYRlpfD38w6iHp1LGhcBMFlbZ6pFtCuTNVI+BJOMWYYD+zU9upav0nk31NTlVDuu2HBcs4ToHpMZRrhMakWUFv6eMJYf12thjMRfYS/erpc0XXI6LPngw6Nhh0tUOFkyzMSlM1TLaC9XvB9h0EZbm2+B0OYd1itBX/G0do6BfW3bHUXdJiZSX630ClGtjwjp+rj9+90C6js/mBBOHY0+Ac2G3zDLRRLZELw+LA2dQkDWLdrxzMSFKsQ3CmoW/eeb7dnh3NkbVE37yaNRQ4h9BKEVk8bljkHCSvVAmrLWt9sqq0Y5ONhlncY/axmd+Y+lQy0EgYTSPWjZ8MhcmJaWqCDHTyKK1a1QPVpDYTBBFIuoOGcHzQYvz9XaIH6w9GvXOwSUDueEb9suz6flAuoHd+uSdkdfr3z2fp/mwRUTwS11Uy+1CvVApr0c5BOeUChYMkQ+akKJfy3TV9oeip9wq0R7O2nXECDhRtW7oVius0YFmen5dgkoBn0c6jZU/3k2fLtWizSAh3q5SFftElAu7RAh3pPqgU0o+wQnqxVnW5D/TURF7O5RNymo5vMWvKMOKqsQaRUCyi+YeAxJEkVgZ4dbYzAbJZyAcU7AvMsMraCQCaMta8JJhX8zgoxhoNzODfOG6/5pj5TKPlfOMtLrKxxbnWJmXybu6uvu9jpFlCcw7G3HJ1pOI5LRHsI2LQsNQirpPsV3qbe/iC8gzxTT4C3tOEukGoBzSKgw72Dq6knkM2m+iV1pP3TLaAZi+abjDQ1ESDgnkCGRsZQaOkWUJxjqHNwEQK8pQ33gVQLqOL1ZLh3cDX1BDI8I0N9INUCmsvRvzPUO7iYegJZnpGhPpBqAc3m5KA05rkN9RAuppeAXiKczdpxmGBQRky1gIp45voiGhRe8oVAcgnkEM+Rxku5gOrjMPJ8w470EiKkkkAuX0xlvd1UGgHN4SRuHIa46SGQ5dkYaezUC2gOJxnpJERIJ4FsvpTOiruodeoFNF8ou8BFVAikh0AeAR1p7NQLaC5fGQmJCBBII4FcnsbFKLunXkBlnhvL1Ua5CdfTRkDWwDMHdLTVUy+ggohXldGOQox0Ecjx+u7I4AioxpQvVh3BIhIE0kIgX+KZcGJrBFRTyhfHnLAiDgRSQ6DAM+HI1gioxlTQLVB23nbkL0RKBYGMKhRogToxNQKqKcmu27kCo/FOHIY49hMolGryUNhfUR9qiICehNh3Gh+AkgUEkk6AMQHnFkRAT7Kiz8e50xDTbgI8C87ti4CeZHWiz4fXFueuQ0wbCUh3Vp7uLMemRUBPodJ9PrzGn4LB77QSYEDVneUR0DW86PtZA4M/U0kgX9QDSATHBBDQNaiKzH1bQ4M/00igUGJOtBu7I6BraEkLlD0Q1wDhz1QRkO3r6P90Z3IEdB2vUmVi3Sf8FwLpIFAu4/tuLY2AriNWqkyu+4T/QiAdBIpVfN+tpRHQdcRkFxpeY9ZB4b/WE5DRd05ncG9mBHQDZrRCN4DCR1YTKPLmZWRfBHQDbCeciUn1G6DhIxsJ6DnQRfr+jSyLgG6ALZvNqSLTOTYgw0c2EiiW6iqbydlYtcDrhIAOQFyqbhpwhY8hYBcBuqzM7YmADmBXLNc5K2kAGz62h4CcByYtUIIZAQR0ILeMKldohQ7EwwUrCJSrm9n704MlEdAh8CpjW/VVBpOGIOJSggnIzkvlmvg4wZQAAjqEXEYf7Vqu0QodgohLCSYg/fwyYEowJ4CAjmBXqW3TMWiFjsDE5aQR0FOXKrQ+PVsNAR2BMJsrKNbHj4DE5cQRKOuJ8+LbBG8EEFAH/Cpj0golQMAWArQ+/bIkAuqApKyPL5bHHcQkCgTiT6BYGVeydR3BOwEE1CHD6tiUw5hEg0C8CVR5o/LNQAioQ5S5QlmfmcRu3Q5xES2mBGSBSC5fjundJe+2EFAXNquNn6kyevSSAIFEEtC+W9U+TPCPAALqgqX0hZarW1ykICoE4kNApi2x56e/9kBAXfKs1qf09I+8y1REh0C0BOSsL2aT+G8DBNQtU738rTa+w20q4kMgUgK18TN09xOPu99GgKgBUZnSVOD8bANyJImCgAx+Mg0vGPIIqCHX2oRuhTKgZEiPZOERyPDGFCBsBNQQrgwoVarsZGOIj2QhEajUt+lpS8WQSktfMQioB5uLc7Ke2ANAkgZKQEbcmTQfKGKFgHrgK53ytYmzPORAUggER+CEbzJvOTjCCgH1ClcOnzux5Z3XnEgPAf8IyNtRoVTzL0Ny2pAALdANsbj7sDo+pUflq+4SERsCARGQGSLs3RAQ3HXZIqDrgJj9V490Tu7iEDozeKTykYDsMD82uVPnyKu7j1gHZoWADkTj7kJOb057wnHdpSM2BPwkIF/kDGz6SXR4XgjocD6ursrxsBzS5QoZkX0kUNbb1EmfPCE8Agioz6yr9e0qX6j4nCvZQWA4AemDr+l9GgjhEkBAfeYt293VN+1m3bHPXMluMIGM7veUV3f6PQczCuoKAhoAWemDEhFlqWcAcMnydAInv7ClD54QPgEENCDmsoHD2ISMhhIgEByBum55srFNcHxH5YyAjiLk4bochyy72BMgEAQB2VaRXZaCIOs8TwTUOSujmOXaFlYqGZEj0TACstKoXNs8LArXQiCAgIYAuTq+XZWqm0IoiSLSQKBU3axXGm1PQ1VjX0cENCQTjen9Q2WeKAECXgjIK/vYBN1CXhj6mRYB9ZPm0LwyamzTLpVnzfxQSlwcTCCv17jXtQ8xXWkwo7CvIKAhEpft7+qb9yCiITK3pSj54h3frKfGscY9ViZFQEM2RzaT0w/C2XqrMZbchYw+scUVS+N9n8lo3yHEiwACGoE9pCU6rluipcpkBKVTZJIIyOBjfbPe6YsTNWNpNg44j8wsuk9Ubzsm2481lo5GdhcUHF8ClbGtqlo/I743yJ2xI33UPlDVE+1lmhMBAmsJVPU57ojnWiLx/JsWaAzsIkeCZLJ5tTR7QN9NLwZ3xC1ER0DeTM6ieyc6A7gqGQF1hSu4yOXKJiUDTIuz+1Wv1w2uIHKOLwGZpaGnKTFfOL4mWn9nDCKtJxLh/2WS9MTWZ+tzvEsR3gVFR0EgVyirSW17xDMK+uZlIqDm7AJJKeIpIsoIfSB4Y5mpvH1MbDmHL85YWmf4TfEKP5xPJFdlyoqM0Ms2ZUvzB3mlj8QKwRcqdq7pJb58WQbPOqgSENCgyPqQr8wBlONBFmanVafd9CFHsogLAXnTkE236a6Ji0XM7oNXeDNuoaWSvjFe6UPDHUpB8sVIX3coqAMvhBZo4Ii9F8ArvXeGcchBZllU9U5KvLLHwRr+3AMC6g/HUHKRlkuhXFfL84dUszEbSpkU4g8BsZ1MjJeVZwR7CCCgCbNlVk+4lwEmeSCX5g7QNxpz+0kXzJhebSZb0RHsI4CAJtSmMkI/sfVctbKs19FnHkpoLey9bel2qYxN6Z8tupIZeyua8pohoAl2ADmDvlLbenIkt5Hgmth16yKeE9vOUxw1bJddN6oNo/AbUUncZ7Rw4mQy2bcT8YyTRYK7FwQ0OLbkDAEIWE6AV3jLDexX9c7cUVOFQvK/b6f3LeqVXex45ZdfpD0fBDTtHuCw/p+/+XK1a0/yTxX9vd+9VS0tthzWmmgQGE4AAR3Oh6snCRx4ekkPJie/r5WdAnFpPwkgoH7StDivt177LYtrR9UgYEYg+Z1aZvUmFQQgAAHPBBBQzwjJAAIQSCsBBDStlqfeEICAZwIIqGeEZAABCKSVAAKaVstTbwhAwDMBBNQzQjKAAATSSgABTavlqTcEIOCZAALqGSEZQAACaSWAgKbV8tQbAhDwTAAB9YyQDCAAgbQSQEDTannqDQEIeCaAgHpGSAYQgEBaCSCgabU89YYABDwTYDcmzwjTkcGWrRV9TEXyt7N75kiDDZXT4bKh1BIBDQVz8gu5+YuvYkPl5JuRGvhMAAH1Gait2c3MrKhyJfnuwobKtnpoNPVK/hMRDbfUlXrtNXemrs5UGAKjCDCINIoQ1yEAAQgMIICADgDDxxCAAARGEUBARxHiOgQgAIEBBBDQAWD4GAIQgMAoAgjoKEJchwAEIDCAAAI6AAwfQwACEBhFAAEdRYjrEIAABAYQQEAHgOFjCEAAAqMIIKCjCHEdAhCAwAACCOgAMHwMAQhAYBQBBHQUIa5DAAIQGEAAAR0Aho8hAAEIjCKAgI4ixHUIQAACAwiwG9MAMHx8OoGxelHlssnfUHlurnl6xfgfBDwQQEA9wEtT0i/d8Wo2VE6TwamrIwIIqCNMRFpYaKn5+dXEg+j1El8FKhAjAghojIwR51u55rXfiPPtcW8QiIQAg0iRYKdQCEDABgIIqA1WpA4QgEAkBBDQSLBTKAQgYAMBBNQGK1IHCEAgEgIIaCTYKRQCELCBAAJqgxWpAwQgEAkBBDQS7BQKAQjYQAABtcGK1AECEIiEAAIaCXYKhQAEbCCAgNpgReoAAQhEQgABjQQ7hUIAAjYQQEBtsCJ1gAAEIiGAgEaCnUIhAAEbCCCgNliROkAAApEQQEAjwU6hEICADQQQUBusSB0gAIFICCCgkWCnUAhAwAYCCKgNVqQOEIBAJAQQ0EiwUygEIGADAQTUBitSBwhAIBICCGgk2CkUAhCwgQACaoMVqQMEIBAJAQQ0EuwUCgEI2EAAAbXBitQBAhCIhAACGgl2CoUABGwggIDaYEXqAAEIREIAAY0EO4VCAAI2EEBAbbAidYAABCIhgIBGgp1CIQABGwggoDZYkTpAAAKREMhEUiqF+k3gfp3hC/zOlPyMCRzUKXcYpyZhYgggoIkx1dAb3aavFobG4GKYBDq6sMNhFkhZ0RD4P5IGrkPcc3Z+AAAAAElFTkSuQmCC"

/***/ }),

/***/ "ilJb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialMediaSharing_vue__ = __webpack_require__("lAlH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialMediaSharing_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialMediaSharing_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialMediaSharing_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialMediaSharing_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52d72800_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialMediaSharing_vue__ = __webpack_require__("WH49");
function injectStyle (ssrContext) {
  __webpack_require__("D/vw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialMediaSharing_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52d72800_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialMediaSharing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "iu78":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _default = __webpack_require__("lfHO");

var _default2 = _interopRequireDefault(_default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'modulesLayout',
  props: ['data', 'page'],
  components: { defaultLayout: _default2.default },
  data: function data() {
    return {
      section: 'default'
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "jW0R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleBody_vue__ = __webpack_require__("4OCw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleBody_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleBody_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleBody_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleBody_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7015ba78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticleBody_vue__ = __webpack_require__("C27M");
function injectStyle (ssrContext) {
  __webpack_require__("15Jj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7015ba78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticleBody_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7015ba78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticleBody_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jb4Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcAbout_vue__ = __webpack_require__("+asZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcAbout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcAbout_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcAbout_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcAbout_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a32df2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcAbout_vue__ = __webpack_require__("HdBo");
function injectStyle (ssrContext) {
  __webpack_require__("q67U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hcAbout_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a32df2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hcAbout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "joyZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactMap_vue__ = __webpack_require__("CEP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactMap_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactMap_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactMap_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a790b256_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactMap_vue__ = __webpack_require__("Q4na");
function injectStyle (ssrContext) {
  __webpack_require__("1LY0")
  __webpack_require__("MFCq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a790b256"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactMap_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a790b256_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jpl5":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "k8rL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/preview.b923e5e.jpg";

/***/ }),

/***/ "kE4L":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3MyAxMDAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+aHBfd2hpdGU8L3RpdGxlPjxnIGlkPSJQRGNsaWVudGxvZ29fMTAweFZhcmlhYmxlX2hwIiBkYXRhLW5hbWU9IlBEY2xpZW50bG9nb18xMDB4VmFyaWFibGUvaHAiPjxnIGlkPSJQRF9jbGllbnRsb2dvX2hwIiBkYXRhLW5hbWU9IlBEIGNsaWVudGxvZ28gaHAiPjxwYXRoIGlkPSJTaGFwZSIgY2xhc3M9ImNscy0xIiBkPSJNNzMuMDgsNDcuMzNBMzYuMTYsMzYuMTYsMCwwLDAsNDAuMTEsMTRhMTUuNjUsMTUuNjUsMCwwLDAtMy4yMSwwYy0yLjU0LDcuMjgtNS4xOCwxNC41Mi03Ljc0LDIxLjc4LDEuODYsMCwzLjczLDAsNS41OCwwYTQuMzMsNC4zMywwLDAsMSwzLjU0LDEuODEsNS4xNCw1LjE0LDAsMCwxLC4yOCw0LjUyUTM0Ljc1LDUyLjgzLDMwLjk0LDYzLjVjLTIuMjIsMC00LjQ0LDAtNi43LDBhMi40NCwyLjQ0LDAsMCwxLS45My0uMDljMi44NC03LjgzLDUuNjEtMTUuNjgsOC40MS0yMy41M2gtNGExMS4zNiwxMS4zNiwwLDAsMC0uNTEsMS4zM0MyNC42NCw0OC40MywyMiw1NS42NiwxOS40OCw2Mi45MmMtLjEyLjE4LS4wOS41OS0uMzkuNTlIMTIuNzFhNCw0LDAsMCwxLTEuMTUtLjA4QzE3LjQxLDQ3LjIyLDIzLjExLDMxLDI5LDE0LjgxQTM2LDM2LDAsMCwwLDMuNDgsMzYuNjMsMzguMDYsMzguMDYsMCwwLDAsLjg5LDUwLjE4YTQ3LjQ5LDQ3LjQ5LDAsMCwwLC43LDYuNjJBMzYuMTYsMzYuMTYsMCwwLDAsMjgsODQuOTNxOC43Mi0yNC4zNywxNy4zOS00OC44MmwuMjMtLjQ3YzMuNTgsMCw3LjE1LDAsMTAuNzMsMGExMS44OCwxMS44OCwwLDAsMSwzLjUyLjI0LDQuMTYsNC4xNiwwLDAsMSwyLjk0LDIuNjQsNS4xOCw1LjE4LDAsMCwxLS4yOSwzLjE4Yy0yLjI4LDYuNjctNC43LDEzLjI4LTcuMDUsMTkuOTJhNC40OSw0LjQ5LDAsMCwxLTQuMTMsMi44N2MtMi43Ny4wNS01LjU1LDAtOC4zNiwwcS0zLjg0LDEwLjcxLTcuNjMsMjEuNDJhNS45Miw1LjkyLDAsMCwwLDIuMDYuMSwyMC4yMSwyMC4yMSwwLDAsMCwzLjExLS4xOCwzNi4xMSwzNi4xMSwwLDAsMCwyOS0yMC4wOCwzNi41NiwzNi41NiwwLDAsMCwzLjYxLTEzLjU2QTMzLjI2LDMzLjI2LDAsMCwxLDczLjA4LDQ3LjMzWk00OC40NSw2MC40M2MyLjM3LTYuODgsNC44OC0xMy43MSw3LjI5LTIwLjU1aC0zLjFjLS4yOSwwLS42OC0uMTEtLjkxLjE0LTIuNDUsNi44Mi00Ljg2LDEzLjY2LTcuMzEsMjAuNDlDNDUuNzcsNjAuNDcsNDcuMTEsNjAuNTYsNDguNDUsNjAuNDNaIi8+PC9nPjwvZz48L3N2Zz4="

/***/ }),

/***/ "kGP1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"work-image-text-column"}},[_c('div',{staticClass:"module-layout"},[(_vm.hasImage)?_c('div',{ref:"imageContainer",staticClass:"image-container",class:_vm.imageContainerClasses},[_c('div',{staticClass:"image",style:(_vm.imageStyles)}),_vm._v(" "),(_vm.imageCaption)?_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.imageCaption))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.hasContent)?_c('div',{staticClass:"content-container",class:_vm.contentContainerClasses},[_c('markdown',{staticClass:"markdown"},[_vm._v(_vm._s(_vm.contentText))])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kOWT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',{attrs:{"data":_vm.data,"section":"work"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('div',{staticClass:"work-container"},[_c('work-header'),_vm._v(" "),(_vm.isMobile)?_c('work-articles-mobile',{attrs:{"articles":_vm.articlesData}}):_c('work-articles-tablet',{attrs:{"articles":_vm.articlesData}}),_vm._v(" "),_c('contact-form')],1)]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kRr6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_vue__ = __webpack_require__("3Ill");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff547cf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_image_vue__ = __webpack_require__("L6Nz");
function injectStyle (ssrContext) {
  __webpack_require__("67B1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff547cf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_image_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "kis0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "knbV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"announcement"}},[_c('p',[_vm._v("Particle acquired by Wind River")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "krgZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lAlH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueSocialSharing = __webpack_require__("VK1f");

var _vueSocialSharing2 = _interopRequireDefault(_vueSocialSharing);

var _WorkMixin = __webpack_require__("OytB");

var _WorkMixin2 = _interopRequireDefault(_WorkMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  Matter section Social Media Sharing

  data record: (article record)
  {
    title: <string>
    standfirst: <string>
  }
*/
// Lib
exports.default = {

  name: 'matter-social-media-sharing',

  mixins: [_WorkMixin2.default],

  components: {
    SocialSharing: _vueSocialSharing2.default
  },

  props: ['data', 'href'],

  computed: {
    containerClasses: function containerClasses() {
      var deviceStr = '';
      if (this.isMobile) {
        deviceStr = 'mobile';
      } else if (this.isTablet) {
        deviceStr = 'tablet';
      } else {
        deviceStr = 'desktop';
      }
      return deviceStr;
    },
    shareTitle: function shareTitle() {
      var title = this.data.title;

      return title || '';
    },
    shareDescription: function shareDescription() {
      var standfirst = this.data.standfirst;

      return standfirst || '';
    }
  }

};

// Components

/***/ }),

/***/ "lJjj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',{attrs:{"section":"holiday-landing-2008"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('div',{staticClass:"landing-container"},[_c('nav-spacer'),_vm._v(" "),_c('image-text-row',{attrs:{"data":_vm.imageTextRow}})],1)]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lM8h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__ = __webpack_require__("EUtp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7230256c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__ = __webpack_require__("WOFi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7230256c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lfHO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_default_vue__ = __webpack_require__("cHHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_default_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_default_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_default_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_default_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a9a7d3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_default_vue__ = __webpack_require__("N8oW");
function injectStyle (ssrContext) {
  __webpack_require__("FoPb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_default_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a9a7d3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_default_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ljI3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m7L3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
  THIS FILE IS GENERATED !!

  #> npm run gen:work
*/
/* eslint-disable */

exports.default = [{ "slug": "ai-future-smart-car", "date": "2018-12-18", "isCategory": false, "client": "particleDesign", "colSpan": 1, "group": 1, "headline": "Ushering in The Future Smart Car.", "image": { "src": "/static/content/uploads/work-ai-car.jpg", "aspect": "landscape", "hAlign": "center", "vAlign": "center" }, "linkText": "Learn more about our work in Transportation.", "tileOffset": "small", "url": "/work/ai-future-smart-car" }, { "slug": "artificial-intelligence", "date": "2018-11-01", "isCategory": true, "client": "particleDesign", "colSpan": 2, "group": 1, "headline": "Artificial Intelligence", "image": { "src": "/static/content/uploads/test-gear-square-tile.jpg", "aspect": "category-tile", "hAlign": "center", "vAlign": "center" }, "linkText": "Category Test Page - Artificial Intelligence", "tileOffset": "medium", "url": "/work/artificial-intelligence" }, { "slug": "dhl-honeywell-iot-shipping", "date": "2018-06-08", "isCategory": false, "client": "honeywell", "colSpan": 1, "group": 1, "headline": "A New Future of Global Shipping.", "image": { "src": "/static/content/uploads/work-honeywell-tile.jpg", "aspect": "square", "hAlign": "center", "vAlign": "center" }, "linkText": "Learn more about our work with Honeywell", "tileOffset": "small", "url": "/work/dhl-honeywell-iot-shipping" }, { "slug": "dreamworks-kids-gaming", "date": "2018-06-07", "isCategory": false, "client": "dreamworks", "colSpan": 1, "group": 2, "headline": "Designing a Digital Storytelling Adventure.", "image": { "src": "/static/content/uploads/work-dw-create-tile.jpg", "aspect": "portrait", "hAlign": "center", "vAlign": "center" }, "linkText": "Learn more about our work with DreamWorks", "tileOffset": "none", "url": "/work/dreamworks-kids-gaming" }, { "slug": "eb-retail-ecommerce", "date": "2018-06-07", "isCategory": false, "client": "eb", "colSpan": 1, "group": 3, "headline": "The Online Platform of the Future Bra.", "image": { "src": "/static/content/uploads/work-eb-bra-tile.jpg", "aspect": "medium", "hAlign": "center", "vAlign": "center" }, "linkText": "Learn more about our work with Evelyn-Bobbie", "tileOffset": "none", "url": "/work/eb-retail-ecommerce" }, { "slug": "hp-wearable-smartwatch", "date": "2018-06-07", "isCategory": false, "client": "hp", "colSpan": 1, "group": 2, "headline": "Launching a New Class of Smart Watch.", "image": { "src": "/static/content/uploads/hp-wearable-tile.jpg", "aspect": "square", "hAlign": "center", "vAlign": "center" }, "linkText": "Learn more about our work with HP", "tileOffset": "medium", "url": "/work/hp-wearable-smartwatch" }, { "slug": "jlr-electric-vehicle", "date": "2018-06-07", "isCategory": false, "client": "jaguar", "colSpan": 2, "group": 2, "headline": "Reimagining IVI Design for a New Electric Vehicle.", "image": { "src": "/static/content/uploads/work-lr-ev-hero.jpg", "aspect": "landscape", "hAlign": "center", "vAlign": "center" }, "linkText": "Learn more about our work with Jaguar Land Rover", "tileOffset": "medium", "url": "/work/jlr-electric-vehicle" }, { "slug": "jlr-future-car", "date": "2018-06-07", "isCategory": false, "client": "landrover", "colSpan": 1, "group": 2, "headline": "The Luxury Vehicle of Tomorrow.", "image": { "src": "/static/content/uploads/work-jlr-2020-tile.jpg", "aspect": "landscape", "hAlign": "center", "vAlign": "center" }, "linkText": "Learn more about our work with Jaguar Land Rover", "tileOffset": "medium", "url": "/work/jlr-future-car" }, { "slug": "machine-learning-wearable-development", "date": "2018-12-20", "isCategory": false, "client": "particleDesign", "colSpan": 1, "group": 2, "headline": "When AI and Wearables Meet.", "image": { "src": "/static/content/uploads/work-machine-learning-wearable.jpg", "aspect": "square", "hAlign": "center", "vAlign": "center" }, "linkText": "Learn more about our work in Artificial Intelligence.", "tileOffset": "small", "url": "/work/machine-learning-wearable-development" }, { "slug": "regence-healthcare-user-journey", "date": "2018-06-07", "isCategory": false, "client": "regence", "colSpan": 1, "group": 3, "headline": "Healthcare Made Accessible.", "image": { "src": "/static/content/uploads/work-regence-tile.jpg", "aspect": "small", "hAlign": "center", "vAlign": "center" }, "linkText": "Learn more about our work with Regence", "tileOffset": "large", "url": "/work/regence-healthcare-user-journey" }, { "slug": "samsung-mobile-research", "date": "2018-06-07", "isCategory": false, "client": "samsung", "colSpan": 1, "group": 3, "headline": "Product Development from Tablet to Cloud.", "image": { "src": "/static/content/uploads/work-samsung-tile.jpg", "aspect": "square", "hAlign": "center", "vAlign": "center" }, "linkText": "Learn more about our work with Samsung", "tileOffset": "large", "url": "/work/samsung-mobile-research" }, { "slug": "transportation", "date": "2018-11-01", "isCategory": true, "client": "particleDesign", "colSpan": 2, "group": 3, "headline": "Transport­ation", "image": { "src": "/static/content/uploads/test-gear-square-tile.jpg", "aspect": "category-tile", "hAlign": "center", "vAlign": "center" }, "linkText": "Transportation", "tileOffset": "medium", "url": "/work/transportation" }, { "slug": "vho-ai-transportation-rider-app", "date": "2018-1-4", "isCategory": false, "client": "vh1", "colSpan": 1, "group": 1, "headline": "How we designed a new way to think about travel.", "image": { "src": "/static/content/uploads/work-vho-pod-city.jpg", "aspect": "landscape", "hAlign": "center", "vAlign": "center" }, "linkText": "Learn more about our work with Virgin Hyperloop One.", "tileOffset": "small", "url": "/work/vho-ai-transportation-rider-app" }, { "slug": "vho-incorporating-ux-ai-software", "date": "2018-12-20", "isCategory": false, "client": "vh1", "colSpan": 2, "group": 1, "headline": "Designing AI for Virgin Hyperloop One.", "image": { "src": "/static/content/uploads/work-vho-tube-outside.jpg", "aspect": "landscape", "hAlign": "center", "vAlign": "center" }, "linkText": "Learn more about our work with Virgin Hyperloop One", "tileOffset": "small", "url": "/work/vho-incorporating-ux-ai-software" }, { "slug": "vr-science-education", "date": "2018-06-07", "isCategory": false, "client": "particleDesign", "colSpan": 1, "group": 3, "headline": "How We Built a Virtual, Underwater Classroom.", "image": { "src": "/static/content/uploads/work-vlp-classroom.jpg", "aspect": "medium", "hAlign": "center", "vAlign": "center" }, "linkText": "Learn more about our work in education", "tileOffset": "large", "url": "/work/vr-science-education" }, { "slug": "vr-transportation-drivers-ed", "date": "2018-01-03", "isCategory": false, "client": "vrMotion", "colSpan": 1, "group": 2, "headline": "Meshing virtual reality and driver’s education.", "image": { "src": "/static/content/uploads/work-vr-transport-outside.jpg", "aspect": "landscape", "hAlign": "center", "vAlign": "center" }, "linkText": "Learn more about our work with VR Motion.", "tileOffset": "small", "url": "/work/vr-transportation-drivers-ed" }];

/***/ }),

/***/ "mZo6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('address',{staticClass:"smart-address",attrs:{"data-type":"default"}},[_c('a',{on:{"click":_vm.handleAddressClick}},[_c('p',[_vm._v(_vm._s(_vm.address.address1))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.address.address2))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mg7H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"work-one-column-text"}},[_c('div',{staticClass:"module-layout"},[_c('div',{staticClass:"content-container",class:_vm.contentContainerClasses},[_c('markdown',{staticClass:"markdown"},[_vm._v(_vm._s(_vm.data.content))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mkP7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ContentRevealTile = __webpack_require__("GZoJ");

var _ContentRevealTile2 = _interopRequireDefault(_ContentRevealTile);

var _CategoryPageTile = __webpack_require__("XDdv");

var _CategoryPageTile2 = _interopRequireDefault(_CategoryPageTile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
exports.default = {

  props: ['articles'],

  components: {
    ArticleTile: _ContentRevealTile2.default,
    CategoryPageTile: _CategoryPageTile2.default
  }

};

/***/ }),

/***/ "n/d4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"text_image_stack"}},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"content"},[_c('markdown',{staticClass:"markdown"},[_vm._v(_vm._s(_vm.data.content))])],1)]),_vm._v(" "),_c('div',{staticClass:"aside"},[_c('img',{attrs:{"src":_vm.data.image.src,"alt":_vm.data.image.alt}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n3gS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nFlW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/preview.7ccf31e.jpg";

/***/ }),

/***/ "nHy4":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "nXDj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-debug":"windowDimensions"}},[_c('ul',[_c('li',[_vm._v("\n      width: "+_vm._s(_vm.window.width)+"\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      height: "+_vm._s(_vm.window.height)+"\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      w/h: "+_vm._s(_vm.ratioWH)+"\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      h/w: "+_vm._s(_vm.ratioHW)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "naH/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nsjT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"hiring"}},[_c('div',{staticClass:"headline"},[_c('div',{attrs:{"data-ornament":"rectangle"}}),_vm._v(" "),_c('h1',{domProps:{"innerHTML":_vm._s(_vm.heading)}})]),_vm._v(" "),_c('div',{staticClass:"intro"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.teaser)}})]),_vm._v(" "),(_vm.haveJobs)?[_c('div',{staticClass:"listings"},[_c('ul',_vm._l((_vm.data.listings),function(listing){return _c('li',{key:listing.jobTitle},[_c('a',{attrs:{"href":listing.listingURL,"rel":"external","target":"_blank"}},[_vm._v("\n          "+_vm._s(listing.jobTitle)+"\n        ")]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v(_vm._s(listing.description))])])}),0)])]:[_c('div',{staticClass:"no-listings"},[_c('router-link',{staticClass:"no-hover",attrs:{"to":{ path: '/contact#contact-us-form' }}},[_c('mouse-event-container',[_c('router-link',{staticClass:"link--underline",attrs:{"to":{ path: '/contact#contact-us-form' }}},[_vm._v("\n          Drop us a line\n        ")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.noJobsContent)}})],1)],1)],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nwZe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nwra":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _WorkArticlesMobile = __webpack_require__("t6J1");

var _WorkArticlesMobile2 = _interopRequireDefault(_WorkArticlesMobile);

var _WorkArticlesTablet = __webpack_require__("4mIv");

var _WorkArticlesTablet2 = _interopRequireDefault(_WorkArticlesTablet);

var _dataUtils = __webpack_require__("uhrr");

var _workCategoryIndex = __webpack_require__("MHjq");

var _workCategoryIndex2 = _interopRequireDefault(_workCategoryIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
//
//
//
//
//
//
//

/*
*/
// Components
exports.default = {
  name: 'work-category-content',

  props: ['data'],

  components: {
    WorkArticlesMobile: _WorkArticlesMobile2.default,
    WorkArticlesTablet: _WorkArticlesTablet2.default
  },

  computed: {
    articlesData: function articlesData() {
      var catKey = this.data.category;

      var recs = _workCategoryIndex2.default[catKey] || [];
      return (0, _dataUtils.groupAndShuffleArticleRecords)(recs);
    },
    isMobile: function isMobile() {
      return this.$store.getters.isMobile;
    }
  }

};

// Data

/***/ }),

/***/ "o0Es":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"footer__content",attrs:{"data-module":"footerContent"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"outlinks"},[_c('p',[_vm._v("Find us on the internet")]),_vm._v(" "),_c('ul',_vm._l((_vm.companyInfo.socialMedia),function(link){return _c('li',{key:link.platform},[_c('a',{attrs:{"href":link.url,"data-type":"base-bigger"}},[_vm._v(_vm._s(link.platform))])])}),0),_vm._v(" "),_c('small',{staticClass:"copyright"},[_vm._v("\n        © 2021 Particle Design\n      ")])]),_vm._v(" "),_c('div',{staticClass:"hire-us"},[_c('p',[_vm._v("Plan a project")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'L2', params: { slug: 'contact', hash: 'contact-us-form' }, hash: '#contact-us-form' },"data-type":"title"},nativeOn:{"click":function($event){return _vm.scrollTo('#contact-us-form')}}},[_vm._v("\n        Hire Us\n      ")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('address',{attrs:{"data-type":"default"}},[_vm._v("\n        "+_vm._s(_vm.companyInfo.address.address1)+"\n        "),_c('br'),_vm._v("\n        "+_vm._s(_vm.companyInfo.address.address2)+"\n      ")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},[_c('div',{attrs:{"data-ornament":"circle"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('span',{attrs:{"data-icon":"logo"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spacers"},[_c('span',{staticClass:"spacer"}),_vm._v(" "),_c('span',{staticClass:"spacer"}),_vm._v(" "),_c('span',{staticClass:"spacer"}),_vm._v(" "),_c('span',{staticClass:"spacer"}),_vm._v(" "),_c('span',{staticClass:"spacer"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o0pg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _default = __webpack_require__("lfHO");

var _default2 = _interopRequireDefault(_default);

var _ImageTextRow = __webpack_require__("1Ceh");

var _ImageTextRow2 = _interopRequireDefault(_ImageTextRow);

var _NavSpacer = __webpack_require__("QdRU");

var _NavSpacer2 = _interopRequireDefault(_NavSpacer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

  name: 'WorkMain',

  metaInfo: {
    title: 'Season\'s Greetings - Particle Design'
  },

  components: {
    DefaultLayout: _default2.default,
    ImageTextRow: _ImageTextRow2.default,
    NavSpacer: _NavSpacer2.default
  },

  data: function data() {
    return {
      imageTextRow: {
        reversed: false,
        image: {
          src: "/static/content/uploads/Particle_2018HolidayEcard_LPcactus.gif",
          width: "regular",
          aspect: "medium",
          showResponsiveImage: false
        },
        content: "# Thanks for making the world a brighter place!"
      }
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//

// Components

/***/ }),

/***/ "oHJ4":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "ogV5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.2fd3f87.jpg";

/***/ }),

/***/ "pKud":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"partners"}},[_c('component_bigHeading',{attrs:{"data":{heading: 'Our<br/>Partners.', byline: 'We partner with global brands and wiley start-ups across industries. Take a look at a selection of the people that make us love what we do.'}}}),_vm._v(" "),_c('div',{staticClass:"partners__grid"},[_vm._l((_vm.data.clients),function(client){return _c('div',{key:client.name,staticClass:"client"},[(client.href)?_c('a',{attrs:{"href":client.href}},[(client.logo)?[_c('img',{attrs:{"src":client.logo,"alt":client.name}})]:[_c('span',[_vm._v(_vm._s(client.name))])]],2):[(client.logo)?[_c('img',{attrs:{"src":client.logo,"alt":client.name}})]:[_c('span',[_vm._v(_vm._s(client.name))])]]],2)}),_vm._v(" "),_c('div',{staticClass:"client spanner"}),_vm._v(" "),_c('div',{staticClass:"client spanner"})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pO+a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.1bca7b8.jpg";

/***/ }),

/***/ "pUUz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hero-mobile.0c95584.jpg";

/***/ }),

/***/ "pZpt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pmfv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryHeader_vue__ = __webpack_require__("I+yb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryHeader_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryHeader_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryHeader_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d4201e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryHeader_vue__ = __webpack_require__("8Sbb");
function injectStyle (ssrContext) {
  __webpack_require__("Dqik")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryHeader_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d4201e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pqBA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/boy-head.5a9b2e3.jpg";

/***/ }),

/***/ "pzGH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/preview-mobile.e955c90.jpg";

/***/ }),

/***/ "q2/K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blurb_vue__ = __webpack_require__("+nnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blurb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blurb_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blurb_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blurb_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc8dddf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blurb_vue__ = __webpack_require__("c1Pa");
function injectStyle (ssrContext) {
  __webpack_require__("wctg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blurb_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc8dddf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blurb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "q67U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qAWR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qLtD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"linkWithButtonBelow"}},[(_vm.data.href.name === 'ext')?[_c('a',{attrs:{"href":_vm.data.href.url,"rel":"external","target":"_blank"}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.data.text))]),_vm._v(" "),(_vm.showOrnament)?_c('span',{attrs:{"data-ornament":"arrow-in-circle--right"}}):_vm._e()])]:[_c('router-link',{attrs:{"to":{ name: _vm.data.href.name, params: _vm.data.href.params }}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.data.text))]),_vm._v(" "),(_vm.showOrnament)?_c('span',{attrs:{"data-ornament":"arrow-in-circle--right"}}):_vm._e()])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qnuT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/preview-mobile.41612d6.jpg";

/***/ }),

/***/ "r2AQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _appConstants = __webpack_require__("y3R9");

var _peopleIndex = __webpack_require__("+zjS");

var _peopleIndex2 = _interopRequireDefault(_peopleIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({

  state: {
    scrollState: {},
    scrollDirection: '',
    // device: 'mobile', // mobile, tablet, desktop

    // current width / height of window, dynamically updated
    width: 0,
    height: 0,

    people: _peopleIndex2.default,
    workArticles: {
      // key'd on article slug
    }
  },

  getters: {
    isDesktop: function isDesktop(state, getters) {
      return getters.deviceType === _appConstants.BreakPoints.desktop.key;
    },
    isMobile: function isMobile(state, getters) {
      return getters.deviceType === _appConstants.BreakPoints.mobile.key;
    },
    isTablet: function isTablet(state, getters) {
      return getters.deviceType === _appConstants.BreakPoints.tablet.key;
    },
    deviceType: function deviceType(state) {
      var width = state.width;
      var device = '';
      if (width >= _appConstants.BreakPoints.desktop.size) {
        device = _appConstants.BreakPoints.desktop.key;
      } else if (width >= _appConstants.BreakPoints.tablet.size) {
        device = _appConstants.BreakPoints.tablet.key;
      } else {
        device = _appConstants.BreakPoints.mobile.key;
      }
      return device;
    },
    getPersonInfo: function getPersonInfo(state) {
      return function (key) {
        return state.people[key] || null;
      };
    },
    getWorkArticleBySlug: function getWorkArticleBySlug(state) {
      return function (slug) {
        return state.workArticles[slug] || null;
      };
    }
  },

  mutations: {
    saveWorkArticleData: function saveWorkArticleData(state, payload) {
      var workArticles = state.workArticles;
      var slug = payload.slug;

      _vue2.default.set(workArticles, slug, payload);
    },
    updateScrollState: function updateScrollState(state, payload) {
      var s = state;
      s.scrollState = payload;
    },
    updateScrollDirection: function updateScrollDirection(state, newState) {
      var s = state;
      s.scrollDirection = newState;
    },


    /*
      payload:
      {
        width: 0,
        height: 0,
      }
    */
    updateWindowDimensions: function updateWindowDimensions(state, payload) {
      var width = payload.width,
          height = payload.height;

      var s = state;
      s.width = width;
      s.height = height;
    }
  },

  actions: {
    loadWorkArticleData: function loadWorkArticleData(_ref, payload) {
      var commit = _ref.commit;
      var url = payload.url;

      return (0, _axios2.default)({ method: 'get', url: url }).then(function (response) {
        var status = response.status,
            data = response.data;

        if (status === 200) {
          return data;
        }
        throw new Error('something happened');
      }).then(function (data) {
        commit('saveWorkArticleData', data);
      });
    }
  }
});

/***/ }),

/***/ "rAq1":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "rM9G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturedArticle_vue__ = __webpack_require__("AarE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturedArticle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturedArticle_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturedArticle_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturedArticle_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35f505b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeaturedArticle_vue__ = __webpack_require__("5qSk");
function injectStyle (ssrContext) {
  __webpack_require__("V4vZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturedArticle_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35f505b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeaturedArticle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "rRzr":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjAwcHgiIGhlaWdodD0iMjAwcHgiIHZpZXdCb3g9IjAgMCAyMDAgMjAwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OS4zICg1MTE2NykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+R3JvdXAgMTEgQ29weSAzPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9Ik1haW4iIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJBcnRib2FyZC0zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTI2MS4wMDAwMDAsIC0yNDI5LjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMTEtQ29weS0zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzYxLjAwMDAwMCwgMjUyOS4wMDAwMDApIHNjYWxlKC0xLCAxKSByb3RhdGUoLTI3MC4wMDAwMDApIHRyYW5zbGF0ZSgtMTM2MS4wMDAwMDAsIC0yNTI5LjAwMDAwMCkgdHJhbnNsYXRlKDEyNjEuMDAwMDAwLCAyNDI5LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkZpbGwtMTQ2NC1Db3B5LTIiIGZpbGw9IiNENERENUQiIHBvaW50cz0iMCAyMDAgMjAwIDIwMCAyMDAgMCAwIDAiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJGaWxsLTE0NjQtQ29weSIgZmlsbD0iIzAwMDAwMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAwLjAwMDAwMCwgMTAwLjAwMDAwMCkgc2NhbGUoMSwgLTEpIHRyYW5zbGF0ZSgtMTAwLjAwMDAwMCwgLTEwMC4wMDAwMDApICIgcG9pbnRzPSIwIDIwMCAyMDAgMCAwIDAiPjwvcG9seWdvbj4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ "rWLT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "roTQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hiring_vue__ = __webpack_require__("gmyM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hiring_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hiring_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hiring_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hiring_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd4c6b4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hiring_vue__ = __webpack_require__("nsjT");
function injectStyle (ssrContext) {
  __webpack_require__("GHPs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hiring_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd4c6b4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hiring_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "s6ON":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  layout: 'default',
  blocks: [{
    module: 'headline',
    headline: "Our Work.",
    byline: "A quick intro blurb that talks about the types of projects we take on, the services we provide and the industries we have deep experinece in."
  }, {
    module: 'grid',
    id: 'our-work',
    rows: [[{
      component: 'component_featuredBlurb',
      itemType: 'work',
      item: 'placeholder1',
      columnStart: 1,
      columnEnd: 7
    }, {
      component: 'component_featuredBlurb',
      itemType: 'work',
      item: 'placeholder1',
      columnStart: 9,
      columnEnd: 12
    }], [{
      component: 'component_featuredBlurb',
      itemType: 'work',
      item: 'placeholder2',
      columnStart: 1,
      columnEnd: 4
    }, {
      component: 'component_featuredBlurb',
      itemType: 'work',
      item: 'placeholder1',
      columnStart: 5,
      columnEnd: 8
    }, {
      component: 'component_bigBlockquote',
      quote: "Destroy couch eat and than sleep on your face scratch the furniture damn that dog meow to be let in. Cat not kitten around. Cats are fats I like to pets them they like to meow.",
      author: "Kat Sutton",
      authorTitle: "UX Lead, Particle",
      columnStart: 9,
      columnEnd: 12,
      alignSelf: 'center'
    }, {
      component: 'component_featuredBlurb',
      itemType: 'work',
      item: 'placeholder1',
      columnStart: 1,
      columnEnd: 4
    }, {
      component: 'component_featuredBlurb',
      itemType: 'work',
      item: 'placeholder2',
      columnStart: 6,
      columnEnd: 12
    }]]
  }, {
    module: 'grid',
    id: 'our-partners',
    rows: [[{
      component: 'component_sectionHeader',
      title: "Our Partners.",
      byline: "We partner with global brands and wiley start-ups. Working at the cutting edge has its drawbacks. Sometimes it means we can’t share our work for several years. We respect our clients NDAs. Let’s chat about your opportunities. We’d love to talk through some of our relevant work experience.",
      columnStart: 1,
      columnEnd: 7
    }], [{
      component: 'component_itemGrid',
      columnStart: 1,
      columnEnd: 12,
      itemsPerRow: 4,
      items: [{
        component: 'component_image',
        image: __webpack_require__("xr0L")
      }, {
        component: 'component_image',
        image: __webpack_require__("vCaE")
      }, {
        component: 'component_image',
        image: __webpack_require__("3mXB")
      }, {
        component: 'component_image',
        image: __webpack_require__("VrjG")
      }]
    }]]
  }, {
    module: 'contactForm'
  }]
};

/***/ }),

/***/ "sFEi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/regence.3cb2242.svg";

/***/ }),

/***/ "sWJL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ArticleTile = __webpack_require__("G9fO");

var _ArticleTile2 = _interopRequireDefault(_ArticleTile);

var _appConstants = __webpack_require__("y3R9");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//

exports.default = {

  props: ['articles'],

  components: { ArticleTile: _ArticleTile2.default },

  computed: {
    columns: function columns() {
      var articles = this.articles;
      var device = this.$store.getters.deviceType;
      var columnCount = 0;
      switch (device) {
        case _appConstants.BreakPoints.desktop.key:
          columnCount = 3;
          break;
        case _appConstants.BreakPoints.tablet.key:
          columnCount = 2;
          break;
        case _appConstants.BreakPoints.mobile.key:
        default:
          columnCount = 1;
          break;
      }

      /*
        two dimensional array
        column containers
        column stories
      */
      var columns = [];

      for (var i = 0; i < articles.length; i += 1) {
        var col = i % columnCount;
        if (!columns[col]) {
          columns[col] = [];
        }

        columns[col].push(articles[i]);
      }

      return columns;
    }
  }
};

/***/ }),

/***/ "sZvB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"work-header"}},[_c('div',{ref:"headerHeroImage",staticClass:"image-background",style:(_vm.bgImageStyles)}),_vm._v(" "),_c('div',{staticClass:"work-layout"},[_c('div',{staticClass:"work-main"},[_c('div',{staticClass:"work-main-content"},[_c('h1',[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('markdown',{staticClass:"markdown"},[_vm._v(_vm._s(_vm.data.content))])],1)])]),_vm._v(" "),_c('div',{staticClass:"work-sidebar"},[_c('div',{staticClass:"work-sidebar-bg"},[_c('div',{staticClass:"work-sidebar-content"},[_c('h2',[_vm._v("Our role")]),_vm._v(" "),_c('ul',{staticClass:"roles"},_vm._l((_vm.data.roles),function(role){return _c('li',{key:role,staticClass:"role"},[_vm._v("\n              "+_vm._s(role)+"\n            ")])}),0),_vm._v(" "),_c('div',{staticClass:"white"})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "spc+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatedWorks_vue__ = __webpack_require__("9usk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatedWorks_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatedWorks_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatedWorks_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatedWorks_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63988b9b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatedWorks_vue__ = __webpack_require__("8ioz");
function injectStyle (ssrContext) {
  __webpack_require__("EZhh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_relatedWorks_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63988b9b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_relatedWorks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "t1Ph":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _companyInfo = __webpack_require__("2Tf9");

var _currentDevice = __webpack_require__("GtN+");

var _currentDevice2 = _interopRequireDefault(_currentDevice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//

exports.default = {

  name: 'SmartAddress',

  data: function data() {
    return {
      address: _companyInfo.address
    };
  },


  computed: {
    mapUrl: function mapUrl() {
      var latitude = _companyInfo.address.latitude,
          longitude = _companyInfo.address.longitude;

      if (_currentDevice2.default.ios()) {
        return 'maps://maps.google.com/maps?daddr=' + latitude + ',' + longitude + '&ll=';
      }
      return 'https://maps.google.com/maps?daddr=' + latitude + ',' + longitude + '&ll=';
    }
  },

  methods: {
    handleAddressClick: function handleAddressClick() {
      window.open(this.mapUrl);
    }
  }

};

/***/ }),

/***/ "t6J1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkArticlesMobile_vue__ = __webpack_require__("mkP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkArticlesMobile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkArticlesMobile_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkArticlesMobile_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkArticlesMobile_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f78dd46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkArticlesMobile_vue__ = __webpack_require__("RdN2");
function injectStyle (ssrContext) {
  __webpack_require__("GXFC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f78dd46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkArticlesMobile_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f78dd46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkArticlesMobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tTgq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clients = __webpack_require__("fL60");

var _clients2 = _interopRequireDefault(_clients);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  slug: 'vr-science-education',
  company: _clients2.default.particleDesign.name,
  logo: _clients2.default.particleDesign.logo,
  logoWhite: _clients2.default.particleDesign.logoWhite,
  blurb: {
    headline: 'How we built a virtual, underwater classroom.',
    tags: [],
    byline: 'Learn more about our work in education',
    background: __webpack_require__("CJVr"),
    backgroundSet: [{
      max: 1024,
      src: __webpack_require__("pzGH")
    }]
  },
  blocks: [{
    module: 'hero',
    background: {
      image: __webpack_require__("12GE"),
      type: 'image'
    },
    constrain: true
  }, {
    module: 'intro',
    title: 'The Classroom of Tomorrow.',
    content: 'Particle Design partnered with a leading HW / SW company whose innovation group is tasked with dreaming up and creating pioneering experiences for new technologies yet to be released to the market.\n\nWith more than 9 years of experience partnering with this innovative company, Particle was poised to help them create an educational experience that would support interesting and engaging interactions that were supported by new 3D depth camera technology.',
    roles: ["UX Strategy", "Interaction Design", "Visual Design", "Front-End Development", "Back-End Development"]
  }, {
    module: 'text_image_row',
    images: [{
      src: __webpack_require__("FOuc"),
      height: '490px',
      gravity: 'right center',
      primary: true
    }],
    content: '## Elevating education through immersive environments.\n\nThe company was looking to design education prototypes that would increase student retention in STEM subjects (science, technology, engineering, and mathematics), with the goal of inspiring collaboration with larger educational SW partners. Most schools currently have tablets for students, but most digital curriculum focus on e-textbooks and videos. Moving beyond this paradigm and harnessing the power of immersive digital experiences meant an opportunity for greater student engagement and thus retention.\n\nWe first tested concept storyboards with middle school and high school science teachers with the goal of building a prototype of the one that showed the most promise. Teachers found the idea of students being able to scan themselves with the 3D camera and insert their avatars into otherwise inaccessible environments, such as space or underwater, most compelling. The Chesapeake Bay Underwater Virtual Curriculum was born.'
  }, {
    module: 'text_image_row',
    images: [{
      src: __webpack_require__("diZL"),
      height: '368px',
      gravity: 'left center',
      primary: true
    }, {
      src: __webpack_require__("ogV5"),
      height: '252px',
      gravity: 'left bottom',
      primary: false
    }],
    content: '## Bringing students a new approach to learning.\n\nOur approach to the design of the prototype was to make the learning experience look and feel like a video game. An RPG aligned with national STEM education standards.\n\nWe built the immersive environment using a 3D game engine and 3D objects. Students could scan themselves and insert their avatar into the environment, walking along the floor of the Bay where they were surrounded by the creatures and plant life of that ecosystem. All organisms were interactive, with info on their unique qualities highlighted. Students could conduct a variety of experiments. They could experience a toxic spill from the perspective of a fish and watch the ecosystem change and die while testing water samples over time to see when life could again thrive in that location. Testing of the prototype with teachers showed that the immersive experience was unique and exciting to educators.\n\nOver the course of six months, Particle worked with our client partner to go from early product ideas, to concept storyboards, through to prototype development, with user feedback integrated all throughout the process.  We were able to succeed in the primary goal: create cutting edge STEM curriculum that capitalized on both emerging technology and the devices students had access to every day in school.'
  }, {
    module: 'image',
    src: __webpack_require__("pO+a"),
    alt: 'Image of an apple on top of a stack of books next to a stack of blocks on a table against a white backdrop.',
    visibility: {
      min: 1024,
      max: 10000
    }
  }, {
    module: 'relatedWorks',
    works: ['hp-wearable', 'land-rover']
  }]
};

/***/ }),

/***/ "tk+V":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "u07h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
  THIS FILE IS GENERATED !!

  #> npm run gen:matter
*/
/* eslint-disable */

exports.default = { "featured": [{ "url": "/matter/what-does-designing-for-trust-mean-the-case-of-the-smart-car", "slug": "what-does-designing-for-trust-mean-the-case-of-the-smart-car", "image": { "imageSrc": "/static/content/uploads/pdsite_matter_avtrust_graphic3_headerratio.jpg" }, "title": "We Need to Design Autonomous Vehicles for Trust. Here's How. ", "standfirst": "Cars are well on their way to being fully autonomous. But drivers still don’t trust the technology. UX offers the opportunity to attune and to that fear and design a thoughtful experience. ", "category": "technology" }, { "url": "/matter/why-are-most-of-us-still-using-credit-cards", "slug": "why-are-most-of-us-still-using-credit-cards", "image": { "imageSrc": "/static/content/uploads/code-mnml-571736-unsplash.jpg" }, "title": "Why are We Still Using Credit Cards? ", "standfirst": "Sometime around 2013, the buzz in tech world was that very, very soon smartphones would be used for payment in stores and we could do away with physical credit cards. But five years later, why does it seem that everyone is still using physical cards and cash?", "category": "technology" }], "articles": [{ "url": "/matter/artificial-intelligence-needs-a-design-makeover", "date": "2018-12-20", "slug": "artificial-intelligence-needs-a-design-makeover", "featuredImage": { "aspect": "portrait", "imageSrc": "/static/content/uploads/jj-ying-787486-unsplash.jpg" }, "title": "Artificial Intelligence Needs a Design Makeover", "category": "technology" }, { "url": "/matter/what-does-designing-for-trust-mean-the-case-of-the-smart-car", "date": "2018-11-19", "slug": "what-does-designing-for-trust-mean-the-case-of-the-smart-car", "featuredImage": { "imageSrc": "/static/content/uploads/pdsite_matter_avtrust_graphic3_headerratio.jpg" }, "title": "We Need to Design Autonomous Vehicles for Trust. Here's How. ", "category": "technology" }, { "url": "/matter/3-ways-rapid-prototyping-inspires-meaningful-experiences", "date": "2018-10-11", "slug": "3-ways-rapid-prototyping-inspires-meaningful-experiences", "featuredImage": { "aspect": "landscape", "imageSrc": "/static/content/uploads/pdsite_matter_rapidprototyping_header.jpg" }, "title": "3 Ways Rapid Prototyping Inspires Meaningful Experiences ", "category": "strategy" }, { "url": "/matter/5-principles-for-designing-artificial-intelligence", "date": "2018-10-04", "slug": "5-principles-for-designing-artificial-intelligence", "featuredImage": { "aspect": "square", "imageSrc": "/static/content/uploads/randall-bruder-136626-unsplash.jpg" }, "title": "5 Principles for Designing Artificial Intelligence ", "category": "technology" }, { "url": "/matter/let’s-not-repeat-ux-history", "date": "2018-09-19", "slug": "let’s-not-repeat-ux-history", "featuredImage": { "aspect": "portrait", "imageSrc": "/static/content/uploads/markus-spiske-482453-unsplash.jpg" }, "title": "Let’s Not Repeat UX History", "category": "technology" }, { "url": "/matter/surprise-ai-is-already-here-now-what", "date": "2018-08-22", "slug": "surprise-ai-is-already-here-now-what", "featuredImage": { "aspect": "square", "imageSrc": "/static/content/uploads/phrenology-art-1-.png" }, "title": "AI Must Be Designed for Transparency ", "category": "technology" }, { "url": "/matter/4-critical-elements-in-mindful-product-design", "date": "2018-08-06", "slug": "4-critical-elements-in-mindful-product-design", "featuredImage": { "aspect": "portrait", "imageSrc": "/static/content/uploads/artturi-siivonen-595289-unsplash.jpg" }, "title": "4 Critical Elements in Mindful Product Design ", "category": "strategy" }, { "url": "/matter/josh-lovejoy-and-human-centered-ai", "date": "2018-06-21", "slug": "josh-lovejoy-and-human-centered-ai", "featuredImage": { "imageSrc": "/static/content/uploads/dw2018_particledesign_speakers_joshlovejoy.jpg" }, "title": "Video Talk: Josh Lovejoy's Human-Centered Approach to AI ", "category": "technology" }, { "url": "/matter/crystal-rutland-founder-of-particle-design", "date": "2018-06-15", "slug": "crystal-rutland-founder-of-particle-design", "featuredImage": { "aspect": "landscape", "imageSrc": "/static/content/uploads/dw2018_particledesign_speakers_crystalrutland.jpg" }, "title": "Video Talk: Crystal Rutland and the Future of UX in the AI Revolution ", "category": "technology" }, { "url": "/matter/video-talk-brian-david-johnson-and-the-future-of-ai", "date": "2018-05-31", "slug": "video-talk-brian-david-johnson-and-the-future-of-ai", "featuredImage": { "imageSrc": "/static/content/uploads/dw2018_particledesign_speakers_briandavidjohnson.jpg" }, "title": "Video Talk: Brian David Johnson and the Future of AI ", "category": "technology" }, { "url": "/matter/breaking-bad-user-experiences", "date": "2018-05-10", "slug": "breaking-bad-user-experiences", "featuredImage": { "aspect": "portrait", "imageSrc": "/static/content/uploads/rawpixel-652647-unsplash-1-.jpg" }, "title": "4 Ways to Push Beyond Past Bad User Experiences", "category": "culture" }, { "url": "/matter/video-talk-anima-anandkumar-and-the-question-of-data-in-the-age-of-ai", "date": "2018-04-24", "slug": "video-talk-anima-anandkumar-and-the-question-of-data-in-the-age-of-ai", "featuredImage": { "imageSrc": "/static/content/uploads/dw2018_particledesign_speakers_animaanandkumar.jpg" }, "title": "Video Talk: Anima Anandkumar and the Meaning of Data in the Age of AI", "category": "technology" }, { "url": "/matter/how-to-create-brand-devotees", "date": "2018-04-19", "slug": "how-to-create-brand-devotees", "featuredImage": { "aspect": "portrait", "imageSrc": "/static/content/uploads/autumn-goodman-242816-unsplash.jpg" }, "title": "How to Create Brand Devotees ", "category": "strategy" }, { "url": "/matter/innovation-starts-with-empathy", "date": "2018-03-05", "slug": "innovation-starts-with-empathy", "featuredImage": { "aspect": "square", "imageSrc": "/static/content/uploads/connor-wells-534089-unsplash.jpg" }, "title": "Innovation Starts With Empathy ", "category": "strategy" }, { "url": "/matter/top-5-innovation-books-of-the-21st-century", "date": "2018-02-12", "slug": "top-5-innovation-books-of-the-21st-century", "featuredImage": { "aspect": "portrait", "imageSrc": "/static/content/uploads/untitled-1.jpg" }, "title": "Top 5 Innovation Books of the 21st Century ", "category": "culture" }, { "url": "/matter/ux-of-mobile-productivity", "date": "2018-01-05", "slug": "ux-of-mobile-productivity", "featuredImage": { "imageSrc": "/static/content/uploads/neonbrand-635850-unsplash.jpg" }, "title": "The UX of Mobile Productivity ", "category": "strategy" }, { "url": "/matter/why-are-most-of-us-still-using-credit-cards", "date": "2017-09-01", "slug": "why-are-most-of-us-still-using-credit-cards", "featuredImage": { "imageSrc": "/static/content/uploads/code-mnml-571736-unsplash.jpg" }, "title": "Why are We Still Using Credit Cards? ", "category": "technology" }, { "url": "/matter/look-with-eyes-not-screen", "date": "2017-08-01", "slug": "look-with-eyes-not-screen", "featuredImage": { "aspect": "landscape", "imageSrc": "/static/content/uploads/1_gvux20brzkxur7iy1k0dgq.png" }, "title": "Look with Your Eyes, Not Your Screen ", "category": "culture" }, { "url": "/matter/taco-recombinator", "date": "2017-07-18", "slug": "taco-recombinator", "featuredImage": { "aspect": "landscape", "imageSrc": "/static/content/uploads/1_wjjp4z9hdbopban32t84ja.jpeg" }, "title": "Enter the Recombinator ", "category": "culture" }] };

/***/ }),

/***/ "uPNK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkHeader_vue__ = __webpack_require__("fC9T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkHeader_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkHeader_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkHeader_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad1542b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkHeader_vue__ = __webpack_require__("fKIp");
function injectStyle (ssrContext) {
  __webpack_require__("qAWR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ad1542b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkHeader_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad1542b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "uhiZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OneColumnText_vue__ = __webpack_require__("Fdbr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OneColumnText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OneColumnText_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OneColumnText_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OneColumnText_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_009de874_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OneColumnText_vue__ = __webpack_require__("mg7H");
function injectStyle (ssrContext) {
  __webpack_require__("MhMP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-009de874"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OneColumnText_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_009de874_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OneColumnText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "uhrr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupAndShuffleArticleRecords = exports.shuffleArray = exports.objPropsToPixels = exports.createAddObjectKey = undefined;

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = __webpack_require__("d7EF");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__("W3Iv");

var _entries2 = _interopRequireDefault(_entries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line
var createAddObjectKey = exports.createAddObjectKey = function createAddObjectKey(struct, keyName) {
  return function (obj) {
    var keyValue = obj[keyName];
    // eslint-disable-next-line no-param-reassign
    struct[keyValue] = obj;
  };
};

var objPropsToPixels = exports.objPropsToPixels = function objPropsToPixels(obj) {
  var result = {};
  (0, _entries2.default)(obj).forEach(function (_ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    result[key] = value + "px";
  });
  return result;
};

/*
  https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
  https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array/12646864#12646864
*/
var shuffleArray = exports.shuffleArray = function shuffleArray(array) {
  for (var i = array.length - 1; i > 0; i -= 1) {
    var j = Math.floor(Math.random() * (i + 1));
    // eslint-disable-line no-param-reassign
    var _ref3 = [array[j], array[i]];
    array[i] = _ref3[0];
    array[j] = _ref3[1];
  }
  return array;
};

/*
  return an array of records
  grouped by number and shuffled
*/
var groupAndShuffleArticleRecords = exports.groupAndShuffleArticleRecords = function groupAndShuffleArticleRecords(records) {
  // struct to organize arrays for each group
  var struct = {
    /*
      '1': [],
      '2': [],
      ...
    */
  };

  records.forEach(function (article) {
    var group = article.group;

    var key = parseInt(group, 10);
    var arr = struct[key] || [];
    arr.push(article);
    struct[key] = arr;
  });

  /*
    loop through sorted group IDs
    shuffle array
    push results to master arry
  */
  var articles = [];
  (0, _keys2.default)(struct).sort().forEach(function (key) {
    var arr = struct[key];
    shuffleArray(arr);
    articles = articles.concat(arr);
  });

  return articles;
};

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uy0X":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "v+1E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vCaE":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "vMqN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "va3D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/taillight.5ccb5d3.jpg";

/***/ }),

/***/ "vax0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"work-category-content"}},[(_vm.isMobile)?_c('work-articles-mobile',{attrs:{"articles":_vm.articlesData}}):_c('work-articles-tablet',{attrs:{"articles":_vm.articlesData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wK4Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wctg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x5uD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

// Components
// import MouseEventContainer from '@/components/MouseEventContainer';

exports.default = {

  name: 'announcement',

  // components: { MouseEventContainer },

  props: ['data']

  /* computed: {
      heading() {
       const heading = this.data.heading;
       if (this.haveJobs) {
         return heading.jobs;
       }
       return heading.noJobs;
     },
      teaser() {
       const teaser = this.data.teaser;
       if (this.haveJobs) {
         return teaser.jobs;
       }
       return teaser.noJobs;
     },
      noJobsContent() {
       return this.data.noJobsContent;
     },
      haveJobs() {
       return (this.data.listings.length > 0);
     },
    }, */

};

/***/ }),

/***/ "xJD8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _store = __webpack_require__("r2AQ");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'app',
  store: _store2.default
}; //
//
//
//

/***/ }),

/***/ "xJGN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/steering-wheel.8950ae6.jpg";

/***/ }),

/***/ "xOg+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"about-subsection",attrs:{"data-component":"hcAboutAlive","data-visibility":_vm.visibility}},[(_vm.visibility === 'mobile')?[_vm._m(0),_vm._v(" "),_vm._m(1)]:[_c('div',{staticClass:"content__anchor",attrs:{"id":"hcAboutAlive"}}),_vm._v(" "),_c('ScrollItem',{attrs:{"id":"aboutAlive_component_top"}},[_c('div',{attrs:{"data-anchor":"aboutAlive_component_top"}})]),_vm._v(" "),_c('div',{staticClass:"content",class:_vm.contentFixed},[_c('div',{staticClass:"content__container",style:(_vm.contentOpacity)},[_c('span',{staticClass:"tab-number"},[_vm._v("03")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',[_vm._v("\n        We’re not here to daydream. We live for real-world solutions, and once we get an idea rolling, we launch into its building and development. Our world-class engineers work with clients at every stage of prototyping, software design, and engineering to bring a possibility to the here and now.\n      ")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),(_vm.visibility === 'compact')?_c('div',{staticClass:"graphic",class:_vm.graphicFixed},[_vm._m(5),_vm._v(" "),_vm._m(6)]):_vm._e(),_vm._v(" "),(_vm.visibility === 'full')?_c('div',{staticClass:"graphic",class:_vm.graphicFixed},[_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10)]):_vm._e()]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"graphic"},[_c('div',{staticClass:"quadrant-l"},[_c('div',{staticClass:"subquadrant-tl"},[_c('div',{staticClass:"placeholder yellow"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("rRzr"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"subquadrant-tr"},[_c('div',{staticClass:"placeholder blue"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("NvDy"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"subquadrant-bl"},[_c('div',{staticClass:"placeholder blue"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("OYJs"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"subquadrant-br"},[_c('div',{staticClass:"placeholder white"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("+QJm"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"quadrant-r"},[_c('div',{staticClass:"placeholder yellow"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("/es/"),"alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"content__container"},[_c('span',[_vm._v("03")]),_vm._v(" "),_c('h1',{staticClass:"h1"},[_vm._v("\n          Make it\n          "),_c('br'),_vm._v("\n          Come to life\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          We’re not here to daydream. We live for real-world solutions, and once we get an idea rolling, we launch into its building and development. Our world-class engineers work with clients at every stage of prototyping, software design, and engineering to bring a possibility to the here and now.\n        ")]),_vm._v(" "),_c('div',{staticClass:"headline"},[_c('span',{attrs:{"data-ornament":"rectangle"}}),_vm._v(" "),_c('h2',{staticClass:"h2"},[_vm._v("\n            Services\n          ")])]),_vm._v(" "),_c('ul',{staticClass:"services"},[_c('li',{staticClass:"service"},[_vm._v("Prototyping")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Front-End Development")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Mobile Development")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Back-End Development")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"h1"},[_vm._v("\n        Make it\n        "),_c('br'),_vm._v("\n        Come to life\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headline"},[_c('span',{attrs:{"data-ornament":"rectangle"}}),_vm._v(" "),_c('h2',{staticClass:"h2"},[_vm._v("\n          Services\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"services"},[_c('li',{staticClass:"service"},[_vm._v("Prototyping")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Front-End Development")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Mobile Development")]),_vm._v(" "),_c('li',{staticClass:"service"},[_vm._v("Back-End Development")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-t"},[_c('div',{staticClass:"placeholder blue"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("Lj5t"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-b"},[_c('div',{staticClass:"placeholder yellow"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("/es/"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-tl"},[_c('div',{staticClass:"placeholder blue"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("Lj5t"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-tr"},[_c('div',{staticClass:"placeholder black"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("SaSh"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-bl"},[_c('div',{staticClass:"placeholder white"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("VZc3"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quadrant-br"},[_c('div',{staticClass:"placeholder yellow"}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("/es/"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xr0L":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKkAAABkCAYAAAD9oxBFAAAACXBIWXMAAAsSAAALEgHS3X78AAAI70lEQVR4nO2dv27jyhXGvw1SpJPyBFKRIgECrC6CAOnMrUKysYA8gLh1ivV9AnOfYL1PELoMEODKSECyCSx3AdLYVdKt1KaSgFRpnGJm7iUPZ0hKspGzwfcDhLsczgyHnI/nzwyN++b5+RmEaOZH/+sBEDIERUrUQ5ES9VCkRD0UKVEPRUrUQ5ES9VCkRD0UKVEPRUrUQ5ES9VCkRD0UKVEPRUrUQ5ES9VCkRD0UKVEPRUrUQ5ES9VCkRD0UKVEPRUrUQ5ES9VCkRD0UKVEPRUrUQ5ES9VCkRD0UKVEPRUrUQ5ES9VCkRD0UKVEPRUrUQ5ES9VCkRD0UKVEPRUrUQ5ES9bxJ4t8e8z9y2gFYA7gpq3r7OkP6+kiTOAdwLYq/Lav6pqdNAWDVKHooqzrqqZ8B+IMo/lhWdX7EUL9KjrWkMwAfADymSXz1CuP5Wll7yrKBNktxfJEm8bSnfjTyuv93nOruJwA+WWswmjSJF2kSz0+8plrKqn6E8TJN3oZElybxEuYZSqRw+87t7HVfDS3z9eMRdXYAbgDsAeQw1tSxSpN461xOwO11SJMYAO5gwoZNo3xU+wZBd+dxp7dlVWeeevKaBwDzsqr3gX6nALZoi+wjjFX7IKovARSebkJi9NYPiHrdOB/BWG5Z72Drrcuq7ljdc+bL0/Zdcy5tnSmADYC3jeInGK8Qweipec6dXwMoXEg5xpLOAHwCEJVVPQdwK85fn/i2XQK4f42wwT6clSheDbhTxwR+YTkK+K2gL/7sE6OPy8AYI9/10iSep0m8AXAPc79yXBNb/l2axJs0iReB647hlPnaoC3CA8zLdAPgO3QFClt2DeCLfRGOcverNIlza40exLn8iH4kn6yleElCD3LsA7601qmFLbv0NbBv/ZMo9vURcvUO37OQZU8ApgAeAVz09NXkAsC5QgVGzpf1ZFKgEYAFugYkRJYm8XSMu29yBSPIDMCXRvkq8IY9wLxNTSJ0H2wOfxLwcWA8sm9H1lOeD/TpKNIkXji3by1cMdQGxus4JmkSL4WrHZrglsu3opqJOn+EuXcp9p0t3wKYo+v+J7BCDazOnDtfbswF2kI8wHjixzSJpce5s31N0RVwVlb1/liRTtIkjsqq3qRJ/CAGH3nqb3wxoxV0czJ9Zh+nLK/YpRo5qY5ZmsRZWdXFiK5m+OGlhP13qF/HGu37AoxQjhHpZZrE00ZMHHnq/ApdgXbic/ti5WjHyhP8YGgkx8yXV6S2rrSUy0aS1xJ8WdWt52Hb5/bcBjhvMX8jjo9xI4UseAE35MjEsbTG8nwf1zbDXWBEgjHk8gOu/p2nq+bEZeLcPwD8TpR5E8iyqvdlVV8B+CxOrY7MIwpPWae9NRDyJX0vEyrRJmoeuzHbcQMYL9Jv0E2YzqGTHPiWU9Ikjnp+c0/9Bdpv6pOdvOby0MXACyGXkm7QTYqkEJsU4njWuF4ntrQTKPtbAoC9R+ll5HPajfA4OYzL7VxjJL5kbuvpT242vPd4LXmv92kSP6ZJnPvyAOA0S+oe0phMuYN98NJVSGE47nt+mae+jIuduIqBevJcc0Iv0Bb+Dv1xbd/CvhRGIf7rcFl+5OnrXyOu18KGDrLeqPk7Yr7k8pvbnZT4ylxGf58m8T5N4qJphPpi0j8D+A+Af9vjHPj+hgH/A5Rk4u1YwJ/ZFiP66sWz7HRovMU3aLvrVZrEV4G10D2MUKVVcGR94yirepsm8RPaFjAaWOsMxbK+rF6O2bue62E7os5LztcM5rlnzcKyqnMrwFCG75bNlnaOij5L+jMAf4KZMJcN5sD3ccSQG3IDvWj8fDf88EL7z9I6blxoAPOw5bJZ0Jpaccv6APC5L75qUIjjt57rPbkMOxDLLtFd7pL9AuM92nxEnZeer5VvucouY76DCSFlGOKYwK4F94n0FwD+BrMMUNjOtz1LMZuRA3ccYAL+qKfOu56fHEMmji/RDg/kMoqsL8nQfoAHjF++8rk0ef1i4Ni3HrtG13KOjS1lvbEW2DFmvm5hlpSaFL78oazqTVnVWVnVU5j5/IxuGDEBkPWJ9AHAL9HdfntEdynmNuA6d7afB3TfmD38uzTyRkK/bWNcmWdMQ8xsu9C1t2iLMgttlQba9iVXQFfIQ7Gls7yy3sztzISw54Pbqg3OmS+37ZyhLbbODp5MXO18XgV2NIOJ0w5AXlb1XwDM0yRepkm8hrFIPjHkgX6Ksqoj+/bJN3nW0+5YstdoZz+1ewBw59v7HqDoOfdUisV0e+wLMVr9Bepdh4Qa2J+/DSzmnzNfbnx7dJ/rhRufFejGbtPOPf10nnMocZrBBK43CCy0N/g45ttSuwHwGe0s8EOaxJuQAIYsBEyIsUc3+8562tw3/n0B4J8D1zhmqaaJLxlyhCxSgfA2Z/MZZTAerWkdr61ncCHBFGbs0qiMCltOma+BttdpEv8VJiGfwNznlzSJ7+y9bGCScRm7B3ecDjA3OSTQ2yOTnhzdB1ekSRz66mjMF1FzcVwMLB7fop1Z/qav87Eu3tPOl+U7QpO8hn9VoWV5bd8Ruluj7nvfEG57cttTp0mOwHwNNSyr+sqTYN+hG3Zc2p9vrg8AerP7vo8ADjBfnmdDg20ScAVDXx318RN0xznUl7RiQy/iORSesruQ8G25TDy8/djNjwjDsa/jCXb/fGT9l5ivDO3Y9qcA/o5wRi+5Kqt6HxJp6CudHUwWtuj704g+rJWT23SXJ34JJXeO7oashJ2ksRN7LmMXs09qU1b1Y1nVCwDv4Rf3wZa/L6t6ccpH0qH5AvDzEW0f0Q0tfg3g9wC+RXgebgF841aV3jw/H/MnToS8PDZ8mAPY+owMRUrUwz9pJuqhSIl6KFKiHoqUqIciJeqhSIl6KFKiHoqUqIciJeqhSIl6KFKiHoqUqIciJeqhSIl6KFKiHoqUqIciJeqhSIl6KFKiHoqUqIciJeqhSIl6KFKiHoqUqIciJeqhSIl6KFKiHoqUqIciJeqhSIl6KFKiHoqUqIciJeqhSIl6KFKiHoqUqIciJeqhSIl6/gt0l2aywruqGQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "y3R9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
*/

var ArticleTile = exports.ArticleTile = {
  articleMargin: 40,
  articleInfoOverlap: 54
};

var BreakPoints = exports.BreakPoints = {
  mobile: {
    size: 320,
    key: '-mobile-'
  },
  tablet: {
    size: 600,
    key: '-tablet-'
  },
  desktop: {
    size: 1024,
    key: '-desktop-'
  }
};

var MaxBrowserWidth = exports.MaxBrowserWidth = 1280;

var ResponsiveSizes = exports.ResponsiveSizes = [400, 600, 800, 1200];

var ResponsiveMax = exports.ResponsiveMax = 1200;

var Events = exports.Events = {
  TappedArticle: '--tapped-article--'
};

// location of responsive images, generated by 'get-responsive-images'
var ResponsivePathName = exports.ResponsivePathName = 'responsive';

/*
  definitions for work tile offsets
  in CMS - 'large', 'medium', 'small'
*/
var WorkImageOffsets = exports.WorkImageOffsets = {
  large: 100,
  medium: 50,
  small: 20
};

var DefaultAspectRatio = exports.DefaultAspectRatio = 'square';

var CategoryTileDims = exports.CategoryTileDims = {
  desktop: {
    w: 703,
    h: 205,
    gridGap: 32
  }
};

var catW = CategoryTileDims.desktop.w;
var catH = CategoryTileDims.desktop.h;

var AspectRatios = exports.AspectRatios = {
  // category tile ar
  '7:2': catW / catH,
  '2:7': catH / catW,

  '25:9': 25 / 9,
  '21:9': 21 / 9,
  '16:9': 16 / 9,
  '4:3': 4 / 3,
  '1:1': 1 / 1,
  '3:4': 3 / 4,
  '9:16': 9 / 16,
  '9:21': 9 / 21,
  '9:25': 9 / 25
};

/***/ }),

/***/ "y70L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"hero"}},[(_vm.data.background.type === 'image')?_c('div',{staticClass:"background",class:{ 'stretch': _vm.data.stretch, 'constrain': _vm.data.constrain },style:(_vm.style)}):_vm._e(),_vm._v(" "),(_vm.data.background.type === 'video')?_c('div',{staticClass:"background background--video",class:{ 'stretch': _vm.data.stretch, 'constrain': _vm.data.constrain }},[_c('video',{attrs:{"autoplay":"","muted":"","loop":"","playsinline":"","poster":_vm.data.background.poster},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.data.background.src}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.data.background.poster,"alt":"Picture of Particle's logo on the wall"}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content"},[_c('h1',{staticClass:"headline",attrs:{"data-type":"title"}},[_vm._v(_vm._s(_vm.data.headline))]),_vm._v(" "),(_vm.data.ornament)?_c('div',{attrs:{"data-ornament":"circle"}}):_vm._e()]),_vm._v(" "),(!_vm.data.constrain)?[_c('ScrollItem',{attrs:{"id":"beginNavOverlay","offset":94}},[_c('div',{attrs:{"data-anchor":"beginNavOverlay"}})])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yYDX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"intro"}},[_c('div',{staticClass:"main"},[_c('h1',[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('markdown',{staticClass:"markdown"},[_vm._v(_vm._s(_vm.data.content))])],1)]),_vm._v(" "),_c('div',{staticClass:"aside"},[_c('div',{staticClass:"aside__grid"},[_c('div',{staticClass:"aside__content"},[_c('h2',[_vm._v("Our role")]),_vm._v(" "),_c('ul',{staticClass:"roles"},_vm._l((_vm.data.roles),function(role){return _c('li',{key:role,staticClass:"role"},[_vm._v("\n            "+_vm._s(role)+"\n          ")])}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ybtO":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "zIIn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.data.styles),attrs:{"data-module":"row","data-singleton":_vm.data.singleton,"id":_vm.data.id}},_vm._l((_vm.columns),function(item,i){return _c('div',{key:("row-item--" + i),staticClass:"row-item",attrs:{"data-colstart":item.grid.start,"data-colend":item.grid.end,"data-index":i + 1}},[_c(("component_" + (item.component)),{key:item.component,tag:"component",attrs:{"data":item}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zKSb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zNrC":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "zW8K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
  THIS FILE IS GENERATED !!

  #> npm run gen:work-articles
  #> NETLIFY_ENV=development npm run gen:work-articles
*/
/* eslint-disable */

exports.default = { "ai-future-smart-car": { "slug": "ai-future-smart-car", "date": "2018-12-18", "client": "particleDesign", "isShown": true, "tile": { "headline": "Ushering in The Future Smart Car.", "linkText": "Learn more about our work in Transportation.", "group": 1, "colSpan": 1, "tileOffset": "small", "image": { "src": "/static/content/uploads/work-ai-car.jpg", "aspect": "landscape", "hAlign": "center", "vAlign": "center" } }, "workCategories": { "artificial-intelligence": { "key": "artificial-intelligence", "group": "1" } }, "modules": [{ "type": "work-header", "data": { "image": { "src": "/static/content/uploads/work-ai-car.jpg", "alt": "" }, "title": "Designing AI in the Future Smart Car", "content": "With the emergence of technologies like artificial intelligence and internet of things, a major automotive company wanted to understand what kind of relationship users might want with their cars when their cars might become very intelligent, and how that intelligence could help solve problems drivers are experiencing around transportation today. \n\n Auto manufacturers typically design vehicles 4-5 years in advance. This means they need to consider how to incorporate the technologies of tomorrow into the designs they’re making today so their vehicles can keep up with technological advancements and still be relevant when they’re released.", "roles": ["UX Research", "UX Strategy", "Participatory Design", "User Interviews", "Video User Findings", "Visual Design"] } }, { "type": "work-multi-image-text", "data": { "reversed": true, "images": [{ "src": "/static/content/uploads/work-ai-car-hug.jpg" }, { "src": "/static/content/uploads/work-ai-car-china.jpg" }], "content": "## What relationship do drivers want with their cars?\n\nTo understand what drivers now might want from their cars tomorrow, Particle conducted a three-part study that included iterative research and design. For the first phase, we conducted a metaphor study to understand the dynamic users wanted with their cars. Did users envision their partnerships with their cars like a dog and his master, silently taking orders, or like a family member with a personality that anticipated their next steps? \n\n From there, we had drivers break down the moments before, during and after driving that were particularly challenging for them, to identify opportunities for innovation across the entire user journey especially those tricky transitions into and out of the vehicle. " } }, { "type": "work-one-column-text", "data": { "reversed": false, "size": "large", "content": ">Everyday metaphors helped drivers talk about the relationship they had with their cars now and the relationship they wanted with the cars of the future.\n\n>> Crystal Rutland\nCEO and Founder, Particle Design" } }, { "type": "work-image-text-row", "data": { "reversed": false, "image": { "width": "regular", "aspect": "tall", "src": "/static/content/uploads/work-ai-car-exterior.jpg", "alt": "picture of people in car" }, "content": "## Solving the right problem for drivers. \n\n We heard stories of moms struggling to get their kids out the door and load all of their gear into the car; and tales of unsafe moments when mom’s had to turn around to manage unhappy kids in the backseat who had dropped their favorite toys. We heard about married couples who had to reset everything when they traded vehicles, from the position of the car seat and rear view mirror to the radio station. And we heard from one woman who needed to get her disabled friend into the car and pull up her doctor’s address so she could chauffeur her to an appointment. " } }, { "type": "work-two-column-text", "data": { "reversed": false, "isOffset": true, "contentLeft": "## Design for safety and simulate the experience. \n\nParticle distilled and translated everything we heard into concept storyboards of potential driving usages for intelligent cars that could anticipate some of their user needs. From this concept research we learned what usages drivers found most compelling and when drivers wanted the car to act on their behalf and when they just wanted it to make smart suggestions so they could have the final say.\n\nBy running drivers thru a variety of predictive scenarios in the simulator, we were able to better understand how the intelligent car of the future would need to work when rubber hit the road. Specifically, how it could offer up predictions and assistance in actual driving scenarios in a way that was supportive and safe rather than distracting and irritating \n\n With the insights we gleaned from this research, we were able to provide the auto manufacturer with a set of highly appealing predictive driving features with specific directives on how they would need to be designed and implemented in a vehicle for optimal driver satisfaction and safety.", "contentRight": ">Thru iterative and progressive research, we were able to design an intelligent, predictive in-vehicle experience that was personalized. \n\n>>Amber Ward\nUX Researcher and Project Manager, Particle Design " } }, { "type": "work-related-articles", "data": { "articles": ["jlr-future-car", "machine-learning-wearable-development"] } }], "isWorkArticle": true }, "artificial-intelligence": { "date": "2018-11-01", "client": "particleDesign", "isShown": true, "tile": { "headline": "Artificial Intelligence", "linkText": "Category Test Page - Artificial Intelligence", "group": 1, "colSpan": 2, "tileOffset": "medium", "image": { "src": "/static/content/uploads/test-gear-square-tile.jpg", "aspect": "category-tile", "hAlign": "center", "vAlign": "center" } }, "modules": [{ "type": "category-page-header", "data": { "title": "Artificial Intelli­gence", "burner": "Artificial Intelligence is here, and its entrance has sparked a revolution in how we interact with the digital world. As UX researchers and designers, we’re moved to explore the meaning behind emerging technologies. Artificial Intelligence asks us to consider new complexities in designing for trust, communication, and agency, and why UX is necessary for its transformation." } }, { "type": "work-category-content", "data": { "category": "artificial-intelligence" } }], "slug": "artificial-intelligence", "isWorkArticle": true, "workCategories": {} }, "dhl-honeywell-iot-shipping": { "date": "2018-06-08", "client": "honeywell", "isShown": true, "tile": { "headline": "A New Future of Global Shipping.", "linkText": "Learn more about our work with Honeywell", "group": 1, "colSpan": 1, "tileOffset": "small", "image": { "src": "/static/content/uploads/work-honeywell-tile.jpg", "aspect": "square", "hAlign": "center", "vAlign": "center" } }, "workCategories": { "transportation": { "key": "transportation", "group": "1" } }, "modules": [{ "type": "work-header", "data": { "image": { "src": "/static/content/uploads/work-honeywell-hero.jpg", "alt": "" }, "title": "A New Future of Global Shipping.", "content": "Honeywell and a leading chip manufacturer had a serious concern: they regularly shipped high-value and fragile freight but had no real way to know if it was damaged or stolen until it reached its destination.\n\nThey decided it was time to find a solution. So, they joined forces with their freight logistics providers to create a hardware and software platform that would enable real-time monitoring of any freight, anywhere in the world.\n\nParticle Design was brought on board to help build a design that would work well for logistics providers and their customers and that it could be incorporated into existing workflows without completely disrupting them.", "roles": ["UX Ressearch", "UX Strategy", "Roles and Task Flows", "Field Trial Support", "Industrial Design", "Ideation Workshop", "Participatory Design"] } }, { "type": "work-image-text-row", "data": { "reversed": false, "image": { "src": "/static/content/uploads/work-honeywell-particle-peeps.jpg", "width": "wide", "aspect": "tall" }, "content": "## Designing a user first strategy for real world impact. \n\nParticle launched the project with ideation workshops that included key stakeholders from Honeywell and logistics companies. \n\nBy facilitating user interviews and a series of carefully crafted design-thinking exercises, Particle helped cross-functional teams prototype solutions to address the needs of real users across the logistics supply chain. Teams designed early prototypes using everything from cardboard to legos, which laid the groundwork for the hardware and software requirements that Honeywell needed to kick off the product design. In focusing on the powerful insight of real user experiences, Particle went on to develop a real-world shipping solution that bridged refined IoT with real-time tracking." } }, { "type": "work-one-column-text", "data": { "reversed": false, "size": "large", "content": "## Inspiring the foundation of Honeywell’s award winning platform. \n\nParticle carried the key learnings from the ideations and user research forward to design a contextually aware prototype for the Honeywell team. The output was a sophisticated shipping solution that used Intel(R) sensor technology to provide real-time feedback on a package while in transit. Throughout the design and development process, we navigated across companies and teams to ensure the UX thread remained intact to satisfy both business and user needs.\n\nAs a result of Particle’s research and designs, Honeywell developed an award-winning platform that gives companies unparalleled insight into the health of their products throughout the shipping journey, allowing them to make real-time decisions that can minimize freight loss or spoilage, maximize asset utilization, and optimize end-to-end supply chain operations. By combining sensor technology with refined IoT, our shipping solution provided immediate and essential information to key stakeholders and partners." } }, { "type": "work-image-text-column", "data": { "reversed": false, "image": { "src": "/static/content/uploads/work-honeywell-2-dudes.jpg", "alt": "image of people working", "height": "short" } } }, { "type": "work-one-column-text", "data": { "reversed": false, "size": "large", "content": ">We see visibility tracking solutions such as this as an important component to our semiconductor logistics efforts and is something we believe will bring tangible value across other sectors within DHL as well.\n\n>> Connor Charles\nVP of Technology Sector Americas, DHL" } }, { "type": "work-related-articles", "data": { "articles": ["jlr-electric-vehicle", "hp-wearable-smartwatch"] } }], "slug": "dhl-honeywell-iot-shipping", "isWorkArticle": true }, "dreamworks-kids-gaming": { "date": "2018-06-07", "client": "dreamworks", "isShown": true, "tile": { "headline": "Designing a Digital Storytelling Adventure.", "linkText": "Learn more about our work with DreamWorks", "group": 2, "colSpan": 1, "tileOffset": "none", "image": { "src": "/static/content/uploads/work-dw-create-tile.jpg", "aspect": "portrait", "hAlign": "center", "vAlign": "center" } }, "modules": [{ "type": "work-header", "data": { "image": { "src": "/static/content/uploads/work-dw-create-hero.jpg", "alt": "" }, "title": "Where Kids Become the Directors of Their Own Movies.", "content": "DreamWorks has developed an entire website aimed at inspiring kids to express their creativity (http://create.dreamworks.com/). The site is filled with options for fashioning crafts and paper toys, bringing DreamWorks characters to life through augmented reality, making scrapbooks, learning art techniques, and more.\n\nWhen DreamWorks got in touch with Particle Design, they were looking to add a video and storytelling element to the site. They wanted an activity that would empower kids to feel like they were directing their own movies. They envisioned kids choosing characters, making storyline decisions, and writing the simple scripts that would drive the narrative. They also wanted the final video each child created to convert immediately into a black-and-white comic book that kids could print and color.", "roles": ["UX Strategy", "Interaction Design", "Visual Design", "UX Design", "Front-End Development", "Back-End Development"] } }, { "type": "work-multi-image-text", "data": { "reversed": false, "images": [{ "src": "/static/content/uploads/work-dw-create-discussion.jpg" }, { "src": "/static/content/uploads/work-dw-create-boy-head.jpg" }, { "src": "/static/content/uploads/work-dw-create-camera.jpg" }], "content": "## Inspiring an engaging and functional platform for DreamWorks.\n\nDreamWorks wanted to give kids a great storytelling experience as directors of their own movie scenes. Particle was keen to bring their idea to life but quickly identified the project’s central challenge. The objective was to give children the freedom to create their own stories and have an output when finished. But if there were too many options, the rendering process would take so long kids would give up before the final video could be created. On the other hand, if there weren’t enough options, the activity would be boring and fail to inspire.\n\nParticle’s developers knew the complexity that video brings to web apps and the requirements for success. We were able to help the whole project team understand what would and would not work and kept the project on track. In the end, the video activity we developed struck the perfect balance between creativity and functionality." } }, { "type": "work-two-column-text", "data": { "reversed": false, "contentLeft": "## Designing an interactive DreamWorks app that meets unique design restrictions.\n\nFor this DreamWorks project, Particle had limited time—less than 60 days—and a tight budget. There were also complex restrictions and guidelines about how DreamWorks characters could be used in the experience in order to maintain brand authenticity.\n\nAnd most significantly, since the site was for young children, it was critical that the content maintained compliance with COPPA (Children’s Online Privacy Protection Act), under U.S. federal law. COPPA’s primary goal is to place parents in control of the information collected from their children online. As such, it imposes regulations on websites focused on children under 13. Its requirements are stringent, and Particle’s team had to ensure there was no deviation as design decisions were made throughout the project.", "contentRight": "> Building an experience that allows kids to take an active role in creating the content they consume every day was an exciting opportunity.\n\n>> Stacey Rutland\n>>Particle, Project Lead" } }, { "type": "work-image-text-column", "data": { "reversed": true, "image": { "height": "tall", "src": "/static/content/uploads/work-dw-create-dragon-screenshot.jpg", "alt": "screencapture of create.dreamworks.com", "hAlign": "center", "vAlign": "center" } } }, { "type": "work-related-articles", "data": { "articles": ["jlr-future-car", "vr-science-education"] } }], "slug": "dreamworks-kids-gaming", "isWorkArticle": true, "workCategories": {} }, "eb-retail-ecommerce": { "date": "2018-06-07", "client": "eb", "isShown": true, "tile": { "headline": "The Online Platform of the Future Bra.", "linkText": "Learn more about our work with Evelyn-Bobbie", "group": 3, "colSpan": 1, "tileOffset": "none", "image": { "src": "/static/content/uploads/work-eb-bra-tile.jpg", "aspect": "medium", "hAlign": "center", "vAlign": "center" } }, "modules": [{ "type": "work-header", "data": { "image": { "src": "/static/content/uploads/work-eb-bra-hero.jpg", "alt": "" }, "title": "The Online Platform of the Future Bra.", "content": "Evelyn & Bobbie is an online bra startup that has created the most fundamental innovation in lingerie since the underwire bra was introduced in the 1930s. Using in-depth research, 3D technology, and data science, they designed a bra that is so revolutionary it doesn’t need straps—not a strapless bra, but a bra that contours to women’s bodies so well, it doesn’t need to be held up with straps.\n\nEvelyn & Bobbie’s Founder, Bree McKeen, knew that changing consumers’ minds about what a bra can look and feel like—and still work—would be a critical challenge. She had re-architected the modern bra and needed to know how best to communicate its value and benefits to women. That’s where Particle Design came in.", "roles": ["UX Research", "UX Strategy", "UX Design", "Front-End Development", "Back-End Development", "User Interviews", "Competitive Analysis"] } }, { "type": "work-image-text-row", "data": { "reversed": false, "image": { "src": "/static/content/uploads/work-eb-bra-phone-app.jpg", "alt": "a picture ", "width": "narrow", "aspect": "tall" }, "content": "## When uncharted territory leads to an authentic user experience.\n\nThe bra McKeen and her team designed is entirely different from any bra women have ever experienced—a wireless, seamless, and strapless bra that provides support by distributing weight to the core muscles and torso. But Evelyn & Bobbie is an online store; how could they get women to understand and trust the product without trying it first?\n\nThrough user interviews and analyses, Particle developed a clear sense of users’ relationship with the product and learned what was most important to them. From there, we devised a strategy for effectively communicating the bra’s unique value and designed a digital experience that conveys that messaging and speaks to Evelyn & Bobbie’s customers’ needs." } }, { "type": "work-one-column-text", "data": { "reversed": false, "size": "large", "content": ">The first thing we had to do is forget everything we think we know about how to design a bra.\n\n>> Bree McKeen\nCEO Evelyn & Bobbie" } }, { "type": "work-multi-image-text", "data": { "reversed": false, "images": [{ "src": "/static/content/uploads/work-eb-bra-bra-colors.jpg" }, { "src": "/static/content/uploads/work-eb-bra-tablet-app.jpg", "hAlign": "right" }], "content": "## Connecting the Evelyn and Bobbie brand to its users.\n\n“If you’re paying enough attention to your customers, you can learn a whole lot about what your product can do”—that’s a core principle at Evelyn & Bobbie and the premise behind our up-coming project for them.\n\nEvelyn & Bobbie wants to know what users think about their product so they can continue enhancing it and developing new product lines. To help, Particle will build a sophisticated digital experience that creates a continuous feedback loop between users and the designers, enabling user input to directly affect the product’s design.\n\nParticle Design applied its user-experience expertise to help build a line of communication between Evelyn & Bobbie and their users. Now they can successfully communicate what their product is and understand what their users want and are on track to turn the bra industry upside down." } }, { "type": "work-related-articles", "data": { "articles": ["jlr-future-car", "hp-wearable-smartwatch"] } }], "slug": "eb-retail-ecommerce", "isWorkArticle": true, "workCategories": {} }, "hp-wearable-smartwatch": { "date": "2018-06-07", "client": "hp", "isShown": true, "tile": { "headline": "Launching a New Class of Smart Watch.", "linkText": "Learn more about our work with HP", "group": 2, "colSpan": 1, "tileOffset": "medium", "image": { "src": "/static/content/uploads/hp-wearable-tile.jpg", "aspect": "square", "hAlign": "center", "vAlign": "center" } }, "modules": [{ "type": "work-header", "data": { "image": { "src": "/static/content/uploads/hp-wearable-hero.jpg", "alt": "", "hAlign": "left" }, "title": "A New Class of Smart Watch.", "content": "Several years ago, HP Inc. decided to enter the wearables market. Their approach was unique: HP would provide the engineering and technology; designers and watchmakers would create the watches. Each watch would look and feel like a classic analog timepiece but would have built-in intelligence and connectivity to a smartphone app.\n\nHP brought in Particle Design for help with several projects all tied to their smartwatches&rsquo; UX design.", "roles": ["UX Research", "UX Strategy", "UX Design", "Usability Testing", "Longitudinal Diary Study", "Competitive Analysis", "User Findings Video", "Participatory Design"] } }, { "type": "work-image-text-column", "data": { "reversed": false, "image": { "height": "short", "src": "/static/content/uploads/hp-wearable-table.jpg", "alt": "image of a steering wheel with the digital interface on the dashboard", "hAlign": "center", "vAlign": "center" } } }, { "type": "work-image-text-row", "data": { "reversed": false, "image": { "src": "/static/content/uploads/hp-wearable-try-on-group.jpg", "width": "wide", "aspect": "tall" }, "content": "## Providing HP with a new experience through UX insight. \n\nHP came to Particle Design with several product design ideas and user hypotheses that they wanted to test before moving into product development. \n\nFor each, Particle conducted a series of interviews and exercises with prospective users. We determined which of their suppositions were correct and which were not and identified the ideas that resonated most. We helped shape and redirect their strategy to focus on what mattered to users." } }, { "type": "work-multi-image-text", "data": { "reversed": true, "images": [{ "src": "/static/content/uploads/hp-wearable-discussion.jpg" }, { "src": "/static/content/uploads/hp-wearable-man-wrist-watch.jpg" }], "content": "## Capturing the insight of HP’s users through real-world testing. \n\nHP also asked Particle Design to wear test two versions of a newly developed men’s smartwatch. They had the prototypes but wanted to understand the out-of-box and set-up experience. They also wanted to know which features users found helpful.\n\nParticle asked a group of potential users to wear the prototypes for ten days and maintain a diary. We helped HP streamline the information provided and steps involved with set-up. We also helped pinpoint what features were most useful and where others fell short.\n\nTo date, HP has partnered with several designers and watchmakers to create and bring to market stunning timepieces with digital capabilities, all of which incorporate insights brought to light by the Particle team." } }, { "type": "work-one-column-text", "data": { "reversed": false, "content": ">About 6 months after I purchased an Apple Watch, I stopped wearing it...the beauty of the Coach Bleecker Smart Watch is that when you are wearing it, it simply looks like a nice watch with a regular analog face.\n>>Gear Diary, November 2016" } }, { "type": "work-related-articles", "data": { "articles": ["samsung-mobile-research", "eb-retail-ecommerce"] } }], "slug": "hp-wearable-smartwatch", "isWorkArticle": true, "workCategories": {} }, "jlr-electric-vehicle": { "date": "2018-06-07", "client": "jaguar", "isShown": true, "tile": { "headline": "Reimagining IVI Design for a New Electric Vehicle.", "linkText": "Learn more about our work with Jaguar Land Rover", "group": 2, "colSpan": 2, "tileOffset": "medium", "image": { "src": "/static/content/uploads/work-lr-ev-hero.jpg", "aspect": "landscape", "hAlign": "center", "vAlign": "center" } }, "workCategories": { "transportation": { "key": "transportation", "group": "1" } }, "modules": [{ "type": "work-header", "data": { "image": { "src": "/static/content/uploads/work-lr-ev-hero.jpg", "alt": "", "hAlign": "right" }, "title": "A Luxury All-electric Vehicle.", "content": "When Jaguar Land Rover (JLR) decided to make a move into the electric vehicle market with their first all-electric car, they asked the team at Particle Design to help them create an IVI (in-vehicle infotainment) system for their EV that was as exciting, technologically innovative, and future-facing as the car itself promised to be.\n\nJaguar Land Rover knew they were facing a critical challenge. Electric vehicles need to not only solve many of the same problems as regular cars, they also need to design around key infrastructure challenges that early adopters of electric vehicles face.", "roles": ["UX Research", "UX Strategy", "UX Design", "User Video Findings", "Competitive Analysis", "Rapid Prototyping", "Ideation Workshop"] } }, { "type": "work-image-text-column", "data": { "reversed": false, "image": { "height": "medium", "src": "/static/content/uploads/work-lr-ev-steering-wheel.jpg", "alt": "image of a steering wheel with the digital interface on the dashboard", "hAlign": "center", "vAlign": "center" } } }, { "type": "work-one-column-text", "data": { "reversed": false, "size": "large", "content": "## How do you transform the electric vehicle experience? Reduce range anxiety.\n\nKnown as “range anxiety,” electric vehicle (EV) drivers worry that they may not have enough charge to reach their destination or the next charging station. Some electric car makers have sought to ease the problem of range anxiety by building an infrastructure of charging stations to support drivers. But Jaguar Land Rover is a car company with a global reach , and creating a unique infrastructure to support its worldwide presence was untenable. They knew EVs were the transportation of the future, but until the real world caught up with this burgeoning industry, they’d need to design a vehicle that integrated with existing infrastructures and systems." } }, { "type": "work-image-text-row", "data": { "reversed": true, "image": { "aspect": "medium", "width": "wide", "src": "/static/content/uploads/work-lr-ev-map.jpg", "alt": "Map of charging stations in USA", "hAlign": "center", "vAlign": "center" }, "content": "## Pairing existing infrastructure with sharper design. \n\n Particle Design helped Jaguar Land Rover design an IVI system that can intelligently plan and route people to charging stations, not only when en route but also as they plan their trips. The design we created allows for smart, automated, contextual updates to the navigation system. It also includes a mobile app that can deliver alerts and communications about car and battery status when drivers are away from their vehicle." } }, { "type": "work-two-column-text", "data": { "reversed": true, "isOffset": true, "contentLeft": "## When a JLR concept car is more than a concept.\n\nFrom idea to marketplace, Particle helped JLR bridge the gap between high concept and on-the-road usability by keeping future forecasting and design grounded in solving problems instead of just catching the eye.", "contentRight": ">The new Jaguar I-Pace concept has the potential of becoming a breakthrough vehicle, a luxury electric SUV that could cause quite a headache for Tesla Motors.\n\n>>USA Today, Feb 2016 " } }, { "type": "work-related-articles", "data": { "articles": ["regence-healthcare-user-journey", "jlr-future-car"] } }], "slug": "jlr-electric-vehicle", "isWorkArticle": true }, "jlr-future-car": { "date": "2018-06-07", "client": "landrover", "isShown": true, "tile": { "headline": "The Luxury Vehicle of Tomorrow.", "linkText": "Learn more about our work with Jaguar Land Rover", "group": 2, "colSpan": 1, "tileOffset": "medium", "image": { "src": "/static/content/uploads/work-jlr-2020-tile.jpg", "aspect": "landscape", "hAlign": "center", "vAlign": "center" } }, "workCategories": { "transportation": { "key": "transportation", "group": "1" } }, "modules": [{ "type": "work-header", "data": { "image": { "src": "/static/content/uploads/work-jlr-2020-hero.jpg", "alt": "" }, "title": "The Luxury Vehicle of Tomorrow.", "content": "It was 2015, and Jaguar Land Rover was looking to the future of luxury vehicle design. They brought in Particle Design to help rethink the relationship between users, vehicles, and mobile devices—to think about the vehicle experience holistically—and build those insights into innovative product strategies.", "roles": ["UX Research", "UX Strategy", "UX Design", "Rapid Prototyping", "Ethnographic Research", "Mobile Development", "Competitive Analysis", "Ideation Workshop", "User Video Findings"] } }, { "type": "work-image-text-row", "data": { "reversed": false, "image": { "width": "wide", "aspect": "tall", "src": "/static/content/uploads/work-jlr-2020-office-boards.jpg", "alt": "picture of ideation session" }, "content": "## Reimagining the relationship between users and their vehicles.\n\nOur first undertaking was to help Jaguar Land Rover reimagine what an in-vehicle infotainment (IVI) system could be.\n\nThe landscape analysis we conducted to understand the future of interactions between users and technology surfaced a key trend: anticipatory design. We used that and other observations to develop an IVI system that would get to know its users and intelligently predict what they might want, based on the time of day, who’s in the vehicle, and more.\n\nWe imagined an IVI system for the future, designed the concept from the ground up, and built a full-featured prototype of the media component that simulated the user experience." } }, { "type": "work-one-column-text", "data": { "reversed": false, "size": "large", "content": ">The drivers in 2020 will have different user expectations than the drivers of today. Our design must be forward thinking to meet these expectations, as well as flexible enough to accommodate opportunities not yet on our radar.\n\n>> Matt Adamo\nDirector of UX Strategy, Particle Design" } }, { "type": "work-image-text-row", "data": { "reversed": true, "image": { "width": "wide", "aspect": "tall", "src": "/static/content/uploads/work-jlr-2020-interior.jpg", "alt": "image of person driving car" }, "content": "## Bringing the mobile device into the JLR smart-car eco-system. \n\nNext, we helped Jaguar Land Rover rethink the role mobile devices could play in the relationship between users and their vehicles.\n\nThrough ethnographic research, we cultivated a real understanding of how people currently use their phones before, during, and after they’re in the vehicle. We also developed strategic insights about how people thought a car and a device should interact with each other.\n\nWhat if your smartphone set your car’s comfort levels, based on the time of day or pre-driving activities? What if the music you were listening to while driving continued to play on your phone when you got out of the car? What if every seat had its own comfort zone and screen that could be controlled independently by a mobile app?\n\nBy the end of this six-month project, we were able to build a prototype that not only demonstrated the app’s functionality but also simulated the user’s in-vehicle experience with the app.\n\nWe helped JLR envision the relationship between users, vehicles, and devices differently and developed concepts that would elevate and delight users before, during, and after a journey." } }, { "type": "work-related-articles", "data": { "articles": ["jlr-electric-vehicle", "dreamworks-kids-gaming"] } }], "slug": "jlr-future-car", "isWorkArticle": true }, "machine-learning-wearable-development": { "slug": "machine-learning-wearable-development", "date": "2018-12-20", "client": "particleDesign", "isShown": true, "tile": { "headline": "When AI and Wearables Meet.", "linkText": "Learn more about our work in Artificial Intelligence.", "group": 2, "colSpan": 1, "tileOffset": "small", "image": { "src": "/static/content/uploads/work-machine-learning-wearable.jpg", "aspect": "square", "hAlign": "center", "vAlign": "center" } }, "workCategories": { "artificial-intelligence": { "key": "artificial-intelligence", "group": "1" } }, "modules": [{ "type": "work-header", "data": { "image": { "src": "/static/content/uploads/work-machine-learning-wearable.jpg", "alt": "" }, "title": "Designing a Wearable Powered by Machine Learning.", "content": "Early on in the wearable device boom, a global technology company came to us for help designing the user experience of a new product. But the product wasn’t a wearable device, and the target users weren’t athletes or fashion-conscious tech enthusiasts. The project was a machine-learning development platform that data scientists could use to quickly and efficiently develop models of physical movements. The platform would help make the impending tide of wearable devices more useful for their intended users.", "roles": ["UX Strategy", "UX Research", "UX Design", "Visual Design", "User Interviews"] } }, { "type": "work-image-text-row", "data": { "reversed": false, "image": { "src": "/static/content/uploads/work-machine-learning-running.jpg", "width": "wide", "aspect": "tall" }, "content": "## Powering wearables with enhanced machine learning. \n\nAlthough the specific product we were designing was a machine learning development platform, the goal of the project was more broad. The bigger picture was facilitating the creation of wearable devices that provide useful feedback to wearers. So, before we could design the system, we needed to answer a few key questions - what is useful feedback? And how do data scientists teach a machine how to provide it?" } }, { "type": "work-one-column-text", "data": { "reversed": false, "size": "large", "content": "## From data to strategic engineering design. \n\nThe first task was to understand how data scientists actually work so that we could design a tool that meets their needs and that could be integrated into their workflows. We conducted in-depth user interviews with scientists and engineers across several wearable companies and academic institutions to uncover needs and pain points. We also conducted in-depth interviews with domain experts - fitness coaches, yoga instructors - to learn about how they analyze physical movements and how technology might help them as trainers.\n\nBy keeping human needs - those of athletes, coaches, and data scientists - at the forefront, the final system could be built to address the goals of each stakeholder, using machine learning to analyze data in a specific, useful way. Letting human needs lead the way and allowing technology to follow is the approach that should be used when designing any system involving machine learning or artificial intelligence. " } }, { "type": "work-image-text-column", "data": { "reversed": false, "image": { "src": "/static/content/uploads/work-machine-learning-basketball.jpg", "alt": "image of intelligent range", "height": "short" } } }, { "type": "work-related-articles", "data": { "articles": ["hp-wearable-smartwatch", "ai-future-smart-car"] } }], "isWorkArticle": true }, "regence-healthcare-user-journey": { "date": "2018-06-07", "client": "regence", "isShown": true, "tile": { "headline": "Healthcare Made Accessible.", "linkText": "Learn more about our work with Regence", "group": 3, "colSpan": 1, "tileOffset": "large", "image": { "src": "/static/content/uploads/work-regence-tile.jpg", "aspect": "small", "hAlign": "center", "vAlign": "center" } }, "modules": [{ "type": "work-header", "data": { "image": { "src": "/static/content/uploads/work-regence-hero.jpg", "alt": "" }, "title": "Healthcare Made Accessible.", "content": "Regence of Oregon helps thousands of people sign up for health insurance every year, but something was impeding the process. People were enrolling in health plans, but they weren’t selecting their primary health-care provider. This was a concern for Regence because completion of that second step was a requirement under the Affordable Care Act.", "roles": ["UX Research", "UX Strategy", "User Journey Mapping", "Participatory Design"] } }, { "type": "work-image-text-column", "data": { "reversed": false, "image": { "src": "/static/content/uploads/work-regence-man-xray.jpg", "alt": "man holding xray", "height": "short", "vAlign": "bottom" } } }, { "type": "work-two-column-text", "data": { "reversed": true, "isOffset": true, "contentLeft": "## Redesigning the Regence platform for transparency. \n\nRegence’s existing process wasn’t working—that much was certain. To understand why, we conducted interviews, focusing on what participants saw as a model insurance enrollment process. The interviews revealed several “ideal journey” patterns, enabled us to determine why established workflows were breaking down, and why they weren’t meeting the needs of different participants.\n\nParticle Design was able to create and suggest an ideal process for Regence and provided recommendations for optimizing their enrollment and communications strategy.", "contentRight": ">They should make it simple and clear to understand. We get these huge packets, but nobody reads through all of it. Simplify and clarify." } }, { "type": "work-related-articles", "data": { "articles": ["jlr-electric-vehicle", "eb-retail-ecommerce"] } }], "slug": "regence-healthcare-user-journey", "isWorkArticle": true, "workCategories": {} }, "samsung-mobile-research": { "date": "2018-06-07", "client": "samsung", "isShown": true, "tile": { "headline": "Product Development from Tablet to Cloud.", "linkText": "Learn more about our work with Samsung", "group": 3, "colSpan": 1, "tileOffset": "large", "image": { "src": "/static/content/uploads/work-samsung-tile.jpg", "aspect": "square", "hAlign": "center", "vAlign": "center" } }, "modules": [{ "type": "work-header", "data": { "image": { "src": "/static/content/uploads/work-samsung-hero.jpg", "alt": "" }, "title": "Product Development from Tablet to Cloud.", "content": "Samsung and Particle Design have been working together for over three years across UX design, research, and strategy initiatives. We help Samsung understand user attitudes and behaviours about their products to help them make strategic product development decisions. With deep contextual and user centered strategy, we’ve helped Samsung innovate across tablet, phone, and cloud experiences.", "roles": ["UX Strategy", "UX Research", "UX Design", "Rapid Protyping", "Usability Testing", "Longitudinal Diary Study", "Competitive Analysis"] } }, { "type": "work-multi-image-text", "data": { "reversed": false, "images": [{ "src": "/static/content/uploads/work-samsung-people-paper.jpg" }, { "src": "/static/content/uploads/work-samsung-phone.jpg", "hAlign": "center", "vAlign": "bottom" }], "content": "## Helping Samsung understand their users.\n\nSamsung was about to release a new tablet and phone, and wanted to understand the products’ experiences more deeply. Along with needing to understand how people were using their products while at home, Samsung also wanted a head-to-head comparison of what users liked and disliked about various phones and tablets, including their own. To gather quantitative feedback, we conducted a two-city study that included over 100 participants and several user-research activities. We also conducted a two-week diary study that included daily surveys and user video contributions to understand what users found frustrating or delightful." } }, { "type": "work-one-column-text", "data": { "reversed": false, "size": "large", "content": "## Using UX Strategy to turn the  big picture into strategic decisions. \n\nThere were plenty of companies providing cloud services, and Samsung wanted to understand how to prioritize development of their own cloud.  Particle conducted a variety of user activities to understand users’ perception and use of the cloud in general and Samsung’s cloud app specifically.\n\nFor each project, Particle provided Samsung with big picture insights about how they should be thinking about the product category and made recommendations for future product-line enhancements. From tablets, to phones, to the cloud, Particle has enabled Samsung to think strategically about product development by giving the company insights into user perceptions and experiences." } }, { "type": "work-image-text-column", "data": { "reversed": false, "image": { "src": "/static/content/uploads/work-samsung-particle-boards.jpg", "alt": "image of office with whiteboards", "height": "medium", "vAlign": "bottom" } } }, { "type": "work-related-articles", "data": { "articles": ["hp-wearable-smartwatch", "jlr-future-car"] } }], "slug": "samsung-mobile-research", "isWorkArticle": true, "workCategories": {} }, "transportation": { "date": "2018-11-01", "client": "particleDesign", "isShown": true, "tile": { "headline": "Transport­ation", "linkText": "Transportation", "group": 3, "colSpan": 2, "tileOffset": "medium", "image": { "src": "/static/content/uploads/test-gear-square-tile.jpg", "aspect": "category-tile", "hAlign": "center", "vAlign": "center" } }, "modules": [{ "type": "category-page-header", "data": { "title": "Transport­ation", "burner": "Autonomous cars, ridesharing environments, and high-speed travel technology mark the  entrance of the new era of transportation. We’re moved to understand how UX can explore the challenges and emerging opportunities across transportation technology." } }, { "type": "work-category-content", "data": { "category": "transportation" } }], "slug": "transportation", "isWorkArticle": true, "workCategories": {} }, "vho-ai-transportation-rider-app": { "slug": "vho-ai-transportation-rider-app", "date": "2018-1-4", "client": "vh1", "isShown": true, "tile": { "headline": "How we designed a new way to think about travel.", "linkText": "Learn more about our work with Virgin Hyperloop One.", "group": 1, "colSpan": 1, "tileOffset": "small", "image": { "src": "/static/content/uploads/work-vho-pod-city.jpg", "aspect": "landscape", "hAlign": "center", "vAlign": "center" } }, "workCategories": { "transportation": { "key": "transportation", "group": "1" } }, "modules": [{ "type": "work-header", "data": { "image": { "src": "/static/content/uploads/work-vho-pod-city.jpg", "alt": "" }, "title": "A Multimodal App for a Travel Revolution", "content": "Virgin Hyperloop One (VHO) is on the forefront of a whole new type of transportation, similar to the Wright brothers with the airplane at the turn of the 20th century. Hyperloop technology has been talked about as “space travel, in a tube, on the ground”. It changes our understanding of distance and time. Regions become neighborhoods, 25 minutes gets you not to a suburb but to another city in nearby state. This has significant implications for work and play. People can live in St. Louis, go to dinner and a show in Chicago, and be back home in time for bed. Compressed commute times change the face of work and home as well: it becomes feasible to work in Seattle, but live in Portland with no increase in commute to the common city - suburbs scenario currently experienced. \n\nIn the Fall of 2017, VHO asked Particle to design and develop the initial prototype of a Rider App that would help communicate the concept of a new form of transportation.", "roles": ["UX Strategy", "Design Workshops", "UX Design", "User Interviews", "User Journey Mapping", "Roles & Task Flows", "Visual Design", "Front End Development"] } }, { "type": "work-image-text-row", "data": { "reversed": true, "image": { "src": "/static/content/uploads/vho_subway.jpg", "width": "wide", "aspect": "medium" }, "content": "## A public transportation model for long distance travel.\n\nOn Demand Ridership is something we normally associate with short distance, public transportation. Long distance travel like rail or air, is usually planned and ticket are purchased in advance. VHO flips these ideas on their head. When your region becomes a neighborhood, the transportation system has to behave like today’s neighborhood transportation systems, while actually taking its passengers across long distances. As VHO has been building their demand models and systems for their Hyperloop, they expect a large percentage of their riders to be buying their tickets minutes before taking the trip. Having a system that allows for highly flexible ridership is seen as key to their success." } }, { "type": "work-image-text-row", "data": { "reversed": false, "image": { "width": "regular", "aspect": "tall", "src": "/static/content/uploads/work-ai-car-exterior.jpg", "alt": "picture of people in car" }, "content": "## The UX challenge: guide riders through radically new travel.\n\n How do you help riders understand and take full advantage of the opportunities provided by on-demand, long distance travel in a fraction of the time? Particle worked with VHO to design core experiences that reminds riders of travel opportunities and makes recommendations at key moments to give passengers excellent travel experiences. A critical part of this was designing an interactive map that reinforces the new distance and time shift. By expanding people’s expectations with how distance is represented on maps, the mobile app could make the most of limited screen real estate while highlighting travel experiences for work and play that only a Hyperloop allows for. Similarly, a system that can offer suggestions for relevant, exciting activities in other cities as part of standard search results can motivate people to take advantage of opportunities and begin to incorporate the new travel model into their everyday experiences. " } }, { "type": "work-image-text-row", "data": { "reversed": false, "image": { "src": "/static/content/uploads/vho_rider_app_route_compare.jpg", "width": "regular", "aspect": "tall" }, "content": "## One transportation app to rule them all: A multi-modal, door-to-door, travel experience.\n\nLong distance travel currently requires multiple forms of transportation to complete a trip: a car ride to and from the train station; walking from your home to public transit to get to and from the the airport. Having a single app that brings all options and modes of transit together, including travel times and costs, means that riders can make truly informed decisions for how to get from one place to another, and buy all tickets and fares in one location. Particle worked with VHO to design each experience within the Rider App to highlight the transit ecosystem available to users, while always highlighting the Hyperloop as a key experience within the larger context.  " } }, { "type": "work-one-column-text", "data": { "reversed": false, "size": "large", "content": ">Virgin Hyperloop One is more than getting from A to B. We’re looking to optimize the entire end-to-end passenger experience\n\n>> Matt Jones\nSenior Vice President of Software, Virgin Hyperloop One" } }, { "type": "work-one-column-text", "data": { "reversed": false, "size": "large", "content": "## AI in a rider app? You bet.\n\nLearning passenger behaviors and preferences and serving up possible experiences at just the right time is key to a multimodal transit app becoming the single app in a rider’s life: you always grab coffee during your commute: yesterday you were taking Hyperloop, so the app directed you to a kiosk in the terminal with the shortest wait time, but today you are taking ride-share the whole way so the app recommends you go to at a corner coffee shop near your house and hail the ride share from there. Serving up these nuanced, contextual experiences at just the right time relies on an intelligent system that processes lots of information into useful opportunities. \n\n Similarly, taking into consideration things like weather, traffic, and other ever-shifting environmental factors and marrying that with user preferences, increases the value of the transit app for its riders. The system might recommend to take a ride share if traffic is bad so you can work on the way since you have back-to-back meetings all day. Or it might recommend walking instead of ride share because it’s a beautiful day and you have a little extra time and didn’t get your run in this morning.\n\nDesigning a system that could understand the right times to communicate these factors and offer solutions or recommendations at the right time was a design challenge Particle met head on, through collaboration and exploration with the VHO team. With regional cities becoming neighborhoods, the number of environmental factors greatly increases in any travel scenario, so it was critical to design a system that can help users understand the unique opportunities and value of the Hyperloop in making the most out of travel within and thru dynamic urban areas." } }, { "type": "work-one-column-text", "data": { "reversed": false, "size": "large", "content": ">Serving up nuanced, contextual experiences at just the right time relies on an intelligent system that processes lots of information into useful opportunities\n\n>> Stacey Rutland\nChief Strategist, Particle Design" } }, { "type": "work-related-articles", "data": { "articles": ["vho-incorporating-ux-ai-software", "ai-future-smart-car"] } }], "isWorkArticle": true }, "vho-incorporating-ux-ai-software": { "slug": "vho-incorporating-ux-ai-software", "date": "2018-12-20", "client": "vh1", "isShown": true, "tile": { "headline": "Designing AI for Virgin Hyperloop One.", "linkText": "Learn more about our work with Virgin Hyperloop One", "group": 1, "colSpan": 2, "tileOffset": "small", "image": { "src": "/static/content/uploads/work-vho-tube-outside.jpg", "aspect": "landscape", "hAlign": "center", "vAlign": "center" } }, "workCategories": { "artificial-intelligence": { "key": "artificial-intelligence", "group": "1" } }, "modules": [{ "type": "work-header", "data": { "image": { "src": "/static/content/uploads/work-vho-tube-outside.jpg", "alt": "", "hAlign": "center" }, "title": " Virgin Hyperloop One: The UX Process for AI Software Design.", "content": "Virgin Hyperloop One came to Particle in the summer of 2018 with the goal of helping their Machine Intelligence team design the software that is their hyperloop “brain”. The design had to accomplish two goals: 1. support the business, civil and SW teams to build data centered simulations for project feasibility, and 2. help the Machine Intelligence team further refine their algorithms that would lead to the deep AI required to run a system as complex and high speed as a hyperloop.", "roles": ["UX Strategy", "Design Workshops", "UX Design", "User Interviews", "User Journey Mapping", "Roles & Task Flows", "Visual Design"] } }, { "type": "work-image-text-row", "data": { "reversed": false, "image": { "src": "/static/content/uploads/work-vho-time-difference.jpg", "width": "wide", "aspect": "medium" }, "content": "## Building the tools that create revolutionary transportation. \n\nNot surprisingly, building a system “brain” is a highly technical endeavor. In this case, it was also for a piece of software that would run a system that had never before been designed. When Particle got involved, the tool had existed as a set of algorithms, scripts, and processes living almost exclusively in the Machine Intelligence team’s computers and minds. With these unique challenges, and with the Virgin Hyperloop One team as the end user, deep collaboration was critical to a successful design. " } }, { "type": "work-two-column-text", "data": { "reversed": false, "isOffset": true, "contentLeft": "## From deep discovery, clear user needs emerge.\n\nLike other highly technical projects, Particle knew that the goal for Discovery was not for us to become experts in the relationship between the physical system and the algorithms that made up the brain. Rather, as a UX firm, we needed to work closely with the Machine Intelligence team and ask the right questions to identify required tasks, interactions and outputs of the system for teams across the organization. We interviewed dozens of VHO team members, held early phase workshops to establish needs and potential features, and brought design inspirations to help ground stakeholder discussions in both their current workflows, and their expectations of the system in the future. Particle and the VHO Machine Intelligence team spent over a month in this Discovery phase. Together, we built a highly effective and high trust partnership that allowed for an efficient design phase of the project.", "contentRight": ">It makes you realise this technology is going to happen in your lifetime. You will be able to ride on a Hyperloop and your time will be given back to you.\n\n>>Colin Rhys\nCreative Director, Hyperloop One " } }, { "type": "work-image-text-column", "data": { "reversed": false, "image": { "height": "medium", "src": "/static/content/uploads/work-vho-in-tube.jpg", "alt": "image the hyperloop test tunnel", "hAlign": "center", "vAlign": "center" } } }, { "type": "work-one-column-text", "data": { "reversed": false, "size": "large", "content": "## Collaboration between UX and Engineers leads to efficient design processes.\n\nWhen you have a well established collaboration process and a clear understanding of the user requirements of a product, designs can flow pretty quickly. This project was no exception. Particle’s UX team went to work creating system maps, task flows, and early design sketches of UIs for key experiences. These helped foster more detailed discussions of system behavior and requirements with the Machine Intelligence team, so that they could confidently make key decisions about MVP features and core functionality. Twice weekly collaboration meetings meant each iteration of design was seen immediately by the VHO team, and pivots and shifts were made early, minimizing churn and maximizing efficiency. Within 8 weeks, the “brain” became a product. " } }, { "type": "work-multi-image-text", "data": { "reversed": false, "images": [{ "src": "/static/content/uploads/work-vho-user-flows.jpg", "hAlign": "center" }, { "src": "/static/content/uploads/work-vho-jon-collab.jpg", "hAlign": "left" }, { "src": "/static/content/uploads/work-vho-sticker-act.jpg", "vAlign": "left" }], "content": "## Machine learning algorithms informed by Design? Yes.\n\nThe work that the VHO Machine Intelligence team does every day is critical to the success of VHO as an organization. Taking their attention away from the work they are doing to design a product (even a product that would make their job more effective and efficient), could have compromised the larger company roadmap. Particle led the design and collaborative process for the brain, making sure the MI team was part of every design decision and key discussion. Knowing they would be brought in at critical moments, the MI team was free to focus on the important work that continued to come across their desk each day. \n\n With the partnership between Particle Design and Virgin Hyperloop One, at the end of 3 months VHO had designs in-hand for the foundational piece of software that they will use to simulate and eventually run the hyperloop." } }, { "type": "work-one-column-text", "data": { "reversed": false, "size": "large", "content": ">Our challenge was unique: how do we design for engineers who are inventing a method of transportation that does not yet exist?\n\n>> Matt Adamo\nDirector of UX, Particle Design" } }, { "type": "work-image-text-column", "data": { "reversed": false, "image": { "height": "medium", "src": "/static/content/uploads/work-vho-tube-load.jpg", "alt": "image the hyperloop test tunnel", "hAlign": "center", "vAlign": "center" } } }, { "type": "work-related-articles", "data": { "articles": ["ai-future-smart-car", "machine-learning-wearable-development"] } }], "isWorkArticle": true }, "vr-science-education": { "date": "2018-06-07", "client": "particleDesign", "isShown": true, "tile": { "headline": "How We Built a Virtual, Underwater Classroom.", "linkText": "Learn more about our work in education", "group": 3, "colSpan": 1, "tileOffset": "large", "image": { "src": "/static/content/uploads/work-vlp-classroom.jpg", "aspect": "medium", "hAlign": "center", "vAlign": "center" } }, "modules": [{ "type": "work-header", "data": { "image": { "src": "/static/content/uploads/work-vlp-hero.jpg", "alt": "" }, "title": "The Classroom of Tomorrow.", "content": "Particle Design partnered with a leading HW / SW company whose innovation group is tasked with dreaming up and creating pioneering experiences for new technologies yet to be released to the market.\n\nWith more than 9 years of experience partnering with this innovative company, Particle was poised to help them create an educational experience that would support interesting and engaging interactions that were supported by new 3D depth camera technology.", "roles": ["UX Research", "UX Strategy", "UX Design", "Interaction Design", "Visual Design", "Front-End Development", "Back-End Development", "Rapid Prototyping"] } }, { "type": "work-image-text-row", "data": { "reversed": true, "image": { "width": "regular", "aspect": "tall", "src": "/static/content/uploads/work-vlp-vr-headset.jpg", "alt": "man wearing VR headset", "hAlign": "center", "vAlign": "center" }, "content": "## Exploring virtual education with 3D technology. \n\nThe company was looking to design education prototypes that would increase student retention in STEM subjects (science, technology, engineering, and mathematics), with the goal of inspiring collaboration with larger educational SW partners. Most schools currently have tablets for students, but most digital curriculum focus on e-textbooks and videos. Moving beyond this paradigm and harnessing the power of immersive digital experiences meant an opportunity for greater student engagement and thus retention.\n\nWe first tested concept storyboards with middle school and high school science teachers with the goal of building a prototype of the one that showed the most promise. Teachers found the idea of students being able to scan themselves with the 3D camera and insert their avatars into otherwise inaccessible environments, such as space or underwater, most compelling. The Chesapeake Bay Underwater Virtual Curriculum was born." } }, { "type": "work-multi-image-text", "data": { "reversed": false, "images": [{ "src": "/static/content/uploads/work-vlp-particle-brainstorm.jpg" }, { "src": "/static/content/uploads/work-vlp-crayons.jpg", "hAlign": "center", "vAlign": "bottom" }], "content": "## Building a virtual reality classroom for students. \n\nOur approach to the design of the prototype was to make the learning experience look and feel like a video game. An RPG aligned with national STEM education standards.\n\nWe built the immersive environment using a 3D game engine and 3D objects. Students could scan themselves and insert their avatar into the environment, walking along the floor of the Bay where they were surrounded by the creatures and plant life of that ecosystem. All organisms were interactive, with info on their unique qualities highlighted. Students could conduct a variety of experiments. They could experience a toxic spill from the perspective of a fish and watch the ecosystem change and die while testing water samples over time to see when life could again thrive in that location. Testing of the prototype with teachers showed that the immersive experience was unique and exciting to educators.\n\nOver the course of six months, Particle worked with our client partner to go from early product ideas, to concept storyboards, through to prototype development, with user feedback integrated all throughout the process.  We were able to succeed in the primary goal: create cutting edge STEM curriculum that capitalized on both emerging technology and the devices students had access to every day in school." } }, { "type": "work-image-text-column", "data": { "reversed": false, "image": { "height": "tall", "src": "/static/content/uploads/work-vlp-books-blocks.jpg", "alt": "image of classroom materials", "hAlign": "center", "vAlign": "center" } } }], "slug": "vr-science-education", "isWorkArticle": true, "workCategories": {} }, "vr-transportation-drivers-ed": { "slug": "vr-transportation-drivers-ed", "date": "2018-01-03", "client": "vrMotion", "isShown": true, "tile": { "headline": "Meshing virtual reality and driver’s education.", "linkText": "Learn more about our work with VR Motion.", "group": 2, "colSpan": 1, "tileOffset": "small", "image": { "src": "/static/content/uploads/work-vr-transport-outside.jpg", "aspect": "landscape", "hAlign": "center", "vAlign": "center" } }, "modules": [{ "type": "work-header", "data": { "image": { "src": "/static/content/uploads/work-vr-transport-outside.jpg", "alt": "" }, "title": "Virtual Reality Meets Driver’s Education", "content": "<a href=\"https://vrmotioncorp.com\">VR Motion</a>, a virtual reality experience company, partnered with a global tech company to explore a new opportunity to use virtual reality for education with a particular user group: teen drivers. As new drivers on the road, teen drivers have a lack of experience that creates anxiety both for the driver themselves, and their parents. VR Motion and the global technology company came to Particle with the goal of exploring the concept of VR integration into driver's education with both teen drivers and their parents.", "roles": ["UX Research", "UX Strategy", "User Interviews"] } }, { "type": "work-one-column-text", "data": { "reversed": false, "size": "large", "content": ">Originally, I wanted someone else to teach my son. I knew I would get stressed out, and I did, which made learning very difficult for him.\n\n>> Parent\nResearch Participant" } }, { "type": "work-image-text-row", "data": { "reversed": false, "image": { "width": "wide", "aspect": "medium", "src": "/static/content/uploads/work-vr-transport-fpview.jpg", "alt": "Image courtesy of VR Motion" }, "content": "## Designing virtual reality that builds trust.\n\nVR Motion and the global technology company had built a VR simulator that allowed the user to immerse themselves in the experience of driving. Using headsets, custom software solutions, and a simulator seat fit with brakes, a handle, and all the necessities of a car, VR motion had a fully built custom driving simulator to immerse users in the experience of driving. But they needed to understand if it would be of use to young drivers, and what they would need to change in the simulator to offer a meaningful experience. Our UX team designed a research study that would both explore teens and parents’ experiences in the driver training process, as well as to better understand which scenarios users felt would be best suited for the VR simulator." } }, { "type": "work-one-column-text", "data": { "reversed": false, "size": "large", "content": "## Understanding where virtual reality can offer a unique value.\n\nToday, Virtual Reality offers the opportunity to explore new environments without the possibility of harming the user, or others. We’ve seen Virtual Reality offer education in spaces from medical training, to disaster relief. VR Motions’ virtual driving simulator offered the opportunity for young drivers to practice their driving without the fear of harming themselves or others. To understand if this would be of value, we led roundtable discussions with teens who were currently learning to drive, and their parents. We then had both teens and parents experience the VR simulator. We then discussed with users their impressions of the VR driving simulator, and explored their ideas of most effective ways for VR to support and reinforce key aspects of the larger driver's training curriculum." } }, { "type": "work-image-text-row", "data": { "reversed": true, "image": { "width": "wide", "aspect": "tall", "src": "/static/content/uploads/work-vr-transport-class.jpg", "alt": "picture of VR experience" }, "content": "## Creating a meaningful Virtual Reality experience for both teens and parents.\n\nTalking to both teens and parents, we found similarities as well as divergences in their expectations and perceived value of the VR simulator. Teens needed help with understanding the basics of driving. As new learners, they had trouble even conceiving skills beyond the basic mastery of the car and the rules of the road. They saw the virtual reality  simulator as a way to master the basics with more confidence and more safety than on the road.\n\nIn comparison to teens, parents described the difficulty in teaching their young drivers more advanced driving scenarios, such as merging onto a busy highway or parallel parking. These advanced driving scenarios were key to their young drivers learning to drive, but they posed greater danger to both themselves and their kids. They saw value in the possibility of the VR simulator to teach beyond the basics. Road Awareness - the type of knowledge that today comes from years of driving - is what they wanted help in teaching their kids. Not just what you do when your in a dangerous situation, but how do you avoid it in the first place." } }, { "type": "work-two-column-text", "data": { "reversed": false, "isOffset": true, "contentLeft": "## Helping VR Motion transform the Driver's Ed experience.\n\nMore than merely a gaming experience, virtual reality offers tremendous possibilities in exploring new modes of education and learning. From our user research, we gave VR Motion, partnered with the global technology company, clear design recommendations to better connect their VR driving simulator to its users. VR Motions’ driving simulator has been incorporated into a number of driver and operator training systems for applications including commercial truck and equipment operators, law enforcement, military and teen drivers alike.", "contentRight": ">I think VR Motion built an experience that is  super helpful for students who have not driven a car yet.  I am excited for future versions.\n\n>> Parent\nResearch Participant" } }, { "type": "work-related-articles", "data": { "articles": ["ai-future-smart-car", "dreamworks-kids-gaming"] } }], "isWorkArticle": true, "workCategories": {} } };

/***/ }),

/***/ "zWeP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zyDQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.484503e5a10cd58fc6a2.js